/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve();
/******/
/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"background","1":"debug-manager","2":"pp"}[chunkId]||chunkId) + "-" + "ee010cd8bdbe317887e9" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunks[chunkId][2] = promise;
/******/
/******/ 		head.appendChild(script);
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./assets/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 267);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/


/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";
    var noop = function() {};
    var undefinedType = "undefined";

    function realMethod(methodName) {
        if (typeof console === undefinedType) {
            return false; // We can't build a real method without a console to log to
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // these private functions always need `this` to be set properly

    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }
    }

    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public API
       *
       */

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Package-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    return defaultLogger;
}));



/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
  var BaseManager;
  return BaseManager = (function() {
    function BaseManager() {}

    BaseManager.prototype._instance = null;

    BaseManager.getInstance = function() {
      if (this._instance == null) {
        this._instance = new this;
      }
      return this._instance;
    };

    return BaseManager;

  })();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var BaseModel, GameModel,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseModel = __webpack_require__(23);

GameModel = (function(_super) {
  __extends(GameModel, _super);

  function GameModel() {
    return GameModel.__super__.constructor.apply(this, arguments);
  }

  GameModel.prototype.name = 'GameModel';

  GameModel.prototype._instance = null;

  GameModel.prototype.getDebug = function() {
    return this.get('debug');
  };

  GameModel.prototype.getFont = function() {
    return this.get('font');
  };

  GameModel.prototype.getFontWithVariations = function() {
    return this.getFont() + this.get('fontVariations');
  };

  GameModel.prototype.getSecondaryFont = function() {
    return this.get('secondaryFont');
  };

  GameModel.prototype.getBaseMultiplier = function() {
    return this.get('baseMultiplier');
  };

  GameModel.prototype.getDefaultStake = function() {
    return this.get('defaultStake');
  };

  GameModel.prototype.getStake = function() {
    return this.getDefaultStake();
  };

  GameModel.prototype.getCurrencyMultiplier = function() {
    return this.getDefaultStake() / this.getBaseMultiplier();
  };

  GameModel.prototype.getPlayerTokenId = function() {
    return this.get('playerTokenId');
  };

  GameModel.prototype.getDefaultCurrencyCode = function() {
    return this.get('defaultCurrency');
  };

  GameModel.prototype.getCurrencyCode = function() {
    return this.get('currencyCode');
  };

  GameModel.prototype.getDefaultLanguageCode = function() {
    return this.get('defaultLanguage');
  };

  GameModel.prototype.getLanguageCode = function() {
    return this.get('languageCode');
  };

  GameModel.prototype.getBaseLanguageCode = function() {
    return this.getLanguageCode().substring(0, 2);
  };

  GameModel.prototype.getClientToken = function() {
    return this.get('clientToken');
  };

  GameModel.prototype.getBalanceUrl = function() {
    return this.get('balanceUrl');
  };

  GameModel.prototype.getBalanceDelay = function() {
    return this.get('balanceDelay');
  };

  GameModel.prototype.getEndUrl = function() {
    return this.get('endUrl');
  };

  GameModel.prototype.getNotifyUrl = function() {
    return this.get('notifyUrl');
  };

  GameModel.prototype.getPlaceBetUrl = function() {
    return this.get('placeBetUrl');
  };

  GameModel.prototype.getCashierUrl = function() {
    return this.get('cashierUrl');
  };

  GameModel.prototype.getBuyMoreUrl = function() {
    return this.get('buyMoreUrl');
  };

  GameModel.prototype.getShowBuyMorePopup = function() {
    return this.get('showBuyMorePopup');
  };

  GameModel.prototype.getHistoryUrl = function() {
    return this.get('historyUrl');
  };

  GameModel.prototype.shouldShowBuyMoreButton = function() {
    return this.getShowBuyMorePopup() != null;
  };

  GameModel.prototype.shouldShowBuyMorePopup = function() {
    var bu, hm, sp;
    hm = this.getHomeUrl();
    bu = this.getBuyMoreUrl();
    sp = this.getShowBuyMorePopup();
    if (sp && ((bu != null) || (hm != null))) {
      return true;
    }
    return false;
  };

  GameModel.prototype.isOutOfTickets = function() {
    var bm, hr, res;
    bm = this.isBasketMode();
    hr = this.hasRoundsLeft();
    res = false;
    if (bm && !hr) {
      res = true;
    }
    return res;
  };

  GameModel.prototype.isOutOfFunds = function() {
    var ba, bm;
    bm = this.isBasketMode();
    ba = this.getBalance();
    if (!bm && ba <= 0) {
      return true;
    }
    return false;
  };

  GameModel.prototype.getHomeUrl = function() {
    var url;
    url = this.get('homeUrl');
    if ((url == null) || typeof url !== 'string') {
      return null;
    }
    if (url === '(none)') {
      return null;
    }
    return url;
  };

  GameModel.prototype.getHelpUrl = function() {
    var bm, cc, lc, mu, rc, s, url;
    url = this.get('helpUrl');
    if (url == null) {
      return null;
    }
    s = this.getStake();
    bm = this.getBaseMultiplier();
    mu = s / bm;
    lc = this.getBaseLanguageCode();
    cc = this.getCurrencyCode();
    rc = false;
    if (url == null) {
      return '';
    }
    url = url + "&data=cc-" + cc + "$mu-" + mu + "$rc-" + rc + "&v=" + window.__version;
    return url;
  };

  GameModel.prototype.shouldShowRealityCheck = function() {
    var rct;
    rct = this.getRealityCheckTimeout();
    if (rct == null) {
      return false;
    }
    if (isNaN(rct)) {
      return false;
    }
    if (rct <= 0) {
      return false;
    }
    return true;
  };

  GameModel.prototype.getRealityCheckTimeout = function() {
    return this.get('realityCheckTimeout');
  };

  GameModel.prototype.setRealityCheckTimeout = function(v) {
    return this.set('realityCheckTimeout', v);
  };

  GameModel.prototype.getRealityInterval = function() {
    return this.get('realityInterval');
  };

  GameModel.prototype.getRealityIntervalInMs = function() {
    return this.getRealityInterval() * 60 * 1000;
  };

  GameModel.prototype.setRealityInterval = function(v) {
    this.set('realityInterval', v);
    return window.localStorage.setItem('reality', v);
  };

  GameModel.prototype.setDefaultRealityInterval = function() {
    var r;
    r = this.getRealityCheckTimeout();
    this.setRealityInterval(r);
    return r;
  };

  GameModel.prototype.getGameCode = function() {
    return this.get('gameCode');
  };

  GameModel.prototype.getReplayOutcome = function() {
    return this.get('replayOutcome');
  };

  GameModel.prototype.getPaytable = function() {
    return this.get('paytable');
  };

  GameModel.prototype.getRandomWin = function() {
    var p;
    p = this.getPaytable();
    return Math.floor(Math.random() * p.length);
  };

  GameModel.prototype.getPrizeForId = function(index) {
    var p;
    if (index <= 0) {
      console.error('prizesIndex cannot be:', index);
    }
    p = this.images.prizes[index];
    return p.split('|');
  };

  GameModel.prototype.getPrizeImgForId = function(index) {
    var prizeData, prizeNum;
    if (this.hasMultiplier) {
      prizeData = this.getPrizeForId(index);
      prizeNum = prizeData[0];
      return Number(prizeNum);
    }
    return this.images.prizes[index];
  };

  GameModel.prototype.getPrizeAmount = function(index) {
    var a, m, multi, offsetIndex, p, r;
    index = parseInt(index);
    offsetIndex = index - 1;
    p = this.getPaytable();
    a = p[offsetIndex];
    m = a * this.getStake();
    if (this.hasMultiplier) {
      multi = this.getPrizeForId(index)[1];
      m = m / Number(multi);
    }
    r = Math.round(m * 100) / 100;
    return r;
  };

  GameModel.prototype.getPrizeYOffetForId = function(index) {
    var _ref;
    if (((_ref = this.images.yOffset) != null ? _ref[index] : void 0) == null) {
      return 0;
    }
    return this.images.yOffset[index];
  };

  GameModel.prototype.getSoundForPrizeId = function(prizeId) {
    var _ref;
    if (((_ref = this.sounds) != null ? _ref.prizes : void 0) == null) {
      return null;
    }
    return this.sounds.prizes[prizeId];
  };

  GameModel.prototype.isMaxPrize = function(index) {
    return this.maxPrize === Number(index);
  };

  GameModel.prototype.getMaxPrize = function() {
    var a, m, p;
    p = this.getPaytable();
    if (p == null) {
      return "";
    }
    a = this.getPrizeAmount(p.length);
    if (this.hasMultiplier) {
      m = this.getPrizeForId(p.length)[1];
      a = a * m;
    }
    return a;
  };

  GameModel.prototype.getExtraData = function() {
    return this.get('extraData');
  };

  GameModel.prototype.getStatus = function() {
    return this.get('status');
  };

  GameModel.prototype.getBalance = function() {
    var s;
    s = this.getStatus();
    if (s == null) {
      return null;
    }
    return s.balance;
  };

  GameModel.prototype.setBalance = function(v) {
    var s;
    s = this.getStatus();
    if (s == null) {
      return null;
    }
    return s.balance = v;
  };

  GameModel.prototype.getFinancialMode = function() {
    var s;
    s = this.getStatus();
    if (s == null) {
      return null;
    }
    return s.financialMode;
  };

  GameModel.prototype.setFinancialMode = function(v) {
    var s;
    s = this.getStatus();
    if (s == null) {
      return null;
    }
    return s.financialMode = v;
  };

  GameModel.prototype.isBasketMode = function() {
    return this.getFinancialMode() === 1;
  };

  GameModel.prototype.getRoundsLeft = function() {
    var s;
    s = this.getStatus();
    if (s == null) {
      return null;
    }
    return s.roundsLeft;
  };

  GameModel.prototype.setRoundsLeft = function(v) {
    var s;
    s = this.getStatus();
    if (s == null) {
      return null;
    }
    return s.roundsLeft = v;
  };

  GameModel.prototype.hasRoundsLeft = function() {
    return this.getRoundsLeft() > 0;
  };

  GameModel.prototype.isDebug = function() {
    return this.get('debug');
  };

  GameModel.prototype.getMode = function() {
    return this.get('mode');
  };

  GameModel.prototype.getDontShowBalance = function() {
    return this.get('dontShowBalance');
  };

  GameModel.prototype.getDontShowStake = function() {
    return this.get('dontShowStake');
  };

  GameModel.prototype.getShowTicketId = function() {
    return this.get('showTicketId');
  };

  GameModel.prototype.getSound = function() {
    var s;
    s = this.get('sound');
    if (typeof s === 'number') {
      if (s > 0) {
        this.set('defaultVolume', s);
        this.setMute(false);
      } else {
        this.setMute(true);
      }
    }
    if (typeof s === 'boolean') {
      this.setMute(!s);
    }
    return this.getDefaultVolume();
  };

  GameModel.prototype.getInitialMute = function() {
    var m, mute;
    mute = true;
    if (!__isMobile) {
      m = window.localStorage.getItem('mute');
      if ((m == null) || m === 'false') {
        mute = false;
      }
    }
    this.setMute(mute);
    return mute;
  };

  GameModel.prototype.getMute = function() {
    var m;
    m = this.get('mute');
    if (m != null) {
      return m;
    }
    return this.getInitialMute();
  };

  GameModel.prototype.setMute = function(v) {
    this.set('mute', v);
    return window.localStorage.setItem('mute', v);
  };

  GameModel.prototype.getDefaultVolume = function() {
    return this.get('defaultVolume');
  };

  GameModel.getInstance = function() {
    if (this._instance == null) {
      this._instance = new this;
    }
    return this._instance;
  };

  return GameModel;

})(BaseModel);

module.exports = GameModel.getInstance();


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, EventManager, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

BaseManager = __webpack_require__(1);

EventManager = (function(_super) {
  __extends(EventManager, _super);

  function EventManager() {
    var CustomEvent, e;
    try {
      new CustomEvent('test');
    } catch (_error) {
      e = _error;
      CustomEvent = function(event, params) {
        var evt;
        params = params || {
          bubbles: false,
          cancelable: false,
          detail: undefined
        };
        evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      };
      CustomEvent.prototype = window.Event.prototype;
      window.CustomEvent = CustomEvent;
    }
  }

  EventManager.prototype.trigger = function(eventName, eventData) {
    var event;
    if (eventData == null) {
      eventData = '';
    }
    event = new CustomEvent(eventName, {
      detail: eventData
    });
    return document.dispatchEvent(event);
  };

  EventManager.prototype.listenTo = function(eventName, cb, onlyOnce) {
    var _callback;
    if (onlyOnce == null) {
      onlyOnce = false;
    }
    _callback = (function(_this) {
      return function(e) {
        if (onlyOnce) {
          _this.stopListeningTo(eventName, _callback);
        }
        return cb(e.detail, e);
      };
    })(this);
    document.addEventListener(eventName, _callback, false);
    return _callback;
  };

  EventManager.prototype.listenOnce = function(eventName, cb) {
    return this.listenTo(eventName, cb, true);
  };

  EventManager.prototype.stopListeningTo = function(eventName, cb) {
    return document.removeEventListener(eventName, cb, false);
  };

  return EventManager;

})(BaseManager);

module.exports = EventManager.getInstance();


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, ImageManager, each, loadingManager, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

loadingManager = __webpack_require__(19);

each = __webpack_require__(213);

log = __webpack_require__(0);

ImageManager = (function(_super) {
  __extends(ImageManager, _super);

  function ImageManager() {
    return ImageManager.__super__.constructor.apply(this, arguments);
  }

  ImageManager.prototype.allNamespaces = [];

  ImageManager.prototype.loadImage = function(url, cb) {
    var img;
    img = new Image();
    img.onload = (function(_this) {
      return function() {
        return cb(img);
      };
    })(this);
    return img.src = url + '?v=' + window.__version;
  };

  ImageManager.prototype.loadAsset = function(url, callback) {
    return this.loadAssets([url], callback);
  };

  ImageManager.prototype.loadAssets = function(urls, callback) {
    var extension, tmp, url, _i, _len;
    if (this.loader == null) {
      this.loader = new PIXI.loaders.Loader();
    }
    urls = urls.noDupe();
    tmp = [];
    for (_i = 0, _len = urls.length; _i < _len; _i++) {
      url = urls[_i];
      if (this.loader.resources[url] == null) {
        tmp.push(url);
        extension = url.split('.').pop();
        if (extension === 'json') {
          this.allNamespaces.push(url);
        }
      }
    }
    if (!tmp.length) {
      return callback();
    }
    this.loader.defaultQueryString = 'v=' + window.__version;
    this.loader.add(tmp);
    this.loader.on('progress', (function(_this) {
      return function(progress, resource) {
        return loadingManager.set(progress.progress / 100);
      };
    })(this));
    this.loader.on('error', (function(_this) {
      return function(err) {
        console.error(err);
        return callback(err);
      };
    })(this));
    this.loader.once('complete', (function(_this) {
      return function(result) {
        return callback(result);
      };
    })(this));
    return this.loader.load();
  };

  ImageManager.prototype.makeTexturesFromName = function(name) {
    var namespace, newTextures, textures, _i, _len, _ref;
    textures = [];
    _ref = this.allNamespaces;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      namespace = _ref[_i];
      newTextures = this.makeTexturesFromNamespace(namespace, name);
      textures = textures.concat(newTextures);
    }
    textures.sortByKey('__name');
    return textures;
  };

  ImageManager.prototype.makeTexturesFromNamespace = function(namespace, name) {
    var key, re, textures, tmp, value;
    textures = this.loader.resources[namespace].textures;
    re = new RegExp(name, "g");
    tmp = [];
    for (key in textures) {
      value = textures[key];
      if (key.match(re)) {
        value.__name = key;
        tmp.push(value);
      }
    }
    return tmp;
  };

  ImageManager.prototype.getSpriteSheetImageNames = function() {
    var resourceName, tmp, _i, _len, _ref;
    tmp = [];
    _ref = this.allNamespaces;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      resourceName = _ref[_i];
      tmp.push(resourceName + '_image');
    }
    return tmp;
  };

  ImageManager.prototype.exists = function(key) {
    return this.loader.resources[key] != null;
  };

  return ImageManager;

})(BaseManager);

module.exports = ImageManager.getInstance();


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/


/*!
 * VERSION: 1.19.1
 * DATE: 2017-01-17
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("TweenMax",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},e=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},f=function(a,b,d){c.call(this,a,b,d),this._cycle=0,this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._dirty=!0,this.render=f.prototype.render},g=1e-10,h=c._internals,i=h.isSelector,j=h.isArray,k=f.prototype=c.to({},.1,{}),l=[];f.version="1.19.1",k.constructor=f,k.kill()._gc=!1,f.killTweensOf=f.killDelayedCallsTo=c.killTweensOf,f.getTweensOf=c.getTweensOf,f.lagSmoothing=c.lagSmoothing,f.ticker=c.ticker,f.render=c.render,k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),c.prototype.invalidate.call(this)},k.updateTo=function(a,b){var d,e=this.ratio,f=this.vars.immediateRender||a.immediateRender;b&&this._startTime<this._timeline._time&&(this._startTime=this._timeline._time,this._uncache(!1),this._gc?this._enabled(!0,!1):this._timeline.insert(this,this._startTime-this._delay));for(d in a)this.vars[d]=a[d];if(this._initted||f)if(b)this._initted=!1,f&&this.render(0,!0,!0);else if(this._gc&&this._enabled(!0,!1),this._notifyPluginsOfEnabled&&this._firstPT&&c._onPluginEvent("_onDisable",this),this._time/this._duration>.998){var g=this._totalTime;this.render(0,!0,!1),this._initted=!1,this.render(g,!0,!1)}else if(this._initted=!1,this._init(),this._time>0||f)for(var h,i=1/(1-e),j=this._firstPT;j;)h=j.s+j.c,j.c*=i,j.s=h-j.c,j=j._next;return this},k.render=function(a,b,c){this._initted||0===this._duration&&this.vars.repeat&&this.invalidate();var d,e,f,i,j,k,l,m,n=this._dirty?this.totalDuration():this._totalDuration,o=this._time,p=this._totalTime,q=this._cycle,r=this._duration,s=this._rawPrevTime;if(a>=n-1e-7&&a>=0?(this._totalTime=n,this._cycle=this._repeat,this._yoyo&&0!==(1&this._cycle)?(this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0):(this._time=r,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1),this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===r&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>s||0>=a&&a>=-1e-7||s===g&&"isPause"!==this.data)&&s!==a&&(c=!0,s>g&&(e="onReverseComplete")),this._rawPrevTime=m=!b||a||s===a?a:g)):1e-7>a?(this._totalTime=this._time=this._cycle=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==p||0===r&&s>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===r&&(this._initted||!this.vars.lazy||c)&&(s>=0&&(c=!0),this._rawPrevTime=m=!b||a||s===a?a:g)),this._initted||(c=!0)):(this._totalTime=this._time=a,0!==this._repeat&&(i=r+this._repeatDelay,this._cycle=this._totalTime/i>>0,0!==this._cycle&&this._cycle===this._totalTime/i&&a>=p&&this._cycle--,this._time=this._totalTime-this._cycle*i,this._yoyo&&0!==(1&this._cycle)&&(this._time=r-this._time),this._time>r?this._time=r:this._time<0&&(this._time=0)),this._easeType?(j=this._time/r,k=this._easeType,l=this._easePower,(1===k||3===k&&j>=.5)&&(j=1-j),3===k&&(j*=2),1===l?j*=j:2===l?j*=j*j:3===l?j*=j*j*j:4===l&&(j*=j*j*j*j),1===k?this.ratio=1-j:2===k?this.ratio=j:this._time/r<.5?this.ratio=j/2:this.ratio=1-j/2):this.ratio=this._ease.getRatio(this._time/r)),o===this._time&&!c&&q===this._cycle)return void(p!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=o,this._totalTime=p,this._rawPrevTime=s,this._cycle=q,h.lazyTweens.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/r):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==o&&a>=0&&(this._active=!0),0===p&&(2===this._initted&&a>0&&this._init(),this._startAt&&(a>=0?this._startAt.render(a,b,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._totalTime||0===r)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&this._startTime&&this._startAt.render(a,b,c),b||(this._totalTime!==p||e)&&this._callback("onUpdate")),this._cycle!==q&&(b||this._gc||this.vars.onRepeat&&this._callback("onRepeat")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&this._startTime&&this._startAt.render(a,b,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===r&&this._rawPrevTime===g&&m!==g&&(this._rawPrevTime=0))},f.to=function(a,b,c){return new f(a,b,c)},f.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new f(a,b,c)},f.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new f(a,b,d)},f.staggerTo=f.allTo=function(a,b,g,h,k,m,n){h=h||0;var o,p,q,r,s=0,t=[],u=function(){g.onComplete&&g.onComplete.apply(g.onCompleteScope||this,arguments),k.apply(n||g.callbackScope||this,m||l)},v=g.cycle,w=g.startAt&&g.startAt.cycle;for(j(a)||("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a))),a=a||[],0>h&&(a=d(a),a.reverse(),h*=-1),o=a.length-1,q=0;o>=q;q++){p={};for(r in g)p[r]=g[r];if(v&&(e(p,a,q),null!=p.duration&&(b=p.duration,delete p.duration)),w){w=p.startAt={};for(r in g.startAt)w[r]=g.startAt[r];e(p.startAt,a,q)}p.delay=s+(p.delay||0),q===o&&k&&(p.onComplete=u),t[q]=new f(a[q],b,p),s+=h}return t},f.staggerFrom=f.allFrom=function(a,b,c,d,e,g,h){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,f.staggerTo(a,b,c,d,e,g,h)},f.staggerFromTo=f.allFromTo=function(a,b,c,d,e,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,f.staggerTo(a,b,d,e,g,h,i)},f.delayedCall=function(a,b,c,d,e){return new f(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,useFrames:e,overwrite:0})},f.set=function(a,b){return new f(a,0,b)},f.isTweening=function(a){return c.getTweensOf(a,!0).length>0};var m=function(a,b){for(var d=[],e=0,f=a._first;f;)f instanceof c?d[e++]=f:(b&&(d[e++]=f),d=d.concat(m(f,b)),e=d.length),f=f._next;return d},n=f.getAllTweens=function(b){return m(a._rootTimeline,b).concat(m(a._rootFramesTimeline,b))};f.killAll=function(a,c,d,e){null==c&&(c=!0),null==d&&(d=!0);var f,g,h,i=n(0!=e),j=i.length,k=c&&d&&e;for(h=0;j>h;h++)g=i[h],(k||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&(a?g.totalTime(g._reversed?0:g.totalDuration()):g._enabled(!1,!1))},f.killChildTweensOf=function(a,b){if(null!=a){var e,g,k,l,m,n=h.tweenLookup;if("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a)),j(a))for(l=a.length;--l>-1;)f.killChildTweensOf(a[l],b);else{e=[];for(k in n)for(g=n[k].target.parentNode;g;)g===a&&(e=e.concat(n[k].tweens)),g=g.parentNode;for(m=e.length,l=0;m>l;l++)b&&e[l].totalTime(e[l].totalDuration()),e[l]._enabled(!1,!1)}}};var o=function(a,c,d,e){c=c!==!1,d=d!==!1,e=e!==!1;for(var f,g,h=n(e),i=c&&d&&e,j=h.length;--j>-1;)g=h[j],(i||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&g.paused(a)};return f.pauseAll=function(a,b,c){o(!0,a,b,c)},f.resumeAll=function(a,b,c){o(!1,a,b,c)},f.globalTimeScale=function(b){var d=a._rootTimeline,e=c.ticker.time;return arguments.length?(b=b||g,d._startTime=e-(e-d._startTime)*d._timeScale/b,d=a._rootFramesTimeline,e=c.ticker.frame,d._startTime=e-(e-d._startTime)*d._timeScale/b,d._timeScale=a._rootTimeline._timeScale=b,b):d._timeScale},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.duration=function(b){return arguments.length?a.prototype.duration.call(this,b):this._duration},k.totalDuration=function(a){return arguments.length?-1===this._repeat?this:this.duration((a-this._repeat*this._repeatDelay)/(this._repeat+1)):(this._dirty&&(this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat,this._dirty=!1),this._totalDuration)},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},f},!0),_gsScope._gsDefine("TimelineLite",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){b.call(this,a),this._labels={},this.autoRemoveChildren=this.vars.autoRemoveChildren===!0,this.smoothChildTiming=this.vars.smoothChildTiming===!0,this._sortChildren=!0,this._onUpdate=this.vars.onUpdate;var c,d,e=this.vars;for(d in e)c=e[d],i(c)&&-1!==c.join("").indexOf("{self}")&&(e[d]=this._swapSelfInParams(c));i(e.tweens)&&this.add(e.tweens,0,e.align,e.stagger)},e=1e-10,f=c._internals,g=d._internals={},h=f.isSelector,i=f.isArray,j=f.lazyTweens,k=f.lazyRender,l=_gsScope._gsDefine.globals,m=function(a){var b,c={};for(b in a)c[b]=a[b];return c},n=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},o=g.pauseCallback=function(){},p=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},q=d.prototype=new b;return d.version="1.19.1",q.constructor=d,q.kill()._gc=q._forcingPlayhead=q._hasPause=!1,q.to=function(a,b,d,e){var f=d.repeat&&l.TweenMax||c;return b?this.add(new f(a,b,d),e):this.set(a,d,e)},q.from=function(a,b,d,e){return this.add((d.repeat&&l.TweenMax||c).from(a,b,d),e)},q.fromTo=function(a,b,d,e,f){var g=e.repeat&&l.TweenMax||c;return b?this.add(g.fromTo(a,b,d,e),f):this.set(a,e,f)},q.staggerTo=function(a,b,e,f,g,i,j,k){var l,o,q=new d({onComplete:i,onCompleteParams:j,callbackScope:k,smoothChildTiming:this.smoothChildTiming}),r=e.cycle;for("string"==typeof a&&(a=c.selector(a)||a),a=a||[],h(a)&&(a=p(a)),f=f||0,0>f&&(a=p(a),a.reverse(),f*=-1),o=0;o<a.length;o++)l=m(e),l.startAt&&(l.startAt=m(l.startAt),l.startAt.cycle&&n(l.startAt,a,o)),r&&(n(l,a,o),null!=l.duration&&(b=l.duration,delete l.duration)),q.to(a[o],b,l,o*f);return this.add(q,g)},q.staggerFrom=function(a,b,c,d,e,f,g,h){return c.immediateRender=0!=c.immediateRender,c.runBackwards=!0,this.staggerTo(a,b,c,d,e,f,g,h)},q.staggerFromTo=function(a,b,c,d,e,f,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,this.staggerTo(a,b,d,e,f,g,h,i)},q.call=function(a,b,d,e){return this.add(c.delayedCall(0,a,b,d),e)},q.set=function(a,b,d){return d=this._parseTimeOrLabel(d,0,!0),null==b.immediateRender&&(b.immediateRender=d===this._time&&!this._paused),this.add(new c(a,0,b),d)},d.exportRoot=function(a,b){a=a||{},null==a.smoothChildTiming&&(a.smoothChildTiming=!0);var e,f,g=new d(a),h=g._timeline;for(null==b&&(b=!0),h._remove(g,!0),g._startTime=0,g._rawPrevTime=g._time=g._totalTime=h._time,e=h._first;e;)f=e._next,b&&e instanceof c&&e.target===e.vars.onComplete||g.add(e,e._startTime-e._delay),e=f;return h.add(g,0),g},q.add=function(e,f,g,h){var j,k,l,m,n,o;if("number"!=typeof f&&(f=this._parseTimeOrLabel(f,0,!0,e)),!(e instanceof a)){if(e instanceof Array||e&&e.push&&i(e)){for(g=g||"normal",h=h||0,j=f,k=e.length,l=0;k>l;l++)i(m=e[l])&&(m=new d({tweens:m})),this.add(m,j),"string"!=typeof m&&"function"!=typeof m&&("sequence"===g?j=m._startTime+m.totalDuration()/m._timeScale:"start"===g&&(m._startTime-=m.delay())),j+=h;return this._uncache(!0)}if("string"==typeof e)return this.addLabel(e,f);if("function"!=typeof e)throw"Cannot add "+e+" into the timeline; it is not a tween, timeline, function, or string.";e=c.delayedCall(0,e)}if(b.prototype.add.call(this,e,f),(this._gc||this._time===this._duration)&&!this._paused&&this._duration<this.duration())for(n=this,o=n.rawTime()>e._startTime;n._timeline;)o&&n._timeline.smoothChildTiming?n.totalTime(n._totalTime,!0):n._gc&&n._enabled(!0,!1),n=n._timeline;return this},q.remove=function(b){if(b instanceof a){this._remove(b,!1);var c=b._timeline=b.vars.useFrames?a._rootFramesTimeline:a._rootTimeline;return b._startTime=(b._paused?b._pauseTime:c._time)-(b._reversed?b.totalDuration()-b._totalTime:b._totalTime)/b._timeScale,this}if(b instanceof Array||b&&b.push&&i(b)){for(var d=b.length;--d>-1;)this.remove(b[d]);return this}return"string"==typeof b?this.removeLabel(b):this.kill(null,b)},q._remove=function(a,c){b.prototype._remove.call(this,a,c);var d=this._last;return d?this._time>this.duration()&&(this._time=this._duration,this._totalTime=this._totalDuration):this._time=this._totalTime=this._duration=this._totalDuration=0,this},q.append=function(a,b){return this.add(a,this._parseTimeOrLabel(null,b,!0,a))},q.insert=q.insertMultiple=function(a,b,c,d){return this.add(a,b||0,c,d)},q.appendMultiple=function(a,b,c,d){return this.add(a,this._parseTimeOrLabel(null,b,!0,a),c,d)},q.addLabel=function(a,b){return this._labels[a]=this._parseTimeOrLabel(b),this},q.addPause=function(a,b,d,e){var f=c.delayedCall(0,o,d,e||this);return f.vars.onComplete=f.vars.onReverseComplete=b,f.data="isPause",this._hasPause=!0,this.add(f,a)},q.removeLabel=function(a){return delete this._labels[a],this},q.getLabelTime=function(a){return null!=this._labels[a]?this._labels[a]:-1},q._parseTimeOrLabel=function(b,c,d,e){var f;if(e instanceof a&&e.timeline===this)this.remove(e);else if(e&&(e instanceof Array||e.push&&i(e)))for(f=e.length;--f>-1;)e[f]instanceof a&&e[f].timeline===this&&this.remove(e[f]);if("string"==typeof c)return this._parseTimeOrLabel(c,d&&"number"==typeof b&&null==this._labels[c]?b-this.duration():0,d);if(c=c||0,"string"!=typeof b||!isNaN(b)&&null==this._labels[b])null==b&&(b=this.duration());else{if(f=b.indexOf("="),-1===f)return null==this._labels[b]?d?this._labels[b]=this.duration()+c:c:this._labels[b]+c;c=parseInt(b.charAt(f-1)+"1",10)*Number(b.substr(f+1)),b=f>1?this._parseTimeOrLabel(b.substr(0,f-1),0,d):this.duration()}return Number(b)+c},q.seek=function(a,b){return this.totalTime("number"==typeof a?a:this._parseTimeOrLabel(a),b!==!1)},q.stop=function(){return this.paused(!0)},q.gotoAndPlay=function(a,b){return this.play(a,b)},q.gotoAndStop=function(a,b){return this.pause(a,b)},q.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,g,h,i,l,m,n=this._dirty?this.totalDuration():this._totalDuration,o=this._time,p=this._startTime,q=this._timeScale,r=this._paused;if(a>=n-1e-7&&a>=0)this._totalTime=this._time=n,this._reversed||this._hasPausedChild()||(f=!0,h="onComplete",i=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||this._rawPrevTime<0||this._rawPrevTime===e)&&this._rawPrevTime!==a&&this._first&&(i=!0,this._rawPrevTime>e&&(h="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,a=n+1e-4;else if(1e-7>a)if(this._totalTime=this._time=0,(0!==o||0===this._duration&&this._rawPrevTime!==e&&(this._rawPrevTime>0||0>a&&this._rawPrevTime>=0))&&(h="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(i=f=!0,h="onReverseComplete"):this._rawPrevTime>=0&&this._first&&(i=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(i=!0)}else{if(this._hasPause&&!this._forcingPlayhead&&!b){if(a>=o)for(d=this._first;d&&d._startTime<=a&&!l;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(l=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!l;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(l=d),d=d._prev;l&&(this._time=a=l._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}this._totalTime=this._time=this._rawPrevTime=a}if(this._time!==o&&this._first||c||i||l){if(this._initted||(this._initted=!0),this._active||!this._paused&&this._time!==o&&a>0&&(this._active=!0),0===o&&this.vars.onStart&&(0===this._time&&this._duration||b||this._callback("onStart")),m=this._time,m>=o)for(d=this._first;d&&(g=d._next,m===this._time&&(!this._paused||r));)(d._active||d._startTime<=m&&!d._paused&&!d._gc)&&(l===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=g;else for(d=this._last;d&&(g=d._prev,m===this._time&&(!this._paused||r));){if(d._active||d._startTime<=o&&!d._paused&&!d._gc){if(l===d){for(l=d._prev;l&&l.endTime()>this._time;)l.render(l._reversed?l.totalDuration()-(a-l._startTime)*l._timeScale:(a-l._startTime)*l._timeScale,b,c),l=l._prev;l=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=g}this._onUpdate&&(b||(j.length&&k(),this._callback("onUpdate"))),h&&(this._gc||(p===this._startTime||q!==this._timeScale)&&(0===this._time||n>=this.totalDuration())&&(f&&(j.length&&k(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[h]&&this._callback(h)))}},q._hasPausedChild=function(){for(var a=this._first;a;){if(a._paused||a instanceof d&&a._hasPausedChild())return!0;a=a._next}return!1},q.getChildren=function(a,b,d,e){e=e||-9999999999;for(var f=[],g=this._first,h=0;g;)g._startTime<e||(g instanceof c?b!==!1&&(f[h++]=g):(d!==!1&&(f[h++]=g),a!==!1&&(f=f.concat(g.getChildren(!0,b,d)),h=f.length))),g=g._next;return f},q.getTweensOf=function(a,b){var d,e,f=this._gc,g=[],h=0;for(f&&this._enabled(!0,!0),d=c.getTweensOf(a),e=d.length;--e>-1;)(d[e].timeline===this||b&&this._contains(d[e]))&&(g[h++]=d[e]);return f&&this._enabled(!1,!0),g},q.recent=function(){return this._recent},q._contains=function(a){for(var b=a.timeline;b;){if(b===this)return!0;b=b.timeline}return!1},q.shiftChildren=function(a,b,c){c=c||0;for(var d,e=this._first,f=this._labels;e;)e._startTime>=c&&(e._startTime+=a),e=e._next;if(b)for(d in f)f[d]>=c&&(f[d]+=a);return this._uncache(!0)},q._kill=function(a,b){if(!a&&!b)return this._enabled(!1,!1);for(var c=b?this.getTweensOf(b):this.getChildren(!0,!0,!1),d=c.length,e=!1;--d>-1;)c[d]._kill(a,b)&&(e=!0);return e},q.clear=function(a){var b=this.getChildren(!1,!0,!0),c=b.length;for(this._time=this._totalTime=0;--c>-1;)b[c]._enabled(!1,!1);return a!==!1&&(this._labels={}),this._uncache(!0)},q.invalidate=function(){for(var b=this._first;b;)b.invalidate(),b=b._next;return a.prototype.invalidate.call(this)},q._enabled=function(a,c){if(a===this._gc)for(var d=this._first;d;)d._enabled(a,!0),d=d._next;return b.prototype._enabled.call(this,a,c)},q.totalTime=function(b,c,d){this._forcingPlayhead=!0;var e=a.prototype.totalTime.apply(this,arguments);return this._forcingPlayhead=!1,e},q.duration=function(a){return arguments.length?(0!==this.duration()&&0!==a&&this.timeScale(this._duration/a),this):(this._dirty&&this.totalDuration(),this._duration)},q.totalDuration=function(a){if(!arguments.length){if(this._dirty){for(var b,c,d=0,e=this._last,f=999999999999;e;)b=e._prev,e._dirty&&e.totalDuration(),e._startTime>f&&this._sortChildren&&!e._paused?this.add(e,e._startTime-e._delay):f=e._startTime,e._startTime<0&&!e._paused&&(d-=e._startTime,this._timeline.smoothChildTiming&&(this._startTime+=e._startTime/this._timeScale),this.shiftChildren(-e._startTime,!1,-9999999999),f=0),c=e._startTime+e._totalDuration/e._timeScale,c>d&&(d=c),e=b;this._duration=this._totalDuration=d,this._dirty=!1}return this._totalDuration}return a&&this.totalDuration()?this.timeScale(this._totalDuration/a):this},q.paused=function(b){if(!b)for(var c=this._first,d=this._time;c;)c._startTime===d&&"isPause"===c.data&&(c._rawPrevTime=0),c=c._next;return a.prototype.paused.apply(this,arguments)},q.usesFrames=function(){for(var b=this._timeline;b._timeline;)b=b._timeline;return b===a._rootFramesTimeline},q.rawTime=function(a){return a&&(this._paused||this._repeat&&this.time()>0&&this.totalProgress()<1)?this._totalTime%(this._duration+this._repeatDelay):this._paused?this._totalTime:(this._timeline.rawTime(a)-this._startTime)*this._timeScale},d},!0),_gsScope._gsDefine("TimelineMax",["TimelineLite","TweenLite","easing.Ease"],function(a,b,c){var d=function(b){a.call(this,b),this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._cycle=0,this._yoyo=this.vars.yoyo===!0,this._dirty=!0},e=1e-10,f=b._internals,g=f.lazyTweens,h=f.lazyRender,i=_gsScope._gsDefine.globals,j=new c(null,null,1,0),k=d.prototype=new a;return k.constructor=d,k.kill()._gc=!1,d.version="1.19.1",k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),a.prototype.invalidate.call(this)},k.addCallback=function(a,c,d,e){return this.add(b.delayedCall(0,a,d,e),c)},k.removeCallback=function(a,b){if(a)if(null==b)this._kill(null,a);else for(var c=this.getTweensOf(a,!1),d=c.length,e=this._parseTimeOrLabel(b);--d>-1;)c[d]._startTime===e&&c[d]._enabled(!1,!1);return this},k.removePause=function(b){return this.removeCallback(a._internals.pauseCallback,b)},k.tweenTo=function(a,c){c=c||{};var d,e,f,g={ease:j,useFrames:this.usesFrames(),immediateRender:!1},h=c.repeat&&i.TweenMax||b;for(e in c)g[e]=c[e];return g.time=this._parseTimeOrLabel(a),d=Math.abs(Number(g.time)-this._time)/this._timeScale||.001,f=new h(this,d,g),g.onStart=function(){f.target.paused(!0),f.vars.time!==f.target.time()&&d===f.duration()&&f.duration(Math.abs(f.vars.time-f.target.time())/f.target._timeScale),c.onStart&&c.onStart.apply(c.onStartScope||c.callbackScope||f,c.onStartParams||[])},f},k.tweenFromTo=function(a,b,c){c=c||{},a=this._parseTimeOrLabel(a),c.startAt={onComplete:this.seek,onCompleteParams:[a],callbackScope:this},c.immediateRender=c.immediateRender!==!1;var d=this.tweenTo(b,c);return d.duration(Math.abs(d.vars.time-a)/this._timeScale||.001)},k.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,i,j,k,l,m,n,o=this._dirty?this.totalDuration():this._totalDuration,p=this._duration,q=this._time,r=this._totalTime,s=this._startTime,t=this._timeScale,u=this._rawPrevTime,v=this._paused,w=this._cycle;if(a>=o-1e-7&&a>=0)this._locked||(this._totalTime=o,this._cycle=this._repeat),this._reversed||this._hasPausedChild()||(f=!0,j="onComplete",k=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||0>u||u===e)&&u!==a&&this._first&&(k=!0,u>e&&(j="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,this._yoyo&&0!==(1&this._cycle)?this._time=a=0:(this._time=p,a=p+1e-4);else if(1e-7>a)if(this._locked||(this._totalTime=this._cycle=0),this._time=0,(0!==q||0===p&&u!==e&&(u>0||0>a&&u>=0)&&!this._locked)&&(j="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(k=f=!0,j="onReverseComplete"):u>=0&&this._first&&(k=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=p||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(k=!0)}else if(0===p&&0>u&&(k=!0),this._time=this._rawPrevTime=a,this._locked||(this._totalTime=a,0!==this._repeat&&(l=p+this._repeatDelay,this._cycle=this._totalTime/l>>0,0!==this._cycle&&this._cycle===this._totalTime/l&&a>=r&&this._cycle--,this._time=this._totalTime-this._cycle*l,this._yoyo&&0!==(1&this._cycle)&&(this._time=p-this._time),this._time>p?(this._time=p,a=p+1e-4):this._time<0?this._time=a=0:a=this._time)),this._hasPause&&!this._forcingPlayhead&&!b&&p>a){if(a=this._time,a>=q||this._repeat&&w!==this._cycle)for(d=this._first;d&&d._startTime<=a&&!m;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(m=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!m;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(m=d),d=d._prev;m&&(this._time=a=m._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}if(this._cycle!==w&&!this._locked){var x=this._yoyo&&0!==(1&w),y=x===(this._yoyo&&0!==(1&this._cycle)),z=this._totalTime,A=this._cycle,B=this._rawPrevTime,C=this._time;if(this._totalTime=w*p,this._cycle<w?x=!x:this._totalTime+=p,this._time=q,this._rawPrevTime=0===p?u-1e-4:u,this._cycle=w,this._locked=!0,q=x?0:p,this.render(q,b,0===p),b||this._gc||this.vars.onRepeat&&(this._cycle=A,this._locked=!1,this._callback("onRepeat")),q!==this._time)return;if(y&&(this._cycle=w,this._locked=!0,q=x?p+1e-4:-1e-4,this.render(q,!0,!1)),this._locked=!1,this._paused&&!v)return;this._time=C,this._totalTime=z,this._cycle=A,this._rawPrevTime=B}if(!(this._time!==q&&this._first||c||k||m))return void(r!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(this._initted||(this._initted=!0),this._active||!this._paused&&this._totalTime!==r&&a>0&&(this._active=!0),0===r&&this.vars.onStart&&(0===this._totalTime&&this._totalDuration||b||this._callback("onStart")),n=this._time,n>=q)for(d=this._first;d&&(i=d._next,n===this._time&&(!this._paused||v));)(d._active||d._startTime<=this._time&&!d._paused&&!d._gc)&&(m===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=i;else for(d=this._last;d&&(i=d._prev,n===this._time&&(!this._paused||v));){if(d._active||d._startTime<=q&&!d._paused&&!d._gc){if(m===d){for(m=d._prev;m&&m.endTime()>this._time;)m.render(m._reversed?m.totalDuration()-(a-m._startTime)*m._timeScale:(a-m._startTime)*m._timeScale,b,c),m=m._prev;m=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=i}this._onUpdate&&(b||(g.length&&h(),this._callback("onUpdate"))),j&&(this._locked||this._gc||(s===this._startTime||t!==this._timeScale)&&(0===this._time||o>=this.totalDuration())&&(f&&(g.length&&h(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[j]&&this._callback(j)))},k.getActive=function(a,b,c){null==a&&(a=!0),null==b&&(b=!0),null==c&&(c=!1);var d,e,f=[],g=this.getChildren(a,b,c),h=0,i=g.length;for(d=0;i>d;d++)e=g[d],e.isActive()&&(f[h++]=e);return f},k.getLabelAfter=function(a){a||0!==a&&(a=this._time);var b,c=this.getLabelsArray(),d=c.length;for(b=0;d>b;b++)if(c[b].time>a)return c[b].name;return null},k.getLabelBefore=function(a){null==a&&(a=this._time);for(var b=this.getLabelsArray(),c=b.length;--c>-1;)if(b[c].time<a)return b[c].name;return null},k.getLabelsArray=function(){var a,b=[],c=0;for(a in this._labels)b[c++]={time:this._labels[a],name:a};return b.sort(function(a,b){return a.time-b.time}),b},k.invalidate=function(){return this._locked=!1,a.prototype.invalidate.call(this)},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()},k.totalDuration=function(b){return arguments.length?-1!==this._repeat&&b?this.timeScale(this.totalDuration()/b):this:(this._dirty&&(a.prototype.totalDuration.call(this),this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat),this._totalDuration)},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},k.currentLabel=function(a){return arguments.length?this.seek(a,!0):this.getLabelBefore(this._time+1e-8)},d},!0),function(){var a=180/Math.PI,b=[],c=[],d=[],e={},f=_gsScope._gsDefine.globals,g=function(a,b,c,d){c===d&&(c=d-(d-b)/1e6),a===b&&(b=a+(c-a)/1e6),this.a=a,this.b=b,this.c=c,this.d=d,this.da=d-a,this.ca=c-a,this.ba=b-a},h=",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",i=function(a,b,c,d){var e={a:a},f={},g={},h={c:d},i=(a+b)/2,j=(b+c)/2,k=(c+d)/2,l=(i+j)/2,m=(j+k)/2,n=(m-l)/8;return e.b=i+(a-i)/4,f.b=l+n,e.c=f.a=(e.b+f.b)/2,f.c=g.a=(l+m)/2,g.b=m-n,h.b=k+(d-k)/4,g.c=h.a=(g.b+h.b)/2,[e,f,g,h]},j=function(a,e,f,g,h){var j,k,l,m,n,o,p,q,r,s,t,u,v,w=a.length-1,x=0,y=a[0].a;for(j=0;w>j;j++)n=a[x],k=n.a,l=n.d,m=a[x+1].d,h?(t=b[j],u=c[j],v=(u+t)*e*.25/(g?.5:d[j]||.5),o=l-(l-k)*(g?.5*e:0!==t?v/t:0),p=l+(m-l)*(g?.5*e:0!==u?v/u:0),q=l-(o+((p-o)*(3*t/(t+u)+.5)/4||0))):(o=l-(l-k)*e*.5,p=l+(m-l)*e*.5,q=l-(o+p)/2),o+=q,p+=q,n.c=r=o,0!==j?n.b=y:n.b=y=n.a+.6*(n.c-n.a),n.da=l-k,n.ca=r-k,n.ba=y-k,f?(s=i(k,y,r,l),a.splice(x,1,s[0],s[1],s[2],s[3]),x+=4):x++,y=p;n=a[x],n.b=y,n.c=y+.4*(n.d-y),n.da=n.d-n.a,n.ca=n.c-n.a,n.ba=y-n.a,f&&(s=i(n.a,y,n.c,n.d),a.splice(x,1,s[0],s[1],s[2],s[3]))},k=function(a,d,e,f){var h,i,j,k,l,m,n=[];if(f)for(a=[f].concat(a),i=a.length;--i>-1;)"string"==typeof(m=a[i][d])&&"="===m.charAt(1)&&(a[i][d]=f[d]+Number(m.charAt(0)+m.substr(2)));if(h=a.length-2,0>h)return n[0]=new g(a[0][d],0,0,a[-1>h?0:1][d]),n;for(i=0;h>i;i++)j=a[i][d],k=a[i+1][d],n[i]=new g(j,0,0,k),e&&(l=a[i+2][d],b[i]=(b[i]||0)+(k-j)*(k-j),c[i]=(c[i]||0)+(l-k)*(l-k));return n[i]=new g(a[i][d],0,0,a[i+1][d]),n},l=function(a,f,g,i,l,m){var n,o,p,q,r,s,t,u,v={},w=[],x=m||a[0];l="string"==typeof l?","+l+",":h,null==f&&(f=1);for(o in a[0])w.push(o);if(a.length>1){for(u=a[a.length-1],t=!0,n=w.length;--n>-1;)if(o=w[n],Math.abs(x[o]-u[o])>.05){t=!1;break}t&&(a=a.concat(),m&&a.unshift(m),a.push(a[1]),m=a[a.length-3])}for(b.length=c.length=d.length=0,n=w.length;--n>-1;)o=w[n],e[o]=-1!==l.indexOf(","+o+","),v[o]=k(a,o,e[o],m);for(n=b.length;--n>-1;)b[n]=Math.sqrt(b[n]),c[n]=Math.sqrt(c[n]);if(!i){for(n=w.length;--n>-1;)if(e[o])for(p=v[w[n]],s=p.length-1,q=0;s>q;q++)r=p[q+1].da/c[q]+p[q].da/b[q]||0,d[q]=(d[q]||0)+r*r;for(n=d.length;--n>-1;)d[n]=Math.sqrt(d[n])}for(n=w.length,q=g?4:1;--n>-1;)o=w[n],p=v[o],j(p,f,g,i,e[o]),t&&(p.splice(0,q),p.splice(p.length-q,q));return v},m=function(a,b,c){b=b||"soft";var d,e,f,h,i,j,k,l,m,n,o,p={},q="cubic"===b?3:2,r="soft"===b,s=[];if(r&&c&&(a=[c].concat(a)),null==a||a.length<q+1)throw"invalid Bezier data";for(m in a[0])s.push(m);for(j=s.length;--j>-1;){for(m=s[j],p[m]=i=[],n=0,l=a.length,k=0;l>k;k++)d=null==c?a[k][m]:"string"==typeof(o=a[k][m])&&"="===o.charAt(1)?c[m]+Number(o.charAt(0)+o.substr(2)):Number(o),r&&k>1&&l-1>k&&(i[n++]=(d+i[n-2])/2),i[n++]=d;for(l=n-q+1,n=0,k=0;l>k;k+=q)d=i[k],e=i[k+1],f=i[k+2],h=2===q?0:i[k+3],i[n++]=o=3===q?new g(d,e,f,h):new g(d,(2*e+d)/3,(2*e+f)/3,f);i.length=n}return p},n=function(a,b,c){for(var d,e,f,g,h,i,j,k,l,m,n,o=1/c,p=a.length;--p>-1;)for(m=a[p],f=m.a,g=m.d-f,
h=m.c-f,i=m.b-f,d=e=0,k=1;c>=k;k++)j=o*k,l=1-j,d=e-(e=(j*j*g+3*l*(j*h+l*i))*j),n=p*c+k-1,b[n]=(b[n]||0)+d*d},o=function(a,b){b=b>>0||6;var c,d,e,f,g=[],h=[],i=0,j=0,k=b-1,l=[],m=[];for(c in a)n(a[c],g,b);for(e=g.length,d=0;e>d;d++)i+=Math.sqrt(g[d]),f=d%b,m[f]=i,f===k&&(j+=i,f=d/b>>0,l[f]=m,h[f]=j,i=0,m=[]);return{length:j,lengths:h,segments:l}},p=_gsScope._gsDefine.plugin({propName:"bezier",priority:-1,version:"1.3.7",API:2,global:!0,init:function(a,b,c){this._target=a,b instanceof Array&&(b={values:b}),this._func={},this._mod={},this._props=[],this._timeRes=null==b.timeResolution?6:parseInt(b.timeResolution,10);var d,e,f,g,h,i=b.values||[],j={},k=i[0],n=b.autoRotate||c.vars.orientToBezier;this._autoRotate=n?n instanceof Array?n:[["x","y","rotation",n===!0?0:Number(n)||0]]:null;for(d in k)this._props.push(d);for(f=this._props.length;--f>-1;)d=this._props[f],this._overwriteProps.push(d),e=this._func[d]="function"==typeof a[d],j[d]=e?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]():parseFloat(a[d]),h||j[d]!==i[0][d]&&(h=j);if(this._beziers="cubic"!==b.type&&"quadratic"!==b.type&&"soft"!==b.type?l(i,isNaN(b.curviness)?1:b.curviness,!1,"thruBasic"===b.type,b.correlate,h):m(i,b.type,j),this._segCount=this._beziers[d].length,this._timeRes){var p=o(this._beziers,this._timeRes);this._length=p.length,this._lengths=p.lengths,this._segments=p.segments,this._l1=this._li=this._s1=this._si=0,this._l2=this._lengths[0],this._curSeg=this._segments[0],this._s2=this._curSeg[0],this._prec=1/this._curSeg.length}if(n=this._autoRotate)for(this._initialRotations=[],n[0]instanceof Array||(this._autoRotate=n=[n]),f=n.length;--f>-1;){for(g=0;3>g;g++)d=n[f][g],this._func[d]="function"==typeof a[d]?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]:!1;d=n[f][2],this._initialRotations[f]=(this._func[d]?this._func[d].call(this._target):this._target[d])||0,this._overwriteProps.push(d)}return this._startRatio=c.vars.runBackwards?1:0,!0},set:function(b){var c,d,e,f,g,h,i,j,k,l,m=this._segCount,n=this._func,o=this._target,p=b!==this._startRatio;if(this._timeRes){if(k=this._lengths,l=this._curSeg,b*=this._length,e=this._li,b>this._l2&&m-1>e){for(j=m-1;j>e&&(this._l2=k[++e])<=b;);this._l1=k[e-1],this._li=e,this._curSeg=l=this._segments[e],this._s2=l[this._s1=this._si=0]}else if(b<this._l1&&e>0){for(;e>0&&(this._l1=k[--e])>=b;);0===e&&b<this._l1?this._l1=0:e++,this._l2=k[e],this._li=e,this._curSeg=l=this._segments[e],this._s1=l[(this._si=l.length-1)-1]||0,this._s2=l[this._si]}if(c=e,b-=this._l1,e=this._si,b>this._s2&&e<l.length-1){for(j=l.length-1;j>e&&(this._s2=l[++e])<=b;);this._s1=l[e-1],this._si=e}else if(b<this._s1&&e>0){for(;e>0&&(this._s1=l[--e])>=b;);0===e&&b<this._s1?this._s1=0:e++,this._s2=l[e],this._si=e}h=(e+(b-this._s1)/(this._s2-this._s1))*this._prec||0}else c=0>b?0:b>=1?m-1:m*b>>0,h=(b-c*(1/m))*m;for(d=1-h,e=this._props.length;--e>-1;)f=this._props[e],g=this._beziers[f][c],i=(h*h*g.da+3*d*(h*g.ca+d*g.ba))*h+g.a,this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i;if(this._autoRotate){var q,r,s,t,u,v,w,x=this._autoRotate;for(e=x.length;--e>-1;)f=x[e][2],v=x[e][3]||0,w=x[e][4]===!0?1:a,g=this._beziers[x[e][0]],q=this._beziers[x[e][1]],g&&q&&(g=g[c],q=q[c],r=g.a+(g.b-g.a)*h,t=g.b+(g.c-g.b)*h,r+=(t-r)*h,t+=(g.c+(g.d-g.c)*h-t)*h,s=q.a+(q.b-q.a)*h,u=q.b+(q.c-q.b)*h,s+=(u-s)*h,u+=(q.c+(q.d-q.c)*h-u)*h,i=p?Math.atan2(u-s,t-r)*w+v:this._initialRotations[e],this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i)}}}),q=p.prototype;p.bezierThrough=l,p.cubicToQuadratic=i,p._autoCSS=!0,p.quadraticToCubic=function(a,b,c){return new g(a,(2*b+a)/3,(2*b+c)/3,c)},p._cssRegister=function(){var a=f.CSSPlugin;if(a){var b=a._internals,c=b._parseToProxy,d=b._setPluginRatio,e=b.CSSPropTween;b._registerComplexSpecialProp("bezier",{parser:function(a,b,f,g,h,i){b instanceof Array&&(b={values:b}),i=new p;var j,k,l,m=b.values,n=m.length-1,o=[],q={};if(0>n)return h;for(j=0;n>=j;j++)l=c(a,m[j],g,h,i,n!==j),o[j]=l.end;for(k in b)q[k]=b[k];return q.values=o,h=new e(a,"bezier",0,0,l.pt,2),h.data=l,h.plugin=i,h.setRatio=d,0===q.autoRotate&&(q.autoRotate=!0),!q.autoRotate||q.autoRotate instanceof Array||(j=q.autoRotate===!0?0:Number(q.autoRotate),q.autoRotate=null!=l.end.left?[["left","top","rotation",j,!1]]:null!=l.end.x?[["x","y","rotation",j,!1]]:!1),q.autoRotate&&(g._transform||g._enableTransforms(!1),l.autoRotate=g._target._gsTransform,l.proxy.rotation=l.autoRotate.rotation||0,g._overwriteProps.push("rotation")),i._onInitTween(l.proxy,q,g._tween),h}})}},q._mod=function(a){for(var b,c=this._overwriteProps,d=c.length;--d>-1;)b=a[c[d]],b&&"function"==typeof b&&(this._mod[c[d]]=b)},q._kill=function(a){var b,c,d=this._props;for(b in this._beziers)if(b in a)for(delete this._beziers[b],delete this._func[b],c=d.length;--c>-1;)d[c]===b&&d.splice(c,1);if(d=this._autoRotate)for(c=d.length;--c>-1;)a[d[c][2]]&&d.splice(c,1);return this._super._kill.call(this,a)}}(),_gsScope._gsDefine("plugins.CSSPlugin",["plugins.TweenPlugin","TweenLite"],function(a,b){var c,d,e,f,g=function(){a.call(this,"css"),this._overwriteProps.length=0,this.setRatio=g.prototype.setRatio},h=_gsScope._gsDefine.globals,i={},j=g.prototype=new a("css");j.constructor=g,g.version="1.19.1",g.API=2,g.defaultTransformPerspective=0,g.defaultSkewType="compensated",g.defaultSmoothOrigin=!0,j="px",g.suffixMap={top:j,right:j,bottom:j,left:j,width:j,height:j,fontSize:j,padding:j,margin:j,perspective:j,lineHeight:""};var k,l,m,n,o,p,q,r,s=/(?:\-|\.|\b)(\d|\.|e\-)+/g,t=/(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,u=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,v=/(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,w=/(?:\d|\-|\+|=|#|\.)*/g,x=/opacity *= *([^)]*)/i,y=/opacity:([^;]*)/i,z=/alpha\(opacity *=.+?\)/i,A=/^(rgb|hsl)/,B=/([A-Z])/g,C=/-([a-z])/gi,D=/(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,E=function(a,b){return b.toUpperCase()},F=/(?:Left|Right|Width)/i,G=/(M11|M12|M21|M22)=[\d\-\.e]+/gi,H=/progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,I=/,(?=[^\)]*(?:\(|$))/gi,J=/[\s,\(]/i,K=Math.PI/180,L=180/Math.PI,M={},N={style:{}},O=_gsScope.document||{createElement:function(){return N}},P=function(a,b){return O.createElementNS?O.createElementNS(b||"http://www.w3.org/1999/xhtml",a):O.createElement(a)},Q=P("div"),R=P("img"),S=g._internals={_specialProps:i},T=(_gsScope.navigator||{}).userAgent||"",U=function(){var a=T.indexOf("Android"),b=P("a");return m=-1!==T.indexOf("Safari")&&-1===T.indexOf("Chrome")&&(-1===a||parseFloat(T.substr(a+8,2))>3),o=m&&parseFloat(T.substr(T.indexOf("Version/")+8,2))<6,n=-1!==T.indexOf("Firefox"),(/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(T)||/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(T))&&(p=parseFloat(RegExp.$1)),b?(b.style.cssText="top:1px;opacity:.55;",/^0.55/.test(b.style.opacity)):!1}(),V=function(a){return x.test("string"==typeof a?a:(a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?parseFloat(RegExp.$1)/100:1},W=function(a){_gsScope.console&&console.log(a)},X="",Y="",Z=function(a,b){b=b||Q;var c,d,e=b.style;if(void 0!==e[a])return a;for(a=a.charAt(0).toUpperCase()+a.substr(1),c=["O","Moz","ms","Ms","Webkit"],d=5;--d>-1&&void 0===e[c[d]+a];);return d>=0?(Y=3===d?"ms":c[d],X="-"+Y.toLowerCase()+"-",Y+a):null},$=O.defaultView?O.defaultView.getComputedStyle:function(){},_=g.getStyle=function(a,b,c,d,e){var f;return U||"opacity"!==b?(!d&&a.style[b]?f=a.style[b]:(c=c||$(a))?f=c[b]||c.getPropertyValue(b)||c.getPropertyValue(b.replace(B,"-$1").toLowerCase()):a.currentStyle&&(f=a.currentStyle[b]),null==e||f&&"none"!==f&&"auto"!==f&&"auto auto"!==f?f:e):V(a)},aa=S.convertToPixels=function(a,c,d,e,f){if("px"===e||!e)return d;if("auto"===e||!d)return 0;var h,i,j,k=F.test(c),l=a,m=Q.style,n=0>d,o=1===d;if(n&&(d=-d),o&&(d*=100),"%"===e&&-1!==c.indexOf("border"))h=d/100*(k?a.clientWidth:a.clientHeight);else{if(m.cssText="border:0 solid red;position:"+_(a,"position")+";line-height:0;","%"!==e&&l.appendChild&&"v"!==e.charAt(0)&&"rem"!==e)m[k?"borderLeftWidth":"borderTopWidth"]=d+e;else{if(l=a.parentNode||O.body,i=l._gsCache,j=b.ticker.frame,i&&k&&i.time===j)return i.width*d/100;m[k?"width":"height"]=d+e}l.appendChild(Q),h=parseFloat(Q[k?"offsetWidth":"offsetHeight"]),l.removeChild(Q),k&&"%"===e&&g.cacheWidths!==!1&&(i=l._gsCache=l._gsCache||{},i.time=j,i.width=h/d*100),0!==h||f||(h=aa(a,c,d,e,!0))}return o&&(h/=100),n?-h:h},ba=S.calculateOffset=function(a,b,c){if("absolute"!==_(a,"position",c))return 0;var d="left"===b?"Left":"Top",e=_(a,"margin"+d,c);return a["offset"+d]-(aa(a,b,parseFloat(e),e.replace(w,""))||0)},ca=function(a,b){var c,d,e,f={};if(b=b||$(a,null))if(c=b.length)for(;--c>-1;)e=b[c],(-1===e.indexOf("-transform")||Da===e)&&(f[e.replace(C,E)]=b.getPropertyValue(e));else for(c in b)(-1===c.indexOf("Transform")||Ca===c)&&(f[c]=b[c]);else if(b=a.currentStyle||a.style)for(c in b)"string"==typeof c&&void 0===f[c]&&(f[c.replace(C,E)]=b[c]);return U||(f.opacity=V(a)),d=Ra(a,b,!1),f.rotation=d.rotation,f.skewX=d.skewX,f.scaleX=d.scaleX,f.scaleY=d.scaleY,f.x=d.x,f.y=d.y,Fa&&(f.z=d.z,f.rotationX=d.rotationX,f.rotationY=d.rotationY,f.scaleZ=d.scaleZ),f.filters&&delete f.filters,f},da=function(a,b,c,d,e){var f,g,h,i={},j=a.style;for(g in c)"cssText"!==g&&"length"!==g&&isNaN(g)&&(b[g]!==(f=c[g])||e&&e[g])&&-1===g.indexOf("Origin")&&("number"==typeof f||"string"==typeof f)&&(i[g]="auto"!==f||"left"!==g&&"top"!==g?""!==f&&"auto"!==f&&"none"!==f||"string"!=typeof b[g]||""===b[g].replace(v,"")?f:0:ba(a,g),void 0!==j[g]&&(h=new sa(j,g,j[g],h)));if(d)for(g in d)"className"!==g&&(i[g]=d[g]);return{difs:i,firstMPT:h}},ea={width:["Left","Right"],height:["Top","Bottom"]},fa=["marginLeft","marginRight","marginTop","marginBottom"],ga=function(a,b,c){if("svg"===(a.nodeName+"").toLowerCase())return(c||$(a))[b]||0;if(a.getCTM&&Oa(a))return a.getBBox()[b]||0;var d=parseFloat("width"===b?a.offsetWidth:a.offsetHeight),e=ea[b],f=e.length;for(c=c||$(a,null);--f>-1;)d-=parseFloat(_(a,"padding"+e[f],c,!0))||0,d-=parseFloat(_(a,"border"+e[f]+"Width",c,!0))||0;return d},ha=function(a,b){if("contain"===a||"auto"===a||"auto auto"===a)return a+" ";(null==a||""===a)&&(a="0 0");var c,d=a.split(" "),e=-1!==a.indexOf("left")?"0%":-1!==a.indexOf("right")?"100%":d[0],f=-1!==a.indexOf("top")?"0%":-1!==a.indexOf("bottom")?"100%":d[1];if(d.length>3&&!b){for(d=a.split(", ").join(",").split(","),a=[],c=0;c<d.length;c++)a.push(ha(d[c]));return a.join(",")}return null==f?f="center"===e?"50%":"0":"center"===f&&(f="50%"),("center"===e||isNaN(parseFloat(e))&&-1===(e+"").indexOf("="))&&(e="50%"),a=e+" "+f+(d.length>2?" "+d[2]:""),b&&(b.oxp=-1!==e.indexOf("%"),b.oyp=-1!==f.indexOf("%"),b.oxr="="===e.charAt(1),b.oyr="="===f.charAt(1),b.ox=parseFloat(e.replace(v,"")),b.oy=parseFloat(f.replace(v,"")),b.v=a),b||a},ia=function(a,b){return"function"==typeof a&&(a=a(r,q)),"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2)):parseFloat(a)-parseFloat(b)||0},ja=function(a,b){return"function"==typeof a&&(a=a(r,q)),null==a?b:"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2))+b:parseFloat(a)||0},ka=function(a,b,c,d){var e,f,g,h,i,j=1e-6;return"function"==typeof a&&(a=a(r,q)),null==a?h=b:"number"==typeof a?h=a:(e=360,f=a.split("_"),i="="===a.charAt(1),g=(i?parseInt(a.charAt(0)+"1",10)*parseFloat(f[0].substr(2)):parseFloat(f[0]))*(-1===a.indexOf("rad")?1:L)-(i?0:b),f.length&&(d&&(d[c]=b+g),-1!==a.indexOf("short")&&(g%=e,g!==g%(e/2)&&(g=0>g?g+e:g-e)),-1!==a.indexOf("_cw")&&0>g?g=(g+9999999999*e)%e-(g/e|0)*e:-1!==a.indexOf("ccw")&&g>0&&(g=(g-9999999999*e)%e-(g/e|0)*e)),h=b+g),j>h&&h>-j&&(h=0),h},la={aqua:[0,255,255],lime:[0,255,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,255],navy:[0,0,128],white:[255,255,255],fuchsia:[255,0,255],olive:[128,128,0],yellow:[255,255,0],orange:[255,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[255,0,0],pink:[255,192,203],cyan:[0,255,255],transparent:[255,255,255,0]},ma=function(a,b,c){return a=0>a?a+1:a>1?a-1:a,255*(1>6*a?b+(c-b)*a*6:.5>a?c:2>3*a?b+(c-b)*(2/3-a)*6:b)+.5|0},na=g.parseColor=function(a,b){var c,d,e,f,g,h,i,j,k,l,m;if(a)if("number"==typeof a)c=[a>>16,a>>8&255,255&a];else{if(","===a.charAt(a.length-1)&&(a=a.substr(0,a.length-1)),la[a])c=la[a];else if("#"===a.charAt(0))4===a.length&&(d=a.charAt(1),e=a.charAt(2),f=a.charAt(3),a="#"+d+d+e+e+f+f),a=parseInt(a.substr(1),16),c=[a>>16,a>>8&255,255&a];else if("hsl"===a.substr(0,3))if(c=m=a.match(s),b){if(-1!==a.indexOf("="))return a.match(t)}else g=Number(c[0])%360/360,h=Number(c[1])/100,i=Number(c[2])/100,e=.5>=i?i*(h+1):i+h-i*h,d=2*i-e,c.length>3&&(c[3]=Number(a[3])),c[0]=ma(g+1/3,d,e),c[1]=ma(g,d,e),c[2]=ma(g-1/3,d,e);else c=a.match(s)||la.transparent;c[0]=Number(c[0]),c[1]=Number(c[1]),c[2]=Number(c[2]),c.length>3&&(c[3]=Number(c[3]))}else c=la.black;return b&&!m&&(d=c[0]/255,e=c[1]/255,f=c[2]/255,j=Math.max(d,e,f),k=Math.min(d,e,f),i=(j+k)/2,j===k?g=h=0:(l=j-k,h=i>.5?l/(2-j-k):l/(j+k),g=j===d?(e-f)/l+(f>e?6:0):j===e?(f-d)/l+2:(d-e)/l+4,g*=60),c[0]=g+.5|0,c[1]=100*h+.5|0,c[2]=100*i+.5|0),c},oa=function(a,b){var c,d,e,f=a.match(pa)||[],g=0,h=f.length?"":a;for(c=0;c<f.length;c++)d=f[c],e=a.substr(g,a.indexOf(d,g)-g),g+=e.length+d.length,d=na(d,b),3===d.length&&d.push(1),h+=e+(b?"hsla("+d[0]+","+d[1]+"%,"+d[2]+"%,"+d[3]:"rgba("+d.join(","))+")";return h+a.substr(g)},pa="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";for(j in la)pa+="|"+j+"\\b";pa=new RegExp(pa+")","gi"),g.colorStringFilter=function(a){var b,c=a[0]+a[1];pa.test(c)&&(b=-1!==c.indexOf("hsl(")||-1!==c.indexOf("hsla("),a[0]=oa(a[0],b),a[1]=oa(a[1],b)),pa.lastIndex=0},b.defaultStringFilter||(b.defaultStringFilter=g.colorStringFilter);var qa=function(a,b,c,d){if(null==a)return function(a){return a};var e,f=b?(a.match(pa)||[""])[0]:"",g=a.split(f).join("").match(u)||[],h=a.substr(0,a.indexOf(g[0])),i=")"===a.charAt(a.length-1)?")":"",j=-1!==a.indexOf(" ")?" ":",",k=g.length,l=k>0?g[0].replace(s,""):"";return k?e=b?function(a){var b,m,n,o;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(o=a.replace(I,"|").split("|"),n=0;n<o.length;n++)o[n]=e(o[n]);return o.join(",")}if(b=(a.match(pa)||[f])[0],m=a.split(b).join("").match(u)||[],n=m.length,k>n--)for(;++n<k;)m[n]=c?m[(n-1)/2|0]:g[n];return h+m.join(j)+j+b+i+(-1!==a.indexOf("inset")?" inset":"")}:function(a){var b,f,m;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(f=a.replace(I,"|").split("|"),m=0;m<f.length;m++)f[m]=e(f[m]);return f.join(",")}if(b=a.match(u)||[],m=b.length,k>m--)for(;++m<k;)b[m]=c?b[(m-1)/2|0]:g[m];return h+b.join(j)+i}:function(a){return a}},ra=function(a){return a=a.split(","),function(b,c,d,e,f,g,h){var i,j=(c+"").split(" ");for(h={},i=0;4>i;i++)h[a[i]]=j[i]=j[i]||j[(i-1)/2>>0];return e.parse(b,h,f,g)}},sa=(S._setPluginRatio=function(a){this.plugin.setRatio(a);for(var b,c,d,e,f,g=this.data,h=g.proxy,i=g.firstMPT,j=1e-6;i;)b=h[i.v],i.r?b=Math.round(b):j>b&&b>-j&&(b=0),i.t[i.p]=b,i=i._next;if(g.autoRotate&&(g.autoRotate.rotation=g.mod?g.mod(h.rotation,this.t):h.rotation),1===a||0===a)for(i=g.firstMPT,f=1===a?"e":"b";i;){if(c=i.t,c.type){if(1===c.type){for(e=c.xs0+c.s+c.xs1,d=1;d<c.l;d++)e+=c["xn"+d]+c["xs"+(d+1)];c[f]=e}}else c[f]=c.s+c.xs0;i=i._next}},function(a,b,c,d,e){this.t=a,this.p=b,this.v=c,this.r=e,d&&(d._prev=this,this._next=d)}),ta=(S._parseToProxy=function(a,b,c,d,e,f){var g,h,i,j,k,l=d,m={},n={},o=c._transform,p=M;for(c._transform=null,M=b,d=k=c.parse(a,b,d,e),M=p,f&&(c._transform=o,l&&(l._prev=null,l._prev&&(l._prev._next=null)));d&&d!==l;){if(d.type<=1&&(h=d.p,n[h]=d.s+d.c,m[h]=d.s,f||(j=new sa(d,"s",h,j,d.r),d.c=0),1===d.type))for(g=d.l;--g>0;)i="xn"+g,h=d.p+"_"+i,n[h]=d.data[i],m[h]=d[i],f||(j=new sa(d,i,h,j,d.rxp[i]));d=d._next}return{proxy:m,end:n,firstMPT:j,pt:k}},S.CSSPropTween=function(a,b,d,e,g,h,i,j,k,l,m){this.t=a,this.p=b,this.s=d,this.c=e,this.n=i||b,a instanceof ta||f.push(this.n),this.r=j,this.type=h||0,k&&(this.pr=k,c=!0),this.b=void 0===l?d:l,this.e=void 0===m?d+e:m,g&&(this._next=g,g._prev=this)}),ua=function(a,b,c,d,e,f){var g=new ta(a,b,c,d-c,e,-1,f);return g.b=c,g.e=g.xs0=d,g},va=g.parseComplex=function(a,b,c,d,e,f,h,i,j,l){c=c||f||"","function"==typeof d&&(d=d(r,q)),h=new ta(a,b,0,0,h,l?2:1,null,!1,i,c,d),d+="",e&&pa.test(d+c)&&(d=[c,d],g.colorStringFilter(d),c=d[0],d=d[1]);var m,n,o,p,u,v,w,x,y,z,A,B,C,D=c.split(", ").join(",").split(" "),E=d.split(", ").join(",").split(" "),F=D.length,G=k!==!1;for((-1!==d.indexOf(",")||-1!==c.indexOf(","))&&(D=D.join(" ").replace(I,", ").split(" "),E=E.join(" ").replace(I,", ").split(" "),F=D.length),F!==E.length&&(D=(f||"").split(" "),F=D.length),h.plugin=j,h.setRatio=l,pa.lastIndex=0,m=0;F>m;m++)if(p=D[m],u=E[m],x=parseFloat(p),x||0===x)h.appendXtra("",x,ia(u,x),u.replace(t,""),G&&-1!==u.indexOf("px"),!0);else if(e&&pa.test(p))B=u.indexOf(")")+1,B=")"+(B?u.substr(B):""),C=-1!==u.indexOf("hsl")&&U,p=na(p,C),u=na(u,C),y=p.length+u.length>6,y&&!U&&0===u[3]?(h["xs"+h.l]+=h.l?" transparent":"transparent",h.e=h.e.split(E[m]).join("transparent")):(U||(y=!1),C?h.appendXtra(y?"hsla(":"hsl(",p[0],ia(u[0],p[0]),",",!1,!0).appendXtra("",p[1],ia(u[1],p[1]),"%,",!1).appendXtra("",p[2],ia(u[2],p[2]),y?"%,":"%"+B,!1):h.appendXtra(y?"rgba(":"rgb(",p[0],u[0]-p[0],",",!0,!0).appendXtra("",p[1],u[1]-p[1],",",!0).appendXtra("",p[2],u[2]-p[2],y?",":B,!0),y&&(p=p.length<4?1:p[3],h.appendXtra("",p,(u.length<4?1:u[3])-p,B,!1))),pa.lastIndex=0;else if(v=p.match(s)){if(w=u.match(t),!w||w.length!==v.length)return h;for(o=0,n=0;n<v.length;n++)A=v[n],z=p.indexOf(A,o),h.appendXtra(p.substr(o,z-o),Number(A),ia(w[n],A),"",G&&"px"===p.substr(z+A.length,2),0===n),o=z+A.length;h["xs"+h.l]+=p.substr(o)}else h["xs"+h.l]+=h.l||h["xs"+h.l]?" "+u:u;if(-1!==d.indexOf("=")&&h.data){for(B=h.xs0+h.data.s,m=1;m<h.l;m++)B+=h["xs"+m]+h.data["xn"+m];h.e=B+h["xs"+m]}return h.l||(h.type=-1,h.xs0=h.e),h.xfirst||h},wa=9;for(j=ta.prototype,j.l=j.pr=0;--wa>0;)j["xn"+wa]=0,j["xs"+wa]="";j.xs0="",j._next=j._prev=j.xfirst=j.data=j.plugin=j.setRatio=j.rxp=null,j.appendXtra=function(a,b,c,d,e,f){var g=this,h=g.l;return g["xs"+h]+=f&&(h||g["xs"+h])?" "+a:a||"",c||0===h||g.plugin?(g.l++,g.type=g.setRatio?2:1,g["xs"+g.l]=d||"",h>0?(g.data["xn"+h]=b+c,g.rxp["xn"+h]=e,g["xn"+h]=b,g.plugin||(g.xfirst=new ta(g,"xn"+h,b,c,g.xfirst||g,0,g.n,e,g.pr),g.xfirst.xs0=0),g):(g.data={s:b+c},g.rxp={},g.s=b,g.c=c,g.r=e,g)):(g["xs"+h]+=b+(d||""),g)};var xa=function(a,b){b=b||{},this.p=b.prefix?Z(a)||a:a,i[a]=i[this.p]=this,this.format=b.formatter||qa(b.defaultValue,b.color,b.collapsible,b.multi),b.parser&&(this.parse=b.parser),this.clrs=b.color,this.multi=b.multi,this.keyword=b.keyword,this.dflt=b.defaultValue,this.pr=b.priority||0},ya=S._registerComplexSpecialProp=function(a,b,c){"object"!=typeof b&&(b={parser:c});var d,e,f=a.split(","),g=b.defaultValue;for(c=c||[g],d=0;d<f.length;d++)b.prefix=0===d&&b.prefix,b.defaultValue=c[d]||g,e=new xa(f[d],b)},za=S._registerPluginProp=function(a){if(!i[a]){var b=a.charAt(0).toUpperCase()+a.substr(1)+"Plugin";ya(a,{parser:function(a,c,d,e,f,g,j){var k=h.com.greensock.plugins[b];return k?(k._cssRegister(),i[d].parse(a,c,d,e,f,g,j)):(W("Error: "+b+" js file not loaded."),f)}})}};j=xa.prototype,j.parseComplex=function(a,b,c,d,e,f){var g,h,i,j,k,l,m=this.keyword;if(this.multi&&(I.test(c)||I.test(b)?(h=b.replace(I,"|").split("|"),i=c.replace(I,"|").split("|")):m&&(h=[b],i=[c])),i){for(j=i.length>h.length?i.length:h.length,g=0;j>g;g++)b=h[g]=h[g]||this.dflt,c=i[g]=i[g]||this.dflt,m&&(k=b.indexOf(m),l=c.indexOf(m),k!==l&&(-1===l?h[g]=h[g].split(m).join(""):-1===k&&(h[g]+=" "+m)));b=h.join(", "),c=i.join(", ")}return va(a,this.p,b,c,this.clrs,this.dflt,d,this.pr,e,f)},j.parse=function(a,b,c,d,f,g,h){return this.parseComplex(a.style,this.format(_(a,this.p,e,!1,this.dflt)),this.format(b),f,g)},g.registerSpecialProp=function(a,b,c){ya(a,{parser:function(a,d,e,f,g,h,i){var j=new ta(a,e,0,0,g,2,e,!1,c);return j.plugin=h,j.setRatio=b(a,d,f._tween,e),j},priority:c})},g.useSVGTransformAttr=!0;var Aa,Ba="scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),Ca=Z("transform"),Da=X+"transform",Ea=Z("transformOrigin"),Fa=null!==Z("perspective"),Ga=S.Transform=function(){this.perspective=parseFloat(g.defaultTransformPerspective)||0,this.force3D=g.defaultForce3D!==!1&&Fa?g.defaultForce3D||"auto":!1},Ha=_gsScope.SVGElement,Ia=function(a,b,c){var d,e=O.createElementNS("http://www.w3.org/2000/svg",a),f=/([a-z])([A-Z])/g;for(d in c)e.setAttributeNS(null,d.replace(f,"$1-$2").toLowerCase(),c[d]);return b.appendChild(e),e},Ja=O.documentElement||{},Ka=function(){var a,b,c,d=p||/Android/i.test(T)&&!_gsScope.chrome;return O.createElementNS&&!d&&(a=Ia("svg",Ja),b=Ia("rect",a,{width:100,height:50,x:100}),c=b.getBoundingClientRect().width,b.style[Ea]="50% 50%",b.style[Ca]="scaleX(0.5)",d=c===b.getBoundingClientRect().width&&!(n&&Fa),Ja.removeChild(a)),d}(),La=function(a,b,c,d,e,f){var h,i,j,k,l,m,n,o,p,q,r,s,t,u,v=a._gsTransform,w=Qa(a,!0);v&&(t=v.xOrigin,u=v.yOrigin),(!d||(h=d.split(" ")).length<2)&&(n=a.getBBox(),0===n.x&&0===n.y&&n.width+n.height===0&&(n={x:parseFloat(a.hasAttribute("x")?a.getAttribute("x"):a.hasAttribute("cx")?a.getAttribute("cx"):0)||0,y:parseFloat(a.hasAttribute("y")?a.getAttribute("y"):a.hasAttribute("cy")?a.getAttribute("cy"):0)||0,width:0,height:0}),b=ha(b).split(" "),h=[(-1!==b[0].indexOf("%")?parseFloat(b[0])/100*n.width:parseFloat(b[0]))+n.x,(-1!==b[1].indexOf("%")?parseFloat(b[1])/100*n.height:parseFloat(b[1]))+n.y]),c.xOrigin=k=parseFloat(h[0]),c.yOrigin=l=parseFloat(h[1]),d&&w!==Pa&&(m=w[0],n=w[1],o=w[2],p=w[3],q=w[4],r=w[5],s=m*p-n*o,s&&(i=k*(p/s)+l*(-o/s)+(o*r-p*q)/s,j=k*(-n/s)+l*(m/s)-(m*r-n*q)/s,k=c.xOrigin=h[0]=i,l=c.yOrigin=h[1]=j)),v&&(f&&(c.xOffset=v.xOffset,c.yOffset=v.yOffset,v=c),e||e!==!1&&g.defaultSmoothOrigin!==!1?(i=k-t,j=l-u,v.xOffset+=i*w[0]+j*w[2]-i,v.yOffset+=i*w[1]+j*w[3]-j):v.xOffset=v.yOffset=0),f||a.setAttribute("data-svg-origin",h.join(" "))},Ma=function(a){var b,c=P("svg",this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),d=this.parentNode,e=this.nextSibling,f=this.style.cssText;if(Ja.appendChild(c),c.appendChild(this),this.style.display="block",a)try{b=this.getBBox(),this._originalGetBBox=this.getBBox,this.getBBox=Ma}catch(g){}else this._originalGetBBox&&(b=this._originalGetBBox());return e?d.insertBefore(this,e):d.appendChild(this),Ja.removeChild(c),this.style.cssText=f,b},Na=function(a){try{return a.getBBox()}catch(b){return Ma.call(a,!0)}},Oa=function(a){return!(!(Ha&&a.getCTM&&Na(a))||a.parentNode&&!a.ownerSVGElement)},Pa=[1,0,0,1,0,0],Qa=function(a,b){var c,d,e,f,g,h,i=a._gsTransform||new Ga,j=1e5,k=a.style;if(Ca?d=_(a,Da,null,!0):a.currentStyle&&(d=a.currentStyle.filter.match(G),d=d&&4===d.length?[d[0].substr(4),Number(d[2].substr(4)),Number(d[1].substr(4)),d[3].substr(4),i.x||0,i.y||0].join(","):""),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,c&&Ca&&((h="none"===$(a).display)||!a.parentNode)&&(h&&(f=k.display,k.display="block"),a.parentNode||(g=1,Ja.appendChild(a)),d=_(a,Da,null,!0),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,f?k.display=f:h&&Va(k,"display"),g&&Ja.removeChild(a)),(i.svg||a.getCTM&&Oa(a))&&(c&&-1!==(k[Ca]+"").indexOf("matrix")&&(d=k[Ca],c=0),e=a.getAttribute("transform"),c&&e&&(-1!==e.indexOf("matrix")?(d=e,c=0):-1!==e.indexOf("translate")&&(d="matrix(1,0,0,1,"+e.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",")+")",c=0))),c)return Pa;for(e=(d||"").match(s)||[],wa=e.length;--wa>-1;)f=Number(e[wa]),e[wa]=(g=f-(f|=0))?(g*j+(0>g?-.5:.5)|0)/j+f:f;return b&&e.length>6?[e[0],e[1],e[4],e[5],e[12],e[13]]:e},Ra=S.getTransform=function(a,c,d,e){if(a._gsTransform&&d&&!e)return a._gsTransform;var f,h,i,j,k,l,m=d?a._gsTransform||new Ga:new Ga,n=m.scaleX<0,o=2e-5,p=1e5,q=Fa?parseFloat(_(a,Ea,c,!1,"0 0 0").split(" ")[2])||m.zOrigin||0:0,r=parseFloat(g.defaultTransformPerspective)||0;if(m.svg=!(!a.getCTM||!Oa(a)),m.svg&&(La(a,_(a,Ea,c,!1,"50% 50%")+"",m,a.getAttribute("data-svg-origin")),Aa=g.useSVGTransformAttr||Ka),f=Qa(a),f!==Pa){if(16===f.length){var s,t,u,v,w,x=f[0],y=f[1],z=f[2],A=f[3],B=f[4],C=f[5],D=f[6],E=f[7],F=f[8],G=f[9],H=f[10],I=f[12],J=f[13],K=f[14],M=f[11],N=Math.atan2(D,H);m.zOrigin&&(K=-m.zOrigin,I=F*K-f[12],J=G*K-f[13],K=H*K+m.zOrigin-f[14]),m.rotationX=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=B*v+F*w,t=C*v+G*w,u=D*v+H*w,F=B*-w+F*v,G=C*-w+G*v,H=D*-w+H*v,M=E*-w+M*v,B=s,C=t,D=u),N=Math.atan2(-z,H),m.rotationY=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=x*v-F*w,t=y*v-G*w,u=z*v-H*w,G=y*w+G*v,H=z*w+H*v,M=A*w+M*v,x=s,y=t,z=u),N=Math.atan2(y,x),m.rotation=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),x=x*v+B*w,t=y*v+C*w,C=y*-w+C*v,D=z*-w+D*v,y=t),m.rotationX&&Math.abs(m.rotationX)+Math.abs(m.rotation)>359.9&&(m.rotationX=m.rotation=0,m.rotationY=180-m.rotationY),m.scaleX=(Math.sqrt(x*x+y*y)*p+.5|0)/p,m.scaleY=(Math.sqrt(C*C+G*G)*p+.5|0)/p,m.scaleZ=(Math.sqrt(D*D+H*H)*p+.5|0)/p,m.rotationX||m.rotationY?m.skewX=0:(m.skewX=B||C?Math.atan2(B,C)*L+m.rotation:m.skewX||0,Math.abs(m.skewX)>90&&Math.abs(m.skewX)<270&&(n?(m.scaleX*=-1,m.skewX+=m.rotation<=0?180:-180,m.rotation+=m.rotation<=0?180:-180):(m.scaleY*=-1,m.skewX+=m.skewX<=0?180:-180))),m.perspective=M?1/(0>M?-M:M):0,m.x=I,m.y=J,m.z=K,m.svg&&(m.x-=m.xOrigin-(m.xOrigin*x-m.yOrigin*B),m.y-=m.yOrigin-(m.yOrigin*y-m.xOrigin*C))}else if(!Fa||e||!f.length||m.x!==f[4]||m.y!==f[5]||!m.rotationX&&!m.rotationY){var O=f.length>=6,P=O?f[0]:1,Q=f[1]||0,R=f[2]||0,S=O?f[3]:1;m.x=f[4]||0,m.y=f[5]||0,i=Math.sqrt(P*P+Q*Q),j=Math.sqrt(S*S+R*R),k=P||Q?Math.atan2(Q,P)*L:m.rotation||0,l=R||S?Math.atan2(R,S)*L+k:m.skewX||0,Math.abs(l)>90&&Math.abs(l)<270&&(n?(i*=-1,l+=0>=k?180:-180,k+=0>=k?180:-180):(j*=-1,l+=0>=l?180:-180)),m.scaleX=i,m.scaleY=j,m.rotation=k,m.skewX=l,Fa&&(m.rotationX=m.rotationY=m.z=0,m.perspective=r,m.scaleZ=1),m.svg&&(m.x-=m.xOrigin-(m.xOrigin*P+m.yOrigin*R),m.y-=m.yOrigin-(m.xOrigin*Q+m.yOrigin*S))}m.zOrigin=q;for(h in m)m[h]<o&&m[h]>-o&&(m[h]=0)}return d&&(a._gsTransform=m,m.svg&&(Aa&&a.style[Ca]?b.delayedCall(.001,function(){Va(a.style,Ca)}):!Aa&&a.getAttribute("transform")&&b.delayedCall(.001,function(){a.removeAttribute("transform")}))),m},Sa=function(a){var b,c,d=this.data,e=-d.rotation*K,f=e+d.skewX*K,g=1e5,h=(Math.cos(e)*d.scaleX*g|0)/g,i=(Math.sin(e)*d.scaleX*g|0)/g,j=(Math.sin(f)*-d.scaleY*g|0)/g,k=(Math.cos(f)*d.scaleY*g|0)/g,l=this.t.style,m=this.t.currentStyle;if(m){c=i,i=-j,j=-c,b=m.filter,l.filter="";var n,o,q=this.t.offsetWidth,r=this.t.offsetHeight,s="absolute"!==m.position,t="progid:DXImageTransform.Microsoft.Matrix(M11="+h+", M12="+i+", M21="+j+", M22="+k,u=d.x+q*d.xPercent/100,v=d.y+r*d.yPercent/100;if(null!=d.ox&&(n=(d.oxp?q*d.ox*.01:d.ox)-q/2,o=(d.oyp?r*d.oy*.01:d.oy)-r/2,u+=n-(n*h+o*i),v+=o-(n*j+o*k)),s?(n=q/2,o=r/2,t+=", Dx="+(n-(n*h+o*i)+u)+", Dy="+(o-(n*j+o*k)+v)+")"):t+=", sizingMethod='auto expand')",-1!==b.indexOf("DXImageTransform.Microsoft.Matrix(")?l.filter=b.replace(H,t):l.filter=t+" "+b,(0===a||1===a)&&1===h&&0===i&&0===j&&1===k&&(s&&-1===t.indexOf("Dx=0, Dy=0")||x.test(b)&&100!==parseFloat(RegExp.$1)||-1===b.indexOf(b.indexOf("Alpha"))&&l.removeAttribute("filter")),!s){var y,z,A,B=8>p?1:-1;for(n=d.ieOffsetX||0,o=d.ieOffsetY||0,d.ieOffsetX=Math.round((q-((0>h?-h:h)*q+(0>i?-i:i)*r))/2+u),d.ieOffsetY=Math.round((r-((0>k?-k:k)*r+(0>j?-j:j)*q))/2+v),wa=0;4>wa;wa++)z=fa[wa],y=m[z],c=-1!==y.indexOf("px")?parseFloat(y):aa(this.t,z,parseFloat(y),y.replace(w,""))||0,A=c!==d[z]?2>wa?-d.ieOffsetX:-d.ieOffsetY:2>wa?n-d.ieOffsetX:o-d.ieOffsetY,l[z]=(d[z]=Math.round(c-A*(0===wa||2===wa?1:B)))+"px"}}},Ta=S.set3DTransformRatio=S.setTransformRatio=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t,u,v,w,x,y,z=this.data,A=this.t.style,B=z.rotation,C=z.rotationX,D=z.rotationY,E=z.scaleX,F=z.scaleY,G=z.scaleZ,H=z.x,I=z.y,J=z.z,L=z.svg,M=z.perspective,N=z.force3D,O=z.skewY,P=z.skewX;if(O&&(P+=O,B+=O),((1===a||0===a)&&"auto"===N&&(this.tween._totalTime===this.tween._totalDuration||!this.tween._totalTime)||!N)&&!J&&!M&&!D&&!C&&1===G||Aa&&L||!Fa)return void(B||P||L?(B*=K,x=P*K,y=1e5,c=Math.cos(B)*E,f=Math.sin(B)*E,d=Math.sin(B-x)*-F,g=Math.cos(B-x)*F,x&&"simple"===z.skewType&&(b=Math.tan(x-O*K),b=Math.sqrt(1+b*b),d*=b,g*=b,O&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b)),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset,Aa&&(z.xPercent||z.yPercent)&&(q=this.t.getBBox(),H+=.01*z.xPercent*q.width,I+=.01*z.yPercent*q.height),q=1e-6,q>H&&H>-q&&(H=0),q>I&&I>-q&&(I=0)),u=(c*y|0)/y+","+(f*y|0)/y+","+(d*y|0)/y+","+(g*y|0)/y+","+H+","+I+")",L&&Aa?this.t.setAttribute("transform","matrix("+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+E+",0,0,"+F+","+H+","+I+")");if(n&&(q=1e-4,q>E&&E>-q&&(E=G=2e-5),q>F&&F>-q&&(F=G=2e-5),!M||z.z||z.rotationX||z.rotationY||(M=0)),B||P)B*=K,r=c=Math.cos(B),s=f=Math.sin(B),P&&(B-=P*K,r=Math.cos(B),s=Math.sin(B),"simple"===z.skewType&&(b=Math.tan((P-O)*K),b=Math.sqrt(1+b*b),r*=b,s*=b,z.skewY&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b))),d=-s,g=r;else{if(!(D||C||1!==G||M||L))return void(A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) translate3d(":"translate3d(")+H+"px,"+I+"px,"+J+"px)"+(1!==E||1!==F?" scale("+E+","+F+")":""));c=g=1,d=f=0}k=1,e=h=i=j=l=m=0,o=M?-1/M:0,p=z.zOrigin,q=1e-6,v=",",w="0",B=D*K,B&&(r=Math.cos(B),s=Math.sin(B),i=-s,l=o*-s,e=c*s,h=f*s,k=r,o*=r,c*=r,f*=r),B=C*K,B&&(r=Math.cos(B),s=Math.sin(B),b=d*r+e*s,t=g*r+h*s,j=k*s,m=o*s,e=d*-s+e*r,h=g*-s+h*r,k*=r,o*=r,d=b,g=t),1!==G&&(e*=G,h*=G,k*=G,o*=G),1!==F&&(d*=F,g*=F,j*=F,m*=F),1!==E&&(c*=E,f*=E,i*=E,l*=E),(p||L)&&(p&&(H+=e*-p,I+=h*-p,J+=k*-p+p),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset),q>H&&H>-q&&(H=w),q>I&&I>-q&&(I=w),q>J&&J>-q&&(J=0)),u=z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix3d(":"matrix3d(",u+=(q>c&&c>-q?w:c)+v+(q>f&&f>-q?w:f)+v+(q>i&&i>-q?w:i),u+=v+(q>l&&l>-q?w:l)+v+(q>d&&d>-q?w:d)+v+(q>g&&g>-q?w:g),C||D||1!==G?(u+=v+(q>j&&j>-q?w:j)+v+(q>m&&m>-q?w:m)+v+(q>e&&e>-q?w:e),u+=v+(q>h&&h>-q?w:h)+v+(q>k&&k>-q?w:k)+v+(q>o&&o>-q?w:o)+v):u+=",0,0,0,0,1,0,",u+=H+v+I+v+J+v+(M?1+-J/M:1)+")",A[Ca]=u};j=Ga.prototype,j.x=j.y=j.z=j.skewX=j.skewY=j.rotation=j.rotationX=j.rotationY=j.zOrigin=j.xPercent=j.yPercent=j.xOffset=j.yOffset=0,j.scaleX=j.scaleY=j.scaleZ=1,ya("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",{parser:function(a,b,c,d,f,h,i){if(d._lastParsedTransform===i)return f;d._lastParsedTransform=i;var j,k=i.scale&&"function"==typeof i.scale?i.scale:0;"function"==typeof i[c]&&(j=i[c],i[c]=b),k&&(i.scale=k(r,a));var l,m,n,o,p,s,t,u,v,w=a._gsTransform,x=a.style,y=1e-6,z=Ba.length,A=i,B={},C="transformOrigin",D=Ra(a,e,!0,A.parseTransform),E=A.transform&&("function"==typeof A.transform?A.transform(r,q):A.transform);if(d._transform=D,E&&"string"==typeof E&&Ca)m=Q.style,m[Ca]=E,m.display="block",m.position="absolute",O.body.appendChild(Q),l=Ra(Q,null,!1),D.svg&&(s=D.xOrigin,t=D.yOrigin,l.x-=D.xOffset,l.y-=D.yOffset,(A.transformOrigin||A.svgOrigin)&&(E={},La(a,ha(A.transformOrigin),E,A.svgOrigin,A.smoothOrigin,!0),s=E.xOrigin,t=E.yOrigin,l.x-=E.xOffset-D.xOffset,l.y-=E.yOffset-D.yOffset),(s||t)&&(u=Qa(Q,!0),l.x-=s-(s*u[0]+t*u[2]),l.y-=t-(s*u[1]+t*u[3]))),O.body.removeChild(Q),l.perspective||(l.perspective=D.perspective),null!=A.xPercent&&(l.xPercent=ja(A.xPercent,D.xPercent)),null!=A.yPercent&&(l.yPercent=ja(A.yPercent,D.yPercent));else if("object"==typeof A){if(l={scaleX:ja(null!=A.scaleX?A.scaleX:A.scale,D.scaleX),scaleY:ja(null!=A.scaleY?A.scaleY:A.scale,D.scaleY),scaleZ:ja(A.scaleZ,D.scaleZ),x:ja(A.x,D.x),y:ja(A.y,D.y),z:ja(A.z,D.z),xPercent:ja(A.xPercent,D.xPercent),
yPercent:ja(A.yPercent,D.yPercent),perspective:ja(A.transformPerspective,D.perspective)},p=A.directionalRotation,null!=p)if("object"==typeof p)for(m in p)A[m]=p[m];else A.rotation=p;"string"==typeof A.x&&-1!==A.x.indexOf("%")&&(l.x=0,l.xPercent=ja(A.x,D.xPercent)),"string"==typeof A.y&&-1!==A.y.indexOf("%")&&(l.y=0,l.yPercent=ja(A.y,D.yPercent)),l.rotation=ka("rotation"in A?A.rotation:"shortRotation"in A?A.shortRotation+"_short":"rotationZ"in A?A.rotationZ:D.rotation,D.rotation,"rotation",B),Fa&&(l.rotationX=ka("rotationX"in A?A.rotationX:"shortRotationX"in A?A.shortRotationX+"_short":D.rotationX||0,D.rotationX,"rotationX",B),l.rotationY=ka("rotationY"in A?A.rotationY:"shortRotationY"in A?A.shortRotationY+"_short":D.rotationY||0,D.rotationY,"rotationY",B)),l.skewX=ka(A.skewX,D.skewX),l.skewY=ka(A.skewY,D.skewY)}for(Fa&&null!=A.force3D&&(D.force3D=A.force3D,o=!0),D.skewType=A.skewType||D.skewType||g.defaultSkewType,n=D.force3D||D.z||D.rotationX||D.rotationY||l.z||l.rotationX||l.rotationY||l.perspective,n||null==A.scale||(l.scaleZ=1);--z>-1;)v=Ba[z],E=l[v]-D[v],(E>y||-y>E||null!=A[v]||null!=M[v])&&(o=!0,f=new ta(D,v,D[v],E,f),v in B&&(f.e=B[v]),f.xs0=0,f.plugin=h,d._overwriteProps.push(f.n));return E=A.transformOrigin,D.svg&&(E||A.svgOrigin)&&(s=D.xOffset,t=D.yOffset,La(a,ha(E),l,A.svgOrigin,A.smoothOrigin),f=ua(D,"xOrigin",(w?D:l).xOrigin,l.xOrigin,f,C),f=ua(D,"yOrigin",(w?D:l).yOrigin,l.yOrigin,f,C),(s!==D.xOffset||t!==D.yOffset)&&(f=ua(D,"xOffset",w?s:D.xOffset,D.xOffset,f,C),f=ua(D,"yOffset",w?t:D.yOffset,D.yOffset,f,C)),E="0px 0px"),(E||Fa&&n&&D.zOrigin)&&(Ca?(o=!0,v=Ea,E=(E||_(a,v,e,!1,"50% 50%"))+"",f=new ta(x,v,0,0,f,-1,C),f.b=x[v],f.plugin=h,Fa?(m=D.zOrigin,E=E.split(" "),D.zOrigin=(E.length>2&&(0===m||"0px"!==E[2])?parseFloat(E[2]):m)||0,f.xs0=f.e=E[0]+" "+(E[1]||"50%")+" 0px",f=new ta(D,"zOrigin",0,0,f,-1,f.n),f.b=m,f.xs0=f.e=D.zOrigin):f.xs0=f.e=E):ha(E+"",D)),o&&(d._transformType=D.svg&&Aa||!n&&3!==this._transformType?2:3),j&&(i[c]=j),k&&(i.scale=k),f},prefix:!0}),ya("boxShadow",{defaultValue:"0px 0px 0px 0px #999",prefix:!0,color:!0,multi:!0,keyword:"inset"}),ya("borderRadius",{defaultValue:"0px",parser:function(a,b,c,f,g,h){b=this.format(b);var i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],z=a.style;for(q=parseFloat(a.offsetWidth),r=parseFloat(a.offsetHeight),i=b.split(" "),j=0;j<y.length;j++)this.p.indexOf("border")&&(y[j]=Z(y[j])),m=l=_(a,y[j],e,!1,"0px"),-1!==m.indexOf(" ")&&(l=m.split(" "),m=l[0],l=l[1]),n=k=i[j],o=parseFloat(m),t=m.substr((o+"").length),u="="===n.charAt(1),u?(p=parseInt(n.charAt(0)+"1",10),n=n.substr(2),p*=parseFloat(n),s=n.substr((p+"").length-(0>p?1:0))||""):(p=parseFloat(n),s=n.substr((p+"").length)),""===s&&(s=d[c]||t),s!==t&&(v=aa(a,"borderLeft",o,t),w=aa(a,"borderTop",o,t),"%"===s?(m=v/q*100+"%",l=w/r*100+"%"):"em"===s?(x=aa(a,"borderLeft",1,"em"),m=v/x+"em",l=w/x+"em"):(m=v+"px",l=w+"px"),u&&(n=parseFloat(m)+p+s,k=parseFloat(l)+p+s)),g=va(z,y[j],m+" "+l,n+" "+k,!1,"0px",g);return g},prefix:!0,formatter:qa("0px 0px 0px 0px",!1,!0)}),ya("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius",{defaultValue:"0px",parser:function(a,b,c,d,f,g){return va(a.style,c,this.format(_(a,c,e,!1,"0px 0px")),this.format(b),!1,"0px",f)},prefix:!0,formatter:qa("0px 0px",!1,!0)}),ya("backgroundPosition",{defaultValue:"0 0",parser:function(a,b,c,d,f,g){var h,i,j,k,l,m,n="background-position",o=e||$(a,null),q=this.format((o?p?o.getPropertyValue(n+"-x")+" "+o.getPropertyValue(n+"-y"):o.getPropertyValue(n):a.currentStyle.backgroundPositionX+" "+a.currentStyle.backgroundPositionY)||"0 0"),r=this.format(b);if(-1!==q.indexOf("%")!=(-1!==r.indexOf("%"))&&r.split(",").length<2&&(m=_(a,"backgroundImage").replace(D,""),m&&"none"!==m)){for(h=q.split(" "),i=r.split(" "),R.setAttribute("src",m),j=2;--j>-1;)q=h[j],k=-1!==q.indexOf("%"),k!==(-1!==i[j].indexOf("%"))&&(l=0===j?a.offsetWidth-R.width:a.offsetHeight-R.height,h[j]=k?parseFloat(q)/100*l+"px":parseFloat(q)/l*100+"%");q=h.join(" ")}return this.parseComplex(a.style,q,r,f,g)},formatter:ha}),ya("backgroundSize",{defaultValue:"0 0",formatter:function(a){return a+="",ha(-1===a.indexOf(" ")?a+" "+a:a)}}),ya("perspective",{defaultValue:"0px",prefix:!0}),ya("perspectiveOrigin",{defaultValue:"50% 50%",prefix:!0}),ya("transformStyle",{prefix:!0}),ya("backfaceVisibility",{prefix:!0}),ya("userSelect",{prefix:!0}),ya("margin",{parser:ra("marginTop,marginRight,marginBottom,marginLeft")}),ya("padding",{parser:ra("paddingTop,paddingRight,paddingBottom,paddingLeft")}),ya("clip",{defaultValue:"rect(0px,0px,0px,0px)",parser:function(a,b,c,d,f,g){var h,i,j;return 9>p?(i=a.currentStyle,j=8>p?" ":",",h="rect("+i.clipTop+j+i.clipRight+j+i.clipBottom+j+i.clipLeft+")",b=this.format(b).split(",").join(j)):(h=this.format(_(a,this.p,e,!1,this.dflt)),b=this.format(b)),this.parseComplex(a.style,h,b,f,g)}}),ya("textShadow",{defaultValue:"0px 0px 0px #999",color:!0,multi:!0}),ya("autoRound,strictUnits",{parser:function(a,b,c,d,e){return e}}),ya("border",{defaultValue:"0px solid #000",parser:function(a,b,c,d,f,g){var h=_(a,"borderTopWidth",e,!1,"0px"),i=this.format(b).split(" "),j=i[0].replace(w,"");return"px"!==j&&(h=parseFloat(h)/aa(a,"borderTopWidth",1,j)+j),this.parseComplex(a.style,this.format(h+" "+_(a,"borderTopStyle",e,!1,"solid")+" "+_(a,"borderTopColor",e,!1,"#000")),i.join(" "),f,g)},color:!0,formatter:function(a){var b=a.split(" ");return b[0]+" "+(b[1]||"solid")+" "+(a.match(pa)||["#000"])[0]}}),ya("borderWidth",{parser:ra("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}),ya("float,cssFloat,styleFloat",{parser:function(a,b,c,d,e,f){var g=a.style,h="cssFloat"in g?"cssFloat":"styleFloat";return new ta(g,h,0,0,e,-1,c,!1,0,g[h],b)}});var Ua=function(a){var b,c=this.t,d=c.filter||_(this.data,"filter")||"",e=this.s+this.c*a|0;100===e&&(-1===d.indexOf("atrix(")&&-1===d.indexOf("radient(")&&-1===d.indexOf("oader(")?(c.removeAttribute("filter"),b=!_(this.data,"filter")):(c.filter=d.replace(z,""),b=!0)),b||(this.xn1&&(c.filter=d=d||"alpha(opacity="+e+")"),-1===d.indexOf("pacity")?0===e&&this.xn1||(c.filter=d+" alpha(opacity="+e+")"):c.filter=d.replace(x,"opacity="+e))};ya("opacity,alpha,autoAlpha",{defaultValue:"1",parser:function(a,b,c,d,f,g){var h=parseFloat(_(a,"opacity",e,!1,"1")),i=a.style,j="autoAlpha"===c;return"string"==typeof b&&"="===b.charAt(1)&&(b=("-"===b.charAt(0)?-1:1)*parseFloat(b.substr(2))+h),j&&1===h&&"hidden"===_(a,"visibility",e)&&0!==b&&(h=0),U?f=new ta(i,"opacity",h,b-h,f):(f=new ta(i,"opacity",100*h,100*(b-h),f),f.xn1=j?1:0,i.zoom=1,f.type=2,f.b="alpha(opacity="+f.s+")",f.e="alpha(opacity="+(f.s+f.c)+")",f.data=a,f.plugin=g,f.setRatio=Ua),j&&(f=new ta(i,"visibility",0,0,f,-1,null,!1,0,0!==h?"inherit":"hidden",0===b?"hidden":"inherit"),f.xs0="inherit",d._overwriteProps.push(f.n),d._overwriteProps.push(c)),f}});var Va=function(a,b){b&&(a.removeProperty?(("ms"===b.substr(0,2)||"webkit"===b.substr(0,6))&&(b="-"+b),a.removeProperty(b.replace(B,"-$1").toLowerCase())):a.removeAttribute(b))},Wa=function(a){if(this.t._gsClassPT=this,1===a||0===a){this.t.setAttribute("class",0===a?this.b:this.e);for(var b=this.data,c=this.t.style;b;)b.v?c[b.p]=b.v:Va(c,b.p),b=b._next;1===a&&this.t._gsClassPT===this&&(this.t._gsClassPT=null)}else this.t.getAttribute("class")!==this.e&&this.t.setAttribute("class",this.e)};ya("className",{parser:function(a,b,d,f,g,h,i){var j,k,l,m,n,o=a.getAttribute("class")||"",p=a.style.cssText;if(g=f._classNamePT=new ta(a,d,0,0,g,2),g.setRatio=Wa,g.pr=-11,c=!0,g.b=o,k=ca(a,e),l=a._gsClassPT){for(m={},n=l.data;n;)m[n.p]=1,n=n._next;l.setRatio(1)}return a._gsClassPT=g,g.e="="!==b.charAt(1)?b:o.replace(new RegExp("(?:\\s|^)"+b.substr(2)+"(?![\\w-])"),"")+("+"===b.charAt(0)?" "+b.substr(2):""),a.setAttribute("class",g.e),j=da(a,k,ca(a),i,m),a.setAttribute("class",o),g.data=j.firstMPT,a.style.cssText=p,g=g.xfirst=f.parse(a,j.difs,g,h)}});var Xa=function(a){if((1===a||0===a)&&this.data._totalTime===this.data._totalDuration&&"isFromStart"!==this.data.data){var b,c,d,e,f,g=this.t.style,h=i.transform.parse;if("all"===this.e)g.cssText="",e=!0;else for(b=this.e.split(" ").join("").split(","),d=b.length;--d>-1;)c=b[d],i[c]&&(i[c].parse===h?e=!0:c="transformOrigin"===c?Ea:i[c].p),Va(g,c);e&&(Va(g,Ca),f=this.t._gsTransform,f&&(f.svg&&(this.t.removeAttribute("data-svg-origin"),this.t.removeAttribute("transform")),delete this.t._gsTransform))}};for(ya("clearProps",{parser:function(a,b,d,e,f){return f=new ta(a,d,0,0,f,2),f.setRatio=Xa,f.e=b,f.pr=-10,f.data=e._tween,c=!0,f}}),j="bezier,throwProps,physicsProps,physics2D".split(","),wa=j.length;wa--;)za(j[wa]);j=g.prototype,j._firstPT=j._lastParsedTransform=j._transform=null,j._onInitTween=function(a,b,h,j){if(!a.nodeType)return!1;this._target=q=a,this._tween=h,this._vars=b,r=j,k=b.autoRound,c=!1,d=b.suffixMap||g.suffixMap,e=$(a,""),f=this._overwriteProps;var n,p,s,t,u,v,w,x,z,A=a.style;if(l&&""===A.zIndex&&(n=_(a,"zIndex",e),("auto"===n||""===n)&&this._addLazySet(A,"zIndex",0)),"string"==typeof b&&(t=A.cssText,n=ca(a,e),A.cssText=t+";"+b,n=da(a,n,ca(a)).difs,!U&&y.test(b)&&(n.opacity=parseFloat(RegExp.$1)),b=n,A.cssText=t),b.className?this._firstPT=p=i.className.parse(a,b.className,"className",this,null,null,b):this._firstPT=p=this.parse(a,b,null),this._transformType){for(z=3===this._transformType,Ca?m&&(l=!0,""===A.zIndex&&(w=_(a,"zIndex",e),("auto"===w||""===w)&&this._addLazySet(A,"zIndex",0)),o&&this._addLazySet(A,"WebkitBackfaceVisibility",this._vars.WebkitBackfaceVisibility||(z?"visible":"hidden"))):A.zoom=1,s=p;s&&s._next;)s=s._next;x=new ta(a,"transform",0,0,null,2),this._linkCSSP(x,null,s),x.setRatio=Ca?Ta:Sa,x.data=this._transform||Ra(a,e,!0),x.tween=h,x.pr=-1,f.pop()}if(c){for(;p;){for(v=p._next,s=t;s&&s.pr>p.pr;)s=s._next;(p._prev=s?s._prev:u)?p._prev._next=p:t=p,(p._next=s)?s._prev=p:u=p,p=v}this._firstPT=t}return!0},j.parse=function(a,b,c,f){var g,h,j,l,m,n,o,p,s,t,u=a.style;for(g in b)n=b[g],"function"==typeof n&&(n=n(r,q)),h=i[g],h?c=h.parse(a,n,g,this,c,f,b):(m=_(a,g,e)+"",s="string"==typeof n,"color"===g||"fill"===g||"stroke"===g||-1!==g.indexOf("Color")||s&&A.test(n)?(s||(n=na(n),n=(n.length>3?"rgba(":"rgb(")+n.join(",")+")"),c=va(u,g,m,n,!0,"transparent",c,0,f)):s&&J.test(n)?c=va(u,g,m,n,!0,null,c,0,f):(j=parseFloat(m),o=j||0===j?m.substr((j+"").length):"",(""===m||"auto"===m)&&("width"===g||"height"===g?(j=ga(a,g,e),o="px"):"left"===g||"top"===g?(j=ba(a,g,e),o="px"):(j="opacity"!==g?0:1,o="")),t=s&&"="===n.charAt(1),t?(l=parseInt(n.charAt(0)+"1",10),n=n.substr(2),l*=parseFloat(n),p=n.replace(w,"")):(l=parseFloat(n),p=s?n.replace(w,""):""),""===p&&(p=g in d?d[g]:o),n=l||0===l?(t?l+j:l)+p:b[g],o!==p&&""!==p&&(l||0===l)&&j&&(j=aa(a,g,j,o),"%"===p?(j/=aa(a,g,100,"%")/100,b.strictUnits!==!0&&(m=j+"%")):"em"===p||"rem"===p||"vw"===p||"vh"===p?j/=aa(a,g,1,p):"px"!==p&&(l=aa(a,g,l,p),p="px"),t&&(l||0===l)&&(n=l+j+p)),t&&(l+=j),!j&&0!==j||!l&&0!==l?void 0!==u[g]&&(n||n+""!="NaN"&&null!=n)?(c=new ta(u,g,l||j||0,0,c,-1,g,!1,0,m,n),c.xs0="none"!==n||"display"!==g&&-1===g.indexOf("Style")?n:m):W("invalid "+g+" tween value: "+b[g]):(c=new ta(u,g,j,l-j,c,0,g,k!==!1&&("px"===p||"zIndex"===g),0,m,n),c.xs0=p))),f&&c&&!c.plugin&&(c.plugin=f);return c},j.setRatio=function(a){var b,c,d,e=this._firstPT,f=1e-6;if(1!==a||this._tween._time!==this._tween._duration&&0!==this._tween._time)if(a||this._tween._time!==this._tween._duration&&0!==this._tween._time||this._tween._rawPrevTime===-1e-6)for(;e;){if(b=e.c*a+e.s,e.r?b=Math.round(b):f>b&&b>-f&&(b=0),e.type)if(1===e.type)if(d=e.l,2===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2;else if(3===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3;else if(4===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4;else if(5===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4+e.xn4+e.xs5;else{for(c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}else-1===e.type?e.t[e.p]=e.xs0:e.setRatio&&e.setRatio(a);else e.t[e.p]=b+e.xs0;e=e._next}else for(;e;)2!==e.type?e.t[e.p]=e.b:e.setRatio(a),e=e._next;else for(;e;){if(2!==e.type)if(e.r&&-1!==e.type)if(b=Math.round(e.s+e.c),e.type){if(1===e.type){for(d=e.l,c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}}else e.t[e.p]=b+e.xs0;else e.t[e.p]=e.e;else e.setRatio(a);e=e._next}},j._enableTransforms=function(a){this._transform=this._transform||Ra(this._target,e,!0),this._transformType=this._transform.svg&&Aa||!a&&3!==this._transformType?2:3};var Ya=function(a){this.t[this.p]=this.e,this.data._linkCSSP(this,this._next,null,!0)};j._addLazySet=function(a,b,c){var d=this._firstPT=new ta(a,b,0,0,this._firstPT,2);d.e=c,d.setRatio=Ya,d.data=this},j._linkCSSP=function(a,b,c,d){return a&&(b&&(b._prev=a),a._next&&(a._next._prev=a._prev),a._prev?a._prev._next=a._next:this._firstPT===a&&(this._firstPT=a._next,d=!0),c?c._next=a:d||null!==this._firstPT||(this._firstPT=a),a._next=b,a._prev=c),a},j._mod=function(a){for(var b=this._firstPT;b;)"function"==typeof a[b.p]&&a[b.p]===Math.round&&(b.r=1),b=b._next},j._kill=function(b){var c,d,e,f=b;if(b.autoAlpha||b.alpha){f={};for(d in b)f[d]=b[d];f.opacity=1,f.autoAlpha&&(f.visibility=1)}for(b.className&&(c=this._classNamePT)&&(e=c.xfirst,e&&e._prev?this._linkCSSP(e._prev,c._next,e._prev._prev):e===this._firstPT&&(this._firstPT=c._next),c._next&&this._linkCSSP(c._next,c._next._next,e._prev),this._classNamePT=null),c=this._firstPT;c;)c.plugin&&c.plugin!==d&&c.plugin._kill&&(c.plugin._kill(b),d=c.plugin),c=c._next;return a.prototype._kill.call(this,f)};var Za=function(a,b,c){var d,e,f,g;if(a.slice)for(e=a.length;--e>-1;)Za(a[e],b,c);else for(d=a.childNodes,e=d.length;--e>-1;)f=d[e],g=f.type,f.style&&(b.push(ca(f)),c&&c.push(f)),1!==g&&9!==g&&11!==g||!f.childNodes.length||Za(f,b,c)};return g.cascadeTo=function(a,c,d){var e,f,g,h,i=b.to(a,c,d),j=[i],k=[],l=[],m=[],n=b._internals.reservedProps;for(a=i._targets||i.target,Za(a,k,m),i.render(c,!0,!0),Za(a,l),i.render(0,!0,!0),i._enabled(!0),e=m.length;--e>-1;)if(f=da(m[e],k[e],l[e]),f.firstMPT){f=f.difs;for(g in d)n[g]&&(f[g]=d[g]);h={};for(g in f)h[g]=k[e][g];j.push(b.fromTo(m[e],c,h,f))}return j},a.activate([g]),g},!0),function(){var a=_gsScope._gsDefine.plugin({propName:"roundProps",version:"1.6.0",priority:-1,API:2,init:function(a,b,c){return this._tween=c,!0}}),b=function(a){for(;a;)a.f||a.blob||(a.m=Math.round),a=a._next},c=a.prototype;c._onInitAllProps=function(){for(var a,c,d,e=this._tween,f=e.vars.roundProps.join?e.vars.roundProps:e.vars.roundProps.split(","),g=f.length,h={},i=e._propLookup.roundProps;--g>-1;)h[f[g]]=Math.round;for(g=f.length;--g>-1;)for(a=f[g],c=e._firstPT;c;)d=c._next,c.pg?c.t._mod(h):c.n===a&&(2===c.f&&c.t?b(c.t._firstPT):(this._add(c.t,a,c.s,c.c),d&&(d._prev=c._prev),c._prev?c._prev._next=d:e._firstPT===c&&(e._firstPT=d),c._next=c._prev=null,e._propLookup[a]=i)),c=d;return!1},c._add=function(a,b,c,d){this._addTween(a,b,c,c+d,b,Math.round),this._overwriteProps.push(b)}}(),function(){_gsScope._gsDefine.plugin({propName:"attr",API:2,version:"0.6.0",init:function(a,b,c,d){var e,f;if("function"!=typeof a.setAttribute)return!1;for(e in b)f=b[e],"function"==typeof f&&(f=f(d,a)),this._addTween(a,"setAttribute",a.getAttribute(e)+"",f+"",e,!1,e),this._overwriteProps.push(e);return!0}})}(),_gsScope._gsDefine.plugin({propName:"directionalRotation",version:"0.3.0",API:2,init:function(a,b,c,d){"object"!=typeof b&&(b={rotation:b}),this.finals={};var e,f,g,h,i,j,k=b.useRadians===!0?2*Math.PI:360,l=1e-6;for(e in b)"useRadians"!==e&&(h=b[e],"function"==typeof h&&(h=h(d,a)),j=(h+"").split("_"),f=j[0],g=parseFloat("function"!=typeof a[e]?a[e]:a[e.indexOf("set")||"function"!=typeof a["get"+e.substr(3)]?e:"get"+e.substr(3)]()),h=this.finals[e]="string"==typeof f&&"="===f.charAt(1)?g+parseInt(f.charAt(0)+"1",10)*Number(f.substr(2)):Number(f)||0,i=h-g,j.length&&(f=j.join("_"),-1!==f.indexOf("short")&&(i%=k,i!==i%(k/2)&&(i=0>i?i+k:i-k)),-1!==f.indexOf("_cw")&&0>i?i=(i+9999999999*k)%k-(i/k|0)*k:-1!==f.indexOf("ccw")&&i>0&&(i=(i-9999999999*k)%k-(i/k|0)*k)),(i>l||-l>i)&&(this._addTween(a,e,g,g+i,e),this._overwriteProps.push(e)));return!0},set:function(a){var b;if(1!==a)this._super.setRatio.call(this,a);else for(b=this._firstPT;b;)b.f?b.t[b.p](this.finals[b.p]):b.t[b.p]=this.finals[b.p],b=b._next}})._autoCSS=!0,_gsScope._gsDefine("easing.Back",["easing.Ease"],function(a){var b,c,d,e=_gsScope.GreenSockGlobals||_gsScope,f=e.com.greensock,g=2*Math.PI,h=Math.PI/2,i=f._class,j=function(b,c){var d=i("easing."+b,function(){},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,d},k=a.register||function(){},l=function(a,b,c,d,e){var f=i("easing."+a,{easeOut:new b,easeIn:new c,easeInOut:new d},!0);return k(f,a),f},m=function(a,b,c){this.t=a,this.v=b,c&&(this.next=c,c.prev=this,this.c=c.v-b,this.gap=c.t-a)},n=function(b,c){var d=i("easing."+b,function(a){this._p1=a||0===a?a:1.70158,this._p2=1.525*this._p1},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,e.config=function(a){return new d(a)},d},o=l("Back",n("BackOut",function(a){return(a-=1)*a*((this._p1+1)*a+this._p1)+1}),n("BackIn",function(a){return a*a*((this._p1+1)*a-this._p1)}),n("BackInOut",function(a){return(a*=2)<1?.5*a*a*((this._p2+1)*a-this._p2):.5*((a-=2)*a*((this._p2+1)*a+this._p2)+2)})),p=i("easing.SlowMo",function(a,b,c){b=b||0===b?b:.7,null==a?a=.7:a>1&&(a=1),this._p=1!==a?b:0,this._p1=(1-a)/2,this._p2=a,this._p3=this._p1+this._p2,this._calcEnd=c===!0},!0),q=p.prototype=new a;return q.constructor=p,q.getRatio=function(a){var b=a+(.5-a)*this._p;return a<this._p1?this._calcEnd?1-(a=1-a/this._p1)*a:b-(a=1-a/this._p1)*a*a*a*b:a>this._p3?this._calcEnd?1-(a=(a-this._p3)/this._p1)*a:b+(a-b)*(a=(a-this._p3)/this._p1)*a*a*a:this._calcEnd?1:b},p.ease=new p(.7,.7),q.config=p.config=function(a,b,c){return new p(a,b,c)},b=i("easing.SteppedEase",function(a){a=a||1,this._p1=1/a,this._p2=a+1},!0),q=b.prototype=new a,q.constructor=b,q.getRatio=function(a){return 0>a?a=0:a>=1&&(a=.999999999),(this._p2*a>>0)*this._p1},q.config=b.config=function(a){return new b(a)},c=i("easing.RoughEase",function(b){b=b||{};for(var c,d,e,f,g,h,i=b.taper||"none",j=[],k=0,l=0|(b.points||20),n=l,o=b.randomize!==!1,p=b.clamp===!0,q=b.template instanceof a?b.template:null,r="number"==typeof b.strength?.4*b.strength:.4;--n>-1;)c=o?Math.random():1/l*n,d=q?q.getRatio(c):c,"none"===i?e=r:"out"===i?(f=1-c,e=f*f*r):"in"===i?e=c*c*r:.5>c?(f=2*c,e=f*f*.5*r):(f=2*(1-c),e=f*f*.5*r),o?d+=Math.random()*e-.5*e:n%2?d+=.5*e:d-=.5*e,p&&(d>1?d=1:0>d&&(d=0)),j[k++]={x:c,y:d};for(j.sort(function(a,b){return a.x-b.x}),h=new m(1,1,null),n=l;--n>-1;)g=j[n],h=new m(g.x,g.y,h);this._prev=new m(0,0,0!==h.t?h:h.next)},!0),q=c.prototype=new a,q.constructor=c,q.getRatio=function(a){var b=this._prev;if(a>b.t){for(;b.next&&a>=b.t;)b=b.next;b=b.prev}else for(;b.prev&&a<=b.t;)b=b.prev;return this._prev=b,b.v+(a-b.t)/b.gap*b.c},q.config=function(a){return new c(a)},c.ease=new c,l("Bounce",j("BounceOut",function(a){return 1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375}),j("BounceIn",function(a){return(a=1-a)<1/2.75?1-7.5625*a*a:2/2.75>a?1-(7.5625*(a-=1.5/2.75)*a+.75):2.5/2.75>a?1-(7.5625*(a-=2.25/2.75)*a+.9375):1-(7.5625*(a-=2.625/2.75)*a+.984375)}),j("BounceInOut",function(a){var b=.5>a;return a=b?1-2*a:2*a-1,a=1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375,b?.5*(1-a):.5*a+.5})),l("Circ",j("CircOut",function(a){return Math.sqrt(1-(a-=1)*a)}),j("CircIn",function(a){return-(Math.sqrt(1-a*a)-1)}),j("CircInOut",function(a){return(a*=2)<1?-.5*(Math.sqrt(1-a*a)-1):.5*(Math.sqrt(1-(a-=2)*a)+1)})),d=function(b,c,d){var e=i("easing."+b,function(a,b){this._p1=a>=1?a:1,this._p2=(b||d)/(1>a?a:1),this._p3=this._p2/g*(Math.asin(1/this._p1)||0),this._p2=g/this._p2},!0),f=e.prototype=new a;return f.constructor=e,f.getRatio=c,f.config=function(a,b){return new e(a,b)},e},l("Elastic",d("ElasticOut",function(a){return this._p1*Math.pow(2,-10*a)*Math.sin((a-this._p3)*this._p2)+1},.3),d("ElasticIn",function(a){return-(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2))},.3),d("ElasticInOut",function(a){return(a*=2)<1?-.5*(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2)):this._p1*Math.pow(2,-10*(a-=1))*Math.sin((a-this._p3)*this._p2)*.5+1},.45)),l("Expo",j("ExpoOut",function(a){return 1-Math.pow(2,-10*a)}),j("ExpoIn",function(a){return Math.pow(2,10*(a-1))-.001}),j("ExpoInOut",function(a){return(a*=2)<1?.5*Math.pow(2,10*(a-1)):.5*(2-Math.pow(2,-10*(a-1)))})),l("Sine",j("SineOut",function(a){return Math.sin(a*h)}),j("SineIn",function(a){return-Math.cos(a*h)+1}),j("SineInOut",function(a){return-.5*(Math.cos(Math.PI*a)-1)})),i("easing.EaseLookup",{find:function(b){return a.map[b]}},!0),k(e.SlowMo,"SlowMo","ease,"),k(c,"RoughEase","ease,"),k(b,"SteppedEase","ease,"),o},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a,b){"use strict";var c={},d=a.document,e=a.GreenSockGlobals=a.GreenSockGlobals||a;if(!e.TweenLite){var f,g,h,i,j,k=function(a){var b,c=a.split("."),d=e;for(b=0;b<c.length;b++)d[c[b]]=d=d[c[b]]||{};return d},l=k("com.greensock"),m=1e-10,n=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},o=function(){},p=function(){var a=Object.prototype.toString,b=a.call([]);return function(c){return null!=c&&(c instanceof Array||"object"==typeof c&&!!c.push&&a.call(c)===b)}}(),q={},r=function(d,f,g,h){this.sc=q[d]?q[d].sc:[],q[d]=this,this.gsClass=null,this.func=g;var i=[];this.check=function(j){for(var l,m,n,o,p,s=f.length,t=s;--s>-1;)(l=q[f[s]]||new r(f[s],[])).gsClass?(i[s]=l.gsClass,t--):j&&l.sc.push(this);if(0===t&&g){if(m=("com.greensock."+d).split("."),n=m.pop(),o=k(m.join("."))[n]=this.gsClass=g.apply(g,i),h)if(e[n]=c[n]=o,p="undefined"!=typeof module&&module.exports,!p&&"function"=="function"&&__webpack_require__(34))!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return o}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if(p)if(d===b){module.exports=c[b]=o;for(s in c)o[s]=c[s]}else c[b]&&(c[b][n]=o);for(s=0;s<this.sc.length;s++)this.sc[s].check()}},this.check(!0)},s=a._gsDefine=function(a,b,c,d){return new r(a,b,c,d)},t=l._class=function(a,b,c){return b=b||function(){},s(a,[],function(){return b},c),b};s.globals=e;var u=[0,0,1,1],v=t("easing.Ease",function(a,b,c,d){this._func=a,this._type=c||0,this._power=d||0,this._params=b?u.concat(b):u},!0),w=v.map={},x=v.register=function(a,b,c,d){for(var e,f,g,h,i=b.split(","),j=i.length,k=(c||"easeIn,easeOut,easeInOut").split(",");--j>-1;)for(f=i[j],e=d?t("easing."+f,null,!0):l.easing[f]||{},g=k.length;--g>-1;)h=k[g],w[f+"."+h]=w[h+f]=e[h]=a.getRatio?a:a[h]||new a};for(h=v.prototype,h._calcEnd=!1,h.getRatio=function(a){if(this._func)return this._params[0]=a,this._func.apply(null,this._params);var b=this._type,c=this._power,d=1===b?1-a:2===b?a:.5>a?2*a:2*(1-a);return 1===c?d*=d:2===c?d*=d*d:3===c?d*=d*d*d:4===c&&(d*=d*d*d*d),1===b?1-d:2===b?d:.5>a?d/2:1-d/2},f=["Linear","Quad","Cubic","Quart","Quint,Strong"],g=f.length;--g>-1;)h=f[g]+",Power"+g,x(new v(null,null,1,g),h,"easeOut",!0),x(new v(null,null,2,g),h,"easeIn"+(0===g?",easeNone":"")),x(new v(null,null,3,g),h,"easeInOut");w.linear=l.easing.Linear.easeIn,w.swing=l.easing.Quad.easeInOut;var y=t("events.EventDispatcher",function(a){this._listeners={},this._eventTarget=a||this});h=y.prototype,h.addEventListener=function(a,b,c,d,e){e=e||0;var f,g,h=this._listeners[a],k=0;for(this!==i||j||i.wake(),null==h&&(this._listeners[a]=h=[]),g=h.length;--g>-1;)f=h[g],f.c===b&&f.s===c?h.splice(g,1):0===k&&f.pr<e&&(k=g+1);h.splice(k,0,{c:b,s:c,up:d,pr:e})},h.removeEventListener=function(a,b){var c,d=this._listeners[a];if(d)for(c=d.length;--c>-1;)if(d[c].c===b)return void d.splice(c,1)},h.dispatchEvent=function(a){var b,c,d,e=this._listeners[a];if(e)for(b=e.length,b>1&&(e=e.slice(0)),c=this._eventTarget;--b>-1;)d=e[b],d&&(d.up?d.c.call(d.s||c,{type:a,target:c}):d.c.call(d.s||c))};var z=a.requestAnimationFrame,A=a.cancelAnimationFrame,B=Date.now||function(){return(new Date).getTime()},C=B();for(f=["ms","moz","webkit","o"],g=f.length;--g>-1&&!z;)z=a[f[g]+"RequestAnimationFrame"],A=a[f[g]+"CancelAnimationFrame"]||a[f[g]+"CancelRequestAnimationFrame"];t("Ticker",function(a,b){var c,e,f,g,h,k=this,l=B(),n=b!==!1&&z?"auto":!1,p=500,q=33,r="tick",s=function(a){var b,d,i=B()-C;i>p&&(l+=i-q),C+=i,k.time=(C-l)/1e3,b=k.time-h,(!c||b>0||a===!0)&&(k.frame++,h+=b+(b>=g?.004:g-b),d=!0),a!==!0&&(f=e(s)),d&&k.dispatchEvent(r)};y.call(k),k.time=k.frame=0,k.tick=function(){s(!0)},k.lagSmoothing=function(a,b){p=a||1/m,q=Math.min(b,p,0)},k.sleep=function(){null!=f&&(n&&A?A(f):clearTimeout(f),e=o,f=null,k===i&&(j=!1))},k.wake=function(a){null!==f?k.sleep():a?l+=-C+(C=B()):k.frame>10&&(C=B()-p+5),e=0===c?o:n&&z?z:function(a){return setTimeout(a,1e3*(h-k.time)+1|0)},k===i&&(j=!0),s(2)},k.fps=function(a){return arguments.length?(c=a,g=1/(c||60),h=this.time+g,void k.wake()):c},k.useRAF=function(a){return arguments.length?(k.sleep(),n=a,void k.fps(c)):n},k.fps(a),setTimeout(function(){"auto"===n&&k.frame<5&&"hidden"!==d.visibilityState&&k.useRAF(!1)},1500)}),h=l.Ticker.prototype=new l.events.EventDispatcher,h.constructor=l.Ticker;var D=t("core.Animation",function(a,b){if(this.vars=b=b||{},this._duration=this._totalDuration=a||0,this._delay=Number(b.delay)||0,this._timeScale=1,this._active=b.immediateRender===!0,this.data=b.data,this._reversed=b.reversed===!0,W){j||i.wake();var c=this.vars.useFrames?V:W;c.add(this,c._time),this.vars.paused&&this.paused(!0)}});i=D.ticker=new l.Ticker,h=D.prototype,h._dirty=h._gc=h._initted=h._paused=!1,h._totalTime=h._time=0,h._rawPrevTime=-1,h._next=h._last=h._onUpdate=h._timeline=h.timeline=null,h._paused=!1;var E=function(){j&&B()-C>2e3&&i.wake(),setTimeout(E,2e3)};E(),h.play=function(a,b){return null!=a&&this.seek(a,b),this.reversed(!1).paused(!1)},h.pause=function(a,b){return null!=a&&this.seek(a,b),this.paused(!0)},h.resume=function(a,b){return null!=a&&this.seek(a,b),this.paused(!1)},h.seek=function(a,b){return this.totalTime(Number(a),b!==!1)},h.restart=function(a,b){return this.reversed(!1).paused(!1).totalTime(a?-this._delay:0,b!==!1,!0)},h.reverse=function(a,b){return null!=a&&this.seek(a||this.totalDuration(),b),this.reversed(!0).paused(!1)},h.render=function(a,b,c){},h.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,(this._gc||!this.timeline)&&this._enabled(!0),this},h.isActive=function(){var a,b=this._timeline,c=this._startTime;return!b||!this._gc&&!this._paused&&b.isActive()&&(a=b.rawTime(!0))>=c&&a<c+this.totalDuration()/this._timeScale},h._enabled=function(a,b){return j||i.wake(),this._gc=!a,this._active=this.isActive(),b!==!0&&(a&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!a&&this.timeline&&this._timeline._remove(this,!0)),!1},h._kill=function(a,b){return this._enabled(!1,!1)},h.kill=function(a,b){return this._kill(a,b),this},h._uncache=function(a){for(var b=a?this:this.timeline;b;)b._dirty=!0,b=b.timeline;return this},h._swapSelfInParams=function(a){for(var b=a.length,c=a.concat();--b>-1;)"{self}"===a[b]&&(c[b]=this);return c},h._callback=function(a){var b=this.vars,c=b[a],d=b[a+"Params"],e=b[a+"Scope"]||b.callbackScope||this,f=d?d.length:0;switch(f){case 0:c.call(e);break;case 1:c.call(e,d[0]);break;case 2:c.call(e,d[0],d[1]);break;default:c.apply(e,d)}},h.eventCallback=function(a,b,c,d){if("on"===(a||"").substr(0,2)){var e=this.vars;if(1===arguments.length)return e[a];null==b?delete e[a]:(e[a]=b,e[a+"Params"]=p(c)&&-1!==c.join("").indexOf("{self}")?this._swapSelfInParams(c):c,e[a+"Scope"]=d),"onUpdate"===a&&(this._onUpdate=b)}return this},h.delay=function(a){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+a-this._delay),this._delay=a,this):this._delay},h.duration=function(a){return arguments.length?(this._duration=this._totalDuration=a,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==a&&this.totalTime(this._totalTime*(a/this._duration),!0),this):(this._dirty=!1,this._duration)},h.totalDuration=function(a){return this._dirty=!1,arguments.length?this.duration(a):this._totalDuration},h.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(a>this._duration?this._duration:a,b)):this._time},h.totalTime=function(a,b,c){if(j||i.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(0>a&&!c&&(a+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var d=this._totalDuration,e=this._timeline;if(a>d&&!c&&(a=d),this._startTime=(this._paused?this._pauseTime:e._time)-(this._reversed?d-a:a)/this._timeScale,e._dirty||this._uncache(!1),e._timeline)for(;e._timeline;)e._timeline._time!==(e._startTime+e._totalTime)/e._timeScale&&e.totalTime(e._totalTime,!0),e=e._timeline}this._gc&&this._enabled(!0,!1),(this._totalTime!==a||0===this._duration)&&(J.length&&Y(),this.render(a,b,!1),J.length&&Y())}return this},h.progress=h.totalProgress=function(a,b){var c=this.duration();return arguments.length?this.totalTime(c*a,b):c?this._time/c:this.ratio},h.startTime=function(a){return arguments.length?(a!==this._startTime&&(this._startTime=a,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,a-this._delay)),this):this._startTime},h.endTime=function(a){return this._startTime+(0!=a?this.totalDuration():this.duration())/this._timeScale},h.timeScale=function(a){if(!arguments.length)return this._timeScale;if(a=a||m,this._timeline&&this._timeline.smoothChildTiming){var b=this._pauseTime,c=b||0===b?b:this._timeline.totalTime();this._startTime=c-(c-this._startTime)*this._timeScale/a}return this._timeScale=a,this._uncache(!1)},h.reversed=function(a){return arguments.length?(a!=this._reversed&&(this._reversed=a,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},h.paused=function(a){if(!arguments.length)return this._paused;var b,c,d=this._timeline;return a!=this._paused&&d&&(j||a||i.wake(),b=d.rawTime(),c=b-this._pauseTime,!a&&d.smoothChildTiming&&(this._startTime+=c,this._uncache(!1)),this._pauseTime=a?b:null,this._paused=a,this._active=this.isActive(),!a&&0!==c&&this._initted&&this.duration()&&(b=d.smoothChildTiming?this._totalTime:(b-this._startTime)/this._timeScale,this.render(b,b===this._totalTime,!0))),this._gc&&!a&&this._enabled(!0,!1),this};var F=t("core.SimpleTimeline",function(a){D.call(this,0,a),this.autoRemoveChildren=this.smoothChildTiming=!0});h=F.prototype=new D,h.constructor=F,h.kill()._gc=!1,h._first=h._last=h._recent=null,h._sortChildren=!1,h.add=h.insert=function(a,b,c,d){var e,f;if(a._startTime=Number(b||0)+a._delay,a._paused&&this!==a._timeline&&(a._pauseTime=a._startTime+(this.rawTime()-a._startTime)/a._timeScale),a.timeline&&a.timeline._remove(a,!0),a.timeline=a._timeline=this,a._gc&&a._enabled(!0,!0),e=this._last,this._sortChildren)for(f=a._startTime;e&&e._startTime>f;)e=e._prev;return e?(a._next=e._next,e._next=a):(a._next=this._first,this._first=a),a._next?a._next._prev=a:this._last=a,a._prev=e,this._recent=a,this._timeline&&this._uncache(!0),this},h._remove=function(a,b){return a.timeline===this&&(b||a._enabled(!1,!0),a._prev?a._prev._next=a._next:this._first===a&&(this._first=a._next),a._next?a._next._prev=a._prev:this._last===a&&(this._last=a._prev),a._next=a._prev=a.timeline=null,a===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},h.render=function(a,b,c){var d,e=this._first;for(this._totalTime=this._time=this._rawPrevTime=a;e;)d=e._next,(e._active||a>=e._startTime&&!e._paused)&&(e._reversed?e.render((e._dirty?e.totalDuration():e._totalDuration)-(a-e._startTime)*e._timeScale,b,c):e.render((a-e._startTime)*e._timeScale,b,c)),e=d},h.rawTime=function(){return j||i.wake(),this._totalTime};var G=t("TweenLite",function(b,c,d){
if(D.call(this,c,d),this.render=G.prototype.render,null==b)throw"Cannot tween a null target.";this.target=b="string"!=typeof b?b:G.selector(b)||b;var e,f,g,h=b.jquery||b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType),i=this.vars.overwrite;if(this._overwrite=i=null==i?U[G.defaultOverwrite]:"number"==typeof i?i>>0:U[i],(h||b instanceof Array||b.push&&p(b))&&"number"!=typeof b[0])for(this._targets=g=n(b),this._propLookup=[],this._siblings=[],e=0;e<g.length;e++)f=g[e],f?"string"!=typeof f?f.length&&f!==a&&f[0]&&(f[0]===a||f[0].nodeType&&f[0].style&&!f.nodeType)?(g.splice(e--,1),this._targets=g=g.concat(n(f))):(this._siblings[e]=Z(f,this,!1),1===i&&this._siblings[e].length>1&&_(f,this,null,1,this._siblings[e])):(f=g[e--]=G.selector(f),"string"==typeof f&&g.splice(e+1,1)):g.splice(e--,1);else this._propLookup={},this._siblings=Z(b,this,!1),1===i&&this._siblings.length>1&&_(b,this,null,1,this._siblings);(this.vars.immediateRender||0===c&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-m,this.render(Math.min(0,-this._delay)))},!0),H=function(b){return b&&b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType)},I=function(a,b){var c,d={};for(c in a)T[c]||c in b&&"transform"!==c&&"x"!==c&&"y"!==c&&"width"!==c&&"height"!==c&&"className"!==c&&"border"!==c||!(!Q[c]||Q[c]&&Q[c]._autoCSS)||(d[c]=a[c],delete a[c]);a.css=d};h=G.prototype=new D,h.constructor=G,h.kill()._gc=!1,h.ratio=0,h._firstPT=h._targets=h._overwrittenProps=h._startAt=null,h._notifyPluginsOfEnabled=h._lazy=!1,G.version="1.19.1",G.defaultEase=h._ease=new v(null,null,1,1),G.defaultOverwrite="auto",G.ticker=i,G.autoSleep=120,G.lagSmoothing=function(a,b){i.lagSmoothing(a,b)},G.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(G.selector=c,c(b)):"undefined"==typeof d?b:d.querySelectorAll?d.querySelectorAll(b):d.getElementById("#"===b.charAt(0)?b.substr(1):b)};var J=[],K={},L=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,M=function(a){for(var b,c=this._firstPT,d=1e-6;c;)b=c.blob?1===a?this.end:a?this.join(""):this.start:c.c*a+c.s,c.m?b=c.m(b,this._target||c.t):d>b&&b>-d&&!c.blob&&(b=0),c.f?c.fp?c.t[c.p](c.fp,b):c.t[c.p](b):c.t[c.p]=b,c=c._next},N=function(a,b,c,d){var e,f,g,h,i,j,k,l=[],m=0,n="",o=0;for(l.start=a,l.end=b,a=l[0]=a+"",b=l[1]=b+"",c&&(c(l),a=l[0],b=l[1]),l.length=0,e=a.match(L)||[],f=b.match(L)||[],d&&(d._next=null,d.blob=1,l._firstPT=l._applyPT=d),i=f.length,h=0;i>h;h++)k=f[h],j=b.substr(m,b.indexOf(k,m)-m),n+=j||!h?j:",",m+=j.length,o?o=(o+1)%5:"rgba("===j.substr(-5)&&(o=1),k===e[h]||e.length<=h?n+=k:(n&&(l.push(n),n=""),g=parseFloat(e[h]),l.push(g),l._firstPT={_next:l._firstPT,t:l,p:l.length-1,s:g,c:("="===k.charAt(1)?parseInt(k.charAt(0)+"1",10)*parseFloat(k.substr(2)):parseFloat(k)-g)||0,f:0,m:o&&4>o?Math.round:0}),m+=k.length;return n+=b.substr(m),n&&l.push(n),l.setRatio=M,l},O=function(a,b,c,d,e,f,g,h,i){"function"==typeof d&&(d=d(i||0,a));var j,k=typeof a[b],l="function"!==k?"":b.indexOf("set")||"function"!=typeof a["get"+b.substr(3)]?b:"get"+b.substr(3),m="get"!==c?c:l?g?a[l](g):a[l]():a[b],n="string"==typeof d&&"="===d.charAt(1),o={t:a,p:b,s:m,f:"function"===k,pg:0,n:e||b,m:f?"function"==typeof f?f:Math.round:0,pr:0,c:n?parseInt(d.charAt(0)+"1",10)*parseFloat(d.substr(2)):parseFloat(d)-m||0};return("number"!=typeof m||"number"!=typeof d&&!n)&&(g||isNaN(m)||!n&&isNaN(d)||"boolean"==typeof m||"boolean"==typeof d?(o.fp=g,j=N(m,n?o.s+o.c:d,h||G.defaultStringFilter,o),o={t:j,p:"setRatio",s:0,c:1,f:2,pg:0,n:e||b,pr:0,m:0}):(o.s=parseFloat(m),n||(o.c=parseFloat(d)-o.s||0))),o.c?((o._next=this._firstPT)&&(o._next._prev=o),this._firstPT=o,o):void 0},P=G._internals={isArray:p,isSelector:H,lazyTweens:J,blobDif:N},Q=G._plugins={},R=P.tweenLookup={},S=0,T=P.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1},U={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},V=D._rootFramesTimeline=new F,W=D._rootTimeline=new F,X=30,Y=P.lazyRender=function(){var a,b=J.length;for(K={};--b>-1;)a=J[b],a&&a._lazy!==!1&&(a.render(a._lazy[0],a._lazy[1],!0),a._lazy=!1);J.length=0};W._startTime=i.time,V._startTime=i.frame,W._active=V._active=!0,setTimeout(Y,1),D._updateRoot=G.render=function(){var a,b,c;if(J.length&&Y(),W.render((i.time-W._startTime)*W._timeScale,!1,!1),V.render((i.frame-V._startTime)*V._timeScale,!1,!1),J.length&&Y(),i.frame>=X){X=i.frame+(parseInt(G.autoSleep,10)||120);for(c in R){for(b=R[c].tweens,a=b.length;--a>-1;)b[a]._gc&&b.splice(a,1);0===b.length&&delete R[c]}if(c=W._first,(!c||c._paused)&&G.autoSleep&&!V._first&&1===i._listeners.tick.length){for(;c&&c._paused;)c=c._next;c||i.sleep()}}},i.addEventListener("tick",D._updateRoot);var Z=function(a,b,c){var d,e,f=a._gsTweenID;if(R[f||(a._gsTweenID=f="t"+S++)]||(R[f]={target:a,tweens:[]}),b&&(d=R[f].tweens,d[e=d.length]=b,c))for(;--e>-1;)d[e]===b&&d.splice(e,1);return R[f].tweens},$=function(a,b,c,d){var e,f,g=a.vars.onOverwrite;return g&&(e=g(a,b,c,d)),g=G.onOverwrite,g&&(f=g(a,b,c,d)),e!==!1&&f!==!1},_=function(a,b,c,d,e){var f,g,h,i;if(1===d||d>=4){for(i=e.length,f=0;i>f;f++)if((h=e[f])!==b)h._gc||h._kill(null,a,b)&&(g=!0);else if(5===d)break;return g}var j,k=b._startTime+m,l=[],n=0,o=0===b._duration;for(f=e.length;--f>-1;)(h=e[f])===b||h._gc||h._paused||(h._timeline!==b._timeline?(j=j||aa(b,0,o),0===aa(h,j,o)&&(l[n++]=h)):h._startTime<=k&&h._startTime+h.totalDuration()/h._timeScale>k&&((o||!h._initted)&&k-h._startTime<=2e-10||(l[n++]=h)));for(f=n;--f>-1;)if(h=l[f],2===d&&h._kill(c,a,b)&&(g=!0),2!==d||!h._firstPT&&h._initted){if(2!==d&&!$(h,b))continue;h._enabled(!1,!1)&&(g=!0)}return g},aa=function(a,b,c){for(var d=a._timeline,e=d._timeScale,f=a._startTime;d._timeline;){if(f+=d._startTime,e*=d._timeScale,d._paused)return-100;d=d._timeline}return f/=e,f>b?f-b:c&&f===b||!a._initted&&2*m>f-b?m:(f+=a.totalDuration()/a._timeScale/e)>b+m?0:f-b-m};h._init=function(){var a,b,c,d,e,f,g=this.vars,h=this._overwrittenProps,i=this._duration,j=!!g.immediateRender,k=g.ease;if(g.startAt){this._startAt&&(this._startAt.render(-1,!0),this._startAt.kill()),e={};for(d in g.startAt)e[d]=g.startAt[d];if(e.overwrite=!1,e.immediateRender=!0,e.lazy=j&&g.lazy!==!1,e.startAt=e.delay=null,this._startAt=G.to(this.target,0,e),j)if(this._time>0)this._startAt=null;else if(0!==i)return}else if(g.runBackwards&&0!==i)if(this._startAt)this._startAt.render(-1,!0),this._startAt.kill(),this._startAt=null;else{0!==this._time&&(j=!1),c={};for(d in g)T[d]&&"autoCSS"!==d||(c[d]=g[d]);if(c.overwrite=0,c.data="isFromStart",c.lazy=j&&g.lazy!==!1,c.immediateRender=j,this._startAt=G.to(this.target,0,c),j){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=k=k?k instanceof v?k:"function"==typeof k?new v(k,g.easeParams):w[k]||G.defaultEase:G.defaultEase,g.easeParams instanceof Array&&k.config&&(this._ease=k.config.apply(k,g.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(f=this._targets.length,a=0;f>a;a++)this._initProps(this._targets[a],this._propLookup[a]={},this._siblings[a],h?h[a]:null,a)&&(b=!0);else b=this._initProps(this.target,this._propLookup,this._siblings,h,0);if(b&&G._onPluginEvent("_onInitAllProps",this),h&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),g.runBackwards)for(c=this._firstPT;c;)c.s+=c.c,c.c=-c.c,c=c._next;this._onUpdate=g.onUpdate,this._initted=!0},h._initProps=function(b,c,d,e,f){var g,h,i,j,k,l;if(null==b)return!1;K[b._gsTweenID]&&Y(),this.vars.css||b.style&&b!==a&&b.nodeType&&Q.css&&this.vars.autoCSS!==!1&&I(this.vars,b);for(g in this.vars)if(l=this.vars[g],T[g])l&&(l instanceof Array||l.push&&p(l))&&-1!==l.join("").indexOf("{self}")&&(this.vars[g]=l=this._swapSelfInParams(l,this));else if(Q[g]&&(j=new Q[g])._onInitTween(b,this.vars[g],this,f)){for(this._firstPT=k={_next:this._firstPT,t:j,p:"setRatio",s:0,c:1,f:1,n:g,pg:1,pr:j._priority,m:0},h=j._overwriteProps.length;--h>-1;)c[j._overwriteProps[h]]=this._firstPT;(j._priority||j._onInitAllProps)&&(i=!0),(j._onDisable||j._onEnable)&&(this._notifyPluginsOfEnabled=!0),k._next&&(k._next._prev=k)}else c[g]=O.call(this,b,g,"get",l,g,0,null,this.vars.stringFilter,f);return e&&this._kill(e,b)?this._initProps(b,c,d,e,f):this._overwrite>1&&this._firstPT&&d.length>1&&_(b,this,c,this._overwrite,d)?(this._kill(c,b),this._initProps(b,c,d,e,f)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(K[b._gsTweenID]=!0),i)},h.render=function(a,b,c){var d,e,f,g,h=this._time,i=this._duration,j=this._rawPrevTime;if(a>=i-1e-7&&a>=0)this._totalTime=this._time=i,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1,this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===i&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>j||0>=a&&a>=-1e-7||j===m&&"isPause"!==this.data)&&j!==a&&(c=!0,j>m&&(e="onReverseComplete")),this._rawPrevTime=g=!b||a||j===a?a:m);else if(1e-7>a)this._totalTime=this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==h||0===i&&j>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===i&&(this._initted||!this.vars.lazy||c)&&(j>=0&&(j!==m||"isPause"!==this.data)&&(c=!0),this._rawPrevTime=g=!b||a||j===a?a:m)),this._initted||(c=!0);else if(this._totalTime=this._time=a,this._easeType){var k=a/i,l=this._easeType,n=this._easePower;(1===l||3===l&&k>=.5)&&(k=1-k),3===l&&(k*=2),1===n?k*=k:2===n?k*=k*k:3===n?k*=k*k*k:4===n&&(k*=k*k*k*k),1===l?this.ratio=1-k:2===l?this.ratio=k:.5>a/i?this.ratio=k/2:this.ratio=1-k/2}else this.ratio=this._ease.getRatio(a/i);if(this._time!==h||c){if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=this._totalTime=h,this._rawPrevTime=j,J.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/i):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==h&&a>=0&&(this._active=!0),0===h&&(this._startAt&&(a>=0?this._startAt.render(a,b,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._time||0===i)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&a!==-1e-4&&this._startAt.render(a,b,c),b||(this._time!==h||d||c)&&this._callback("onUpdate")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&a!==-1e-4&&this._startAt.render(a,b,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===i&&this._rawPrevTime===m&&g!==m&&(this._rawPrevTime=0))}},h._kill=function(a,b,c){if("all"===a&&(a=null),null==a&&(null==b||b===this.target))return this._lazy=!1,this._enabled(!1,!1);b="string"!=typeof b?b||this._targets||this.target:G.selector(b)||b;var d,e,f,g,h,i,j,k,l,m=c&&this._time&&c._startTime===this._startTime&&this._timeline===c._timeline;if((p(b)||H(b))&&"number"!=typeof b[0])for(d=b.length;--d>-1;)this._kill(a,b[d],c)&&(i=!0);else{if(this._targets){for(d=this._targets.length;--d>-1;)if(b===this._targets[d]){h=this._propLookup[d]||{},this._overwrittenProps=this._overwrittenProps||[],e=this._overwrittenProps[d]=a?this._overwrittenProps[d]||{}:"all";break}}else{if(b!==this.target)return!1;h=this._propLookup,e=this._overwrittenProps=a?this._overwrittenProps||{}:"all"}if(h){if(j=a||h,k=a!==e&&"all"!==e&&a!==h&&("object"!=typeof a||!a._tempKill),c&&(G.onOverwrite||this.vars.onOverwrite)){for(f in j)h[f]&&(l||(l=[]),l.push(f));if((l||!a)&&!$(this,c,b,l))return!1}for(f in j)(g=h[f])&&(m&&(g.f?g.t[g.p](g.s):g.t[g.p]=g.s,i=!0),g.pg&&g.t._kill(j)&&(i=!0),g.pg&&0!==g.t._overwriteProps.length||(g._prev?g._prev._next=g._next:g===this._firstPT&&(this._firstPT=g._next),g._next&&(g._next._prev=g._prev),g._next=g._prev=null),delete h[f]),k&&(e[f]=1);!this._firstPT&&this._initted&&this._enabled(!1,!1)}}return i},h.invalidate=function(){return this._notifyPluginsOfEnabled&&G._onPluginEvent("_onDisable",this),this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],D.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-m,this.render(Math.min(0,-this._delay))),this},h._enabled=function(a,b){if(j||i.wake(),a&&this._gc){var c,d=this._targets;if(d)for(c=d.length;--c>-1;)this._siblings[c]=Z(d[c],this,!0);else this._siblings=Z(this.target,this,!0)}return D.prototype._enabled.call(this,a,b),this._notifyPluginsOfEnabled&&this._firstPT?G._onPluginEvent(a?"_onEnable":"_onDisable",this):!1},G.to=function(a,b,c){return new G(a,b,c)},G.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new G(a,b,c)},G.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new G(a,b,d)},G.delayedCall=function(a,b,c,d,e){return new G(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,lazy:!1,useFrames:e,overwrite:0})},G.set=function(a,b){return new G(a,0,b)},G.getTweensOf=function(a,b){if(null==a)return[];a="string"!=typeof a?a:G.selector(a)||a;var c,d,e,f;if((p(a)||H(a))&&"number"!=typeof a[0]){for(c=a.length,d=[];--c>-1;)d=d.concat(G.getTweensOf(a[c],b));for(c=d.length;--c>-1;)for(f=d[c],e=c;--e>-1;)f===d[e]&&d.splice(c,1)}else for(d=Z(a).concat(),c=d.length;--c>-1;)(d[c]._gc||b&&!d[c].isActive())&&d.splice(c,1);return d},G.killTweensOf=G.killDelayedCallsTo=function(a,b,c){"object"==typeof b&&(c=b,b=!1);for(var d=G.getTweensOf(a,b),e=d.length;--e>-1;)d[e]._kill(c,a)};var ba=t("plugins.TweenPlugin",function(a,b){this._overwriteProps=(a||"").split(","),this._propName=this._overwriteProps[0],this._priority=b||0,this._super=ba.prototype},!0);if(h=ba.prototype,ba.version="1.19.0",ba.API=2,h._firstPT=null,h._addTween=O,h.setRatio=M,h._kill=function(a){var b,c=this._overwriteProps,d=this._firstPT;if(null!=a[this._propName])this._overwriteProps=[];else for(b=c.length;--b>-1;)null!=a[c[b]]&&c.splice(b,1);for(;d;)null!=a[d.n]&&(d._next&&(d._next._prev=d._prev),d._prev?(d._prev._next=d._next,d._prev=null):this._firstPT===d&&(this._firstPT=d._next)),d=d._next;return!1},h._mod=h._roundProps=function(a){for(var b,c=this._firstPT;c;)b=a[this._propName]||null!=c.n&&a[c.n.split(this._propName+"_").join("")],b&&"function"==typeof b&&(2===c.f?c.t._applyPT.m=b:c.m=b),c=c._next},G._onPluginEvent=function(a,b){var c,d,e,f,g,h=b._firstPT;if("_onInitAllProps"===a){for(;h;){for(g=h._next,d=e;d&&d.pr>h.pr;)d=d._next;(h._prev=d?d._prev:f)?h._prev._next=h:e=h,(h._next=d)?d._prev=h:f=h,h=g}h=b._firstPT=e}for(;h;)h.pg&&"function"==typeof h.t[a]&&h.t[a]()&&(c=!0),h=h._next;return c},ba.activate=function(a){for(var b=a.length;--b>-1;)a[b].API===ba.API&&(Q[(new a[b])._propName]=a[b]);return!0},s.plugin=function(a){if(!(a&&a.propName&&a.init&&a.API))throw"illegal plugin definition.";var b,c=a.propName,d=a.priority||0,e=a.overwriteProps,f={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},g=t("plugins."+c.charAt(0).toUpperCase()+c.substr(1)+"Plugin",function(){ba.call(this,c,d),this._overwriteProps=e||[]},a.global===!0),h=g.prototype=new ba(c);h.constructor=g,g.API=a.API;for(b in f)"function"==typeof a[b]&&(h[f[b]]=a[b]);return g.version=a.version,ba.activate([g]),g},f=a._gsQueue){for(g=0;g<f.length;g++)f[g]();for(h in q)q[h].func||a.console.log("GSAP encountered missing dependency: "+h)}j=!1}}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenMax");

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var BaseModel, ImageModel, gameModel,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseModel = __webpack_require__(23);

gameModel = __webpack_require__(2);

ImageModel = (function(_super) {
  __extends(ImageModel, _super);

  function ImageModel() {
    return ImageModel.__super__.constructor.apply(this, arguments);
  }

  ImageModel.prototype._instance = null;

  ImageModel.prototype.allNamespaces = [];

  ImageModel.prototype.prizeImages = [];

  ImageModel.prototype.lang = 'de';

  ImageModel.prototype.res = '';

  ImageModel.prototype.setup = function() {
    var preload;
    this.res = this.determineResolutionPostfix();
    this.fingerImg = __webpack_require__(243)("./finger" + this.res + ".png");
    this.brushImage = __webpack_require__(240)("./brush" + this.res + ".png");
    this.flakeImage = __webpack_require__(253)("./flake" + this.res + ".png");
    this.scratchedImage = __webpack_require__(258)("./scratch-bg" + this.res + ".png");
    this.unscratchedImage = __webpack_require__(259)("./scratch-cover" + this.res + ".png");
    this.logoTitleImage = __webpack_require__(255)("./logo-title" + this.res + ".png");
    this.backgroundImage = __webpack_require__(249)("./background" + this.res + ".jpg");
    this.confettiJSON1 = __webpack_require__(126);
    this.confettiJSON2 = __webpack_require__(128);
    this.confettiURL1 = __webpack_require__(127);
    this.confettiURL2 = __webpack_require__(129);
    this.allNamespaces.push(this.confettiJSON1);
    this.allNamespaces.push(this.confettiJSON2);
    this.uiJSON = __webpack_require__(245)("./buttons" + this.res + ".json");
    this.uiURL = __webpack_require__(246)("./buttons" + this.res + ".png");
    this.allNamespaces.push(this.uiJSON);
    this.buttonImage = __webpack_require__(250)("./button" + this.res + ".png");
    this.buttonHoverImage = __webpack_require__(251)("./button-hover" + this.res + ".png");
    this.buttonSecondaryImage = __webpack_require__(241)("./button-secondary" + this.res + ".png");
    this.buttonSecondaryHoverImage = __webpack_require__(242)("./button-secondary-hover" + this.res + ".png");
    preload = [this.fingerImg, this.logoTitleImage, this.flakeImage, this.brushImage, this.scratchedImage, this.unscratchedImage, this.backgroundImage, this.buttonImage, this.buttonHoverImage, this.buttonSecondaryImage, this.buttonSecondaryHoverImage, this.confettiJSON1, this.confettiJSON2, this.uiJSON];
    if (gameModel.showLogoInGame) {
      this.logoGameImage = __webpack_require__(254)("./logo-game" + this.res + ".png");
      preload.push(this.logoGameImage);
    }
    if (!gameModel.hasPrizeAnimations) {
      this.starImage = !(function webpackMissingModule() { var e = new Error("Cannot find module \"../../themes/hm/img\""); e.code = 'MODULE_NOT_FOUND';; throw e; }());
      preload.push(this.starImage);
    }
    if (gameModel.showCharacter) {
      this.characterImage = __webpack_require__(252)("./character" + this.res + ".png");
      preload.push(this.characterImage);
    }
    if (gameModel.winSign === 'movie') {
      this.winSignJSON = __webpack_require__(247)("./win-sign" + this.res + ".json");
      __webpack_require__(248)("./win-sign" + this.res + ".png");
      this.allNamespaces.push(this.winSignJSON);
      preload.push(this.winSignJSON);
    }
    if (gameModel.winSign === 'image') {
      this.winSignImage = __webpack_require__(261)("./win-sign" + this.res + ".png");
      preload.push(this.winSignImage);
    }
    return preload;
  };

  ImageModel.prototype._twoDigits = function(n) {
    return ("0" + n).slice(-2);
  };

  ImageModel.prototype.determineResolutionPostfix = function() {
    var postfix;
    if (__dpi === 1) {
      return '';
    }
    postfix = "@" + __dpi + "x";
    return postfix;
  };

  ImageModel.prototype.getUrlForPrize = function(filename) {
    return __webpack_require__(257)("./prize-" + filename + this.res + ".png");
  };

  ImageModel.prototype.getUrlForMultiplier = function(filename) {
    return __webpack_require__(256)("./multiplier-x" + filename + this.res + ".png");
  };

  ImageModel.prototype.getWinAnimationForPrizeid = function(filename) {
    return __webpack_require__(264)("./prize-" + filename + this.res + ".json");
    return __webpack_require__(265)("./prize-" + filename + this.res + ".png");
  };

  ImageModel.prototype.getMultiAnimationForPrizeid = function(filename) {
    return __webpack_require__(262)("./multi-" + filename + this.res + ".json");
    return __webpack_require__(263)("./multi-" + filename + this.res + ".png");
  };

  ImageModel.prototype.retinize = function(url) {
    var nurl;
    if (__dpi < 2) {
      return url;
    }
    nurl = url.replace(/\.(?=[^.]*$)/, "@2x.");
    return nurl;
  };

  ImageModel.getInstance = function() {
    if (this._instance == null) {
      this._instance = new this;
    }
    return this._instance;
  };

  return ImageModel;

})(BaseModel);

module.exports = ImageModel.getInstance();


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, CurrencyManager, data, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

data = __webpack_require__(239);

log = __webpack_require__(0);

CurrencyManager = (function(_super) {
  __extends(CurrencyManager, _super);

  function CurrencyManager() {
    return CurrencyManager.__super__.constructor.apply(this, arguments);
  }

  CurrencyManager.prototype.name = 'CurrencyManager';

  CurrencyManager.prototype.debug = false;

  CurrencyManager.prototype.defaults = data.defaults;

  CurrencyManager.prototype.locales = data.locales;

  CurrencyManager.prototype.currencies = data.currencies;

  CurrencyManager.prototype.setup = function(options) {
    var cc, decimal, format, lc, parts, symbol, thousand;
    if (this.debug) {
      log.info(this.name, 'setup', options);
    }
    cc = options.cc.toUpperCase();
    lc = options.lc;
    if (!cc || cc === '') {
      return;
    }
    if (!lc || lc === '') {
      return;
    }
    parts = lc.toLowerCase().split('-');
    if (parts[1] && parts[0] === parts[1]) {
      lc = parts[0];
    }
    format = void 0;
    decimal = void 0;
    thousand = void 0;
    symbol = void 0;
    symbol = this._lookFor(this.currencies.s, cc);
    format = this._lookFor(this.locales.f, lc);
    decimal = this._lookFor(this.locales.d, lc);
    thousand = this._lookFor(this.locales.t, lc);
    if (!format) {
      format = this.defaults.format;
    }
    if (!decimal) {
      decimal = this.defaults.decimal;
    }
    if (!thousand) {
      thousand = this.defaults.thousand;
    }
    if (!symbol) {
      symbol = cc;
      format = this.defaults.noSymbolFormat;
    }
    this.options = {
      format: format,
      decimal: decimal,
      thousand: thousand,
      symbol: symbol
    };
    return this.options;
  };

  CurrencyManager.prototype._lookFor = function(data, query) {
    var item, key, val, _i, _len;
    for (key in data) {
      val = data[key];
      for (_i = 0, _len = val.length; _i < _len; _i++) {
        item = val[_i];
        if (item === query) {
          return key;
        }
      }
    }
    return false;
  };

  CurrencyManager.prototype.getCurrencySymbol = function() {
    return this.options.symbol;
  };

  CurrencyManager.prototype.localize = function(amount, remove00, showSymbol) {
    var precision, res;
    if (remove00 == null) {
      remove00 = true;
    }
    if (showSymbol == null) {
      showSymbol = true;
    }
    precision = this.getPrecision(!remove00, amount);
    res = this.formatCurrency(amount, this.options, precision, showSymbol);
    return res;
  };

  CurrencyManager.prototype.formatCurrency = function(number, opts, precision, showSymbol) {
    var result, value;
    value = this.formatNumber(number, opts, precision);
    if (!showSymbol) {
      return value;
    }
    result = opts.format;
    result = result.replace('%s', opts.symbol);
    result = result.replace('%v', value);
    return result;
  };

  CurrencyManager.prototype.formatNumber = function(number, opts, precision) {
    var base, mod, negative, usePrecision;
    usePrecision = precision;
    negative = number < 0 ? '-' : '';
    base = parseInt(Math.abs(number || 0).toFixed(usePrecision), 10) + '';
    mod = base.length > 3 ? base.length % 3 : 0;
    return negative + (mod ? base.substr(0, mod) + opts.thousand : '') + base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + opts.thousand) + (usePrecision ? opts.decimal + Math.abs(number).toFixed(usePrecision).split('.')[1] : '');
  };

  CurrencyManager.prototype.getPrecision = function(showDecimals, amount) {
    if (amount % 1 !== 0) {
      return 2;
    }
    if (showDecimals) {
      return 2;
    }
    return false;
  };

  return CurrencyManager;

})(BaseManager);

module.exports = CurrencyManager.getInstance();


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, SoundManager, howler, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

howler = __webpack_require__(228);

log = __webpack_require__(0);

SoundManager = (function(_super) {
  __extends(SoundManager, _super);

  function SoundManager() {
    return SoundManager.__super__.constructor.apply(this, arguments);
  }

  SoundManager.prototype.name = 'SoundManager';

  SoundManager.prototype.timer = null;

  SoundManager.prototype.ids = {};

  SoundManager.prototype.setup = function(options) {
    this.masterVolume = options.masterVolume;
    this.volumes = options.volumes;
    this.mute = options.mute;
    this.audioSpriteObj = options.audioSpriteObj;
    this.mp3 = options.mp3;
    this.ogg = options.ogg;
    return this.extend();
  };

  SoundManager.prototype.startAudio = function() {
    this.sound = new Howl({
      src: [this.ogg, this.mp3],
      volume: this.masterVolume,
      mute: this.mute,
      sprite: this.audioSpriteObj.sprite,
      onloaderror: (function(_this) {
        return function() {
          return log.error(_this.name, 'loadSounds', 'failed');
        };
      })(this),
      onload: (function(_this) {
        return function() {
          log.info(_this.name, 'loadedSounds');
          return _this.bg();
        };
      })(this)
    });
    return this.sound;
  };

  SoundManager.prototype.setMute = function(newValue) {
    this.mute = newValue;
    if (this.sound != null) {
      this.sound.mute(newValue);
      return this.resumeAll();
    }
  };

  SoundManager.prototype.play = function(key, vol) {
    var id;
    if (vol == null) {
      vol = null;
    }
    if (this.sound != null) {
      id = this.sound.play(key);
      if (vol != null) {
        this.sound.volume(vol * this.masterVolume, id);
      }
      this.ids[key] = id;
      return id;
    }
  };

  SoundManager.prototype.pauseAll = function() {
    if (this.sound != null) {
      return this.sound.pause();
    }
  };

  SoundManager.prototype.resumeAll = function() {
    if (this.sound != null) {
      return this.sound.unpause(this.volumes);
    }
  };

  SoundManager.prototype.stopAll = function() {
    if (this.sound != null) {
      return this.sound.stop();
    }
  };

  SoundManager.prototype.stop = function(key) {
    if (this.sound != null) {
      return this.sound.killByName(key);
    }
  };

  SoundManager.prototype.resume = function(key) {
    var id;
    id = this.ids[key];
    if ((this.sound == null) && (id == null)) {
      return;
    }
    return this.sound.play(id);
  };

  SoundManager.prototype.pause = function(key) {
    var id;
    id = this.ids[key];
    if ((typeof sound === "undefined" || sound === null) && (id == null)) {
      return;
    }
    return this.sound.pause(id);
  };

  SoundManager.prototype.fade = function(key, from, to, d) {
    var id;
    if (d == null) {
      d = 2000;
    }
    id = this.ids[key];
    if ((typeof sound === "undefined" || sound === null) && (id == null)) {
      return;
    }
    return this.sound.fade(from * this.masterVolume, to * this.masterVolume, d, id);
  };

  SoundManager.prototype.bg = function() {
    return this.play('music', this.volumes.music);
  };

  SoundManager.prototype.stopBg = function() {
    return this.stop('music');
  };

  SoundManager.prototype.click = function() {
    return this.play('click', this.volumes.click);
  };

  SoundManager.prototype.reveal = function() {
    this.stopRevealShort();
    if (this.sound.isPlayingByName('reveal')) {
      return;
    }
    return this.play('reveal', this.volumes.reveal);
  };

  SoundManager.prototype.stopReveal = function() {
    return this.stop('reveal');
  };

  SoundManager.prototype.revealShort = function() {
    if (this.sound.isPlayingByName('reveal-shortest')) {
      return;
    }
    return this.play('reveal-shortest', this.volumes.reveal);
  };

  SoundManager.prototype.stopRevealShort = function() {
    return this.stop('reveal-shortest');
  };

  SoundManager.prototype.loss = function() {
    if (this.sound._sprite['loss'] != null) {
      return this.play('loss', this.volumes.loss);
    }
  };

  SoundManager.prototype.win = function(key) {
    if (key == null) {
      key = 'win';
    }
    return this.play(key, this.volumes.win);
  };

  SoundManager.prototype.stopWin = function() {
    return this.stop('win');
  };

  SoundManager.prototype.bigWin = function() {
    this.play('big-win', this.volumes.bigWin);
    this.stopBg();
    return this.timer = setTimeout((function(_this) {
      return function() {
        return _this.stopBigWin();
      };
    })(this), this.sound._sprite['big-win'][1] - 1000);
  };

  SoundManager.prototype.stopBigWin = function() {
    clearTimeout(this.timer);
    if (this.sound.isPlayingByName('big-win')) {
      this.stop('big-win');
      return this.bg();
    }
  };

  SoundManager.prototype.extend = function() {
    Howl.prototype.unpause = function(volumes) {
      var i, id, num, self, track;
      self = this;
      id = void 0;
      num = 0;
      i = 0;
      while (i < self._sounds.length) {
        if (self._sounds[i]._paused && !self._sounds[i]._ended) {
          track = self._sounds[i];
          num++;
          id = track._id;
          self.play(id, volumes[track._sprite]);
        }
        i++;
      }
      return self;
    };
    Howl.prototype.killByName = function(name) {
      var i, id, self, track;
      self = this;
      id = void 0;
      track = void 0;
      i = 0;
      while (i < self._sounds.length) {
        track = self._sounds[i];
        if ((track._sprite != null) && track._sprite === name) {
          id = self._sounds[i]._id;
          self.stop(id);
        }
        i++;
      }
      return self;
    };
    return Howl.prototype.isPlayingByName = function(name) {
      var i, id, self, track;
      self = this;
      id = void 0;
      track = void 0;
      i = 0;
      while (i < self._sounds.length) {
        track = self._sounds[i];
        if ((track._sprite != null) && track._sprite === name && !track._paused && !track._ended) {
          return true;
        }
        i++;
      }
      return false;
    };
  };

  SoundManager.prototype.isSetup = function() {
    return this.sound != null;
  };

  return SoundManager;

})(BaseManager);

module.exports = SoundManager.getInstance();


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;



/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, RealityManager, eventManager, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

eventManager = __webpack_require__(3);

log = __webpack_require__(0);

RealityManager = (function(_super) {
  __extends(RealityManager, _super);

  RealityManager.prototype.name = 'RealityManager';

  RealityManager.prototype.elapsed = 0;

  RealityManager.prototype.started = false;

  RealityManager.prototype.startTime = null;

  RealityManager.prototype.needsToShowRealityCheck = false;

  RealityManager.prototype.allowedToShowRealityCheck = false;

  function RealityManager() {
    log.info(this.constructor.name, 'constructor');
    RealityManager.__super__.constructor.call(this);
  }

  RealityManager.prototype.setCheckIntveral = function(ms) {
    return this.intervalInMs = ms;
  };

  RealityManager.prototype.start = function(ms) {
    if (this.started) {
      return;
    }
    if (ms != null) {
      this.setCheckIntveral(ms);
    }
    log.info(this.constructor.name, 'start');
    this.started = true;
    this.startTime = new Date().getTime();
    this.lastTime = this.startTime;
    return this.loopInterval();
  };

  RealityManager.prototype.loopInterval = function() {
    log.info(this.name, 'realityCheck new loop', this.intervalInMs);
    window.setInterval((function(_this) {
      return function() {
        _this.currentTime = new Date().getTime();
        _this.elapsed = _this.currentTime - _this.lastTime;
        if (_this.elapsed > _this.intervalInMs) {
          log.info(_this.name, 'realityCheck Fired', _this.elapsed);
          _this.lastTime = new Date().getTime();
          return _this.tryToShowRealityCheck();
        }
      };
    })(this), 10000);
    return true;
  };

  RealityManager.prototype.canShowRealityCheck = function(allowedToShowRealityCheck) {
    this.allowedToShowRealityCheck = allowedToShowRealityCheck;
    if (this.allowedToShowRealityCheck && this.needsToShowRealityCheck) {
      this.displayRealityCheck();
      return true;
    }
    return false;
  };

  RealityManager.prototype.tryToShowRealityCheck = function() {
    if (!this.allowedToShowRealityCheck) {
      this.needsToShowRealityCheck = true;
      return;
    }
    return this.displayRealityCheck();
  };

  RealityManager.prototype.displayRealityCheck = function() {
    var duration, msg, now, timeObj, xHours, xMins;
    this.needsToShowRealityCheck = false;
    now = new Date().getTime();
    duration = now - this.startTime;
    timeObj = this.msToTime(duration);
    xHours = __t.str("%{smart_count} hours", {
      smart_count: timeObj.hours
    });
    xMins = __t.str("%{smart_count} mins", {
      smart_count: timeObj.minutes
    });
    msg = __t.str("You have been playing for %{xHours} and %{xMins}", {
      xHours: xHours,
      xMins: xMins
    });
    return eventManager.trigger('reality', msg);
  };

  RealityManager.prototype.msToTime = function(milli) {
    var hours, mins, res;
    hours = parseInt(milli / (1000 * 60 * 60));
    mins = Math.round(milli / 1000 / 60) % 60;
    res = {
      hours: hours,
      minutes: mins
    };
    return res;
  };

  return RealityManager;

})(BaseManager);

module.exports = RealityManager.getInstance();


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var BaseButton, eventManager, gameModel, imageManager, soundManager,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

imageManager = __webpack_require__(4);

soundManager = __webpack_require__(8);

eventManager = __webpack_require__(3);

gameModel = __webpack_require__(2);

BaseButton = (function(_super) {
  __extends(BaseButton, _super);

  BaseButton.prototype.tag = 'button';

  BaseButton.prototype.text = 'Click';

  BaseButton.prototype.isEnabled = true;

  BaseButton.prototype.interactive = true;

  BaseButton.prototype.buttonMode = true;

  BaseButton.prototype.action = null;

  BaseButton.prototype.remainActive = false;

  BaseButton.prototype.w = 288;

  BaseButton.prototype.h = 42;

  BaseButton.prototype.style = {
    fontSize: 16,
    fontWeight: 400,
    fill: "#FFFFFF",
    align: "center",
    lineHeight: 22
  };

  function BaseButton(options) {
    this.options = options;
    BaseButton.__super__.constructor.call(this);
    if (options.width != null) {
      this.w = options.width;
    }
    if (options.height != null) {
      this.h = options.height;
    }
    this.text = options.text;
    this.style.fontFamily = gameModel.getFont();
    if (options.action != null) {
      this.action = options.action;
    }
    if (options.remainActive != null) {
      this.remainActive = options.remainActive;
    }
    this.setupImage(options);
    if (((options != null ? options.type : void 0) == null) || options.type !== 'menu') {
      this.addTextLabel();
    }
    if (options.toggleState != null) {
      if (options.toggleState) {
        this.setOn();
      } else {
        this.setOff();
      }
    }
  }

  BaseButton.prototype.setupImage = function(options) {
    this.enable();
    this.removeChildren();
    if (((options != null ? options.type : void 0) != null) && options.type !== 'menu') {
      options.buttonImage = new PIXI.Texture.fromImage(options.buttonImage);
      options.buttonHoverImage = new PIXI.Texture.fromImage(options.buttonHoverImage);
    }
    this.normalBg = new PIXI.Sprite(options.buttonImage);
    this.addChild(this.normalBg);
    this.w = this.normalBg.width;
    this.h = this.normalBg.height;
    if ((options != null ? options.tint : void 0) != null) {
      return;
    }
    this.downBg = new PIXI.Sprite(options.buttonHoverImage);
    this.downBg.visible = false;
    this.addChild(this.downBg);
    this.hoverBg = new PIXI.Sprite(options.buttonHoverImage);
    this.hoverBg.visible = false;
    return this.addChild(this.hoverBg);
  };

  BaseButton.prototype.addTextLabel = function() {
    var position;
    this.textLabel = new PIXI.Text(this.text, this.style);
    position = {
      x: Math.floor((this.w - this.textLabel.width) / 2),
      y: Math.floor((this.h - this.textLabel.height) / 2)
    };
    this.textLabel.position = position;
    this.textLabel.resolution = __dpi;
    this.textLabel.updateText();
    return this.addChild(this.textLabel);
  };

  BaseButton.prototype.addShadow = function() {
    var blurFilter, shadow;
    shadow = new PIXI.Graphics();
    shadow.beginFill(0x000000);
    shadow.drawRoundedRect(0, 2, this.w, this.h, this.cornerRadius + 3);
    shadow.endFill();
    shadow.alpha = 0.3;
    this.addChild(shadow);
    blurFilter = new PIXI.filters.BlurFilter();
    blurFilter.blur = 1;
    return shadow.filters = [blurFilter];
  };

  BaseButton.prototype.updateText = function(text) {
    this.textLabel.text = text;
    this.textLabel.position = {
      x: Math.floor((this.w - this.textLabel.width) / 2),
      y: Math.floor((this.h - this.textLabel.height) / 2)
    };
    return this.reset();
  };

  BaseButton.prototype.mousedown = function(e) {
    var _ref;
    if (!this.isEnabled) {
      return;
    }
    e.stopPropagation();
    if (((_ref = this.options) != null ? _ref.tint : void 0) != null) {
      this.normalBg.tint = this.options.tint;
      return;
    }
    this.hoverBg.visible = false;
    this.normalBg.visible = false;
    return this.downBg.visible = true;
  };

  BaseButton.prototype.mouseover = function(e) {
    var _ref;
    if (!this.isEnabled) {
      return;
    }
    if (this.hovered != null) {
      this.hovered();
    }
    if (((_ref = this.options) != null ? _ref.tint : void 0) != null) {
      this.normalBg.tint = this.options.tint;
      return;
    }
    this.hoverBg.visible = true;
    this.normalBg.visible = false;
    return this.downBg.visible = false;
  };

  BaseButton.prototype.mouseout = function(e) {
    return this.reset();
  };

  BaseButton.prototype.mouseup = function(e) {
    if (!this.isEnabled) {
      return;
    }
    this.reset();
    return this._tapped(e);
  };

  BaseButton.prototype.mouseupoutside = function(e) {
    return this.reset();
  };

  BaseButton.prototype.touchstart = function(e) {
    var _ref;
    if (!this.isEnabled) {
      return;
    }
    e.data.originalEvent.preventDefault();
    if (((_ref = this.options) != null ? _ref.tint : void 0) != null) {
      this.normalBg.tint = this.options.tint;
      return;
    }
    this.hoverBg.visible = true;
    this.normalBg.visible = false;
    return this.downBg.visible = false;
  };

  BaseButton.prototype.touchend = function(e) {
    e.data.originalEvent.preventDefault();
    this.reset();
    return this._tapped(e);
  };

  BaseButton.prototype.touchendoutside = function(e) {
    return this.reset();
  };

  BaseButton.prototype.reset = function() {
    var _ref;
    if (((_ref = this.options) != null ? _ref.tint : void 0) != null) {
      if (this.normalBg != null) {
        this.normalBg.tint = 0xFFFFFF;
      }
      return;
    }
    if (this.hoverBg != null) {
      this.hoverBg.visible = false;
    }
    if (this.normalBg != null) {
      this.normalBg.visible = true;
    }
    if (this.downBg != null) {
      return this.downBg.visible = false;
    }
  };

  BaseButton.prototype.enable = function() {
    this.reset();
    this.interactive = true;
    this.buttonMode = true;
    this.alpha = 1;
    return this.isEnabled = true;
  };

  BaseButton.prototype.disable = function() {
    this.reset();
    this.interactive = false;
    this.buttonMode = false;
    this.alpha = 0.5;
    return this.isEnabled = false;
  };

  BaseButton.prototype._tapped = function(e) {
    if (this.tapped != null) {
      this.tapped(e);
      soundManager.click();
    } else if (this.action != null) {
      eventManager.trigger(this.action);
      soundManager.click();
    } else {
      console.error('Button has no Action');
    }
    if (this.options.type === 'primary' && !this.remainActive) {
      return this.disable();
    }
  };

  BaseButton.prototype.setOn = function() {
    var _ref;
    this.state = true;
    this.normalBg.texture = this.options.buttonImage;
    if (((_ref = this.options) != null ? _ref.tint : void 0) != null) {
      return;
    }
    this.downBg.texture = this.options.buttonHoverImage;
    return this.hoverBg.texture = this.options.buttonHoverImage;
  };

  BaseButton.prototype.setOff = function() {
    var _ref;
    this.state = false;
    this.normalBg.texture = this.options.buttonOffImage;
    if (((_ref = this.options) != null ? _ref.tint : void 0) != null) {
      return;
    }
    this.downBg.texture = this.options.buttonOffHoverImage;
    return this.hoverBg.texture = this.options.buttonOffHoverImage;
  };

  BaseButton.prototype.toggleState = function() {
    if (this.state) {
      this.setOff();
    } else {
      this.setOn();
    }
    return this.state;
  };

  return BaseButton;

})(PIXI.Container);

module.exports = BaseButton;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, TrackingManager, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

BaseManager = __webpack_require__(1);

TrackingManager = (function(_super) {
  __extends(TrackingManager, _super);

  function TrackingManager() {
    return TrackingManager.__super__.constructor.apply(this, arguments);
  }

  TrackingManager.prototype.name = "TrackingManager";

  TrackingManager.prototype.logging = false;

  TrackingManager.prototype.setup = function(gameCode) {
    log.info(this.name, "setup", gameCode);
    this.gameCode = gameCode;
    return this.jsErrors();
  };

  TrackingManager.prototype.trackPage = function(route, title) {
    if (title == null) {
      title = null;
    }
    if (this.logging) {
      log.info(this.name, 'trackPage', title);
    }
    if (window.ga == null) {
      return;
    }
    return window.ga("send", {
      hitType: "pageview",
      title: "" + title,
      page: "" + route
    });
  };

  TrackingManager.prototype.trackEvent = function(label, category, action, count) {
    if (category == null) {
      category = 'button';
    }
    if (action == null) {
      action = 'click';
    }
    if (count == null) {
      count = 0;
    }
    if (this.logging) {
      log.info(this.name, 'trackEvent', label, action, category, count);
    }
    if (window.ga == null) {
      return;
    }
    return window.ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: count
    });
  };

  TrackingManager.prototype.trackException = function(desc, fatal) {
    if (fatal == null) {
      fatal = false;
    }
    if (this.logging) {
      log.info(this.name, 'trackException', desc, fatal);
    }
    if (window.ga == null) {
      return;
    }
    return window.ga('send', 'exception', {
      exDescription: desc,
      exFatal: fatal,
      appName: this.gameCode,
      appVersion: window.__version
    });
  };

  TrackingManager.prototype.jsErrors = function() {
    return window.addEventListener('error', (function(_this) {
      return function(err) {
        var lineAndColumnInfo, location;
        log.info(_this.name, 'Javascript error');
        lineAndColumnInfo = err.colno ? ' line:' + err.lineno + ', column:' + err.colno : ' line:' + err.lineno;
        location = err.filename + lineAndColumnInfo + ' -> ' + navigator.userAgent;
        _this.trackEvent('JavaScript Error', err.message, location);
        return _this.trackException('JSERROR - ' + err.message);
      };
    })(this));
  };

  return TrackingManager;

})(BaseManager);

module.exports = TrackingManager.getInstance();


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/logo-title@2x.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, DeviceManager, eventManager, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

eventManager = __webpack_require__(3);

log = __webpack_require__(0);

DeviceManager = (function(_super) {
  __extends(DeviceManager, _super);

  DeviceManager.prototype.name = 'DeviceManager';

  DeviceManager.prototype.triedFullscreen = false;

  DeviceManager.prototype.resizeThrottling = 40;

  function DeviceManager() {
    log.info(this.name, 'constructor');
    window.__dpi = this.getDpi();
    window.__isHttps = this.isHttps();
    window.__isTouch = this.isTouchscreen();
    this._pageVisibility();
    this._resize();
  }

  DeviceManager.prototype.isHttps = function() {
    return window.location.protocol === "https:";
  };

  DeviceManager.prototype.isInIframe = function() {
    return self !== top;
  };

  DeviceManager.prototype.whichIE = function() {
    var myNav;
    myNav = navigator.userAgent.toLowerCase();
    if (myNav.indexOf('msie') !== -1) {
      return parseInt(myNav.split('msie')[1]);
    } else {
      return false;
    }
  };

  DeviceManager.prototype.isWebkit = function() {
    var isWebkit;
    isWebkit = /WebKit/.test(navigator.userAgent);
    return isWebkit;
  };

  DeviceManager.prototype.isIOS = function() {
    var iOS;
    iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return iOS;
  };

  DeviceManager.prototype.isTouchscreen = function() {
    return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  };

  DeviceManager.prototype.isRetina = function() {
    return this.getDpi() > 1;
  };

  DeviceManager.prototype.getDpi = function() {
    var dpi, vp;
    vp = this.getViewport();
    if (vp.w > 900 || vp.h > 518) {
      return 2;
    }
    dpi = Math.floor(window.devicePixelRatio);
    if (dpi > 2) {
      return 2;
    }
    return dpi;
  };

  DeviceManager.prototype.isLandscape = function() {
    var h, isLandscape, v, w;
    v = this.getViewport();
    w = v.w;
    h = v.h;
    isLandscape = false;
    if (w > h) {
      isLandscape = true;
    }
    return isLandscape;
  };

  DeviceManager.prototype.getViewport = function() {
    var vp;
    vp = {
      w: Math.floor(document.documentElement.clientWidth, window.innerWidth || 0),
      h: Math.floor(document.documentElement.clientHeight, window.innerHeight || 0)
    };
    return vp;
  };

  DeviceManager.prototype.getWrapperDimensions = function() {
    var vp, wd, wrapper;
    wrapper = document.getElementById('wrapper');
    vp = this.getViewport();
    wd = {
      w: vp.w - 20,
      h: vp.h - 20
    };
    return wd;
  };

  DeviceManager.prototype.viewportSize = function() {
    var dims, test;
    test = document.createElement("div");
    test.style.cssText = "position: fixed;top: 0;left: 0;bottom: 0;right: 0;";
    document.documentElement.insertBefore(test, document.documentElement.firstChild);
    dims = {
      width: test.offsetWidth,
      height: test.offsetHeight
    };
    document.documentElement.removeChild(test);
    return dims;
  };

  DeviceManager.prototype._resize = function() {
    var triggerResize;
    triggerResize = (function(_this) {
      return function() {
        var lazyLayout;
        lazyLayout = UTIL.debounce((function() {
          return eventManager.trigger('page-resize');
        }), _this.resizeThrottling);
        return lazyLayout();
      };
    })(this);
    return window.addEventListener('resize', triggerResize);
  };

  DeviceManager.prototype._pageVisibility = function() {
    var handleVisibilityChange, hidden, visibilityChange;
    hidden = void 0;
    visibilityChange = void 0;
    handleVisibilityChange = function() {
      if (document[hidden]) {
        return eventManager.trigger('page-hide');
      } else {
        return eventManager.trigger('page-show');
      }
    };
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document.mozHidden !== 'undefined') {
      hidden = 'mozHidden';
      visibilityChange = 'mozvisibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }
    return document.addEventListener(visibilityChange, handleVisibilityChange, false);
  };

  return DeviceManager;

})(BaseManager);

module.exports = DeviceManager.getInstance();


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, LayoutManager, gameModel, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

gameModel = __webpack_require__(2);

log = __webpack_require__(0);

LayoutManager = (function(_super) {
  __extends(LayoutManager, _super);

  function LayoutManager() {
    return LayoutManager.__super__.constructor.apply(this, arguments);
  }

  LayoutManager.prototype.name = 'LayoutManager';

  LayoutManager.prototype.offset = 116;

  LayoutManager.prototype.padding = 56;

  LayoutManager.prototype.placeButton = function(button) {
    var x, y;
    if (button == null) {
      return;
    }
    x = Math.round((gameModel.gameWidth - button.width) / 2);
    y = Math.round((gameModel.rendererHeight - this.offset) - (this.padding * button.order));
    button.x = x;
    return button.y = y;
  };

  LayoutManager.prototype.repositionY = function(button) {
    var y;
    if (button == null) {
      return;
    }
    y = Math.round((gameModel.rendererHeight - this.offset) - (this.padding * button.order));
    return button.y = y;
  };

  return LayoutManager;

})(BaseManager);

module.exports = LayoutManager.getInstance();


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




/**
 * Crossplatform Date.now()
 *
 * @return {Number} time in ms
 * @api private
 */
module.exports = Date.now || function() {
    return (new Date).getTime()
}



/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/


var implementation = __webpack_require__(224);

module.exports = Function.prototype.bind || implementation;



/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, LoadingManager, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

BaseManager = __webpack_require__(1);

LoadingManager = (function(_super) {
  __extends(LoadingManager, _super);

  LoadingManager.prototype.name = 'LoadingManager';

  LoadingManager.prototype.debug = false;

  LoadingManager.prototype.hasStarted = false;

  LoadingManager.prototype.container = null;

  LoadingManager.prototype.bar = null;

  LoadingManager.prototype.bg = null;

  LoadingManager.prototype.label = null;

  LoadingManager.prototype.percent = 0;

  LoadingManager.prototype.queue = [];

  LoadingManager.prototype.isProcessingQueue = false;

  LoadingManager.prototype.doneDelay = 3000;

  LoadingManager.prototype.incDelay = 20;

  function LoadingManager() {
    if (this.debug) {
      log.info(this.name, 'constructor');
    }
  }

  LoadingManager.prototype.start = function() {
    if (this.container == null) {
      this.container = document.getElementById('progress-container');
      this.bg = document.createElement("div");
      this.bg.id = 'progress-bg';
      this.container.appendChild(this.bg);
      this.bar = document.createElement("div");
      this.bar.id = 'progress-bar';
      this.bg.appendChild(this.bar);
      this.label = document.createElement("p");
      this.label.id = 'progress-percent';
      this.label.innerHTML = "" + this.percent + "%";
      this.container.appendChild(this.label);
    }
    this.bar.style.display = 'block';
    return this.hasStarted = true;
  };

  LoadingManager.prototype.done = function() {
    setTimeout((function(_this) {
      return function() {
        _this.percent = 0;
        _this.bar.style.display = 'none';
        _this.bar.style.width = "" + _this.percent + "%";
        return _this.label.innerHTML = "" + _this.percent + "%";
      };
    })(this), this.doneDelay);
    return this.hasStarted = false;
  };

  LoadingManager.prototype.set = function(amount) {
    if (!this.hasStarted) {
      return;
    }
    this.queue.push(amount);
    if (!this.isProcessingQueue) {
      return this.processQueue();
    }
  };

  LoadingManager.prototype.processQueue = function() {
    var amount;
    if (this.queue.length === 0) {
      this.isProcessingQueue = false;
      return;
    }
    this.isProcessingQueue = true;
    amount = this.queue.shift();
    this.percent = amount * 100;
    if (this.debug) {
      log.info(this.name, 'percent', this.percent);
    }
    return this.queueTimer = setTimeout((function(_this) {
      return function() {
        if (_this.percent >= 100) {
          _this.percent = 100;
        }
        _this.bar.style.width = "" + _this.percent + "%";
        _this.label.innerHTML = "" + (Math.round(_this.percent)) + "%";
        if (_this.queue.length === 0) {
          if (_this.percent === 100) {
            if (_this.onComplete != null) {
              _this.onComplete();
            }
          }
        }
        return _this.processQueue();
      };
    })(this), this.incDelay);
  };

  LoadingManager.prototype.increment = function() {
    return this.set(this.percent + (0.1 * this.percent));
  };

  LoadingManager.prototype.hideInitialLoader = function() {
    var ele;
    if (this.debug) {
      log.info(this.name, 'hideInitialLoader');
    }
    this.done();
    this.queue = [];
    clearTimeout(this.queueTimer);
    ele = document.getElementById('initial-loader');
    ele.style.opacity = 0;
    ele.style.display = 'none';
    return setTimeout(function() {
      return ele.parentNode.removeChild(ele);
    }, 1000);
  };

  return LoadingManager;

})(BaseManager);

module.exports = LoadingManager.getInstance();


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, NetworkManager, loglevel,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

loglevel = __webpack_require__(0);

NetworkManager = (function(_super) {
  __extends(NetworkManager, _super);

  function NetworkManager() {
    return NetworkManager.__super__.constructor.apply(this, arguments);
  }

  NetworkManager.prototype.name = 'NetworkManager';

  NetworkManager.prototype.getJSON = function(path, callback) {
    var request;
    path = path + "?v=" + window.__version;
    request = new XMLHttpRequest();
    request.open('GET', path, true);
    request.timeout = 120000;
    request.onload = function() {
      var data;
      if (request.status >= 200 && request.status < 400) {
        data = JSON.parse(request.responseText);
      } else {
        callback(null, 'FAIL', request.status);
        return;
      }
      return callback(data, null, request.status);
    };
    request.onerror = function(err) {
      return callback(null, err, request.status);
    };
    request.ontimeout = function() {
      return callback(null, 'timeout', request.status);
    };
    return request.send();
  };

  return NetworkManager;

})(BaseManager);

module.exports = NetworkManager.getInstance();


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

var BaseModel;

BaseModel = (function() {
  BaseModel.prototype.subModels = {};

  function BaseModel(obj) {
    if (obj != null) {
      this.inject(obj);
    }
  }

  BaseModel.prototype.inject = function(obj) {
    var Klass, key, model, value;
    for (key in obj) {
      value = obj[key];
      if (this.subModels[key] != null) {
        Klass = this.subModels[key];
        model = new Klass(value);
        this.set(key, model);
      } else {
        this.set(key, value);
      }
    }
  };

  BaseModel.prototype.get = function(key) {
    if (this[key] == null) {
      return null;
    }
    return this[key];
  };

  BaseModel.prototype.set = function(key, value) {
    key = key.charAt(0).toLowerCase() + key.slice(1);
    return this[key] = value;
  };

  return BaseModel;

})();

module.exports = BaseModel;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var ScratchArea, SingleScratchView, TweenBezier, TweenMax, currencyManager, eventManager, gameModel, imageManager, imageModel, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

TweenMax = __webpack_require__(5);

TweenBezier = __webpack_require__(226);

imageManager = __webpack_require__(4);

eventManager = __webpack_require__(3);

currencyManager = __webpack_require__(7);

ScratchArea = __webpack_require__(59);

gameModel = __webpack_require__(2);

imageModel = __webpack_require__(6);

log = __webpack_require__(0);

SingleScratchView = (function(_super) {
  __extends(SingleScratchView, _super);

  SingleScratchView.prototype.name = 'SingleScratchView';

  SingleScratchView.prototype.el = '#canvas-container';

  SingleScratchView.prototype.dpi = __dpi;

  SingleScratchView.prototype.gameOver = false;

  SingleScratchView.prototype.prizes = [];

  SingleScratchView.prototype.tweens = [];

  SingleScratchView.prototype.pulseSpeed = 10;

  SingleScratchView.prototype.lostAlpha = 0.4;

  SingleScratchView.prototype.hintDelay = 5000;

  SingleScratchView.prototype.prizesStartingZ = 1;

  SingleScratchView.prototype.numberOfMatchesToWin = 3;

  SingleScratchView.prototype.scratchedWinningCount = 0;

  SingleScratchView.prototype.padding = 20;

  SingleScratchView.prototype.initSin = 0;

  SingleScratchView.prototype.pulseSpeed = 0.05;

  SingleScratchView.prototype.startRotationSpeed = 0.03;

  SingleScratchView.prototype.colorCodes = ["255-43-6", "255-49-167", "125-71-167", "74-35-251", "255-213-40", "0-252-255", "0-251-128", "19-210-39", "254-253-50", "243-78-255"];

  function SingleScratchView(htmlWidth, htmlHeight, y) {
    this.htmlWidth = htmlWidth;
    this.htmlHeight = htmlHeight;
    log.info(this.name, 'constructor', this.htmlWidth, this.htmlHeight);
    SingleScratchView.__super__.constructor.call(this);
    this.y = y;
  }

  SingleScratchView.prototype.initSetup = function(callback) {
    log.info(this.name, 'initSetup');
    return imageManager.loadImage(imageModel.unscratchedImage, (function(_this) {
      return function(unscratchedImage) {
        _this.unscratchedImage = unscratchedImage;
        _this.w = _this.unscratchedImage.width / __dpi;
        _this.h = _this.unscratchedImage.height / __dpi;
        _this.x = (gameModel.gameWidth - _this.w) / 2;
        return _this.addBackground(_this.w, _this.h, _this.x, function() {
          _this.addScratchCanvas(_this.w, _this.h, false);
          return callback(_this.x, _this.y, _this.w, _this.h);
        });
      };
    })(this));
  };

  SingleScratchView.prototype.setupWithTicket = function(betModel, callback) {
    var ids, isWinner, multiplierId, possibleWinIndex, prizeMatrix, winningPrizeId;
    this.reset();
    this.betModel = betModel;
    prizeMatrix = this.betModel.getMatrix();
    isWinner = this.betModel.isWin();
    winningPrizeId = this.betModel.getWinIndex();
    if (gameModel.hasMultiplier) {
      possibleWinIndex = this.betModel.getWinPossIndex();
      if (possibleWinIndex <= 0) {
        if (!betModel.isWin()) {
          console.log('PPB: index was 0');
          possibleWinIndex = gameModel.getRandomWin();
        } else {
          console.error("PPB: WinPossIndex issue, please report");
          return;
        }
      }
      ids = gameModel.getPrizeForId(possibleWinIndex);
      multiplierId = ids[1];
    }
    this.addScratchCanvas(this.w, this.h, false);
    return this.loadAllImages(prizeMatrix, multiplierId, winningPrizeId, (function(_this) {
      return function() {
        _this.addPrizes(prizeMatrix, winningPrizeId);
        if (gameModel.hasMultiplier) {
          _this.addMultiplier(multiplierId, isWinner, winningPrizeId);
        }
        _this.scratchArea.setupMasks(_this.prizes);
        return callback();
      };
    })(this));
  };

  SingleScratchView.prototype.allowScratching = function(enabled) {
    if (enabled == null) {
      enabled = true;
    }
    this.scratchArea.allowScratching = enabled;
    this.hasUserDismissedHint = false;
    return this.showHint(this.hintDelay);
  };

  SingleScratchView.prototype.loadAllImages = function(matrix, multiplierId, winningPrizeId, callback) {
    var imagesToLoad, json, prizeId, prizeImageId, prizeImg, winningPrizeImageId, _i, _len;
    imagesToLoad = [];
    for (_i = 0, _len = matrix.length; _i < _len; _i++) {
      prizeId = matrix[_i];
      prizeImageId = gameModel.getPrizeImgForId(prizeId);
      prizeImg = imageModel.getUrlForPrize(prizeImageId);
      imagesToLoad.push(prizeImg);
    }
    imagesToLoad.push(imageModel.scratchedImage);
    if (gameModel.hasMultiplier) {
      imagesToLoad.push(imageModel.getUrlForMultiplier(multiplierId));
    }
    if (gameModel.hasPrizeAnimations && winningPrizeId) {
      winningPrizeImageId = gameModel.getPrizeImgForId(winningPrizeId);
      json = imageModel.getWinAnimationForPrizeid(winningPrizeImageId);
      imagesToLoad.push(json);
    }
    if (gameModel.hasMultiAnimations && winningPrizeId) {
      json = imageModel.getMultiAnimationForPrizeid(multiplierId);
      imagesToLoad.push(json);
    }
    return imageManager.loadAssets(imagesToLoad, (function(_this) {
      return function() {
        return callback();
      };
    })(this));
  };

  SingleScratchView.prototype.reset = function() {
    var i, prize;
    eventManager.stopListeningTo('frame', this.updateCallback);
    if (this.prizes != null) {
      i = this.prizes.length;
      while (i--) {
        prize = this.prizes[i];
        prize.removeChildren();
        this.removeChild(prize);
        this.prizes.splice(i, 1);
      }
    }
    this.removeChild(this.multiplierContainer);
    this.prizes = null;
    this.betModel = null;
    this.multiplierContainer = null;
    delete this.prizes;
    delete this.betModel;
    delete this.multiplierContainer;
    this.scratchedWinningCount = 0;
    this.gameOver = false;
    if (this.scratchArea != null) {
      return this.scratchArea.reset();
    }
  };

  SingleScratchView.prototype.cover = function() {
    if (this.scratchArea != null) {
      return this.scratchArea.reset();
    }
  };

  SingleScratchView.prototype.addScratchCanvas = function(w, h, allowScratching) {
    if (this.scratchArea != null) {
      this.scratchArea.reset();
      this.scratchArea.bringToFront();
      return;
    }
    this.scratchArea = new ScratchArea();
    this.scratchArea.game = this;
    this.scratchArea.allowScratching = allowScratching;
    this.scratchArea.render(this.unscratchedImage, w, h, 0, this.y);
    return this.addChild(this.scratchArea);
  };

  SingleScratchView.prototype.addBackground = function(w, h, p, callback) {
    var prizeUrl;
    prizeUrl = imageModel.scratchedImage;
    return imageManager.loadAsset(prizeUrl, (function(_this) {
      return function() {
        _this.tile = new PIXI.Sprite.fromImage(prizeUrl);
        _this.tile.width = w;
        _this.tile.height = h;
        _this.addChild(_this.tile);
        return callback();
      };
    })(this));
  };

  SingleScratchView.prototype.addPrizes = function(matrix, winningPrizeId, callback) {
    var cc, i, point, prizeId, x, y, _i, _len;
    if (matrix == null) {
      return;
    }
    for (i = _i = 0, _len = matrix.length; _i < _len; i = ++_i) {
      prizeId = matrix[i];
      point = gameModel.positions.points[i];
      if (point == null) {
        return;
      }
      x = point.x * this.width;
      y = point.y * this.height;
      cc = this.colorCodes[i];
      this.addAPrize(x, y, prizeId, winningPrizeId, cc, i);
    }
  };

  SingleScratchView.prototype.addAPrize = function(x, y, prizeId, winningPrizeId, colorCode, index) {
    var amount, container, isWinner, numberAmount, prize, prizeFilename, prizeImageId, prizeImg, prizeYOffet, star, style, text, url;
    isWinner = Number(prizeId) === Number(winningPrizeId);
    container = new PIXI.Container();
    container._name = 'prize-container';
    container.prizeId = prizeId;
    container.colorCode = colorCode;
    container.isWinner = isWinner;
    container.prizeIndex = index;
    container.winningPrizeId = winningPrizeId;
    prizeImageId = gameModel.getPrizeImgForId(prizeId);
    prizeYOffet = gameModel.getPrizeYOffetForId(prizeId);
    prizeFilename = gameModel.images.prizes[prizeImageId];
    prizeImg = imageModel.getUrlForPrize(prizeImageId);
    prize = new PIXI.Sprite.fromImage(prizeImg);
    prize.tag = 'prize';
    prize.scale.set(gameModel.prizeScale);
    prize.anchor.set(0.5);
    prize.y = prizeYOffet;
    container.addChild(prize);
    if (isWinner && !gameModel.hasPrizeAnimations) {
      url = imageModel.starImage;
      star = new PIXI.Sprite.fromImage(url);
      star.visible = true;
      star.alpha = 0;
      star.anchor.set(0.5);
      star.tag = 'star';
      star.scale.set(0.75);
      container.addChildAt(star, 0);
    }
    style = gameModel.styles.prize;
    if (gameModel.isMaxPrize(prizeImageId)) {
      style = gameModel.styles.maxPrize;
    }
    numberAmount = gameModel.getPrizeAmount(prizeId);
    text = currencyManager.localize(numberAmount, true, false);
    amount = new PIXI.Text(text, style);
    container.addChild(amount);
    amount.sizeToFit(80, false);
    amount.centerAtPoint(0, gameModel.prizeTextY);
    amount.clarify();
    container.position.x = Math.round(x);
    container.position.y = Math.round(y);
    this.prizes.push(container);
    this.addChildAt(container, this.prizesStartingZ);
    return container;
  };

  SingleScratchView.prototype.addMultiplier = function(multiplierId, isWinner, winningPrizeId) {
    var prize, prizeImg, star, url, x, y;
    this.multiplierContainer = new PIXI.Container();
    this.multiplierContainer._name = 'multiplier-container';
    this.multiplierContainer.multiplierId = multiplierId;
    this.multiplierContainer.isWinner = isWinner;
    this.multiplierContainer.winningPrizeId = winningPrizeId;
    if (isWinner && !gameModel.hasPrizeAnimations) {
      url = imageModel.starImage;
      star = new PIXI.Sprite.fromImage(url);
      star.visible = true;
      star.alpha = 0.1;
      star.anchor.set(0.5);
      star.tag = 'star';
      star.scale.set(0.75);
      this.multiplierContainer.addChildAt(star, 0);
    }
    prizeImg = imageModel.getUrlForMultiplier(multiplierId);
    prize = new PIXI.Sprite.fromImage(prizeImg);
    prize.tag = 'prize';
    prize.scale.set(gameModel.prizeScale);
    prize.anchor.set(0.5);
    this.multiplierContainer.addChild(prize);
    x = gameModel.positions.multiplier.x * this.width;
    y = gameModel.positions.multiplier.y * this.height;
    this.multiplierContainer.position.x = x;
    this.multiplierContainer.position.y = y;
    return this.addChildAt(this.multiplierContainer, this.prizesStartingZ);
  };

  SingleScratchView.prototype.prizeScratched = function(colorCode) {
    var check, prize, _i, _len, _ref;
    check = false;
    _ref = this.prizes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      prize = _ref[_i];
      if (prize.colorCode === colorCode && prize.isWinner) {
        this.scratchedWinningCount++;
        check = true;
        break;
      }
      if (prize.colorCode === colorCode) {
        check = true;
        break;
      }
    }
    if (this.scratchedWinningCount === this.numberOfMatchesToWin) {
      return this.scratchAll();
    }
  };

  SingleScratchView.prototype.beganScratching = function() {
    this.hideHint();
    return this.updateCallback = eventManager.listenTo('frame', (function(_this) {
      return function() {
        return _this.scratchArea.texture.update();
      };
    })(this));
  };

  SingleScratchView.prototype.allScratched = function() {
    var prizes;
    if (this.gameOver) {
      return;
    }
    this.gameOver = true;
    this.scratchArea.texture.update();
    eventManager.stopListeningTo('frame', this.updateCallback);
    this.updateCallback = null;
    if (gameModel.hasPrizeAnimations) {
      prizes = this.animateMovies();
    } else {
      prizes = this.animateStars();
    }
    return this.parent.endGame(prizes);
  };

  SingleScratchView.prototype.animateStars = function() {
    var i, prize, star, winningPrizes;
    winningPrizes = [];
    i = this.prizes.length;
    while (i--) {
      prize = this.prizes[i];
      if (prize.isWinner) {
        star = prize.getByTag('star');
        star.visible = true;
        winningPrizes.push(prize);
      } else {
        TweenMax.to(prize, 300 / 1000, {
          alpha: 0.5
        });
      }
    }
    if (gameModel.hasMultiplier) {
      if (winningPrizes.length > 0) {
        star = this.multiplierContainer.getByTag('star');
        star.visible = true;
        winningPrizes.push(this.multiplierContainer);
      } else {
        TweenMax.to(this.multiplierContainer, 300 / 1000, {
          alpha: 0.5
        });
      }
    }
    this.updateCallback = eventManager.listenTo('frame', (function(_this) {
      return function() {
        var alpha, prizeContainer, sinus, _i, _len, _results;
        sinus = (Math.sin(_this.initSin) * 0.08) + gameModel.prizeScale;
        _this.initSin += 0.12;
        _results = [];
        for (i = _i = 0, _len = winningPrizes.length; _i < _len; i = ++_i) {
          prizeContainer = winningPrizes[i];
          prize = prizeContainer.getByTag('prize');
          star = prizeContainer.getByTag('star');
          star.rotation += _this.startRotationSpeed;
          if (star.visible) {
            alpha = star.alpha + 0.03;
            if (alpha > 1) {
              alpha = 1;
            }
            star.alpha = alpha;
            prize.scale.x = sinus;
            _results.push(prize.scale.y = sinus);
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
    })(this));
    return winningPrizes;
  };

  SingleScratchView.prototype.animateMovies = function() {
    var animatedPrize, i, multiplierId, prize, prizeContainer, prizeId, prizeYOffet, winningPrizes;
    winningPrizes = [];
    i = this.prizes.length;
    while (i--) {
      prizeContainer = this.prizes[i];
      if (prizeContainer.isWinner) {
        prize = prizeContainer.getByTag('prize');
        prizeId = prizeContainer.prizeId;
        prizeYOffet = gameModel.getPrizeYOffetForId(prizeId);
        animatedPrize = this.getWinAnimation(prizeId);
        animatedPrize.animationSpeed = 0.168;
        animatedPrize.anchor.set(0.5);
        animatedPrize.y = prizeYOffet;
        prize.visible = false;
        prizeContainer.addChildAt(animatedPrize, 1);
        animatedPrize.play();
        winningPrizes.push(prizeContainer);
      } else {
        TweenMax.to(prizeContainer, 1, {
          alpha: 0.5
        });
      }
    }
    if (gameModel.hasMultiplier) {
      if (this.multiplierContainer.isWinner) {
        prize = this.multiplierContainer.getByTag('prize');
        multiplierId = this.multiplierContainer.multiplierId;
        animatedPrize = this.getMultiWinAnimation(multiplierId);
        animatedPrize.animationSpeed = 0.168;
        animatedPrize.anchor.set(0.5);
        animatedPrize.y = prizeYOffet;
        prize.visible = false;
        this.multiplierContainer.addChildAt(animatedPrize, 1);
        animatedPrize.play();
        winningPrizes.push(this.multiplierContainer);
      } else {
        TweenMax.to(this.multiplierContainer, 1, {
          alpha: 0.5
        });
      }
    }
    return winningPrizes;
  };

  SingleScratchView.prototype.getWinAnimation = function(prizeId) {
    var prizeImageId, textureArray, winner;
    prizeImageId = gameModel.getPrizeImgForId(prizeId);
    textureArray = imageManager.makeTexturesFromName('prize-' + prizeImageId);
    winner = new PIXI.extras.AnimatedSprite(textureArray, true);
    return winner;
  };

  SingleScratchView.prototype.getMultiWinAnimation = function(multiplierId) {
    var textureArray, winner;
    textureArray = imageManager.makeTexturesFromName('multi-' + multiplierId + 'x');
    winner = new PIXI.extras.AnimatedSprite(textureArray, true);
    return winner;
  };

  SingleScratchView.prototype.scratchAll = function(cb) {
    eventManager.trigger('will-reveal-all');
    return this.scratchArea.clear(true, (function(_this) {
      return function() {
        _this.allScratched();
        if (cb != null) {
          return cb();
        }
      };
    })(this));
  };

  SingleScratchView.prototype.showHint = function(delay) {
    var url;
    if (this.hasUserDismissedHint) {
      this.hideHint();
      return;
    }
    if (this.finger == null) {
      url = imageModel.fingerImg;
      this.finger = new PIXI.Sprite.fromImage(url);
    }
    return this.hintTimer = setTimeout((function(_this) {
      return function() {
        var bezier, offset, speed, to, x;
        if (_this.hasUserDismissedHint) {
          return _this.hideHint();
        }
        _this.addChild(_this.finger);
        _this.finger.x = 120;
        _this.finger.y = 140;
        x = _this.finger.x;
        speed = 1100;
        offset = 50;
        bezier = {
          values: [
            {
              x: x - offset
            }, {
              x: x + offset
            }, {
              x: x
            }
          ],
          type: 'thru',
          curviness: 0,
          timeResolution: 0
        };
        to = {
          bezier: bezier,
          ease: Linear.easeNone
        };
        _this.fingerAnimation = TweenMax.to(_this.finger, speed / 1000, to);
        return _this.showHint(3000);
      };
    })(this), delay);
  };

  SingleScratchView.prototype.hideHint = function() {
    if (this.hintTimer != null) {
      clearTimeout(this.hintTimer);
    }
    this.removeChild(this.finger);
    clearInterval(this.fingerInterval);
    if (this.fingerAnimation != null) {
      this.fingerAnimation.kill();
    }
    this.fingerAnimation = null;
    return this.hasUserDismissedHint = true;
  };

  return SingleScratchView;

})(PIXI.Container);

module.exports = SingleScratchView;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary-hover.png";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary-hover@2x.png";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/button-hover.png";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/button-hover@2x.png";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var keys = __webpack_require__(231);
var foreach = __webpack_require__(223);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;



/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/


module.exports = __webpack_require__(221).Promise;



/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};



/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var bind = __webpack_require__(17);
var ES = __webpack_require__(214);
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};



/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var implementation = __webpack_require__(32);

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};



/***/ }),
/* 34 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
  Array.prototype.sortByKey = function(key) {
    return this.sort(function(a, b) {
      var x, y;
      x = a[key];
      y = b[key];
      if (x < y) {
        return -1;
      } else if (x > y) {
        return 1;
      } else {
        return 0;
      }
    });
  };
  Array.prototype.lastItem = function() {
    return this[this.length - 1];
  };
  return Array.prototype.noDupe = function() {
    var i, k, r, temp;
    temp = {};
    i = 0;
    while (i < this.length) {
      temp[this[i]] = true;
      i++;
    }
    r = [];
    for (k in temp) {
      r.push(k);
    }
    return r;
  };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
  PIXI.DisplayObject.prototype.bringToFront = function() {
    var parent;
    if (this.parent) {
      parent = this.parent;
      parent.removeChild(this);
      parent.addChild(this);
    }
  };
  PIXI.DisplayObject.prototype.zSort = function() {
    var result;
    result = this.children.sort(function(a, b) {
      if (a.z < b.z) {
        return -1;
      }
      if (a.z > b.z) {
        return 1;
      }
      return 0;
    });
    return this.children = result;
  };
  PIXI.DisplayObject.prototype.getByTag = function(tag) {
    var child, objects, _i, _len, _ref, _ref1;
    if ((((_ref = this.children) != null ? _ref.length : void 0) == null) || !this.children.length) {
      return null;
    }
    objects = [];
    _ref1 = this.children;
    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
      child = _ref1[_i];
      if (child.tag === tag) {
        objects.push(child);
      }
    }
    if (objects.length > 1) {
      return objects;
    }
    if (objects.length === 1) {
      return objects[0];
    }
    return null;
  };
  PIXI.DisplayObject.prototype.removeAllChildren = function() {
    while (this.children[0]) {
      this.children[0].removeChildren();
      this.removeChild(this.children[0]);
    }
  };
  PIXI.DisplayObject.prototype.removeSelf = function() {
    return this.parent.removeChild(this);
  };
  PIXI.Container.prototype.centerX = function(width) {
    if (width == null) {
      width = this.parent.width;
    }
    return this.position.x = Math.floor((width - this.width) / 2);
  };
  PIXI.Container.prototype.centerY = function(height) {
    if (height == null) {
      height = this.parent.height;
    }
    return this.position.y = Math.floor((height - this.height) / 2);
  };
  PIXI.Container.prototype.centerAtPoint = function(x, y) {
    this.x = Math.round(x - (this.width / 2)) + 1;
    return this.y = Math.round(y - (this.height / 2));
  };
  PIXI.Text.prototype.clarify = function(dpi) {
    if (dpi == null) {
      dpi = __dpi;
    }
    this.resolution = dpi;
    return this.updateText();
  };
  return PIXI.Text.prototype.sizeToFit = function(width, scaleUp) {
    var change, h, ratio, w;
    if (scaleUp == null) {
      scaleUp = true;
    }
    w = this.width;
    h = this.height;
    while (this.width > width) {
      this.style.fontSize--;
    }
    ratio = this.width / w;
    change = h - this.height * ratio;
    return this.style.lineHeight -= change;
  };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var AnimationFrame, BaseManager, CanvasManager, Stats, Tween, deviceManager, eventManager, gameModel, log, realityManager, trackingManager,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

Tween = __webpack_require__(5);

BaseManager = __webpack_require__(1);

deviceManager = __webpack_require__(14);

eventManager = __webpack_require__(3);

realityManager = __webpack_require__(10);

trackingManager = __webpack_require__(12);

AnimationFrame = __webpack_require__(208);

Stats = __webpack_require__(234);

gameModel = __webpack_require__(2);

CanvasManager = (function(_super) {
  __extends(CanvasManager, _super);

  CanvasManager.prototype.name = 'CanvasManager';

  CanvasManager.prototype.views = [];

  CanvasManager.prototype.overlays = [];

  CanvasManager.prototype.historyStates = [];

  CanvasManager.prototype.transitionSpeed = 300;

  CanvasManager.prototype.parallaxBgOffeset = 150;

  CanvasManager.prototype.isTransitioning = false;

  function CanvasManager() {
    CanvasManager.__super__.constructor.call(this);
    window.onpopstate = (function(_this) {
      return function(e) {
        return _this.popHistory(e);
      };
    })(this);
    eventManager.listenTo('back', (function(_this) {
      return function() {
        return _this.back();
      };
    })(this));
    eventManager.listenTo('force-back', (function(_this) {
      return function() {
        return _this.forceBack();
      };
    })(this));
    window.nc = this;
  }

  CanvasManager.prototype.setup = function(gameBg, bottomBarView, parallax) {
    this.parallaxBgOffeset = parallax;
    this.bottomBarView = bottomBarView;
    return this.gameBg = gameBg;
  };

  CanvasManager.prototype.renderCanvas = function() {
    var animate, animationFrame, h, hasStats, rendererOptions, stats, w;
    log.info(this.name, 'renderCanvas');
    this.canvasContainerEle = document.getElementById('canvas-container');
    this.canvasEle = document.getElementById('canvas');
    rendererOptions = {
      view: this.canvasEle,
      transparent: true,
      autoResize: true,
      antialias: false,
      resolution: __dpi,
      clearBeforeRender: false
    };
    w = gameModel.gameWidth;
    h = gameModel.gameHeight;
    this.renderer = new PIXI.autoDetectRenderer(w, h, rendererOptions);
    this.renderer.backgroundColor = 0xFF66CC;
    window.__renderer = this.renderer;
    this.disableScrolling();
    this.outerStage = new PIXI.Container();
    this.innerStage = new PIXI.Container();
    this.outerStage.addChild(this.innerStage);
    if (gameModel.fps) {
      hasStats = true;
      stats = new Stats();
      stats.domElement.style.position = 'fixed';
      stats.domElement.style.left = '0px';
      stats.domElement.style.top = '0px';
      stats.domElement.id = 'stats-container';
      document.body.appendChild(stats.domElement);
    }
    this.addBackground();
    this.addUiBars();
    animationFrame = new AnimationFrame(60);
    animate = (function(_this) {
      return function() {
        if (hasStats != null) {
          stats.begin();
        }
        _this.renderLoop();
        if (hasStats != null) {
          stats.end();
        }
        return animationFrame.request(animate);
      };
    })(this);
    return animate();
  };

  CanvasManager.prototype.renderLoop = function(time) {
    if (this.freezeGame) {
      return;
    }
    eventManager.trigger('frame', time);
    return this.renderer.render(this.outerStage);
  };

  CanvasManager.prototype.showCanvasEle = function() {
    return this.canvasEle.style.display = 'block';
  };

  CanvasManager.prototype.sizeToFit = function() {
    var gH, gW, h, heightGrowthRatio, ratio, rendererH, rendererW, vp, w, widthGrowthRatio, x, y, _ref;
    if (this.canvasEle == null) {
      return;
    }
    vp = deviceManager.getViewport();
    w = vp.w;
    h = vp.h;
    gW = gameModel.gameWidth;
    gH = gameModel.gameHeight;
    widthGrowthRatio = w / gW;
    heightGrowthRatio = h / gH;
    if (heightGrowthRatio > widthGrowthRatio) {
      rendererW = gW;
      rendererH = Math.round(h * gW / w);
    } else {
      rendererW = Math.round(w * gH / h);
      rendererH = gH;
    }
    this.renderer.resize(rendererW, rendererH);
    this.canvasEle.style.width = w + 'px';
    this.canvasEle.style.height = h + 'px';
    this.canvasContainerEle.style.width = w + 'px';
    this.canvasContainerEle.style.height = h + 'px';
    ratio = w / rendererW;
    gameModel.scaledRatio = ratio;
    gameModel.rendererWidth = rendererW;
    gameModel.rendererHeight = rendererH;
    this.centerBg();
    x = Math.round((rendererW - gW) / 2);
    y = Math.round((rendererH - gH) / 2);
    y = 0;
    this.innerStage.position.set(x, y);
    gameModel.stageX = x;
    gameModel.stageY = y;
    if (this.bottomBarView != null) {
      this.bottomBarView.resize(rendererW, rendererH);
    }
    if (this.topBarView != null) {
      this.topBarView.resize(rendererW, rendererH);
    }
    if (((_ref = this.backgroundView) != null ? _ref.resize : void 0) != null) {
      this.backgroundView.resize(rendererW, rendererH, this.parallaxBgOffeset, this.views.lastItem().name);
    }
    this.rendererWidth = rendererW;
    this.gameWidth = gameModel.gameWidth;
    return this.stageX = x;
  };

  CanvasManager.prototype.addBackground = function() {
    this.gameBg.anchor.set(gameModel.backgroundAnchorX, gameModel.backgroundAnchorY);
    this.outerStage.addChildAt(this.gameBg, 0);
    return this.centerBg();
  };

  CanvasManager.prototype.addUiBars = function() {
    this.outerStage.addChild(this.bottomBarView);
    if (this.topBarView != null) {
      return this.outerStage.addChild(this.topBarView);
    }
  };

  CanvasManager.prototype.bringUiToFront = function() {
    this.bottomBarView.bringToFront();
    if (this.topBarView != null) {
      return this.topBarView.bringToFront();
    }
  };

  CanvasManager.prototype.centerBg = function() {
    if (this.gameBg != null) {
      this.scaleToFill(this.gameBg, this.parallaxBgOffeset);
      return this.gameBg.originalX = this.gameBg.position.x;
    }
  };

  CanvasManager.prototype.addBackgroundView = function(backgroundView, cb) {
    this.backgroundView = backgroundView;
    return this.backgroundView.setup(gameModel.rendererWidth, gameModel.rendererHeight, this.parallaxBgOffeset, (function(_this) {
      return function() {
        _this.outerStage.addChildAt(_this.backgroundView, 1);
        return cb();
      };
    })(this));
  };

  CanvasManager.prototype.scaleToFill = function(sprite, parallaxPadding) {
    var bgAspect, bgH, bgW, rAspect, rH, rW, ratio, ratioH, ratioW, x, y;
    rW = gameModel.rendererWidth + parallaxPadding;
    rH = gameModel.rendererHeight;
    bgW = sprite.texture.width;
    bgH = sprite.texture.height;
    if (gameModel.backgroundAnchorX > 0) {
      rW = rW + (parallaxPadding / gameModel.backgroundAnchorX);
    }
    ratioW = rW / bgW;
    ratioH = rH / bgH;
    rAspect = rW / rH;
    bgAspect = bgW / bgH;
    if (rAspect > bgAspect) {
      ratio = ratioW;
    } else {
      ratio = ratioH;
    }
    x = Math.floor(rW * gameModel.backgroundAnchorX) - ((rW - gameModel.rendererWidth - parallaxPadding) / 2);
    y = Math.floor(rH * gameModel.backgroundAnchorY);
    sprite.scale.set(ratio, ratio);
    return sprite.position.set(x, y);
  };

  CanvasManager.prototype.pushView = function(view) {
    if (this.isViewShowing(view.name)) {
      return;
    }
    this._pushView(view);
    if (this.views.length > 1 && (view.isHTML == null)) {
      if (this.topBarView != null) {
        this.topBarView.showBackButton();
      }
    }
    return this.bringUiToFront();
  };

  CanvasManager.prototype._pushView = function(view) {
    var currentView, isRootView, newX, options;
    log.info(this.name, 'pushView', view.name);
    if (this.isTransitioning) {
      return;
    }
    this.isTransitioning = true;
    if ((view.isHTML != null) && view.isHTML) {
      realityManager.canShowRealityCheck(false);
    }
    isRootView = this.views.length < 1;
    if (view.willShow != null) {
      view.willShow();
    }
    if (!isRootView) {
      this.pushHistory(view.name);
      view.x = this.rendererWidth;
      currentView = this.views.lastItem();
      currentView.interactiveChildren = false;
      if (currentView.willHide != null) {
        currentView.willHide();
      }
    }
    this.innerStage.addChild(view);
    this.views.push(view);
    if (isRootView) {
      if (view.didShow != null) {
        view.didShow();
      }
      this.isTransitioning = false;
      return;
    }
    newX = this.gameBg.position.x - this.parallaxBgOffeset;
    Tween.to(this.gameBg, this.transitionSpeed / 1000, {
      x: newX
    });
    options = {
      x: 0,
      onUpdate: (function(_this) {
        return function() {
          var domX, ratio;
          if (view.showingProgress != null) {
            ratio = view.x / _this.rendererWidth;
            domX = window.innerWidth * ratio;
            return view.showingProgress(domX);
          }
        };
      })(this),
      onComplete: (function(_this) {
        return function() {
          if (view.didShow != null) {
            view.didShow();
          }
          return _this.isTransitioning = false;
        };
      })(this)
    };
    Tween.to(view, this.transitionSpeed / 1000, options);
    options = {
      x: -this.stageX - this.gameWidth,
      onComplete: (function(_this) {
        return function() {
          currentView.renderable = false;
          if (currentView.didHide != null) {
            return currentView.didHide();
          }
        };
      })(this)
    };
    return Tween.to(currentView, this.transitionSpeed / 1000, options);
  };

  CanvasManager.prototype.popView = function() {
    var isRootView, nextView, options, view;
    if (this.isTransitioning || this.views.length < 1) {
      return false;
    }
    this.isTransitioning = true;
    isRootView = this.views.length === 1;
    view = this.views.pop();
    if (view.willHide != null) {
      view.willHide();
    }
    if ((view.isHTML != null) && view.isHTML) {
      realityManager.canShowRealityCheck(true);
    }
    nextView = this.views.lastItem();
    if (nextView != null) {
      if (nextView.willShow != null) {
        nextView.willShow();
      }
      nextView.interactiveChildren = true;
      nextView.renderable = true;
    }
    if (this.views.length === 1) {
      this.rootViewShown();
    }
    if (isRootView) {
      if (view.didHide != null) {
        view.didHide();
      }
      view.removeSelf();
      this.isTransitioning = false;
      return true;
    }
    Tween.to(this.gameBg, this.transitionSpeed / 1000, {
      x: this.gameBg.originalX
    });
    options = {
      x: this.rendererWidth,
      onUpdate: (function(_this) {
        return function(e) {
          var domX, ratio;
          if (view.showingProgress != null) {
            ratio = view.x / _this.rendererWidth;
            domX = window.innerWidth * ratio;
            return view.showingProgress(domX);
          }
        };
      })(this),
      onComplete: (function(_this) {
        return function() {
          if (view.didHide != null) {
            view.didHide();
          }
          return view.removeSelf();
        };
      })(this)
    };
    Tween.to(view, this.transitionSpeed / 1000, options);
    options = {
      x: 0,
      onComplete: (function(_this) {
        return function() {
          if (nextView.didShow != null) {
            nextView.didShow();
          }
          return _this.isTransitioning = false;
        };
      })(this)
    };
    Tween.to(nextView, this.transitionSpeed / 1000, options);
    return true;
  };

  CanvasManager.prototype.popAllViews = function() {
    var view, _i, _len, _ref, _results;
    _ref = this.views;
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      view = _ref[_i];
      if (!this.popView()) {
        break;
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  CanvasManager.prototype.isViewShowing = function(name) {
    var o;
    o = this.views.lastItem();
    if ((o != null ? o.name : void 0) == null) {
      return false;
    }
    return name === o.name;
  };

  CanvasManager.prototype.pushOverlay = function(overlayView) {
    if (this.isOverlayShowing(overlayView.name)) {
      return;
    }
    this._pushOverlay(overlayView);
    return this.bringUiToFront();
  };

  CanvasManager.prototype._pushOverlay = function(overlayView) {
    var currentView;
    eventManager.trigger('showing-overlay');
    log.info(this.name, 'pushOverlay', overlayView.name);
    currentView = this.views.lastItem();
    if (currentView != null) {
      currentView.interactiveChildren = false;
    }
    this.outerStage.addChild(overlayView);
    return this.overlays.push(overlayView);
  };

  CanvasManager.prototype.popOverlay = function(suppressEvents) {
    var currentView, isLastOverlay, overlayView, view;
    if (suppressEvents == null) {
      suppressEvents = false;
    }
    if (this.overlays.length < 1) {
      return false;
    }
    isLastOverlay = this.overlays.length === 1;
    view = this.views.lastItem();
    if (isLastOverlay) {
      if (view.willShow != null) {
        view.willShow();
      }
    }
    overlayView = this.overlays.pop();
    if (!suppressEvents) {
      eventManager.trigger('hiding-overlay');
    }
    currentView = this.views.lastItem();
    clearTimeout(this.overlayTimer);
    currentView.interactiveChildren = true;
    currentView.filters = null;
    log.info(this.name, 'popOverlay', overlayView.name);
    overlayView.hide((function(_this) {
      return function() {
        _this.outerStage.removeChild(overlayView);
        if (isLastOverlay) {
          if (view.didShow != null) {
            return view.didShow();
          }
        }
      };
    })(this));
    return true;
  };

  CanvasManager.prototype.popAllOverlays = function(suppressEvents) {
    var overlay, _i, _len, _ref, _results;
    _ref = this.overlays;
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      overlay = _ref[_i];
      if (!this.popOverlay(suppressEvents)) {
        break;
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  CanvasManager.prototype.isOverlayShowing = function(name) {
    var o;
    o = this.overlays.lastItem();
    if ((o != null ? o.name : void 0) == null) {
      return false;
    }
    return name === o.name;
  };

  CanvasManager.prototype.pushInitHistory = function(view) {
    this.historyStates.push(view);
    return history.pushState(this.historyStates, "sub-menu", null);
  };

  CanvasManager.prototype.pushHistory = function(view) {
    this.historyStates.push(view);
    return history.replaceState(this.historyStates, "sub-menu", null);
  };

  CanvasManager.prototype.popHistory = function(e) {
    var state;
    if (this.historyStates.length > 1) {
      state = this.historyStates.pop();
      window.history.pushState(this.historyStates, "sub-menu", null);
      this.popView();
      return;
    }
    return window.history.back();
  };

  CanvasManager.prototype.back = function() {
    return this.popHistory();
  };

  CanvasManager.prototype.forceBack = function() {
    this.historyStates = [];
    return window.history.back();
  };

  CanvasManager.prototype.rootViewShown = function() {
    if (this.topBarView != null) {
      return this.topBarView.hideBackButton();
    }
  };

  CanvasManager.prototype.spacebarHit = function(evt) {
    var overlay, view;
    if (this.isTransitioning) {
      return;
    }
    trackingManager.trackEvent('SpaceBar', 'button', 'space');
    evt.preventDefault();
    overlay = this.overlays.lastItem();
    view = this.views.lastItem();
    if ((overlay != null ? overlay.spacebarHit : void 0) != null) {
      return overlay.spacebarHit(evt);
    } else if ((view != null ? view.spacebarHit : void 0) != null) {
      return view.spacebarHit(evt);
    }
  };

  CanvasManager.prototype.enableUserActions = function() {
    return document.onkeydown = (function(_this) {
      return function(evt) {
        evt = evt || window.event;
        if (evt.keyCode === 32) {
          _this.spacebarHit(evt);
          return false;
        }
      };
    })(this);
  };

  CanvasManager.prototype.disableUserActions = function() {
    return document.onkeydown = null;
  };

  CanvasManager.prototype.enableScrolling = function() {
    this.renderer.plugins.interaction.autoPreventDefault = false;
    return this.canvasEle.style['touch-action'] = 'pan-y';
  };

  CanvasManager.prototype.disableScrolling = function() {
    this.renderer.plugins.interaction.autoPreventDefault = true;
    return this.canvasEle.style['touch-action'] = 'none';
  };

  CanvasManager.prototype.uploadImagesToGPU = function(names) {
    var name, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = names.length; _i < _len; _i++) {
      name = names[_i];
      _results.push(this.uploadImageToGPU(name));
    }
    return _results;
  };

  CanvasManager.prototype.uploadImageToGPU = function(resourceName) {
    var t;
    return t = new PIXI.Texture.fromImage(resourceName);
  };

  return CanvasManager;

})(BaseManager);

module.exports = CanvasManager.getInstance();


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, FontManager, WebFont, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

WebFont = __webpack_require__(238);

log = __webpack_require__(0);

FontManager = (function(_super) {
  __extends(FontManager, _super);

  function FontManager() {
    return FontManager.__super__.constructor.apply(this, arguments);
  }

  FontManager.prototype.name = 'FontManager';

  FontManager.prototype.debug = true;

  FontManager.prototype.loadFonts = function(names, url, callback) {
    if (this.debug) {
      log.info(this.name, 'loadFonts', names, url);
    }
    if (names == null) {
      return callback(true);
    }
    url = url + '?v=' + window.__version;
    return WebFont.load({
      custom: {
        families: names,
        urls: [url]
      },
      loading: (function(_this) {
        return function() {
          if (_this.debug) {
            return log.info(_this.name, 'loading ' + names);
          }
        };
      })(this),
      active: (function(_this) {
        return function() {
          if (_this.debug) {
            log.info(_this.name, 'success ' + names);
          }
          _this.renderFontOnce(names);
          return callback(true);
        };
      })(this),
      inactive: (function(_this) {
        return function() {
          log.info(_this.name, 'fail ' + names);
          return callback(false);
        };
      })(this)
    });
  };

  FontManager.prototype.renderFontOnce = function(names) {
    var name, nameParts, nameWeight, option, tmp, weight, weights, _i, _j, _k, _len, _len1, _len2, _results;
    tmp = [];
    for (_i = 0, _len = names.length; _i < _len; _i++) {
      name = names[_i];
      nameParts = name.split(':');
      if (nameParts[1] != null) {
        weights = nameParts[1].split(',');
        for (_j = 0, _len1 = weights.length; _j < _len1; _j++) {
          weight = weights[_j];
          tmp.push(nameParts[0] + "|" + weight[1]);
        }
      } else {
        tmp.push(nameParts[0] + "|" + 4);
      }
    }
    _results = [];
    for (_k = 0, _len2 = tmp.length; _k < _len2; _k++) {
      name = tmp[_k];
      nameWeight = name.split('|');
      option = {
        fontFamily: nameWeight[0],
        fontWeight: Number(nameWeight[1] + "00")
      };
      new PIXI.Text('test', option);
      if (this.debug) {
        _results.push(log.info(this.name, 'test', option));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  return FontManager;

})(BaseManager);

module.exports = FontManager.getInstance();


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var BaseManager, LocaleManager, Polyglot, log, networkManager,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseManager = __webpack_require__(1);

networkManager = __webpack_require__(20);

Polyglot = __webpack_require__(230);

log = __webpack_require__(0);

LocaleManager = (function(_super) {
  __extends(LocaleManager, _super);

  LocaleManager.prototype.name = 'LocaleManager';

  LocaleManager.prototype.defaultLanguage = 'en';

  LocaleManager.prototype.hasDefaultLanguage = false;

  function LocaleManager() {
    log.info(this.name, 'constructor');
    this.polyglot = new Polyglot({
      warn: function(m) {
        return console.warn(m);
      }
    });
    window.__t = this;
  }

  LocaleManager.prototype.clearLanguages = function() {
    this.polyglot.clear();
    return this.hasDefaultLanguage = false;
  };

  LocaleManager.prototype.setLanguage = function(languageCode, callback) {
    if (this.hasDefaultLanguage || languageCode === this.defaultLanguage) {
      return this._setLanguage(languageCode, (function(_this) {
        return function(lang, err) {
          _this.hasDefaultLanguage = true;
          if (callback != null) {
            return callback(lang, err);
          }
        };
      })(this));
    } else {
      this.clearLanguages();
      return this._setLanguage(this.defaultLanguage, (function(_this) {
        return function(lang, err) {
          _this.hasDefaultLanguage = true;
          return _this._setLanguage(languageCode, function(lang, err) {
            if (callback != null) {
              return callback(lang, err);
            }
          });
        };
      })(this));
    }
  };

  LocaleManager.prototype._setLanguage = function(languageCode, callback) {
    var baseLangCode;
    baseLangCode = this._getBaseLang(languageCode);
    log.info(this.name, '_setLanguage', baseLangCode);
    return this._getLanguage(baseLangCode, (function(_this) {
      return function(json, err) {
        if (err == null) {
          _this.polyglot.extend(json);
          _this.polyglot.locale(languageCode);
        }
        if (_this._isBaseLang(languageCode)) {
          return callback(languageCode);
        }
        return _this._getLanguage(languageCode, function(json, err) {
          if (err == null) {
            _this.polyglot.extend(json);
            _this.polyglot.locale(languageCode);
          }
          return callback(languageCode);
        });
      };
    })(this));
  };

  LocaleManager.prototype._getLanguage = function(languageCode, callback) {
    var e, path;
    log.info(this.name, '_getLanguage', languageCode);
    try {
      path = __webpack_require__(244)("./" + languageCode + '.json');
    } catch (_error) {
      e = _error;
      return callback();
    }
    return networkManager.getJSON(path, (function(_this) {
      return function(json, err, code) {
        if ((json != null) && (err == null)) {
          if (callback != null) {
            return callback(json, null);
          }
        } else {
          if (callback != null) {
            callback(null, err);
          }
          return console.error('Lang file failed to load: ' + err, code);
        }
      };
    })(this));
  };

  LocaleManager.prototype.str = function(string, vars, comment) {
    if (vars == null) {
      vars = null;
    }
    if (comment == null) {
      comment = null;
    }
    return this.polyglot.t(string, vars);
  };

  LocaleManager.prototype.html = function(template) {
    return template.replace(/'''([^\0]+?)'''/gm, (function(_this) {
      return function(match, key) {
        var localizedString;
        localizedString = _this.str(key);
        return localizedString;
      };
    })(this));
  };

  LocaleManager.prototype._isBaseLang = function(langCode) {
    return langCode.length <= 2;
  };

  LocaleManager.prototype._getBaseLang = function(langCode) {
    return langCode.substr(0, 2);
  };

  return LocaleManager;

})(BaseManager);

module.exports = LocaleManager.getInstance();


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var BaseButton, BottomBarView, Tween, currencyManager, eventManager, gameModel, imageManager, log, soundManager, trackingManager,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

Tween = __webpack_require__(5);

BaseButton = __webpack_require__(11);

eventManager = __webpack_require__(3);

currencyManager = __webpack_require__(7);

imageManager = __webpack_require__(4);

soundManager = __webpack_require__(8);

trackingManager = __webpack_require__(12);

gameModel = __webpack_require__(2);

BottomBarView = (function(_super) {
  __extends(BottomBarView, _super);

  BottomBarView.prototype.w = 360;

  BottomBarView.prototype.h = 45;

  BottomBarView.prototype.bgAlpha = 0.7;

  BottomBarView.prototype.winAmount = 0;

  BottomBarView.prototype.textYOffset = 18;

  BottomBarView.prototype.textGap = 10;

  BottomBarView.prototype.showTickets = false;

  BottomBarView.prototype.buttonYOffset = 0;

  BottomBarView.prototype.buttonXOffset = 46;

  BottomBarView.prototype.infoGroupWidth = 100;

  BottomBarView.prototype.infoContainerXOffset = 160;

  BottomBarView.prototype.interactive = true;

  BottomBarView.prototype.counterTween = null;

  BottomBarView.prototype.labelStyle = {
    fontSize: 9,
    fontWeight: 400,
    fill: '#FFFFFF',
    wordWrap: false,
    lineHeight: 15,
    padding: 2,
    letterSpacing: 2
  };

  BottomBarView.prototype.valueStyle = {
    fontSize: 12,
    fontWeight: 400,
    wordWrap: false,
    lineHeight: 15,
    padding: 2
  };

  function BottomBarView(viewportWidth, viewportHeight) {
    var amount, label, ticketX;
    BottomBarView.__super__.constructor.call(this);
    this.labelStyle.fontFamily = gameModel.getFont();
    this.valueStyle.fontFamily = gameModel.getFont();
    this.valueStyle.fill = gameModel.primaryColor;
    this._setDimension(viewportWidth, viewportHeight);
    this.showTickets = gameModel.isBasketMode();
    this.showHomeButton = gameModel.getHomeUrl() != null;
    this.showHelpButton = gameModel.getHelpUrl() != null;
    this.addBg();
    this.addInfoContainer();
    this.addButtonContainer();
    if (this.showHomeButton) {
      this.addHomeButton(0);
      this.addSettingsButton(45);
      if (this.showHelpButton) {
        this.addHelpButton(90);
      }
    } else {
      this.addSettingsButton(0);
      if (this.showHelpButton) {
        this.addHelpButton(45);
      }
    }
    if (this.showHelpButton) {
      eventManager.listenTo('disable-navigation', (function(_this) {
        return function() {
          return _this.helpButton.disable();
        };
      })(this));
      eventManager.listenTo('enable-navigation', (function(_this) {
        return function() {
          return _this.helpButton.enable();
        };
      })(this));
      eventManager.listenTo('showing-overlay', (function(_this) {
        return function() {
          return _this.helpButton.disable();
        };
      })(this));
      eventManager.listenTo('hiding-overlay', (function(_this) {
        return function() {
          return _this.helpButton.enable();
        };
      })(this));
    }
    ticketX = 0;
    if (!gameModel.getDontShowBalance()) {
      this.addBalance(gameModel.getBalance(), this.infoGroupWidth);
      eventManager.listenTo('balance', (function(_this) {
        return function(amount) {
          return _this.updateBalance(amount);
        };
      })(this));
    } else {
      ticketX = this.infoGroupWidth;
    }
    if (this.showTickets) {
      eventManager.listenTo('tickets', (function(_this) {
        return function(amount) {
          return _this.updateTicketCount(amount);
        };
      })(this));
      label = __t.str('Tickets left').toUpperCase();
      this.addTickets(label, ticketX, gameModel.getRoundsLeft());
      return this;
    }
    if (!gameModel.getDontShowStake()) {
      label = __t.str('Stake').toUpperCase();
      amount = gameModel.getStake();
      amount = currencyManager.localize(amount, false);
      this.addTickets(label, ticketX, amount);
    }
    this;
  }

  BottomBarView.prototype._setDimension = function(viewportWidth, viewportHeight) {
    var y;
    this.w = viewportWidth;
    y = viewportHeight - this.h;
    return this.position.y = y;
  };

  BottomBarView.prototype.addBg = function() {
    this.bg = new PIXI.Graphics();
    this.bg.beginFill(0x000000);
    this.bg.drawRect(0, 0, this.w, this.h);
    this.bg.endFill();
    this.bg.alpha = this.bgAlpha;
    return this.addChildAt(this.bg, 0);
  };

  BottomBarView.prototype.addButtonContainer = function() {
    this.buttonContainer = new PIXI.Container();
    return this.addChild(this.buttonContainer);
  };

  BottomBarView.prototype.addLine = function(x) {
    var graphics;
    x = x + 45;
    graphics = new PIXI.Graphics();
    graphics.lineStyle(1, 0xffffff);
    graphics.moveTo(x, 0);
    graphics.lineTo(x, 45);
    graphics.endFill();
    graphics.alpha = 0.1;
    graphics.cachedAsBitmap = true;
    return this.buttonContainer.addChild(graphics);
  };

  BottomBarView.prototype.addHomeButton = function(x) {
    var options;
    log.info(this.constructor.name, 'addHomeButton');
    if (this.homeButton != null) {
      return;
    }
    options = {
      type: 'menu',
      tint: gameModel.primaryColor,
      buttonImage: imageManager.makeTexturesFromName('btn-home-normal')[0],
      buttonHoverImage: imageManager.makeTexturesFromName('btn-home-hover')[0]
    };
    this.homeButton = new BaseButton(options);
    this.homeButton.tapped = (function(_this) {
      return function(e) {
        return _this.homeButtonClick(e);
      };
    })(this);
    this.homeButton.position.set(x, this.buttonYOffset);
    this.buttonContainer.addChild(this.homeButton);
    return this.addLine(x);
  };

  BottomBarView.prototype.homeButtonClick = function(e) {
    eventManager.trigger('home');
    return e.stopPropagation();
  };

  BottomBarView.prototype.addHelpButton = function(x) {
    var options;
    log.info(this.constructor.name, 'addHelpButton');
    if (this.helpButton != null) {
      return;
    }
    options = {
      type: 'menu',
      tint: gameModel.primaryColor,
      buttonImage: imageManager.makeTexturesFromName('btn-help-normal')[0],
      buttonHoverImage: imageManager.makeTexturesFromName('btn-help-hover')[0]
    };
    this.helpButton = new BaseButton(options);
    this.helpButton.tapped = (function(_this) {
      return function(e) {
        return _this.helpButtonClick(e);
      };
    })(this);
    this.helpButton.position.set(x, this.buttonYOffset);
    this.buttonContainer.addChild(this.helpButton);
    return this.addLine(x);
  };

  BottomBarView.prototype.helpButtonClick = function(e) {
    eventManager.trigger('show-help');
    return e.stopPropagation();
  };

  BottomBarView.prototype.addSettingsButton = function(x) {
    var options;
    if (this.settingsButton != null) {
      return;
    }
    if (false) {
      options = {
        type: 'menu',
        tint: gameModel.primaryColor,
        buttonImage: imageManager.makeTexturesFromName('btn-settings-normal')[0],
        buttonHoverImage: imageManager.makeTexturesFromName('btn-settings-hover')[0]
      };
    } else {
      options = {
        type: 'menu',
        tint: gameModel.primaryColor,
        toggleBtn: true,
        toggleState: !gameModel.getMute(),
        buttonImage: imageManager.makeTexturesFromName('btn-soundon-normal')[0],
        buttonHoverImage: imageManager.makeTexturesFromName('btn-soundon-normal')[0],
        buttonOffImage: imageManager.makeTexturesFromName('btn-soundoff-normal')[0],
        buttonOffHoverImage: imageManager.makeTexturesFromName('btn-soundoff-normal')[0]
      };
    }
    this.settingsButton = new BaseButton(options);
    this.settingsButton.position.set(x, this.buttonYOffset);
    this.buttonContainer.addChild(this.settingsButton);
    this.settingsButton.tapped = (function(_this) {
      return function(e) {
        if (false) {
          return _this.settingsButtonClick(e);
        } else {
          return _this.toggleSoundClick(e);
        }
      };
    })(this);
    return this.addLine(x);
  };

  BottomBarView.prototype.settingsButtonClick = function(e) {
    eventManager.trigger('show-settings');
    return e.stopPropagation();
  };

  BottomBarView.prototype.toggleSoundClick = function(e) {
    var state;
    e.stopPropagation();
    state = this.settingsButton.toggleState();
    return eventManager.trigger('mute');
  };

  BottomBarView.prototype.displaySoundOnButton = function() {
    return this.settingsButton.setOn();
  };

  BottomBarView.prototype.displaySoundOffButton = function() {
    return this.settingsButton.setOff();
  };

  BottomBarView.prototype.addInfoContainer = function() {
    this.infoContainer = new PIXI.Container();
    this.addChild(this.infoContainer);
    return this.infoContainer.x = gameModel.rendererWidth - this.infoContainerXOffset;
  };

  BottomBarView.prototype.addTickets = function(label, x, amount) {
    var y;
    if (amount == null) {
      amount = '';
    }
    y = this.textYOffset;
    if (this.ticketLabel == null) {
      this.ticketLabel = new PIXI.Text(label, this.labelStyle);
    }
    this.infoContainer.addChild(this.ticketLabel);
    this.ticketLabel.centerAtPoint(x, y);
    this.ticketLabel.clarify();
    y = y + this.textGap;
    this.ticketValue = new PIXI.Text("" + amount, this.valueStyle);
    this.infoContainer.addChild(this.ticketValue);
    this.ticketValue.centerAtPoint(x, y);
    return this.ticketValue.clarify();
  };

  BottomBarView.prototype.addBalance = function(amount, x) {
    var y;
    y = this.textYOffset;
    if (this.balanceLabel == null) {
      this.balanceLabel = new PIXI.Text(__t.str('Balance:').toUpperCase(), this.labelStyle);
    }
    this.infoContainer.addChild(this.balanceLabel);
    this.balanceLabel.centerAtPoint(x, y);
    this.balanceLabel.clarify();
    y = y + this.textGap;
    this.balanceValue = new PIXI.Text('', this.valueStyle);
    this.infoContainer.addChild(this.balanceValue);
    this.balanceValue.centerAtPoint(x, y);
    this.balanceValue.centerPoint = {
      x: x,
      y: y
    };
    this.balanceValue.clarify();
    return this.setBalance(amount);
  };

  BottomBarView.prototype.instantFinishBalance = function() {
    if (this.counterTween != null) {
      return this.counterTween.totalProgress(1).kill();
    }
  };

  BottomBarView.prototype.updateBalance = function(newBalance, cb) {
    var animate, balance, currencyMulitplier, diff, max, maxPrize, min, obj, scale, timeLength, to;
    this.instantFinishBalance();
    animate = true;
    if (typeof newBalance === 'object') {
      animate = newBalance.animate;
      newBalance = newBalance.balance;
    }
    if (this.currentBalance >= newBalance || this.currentBalance < 0 || !animate) {
      this.setBalance(newBalance);
      this.centerBalance();
      return;
    }
    diff = newBalance - this.currentBalance;
    currencyMulitplier = gameModel.getCurrencyMultiplier();
    diff = Math.ceil(diff / currencyMulitplier);
    maxPrize = gameModel.getMaxPrize() / currencyMulitplier;
    min = 2;
    max = 15 - min;
    scale = max / Math.log10(maxPrize);
    timeLength = (Math.log(diff) * Math.LOG10E * scale) + min;
    balance = this.currentBalance;
    obj = {
      balance: this.currentBalance
    };
    to = {
      ease: Power3.easeInOut,
      balance: newBalance,
      onUpdate: (function(_this) {
        return function() {
          return _this.setBalance(obj.balance);
        };
      })(this),
      onComplete: (function(_this) {
        return function() {
          _this.centerBalance();
          _this.counterTween = null;
          if (cb != null) {
            return cb();
          }
        };
      })(this)
    };
    return this.counterTween = Tween.to(obj, timeLength, to);
  };

  BottomBarView.prototype.setBalance = function(amount) {
    var newLength, oldLength;
    if (gameModel.getDontShowBalance()) {
      return false;
    }
    if (this.currentBalance === amount) {
      return false;
    }
    this.currentBalance = amount;
    if ((amount == null) || amount < 0) {
      amount = '';
    } else {
      amount = currencyManager.localize(amount, false);
    }
    newLength = amount.length;
    oldLength = this.balanceValue.text.length;
    this.balanceValue.text = amount;
    if (newLength !== oldLength) {
      this.centerBalance();
    }
    return true;
  };

  BottomBarView.prototype.centerBalance = function() {
    var x, y;
    x = this.balanceValue.centerPoint.x;
    y = this.balanceValue.centerPoint.y;
    return this.balanceValue.centerAtPoint(x, y);
  };

  BottomBarView.prototype.updateTicketCount = function(amount) {
    return this.ticketValue.text = "" + amount;
  };

  BottomBarView.prototype.showLastWin = function(amount) {
    var lastWin, x, y;
    amount = currencyManager.localize(amount);
    lastWin = new PIXI.Text(amount, this.lastWinStyle);
    lastWin.alpha = 1;
    x = this.balanceValue.x + (this.balanceValue.width / 2);
    y = this.balanceValue.y - 30;
    lastWin.centerAtPoint(x, y);
    return this.infoContainer.addChild(lastWin);
  };

  BottomBarView.prototype.resize = function(rendererW, rendererH) {
    this._setDimension(rendererW, rendererH);
    this.removeChild(this.bg);
    this.bg = null;
    this.addBg();
    this.infoContainer.x = rendererW - this.infoContainerXOffset;
    return this.infoContainer.bringToFront();
  };

  return BottomBarView;

})(PIXI.Container);

module.exports = BottomBarView;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var BaseButton, GameView, SingleScratchView, Tween, currencyManager, eventManager, gameModel, imageManager, imageModel, layoutManager, log, realityManager, soundManager,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

Tween = __webpack_require__(5);

BaseButton = __webpack_require__(11);

SingleScratchView = __webpack_require__(24);

currencyManager = __webpack_require__(7);

eventManager = __webpack_require__(3);

imageManager = __webpack_require__(4);

layoutManager = __webpack_require__(15);

realityManager = __webpack_require__(10);

soundManager = __webpack_require__(8);

gameModel = __webpack_require__(2);

imageModel = __webpack_require__(6);

GameView = (function(_super) {
  __extends(GameView, _super);

  function GameView() {
    return GameView.__super__.constructor.apply(this, arguments);
  }

  GameView.prototype.name = 'GameView';

  GameView.prototype.gameOver = true;

  GameView.prototype.resultShown = true;

  GameView.prototype.flakeThrottling = 50;

  GameView.prototype.canDropFlakes = true;

  GameView.prototype.isReplay = false;

  GameView.prototype.tweens = [];

  GameView.prototype.timer = null;

  GameView.prototype.realityCheckTimer = null;

  GameView.prototype.canClick = false;

  GameView.prototype.finalPrizeY = 300;

  GameView.prototype.bgWinAlpha = 0.4;

  GameView.prototype.bgLossAlpha = 0;

  GameView.prototype.signYOffset = -200;

  GameView.prototype.ticketStyle = {
    fontFamily: "Courier",
    fontWeight: 100,
    fontSize: 8,
    fill: "#FFFFFF",
    lineHeight: 15
  };

  GameView.prototype.style = {
    fontSize: 22,
    fill: "#FFFFFF",
    align: "center",
    lineHeight: 32,
    dropShadow: true,
    dropShadowBlur: 20,
    dropShadowColor: '#000000',
    dropShadowAngle: Math.PI / 2,
    dropShadowDistance: 1,
    padding: 10
  };

  GameView.prototype.amountStyle = {
    fontSize: 56,
    fontWeight: 700,
    fill: "#FFFFFF",
    align: "center",
    lineHeight: 60
  };

  GameView.prototype.menuStyle = {
    fontWeight: 100,
    fontSize: 12,
    fill: "#FFFFFF",
    lineHeight: 15,
    lineJoin: 'round',
    padding: 10,
    stroke: 'rgba(0,0,0,0.7)',
    strokeThickness: 3
  };

  GameView.prototype.lastWinStyle = {
    fontSize: 12,
    fontWeight: 400,
    wordWrap: false,
    lineHeight: 15,
    padding: 2,
    lineJoin: 'round',
    stroke: 'rgba(0,0,0,0.7)',
    strokeThickness: 3
  };

  GameView.prototype.initSetup = function(cb) {
    log.info(this.constructor.name, 'initSetup');
    eventManager.listenTo('scratching', (function(_this) {
      return function(data) {
        return _this.dropFlakes(data);
      };
    })(this));
    this.style.fontFamily = gameModel.getSecondaryFont();
    this.amountStyle.fontFamily = gameModel.getFont();
    this.amountStyle.fontSize = gameModel.winSignTextMaxFontSize;
    this.menuStyle.fontFamily = gameModel.getFont();
    this.replayStyle = gameModel.styles.introText;
    this.lastWinStyle.fill = gameModel.primaryColor;
    this.titleLossY = gameModel.titleLossY;
    if (gameModel.showLogoInGame) {
      this.addLogo();
    }
    this.addButton();
    this.addScratch(function() {
      if (cb != null) {
        return cb();
      }
    });
    this.addConfetti();
    this.addWinSign();
    this.addLostText();
    if (!gameModel.getShowTicketId()) {
      return;
    }
    this.addTicketText();
  };

  GameView.prototype.resetAfterNotification = function() {
    this.gameOver = true;
    this.resultShown = true;
    return this.enableInteraction();
  };

  GameView.prototype.buttonClick = function() {
    if (!this.canClick) {
      return;
    }
    this.disableInteraction();
    if (this.isReplay) {
      return this.endOfReplayClick();
    }
    if (!this.gameOver) {
      return this.scratchAll();
    }
    if (this.showRealityFirst()) {
      return;
    }
    return this.placeNewBet();
  };

  GameView.prototype.placeNewBet = function() {
    this.skipResultAnimation();
    this.hideResult();
    this.disableInteraction();
    return eventManager.trigger('place-bet');
  };

  GameView.prototype.endOfReplayClick = function() {
    this.showStart();
    this.removeEndOfReplay();
    this.disableInteraction();
    return eventManager.trigger('end-replay');
  };

  GameView.prototype.executeBet = function(betModel, err, code, cb) {
    var ticketId;
    if ((err != null) || (betModel == null)) {
      this.betModel = null;
      return;
    }
    this.betModel = betModel;
    ticketId = this.betModel.getTicketId();
    return this.setupWithTicket(this.betModel, (function(_this) {
      return function() {
        eventManager.trigger('balance', _this.betModel.getBalanceBefore());
        eventManager.trigger('tickets', _this.betModel.getRoundsLeftAfter());
        if (cb != null) {
          return cb();
        }
      };
    })(this));
  };

  GameView.prototype.setupWithTicket = function(betModel, cb, isReplay) {
    this.betModel = betModel;
    this.isReplay = isReplay != null ? isReplay : false;
    this.gameOver = false;
    this.resultShown = false;
    this.lossTitleText.visible = false;
    if (this.menuButton != null) {
      this.menuButton.visible = false;
    }
    this.updateTicktId(this.betModel.getTicketId());
    return this.scratchView.setupWithTicket(this.betModel, (function(_this) {
      return function() {
        if (_this.isReplay) {
          _this.disableInteraction();
          setTimeout(function() {
            return _this.scratchAll();
          }, 1000);
        } else {
          _this.playButton.updateText(__t.str("Scratch all"));
          _this.enableInteraction();
        }
        _this.scratchView.allowScratching();
        return cb();
      };
    })(this));
  };

  GameView.prototype.endGame = function(winningPrizes) {
    var balanceAfter, hasNoTickets, isWinner, prizeId, roundsLeft, ticketId, winAmount;
    log.info(this.constructor.name, 'endGame');
    this.gameOver = true;
    if (this.isReplay) {
      this.playButton.updateText(__t.str('Okay'));
    }
    isWinner = this.betModel.isWin();
    prizeId = this.betModel.getWinIndex();
    ticketId = this.betModel.getTicketId();
    roundsLeft = this.betModel.getRoundsLeftAfter();
    winAmount = this.betModel.getTotalWinAmount();
    balanceAfter = this.betModel.getBalanceAfter();
    hasNoTickets = roundsLeft <= 0 && gameModel.isBasketMode() && !this.betModel.isReplay;
    if (!this.betModel.isReplay) {
      gameModel.setRoundsLeft(roundsLeft);
    }
    eventManager.trigger('balance', balanceAfter);
    eventManager.trigger('end-round', {
      ticketId: ticketId,
      winAmount: winAmount,
      balanceAfter: balanceAfter,
      roundsLeft: roundsLeft
    });
    this.enableInteraction();
    return this.showResult(isWinner, winAmount, ticketId, prizeId, this.betModel.isReplay, hasNoTickets, (function(_this) {
      return function() {
        _this.resultShown = true;
        if (gameModel.isOutOfTickets()) {
          return eventManager.trigger('no-tickets-left');
        }
      };
    })(this));
  };

  GameView.prototype.showLastWin = function(x, y, amount) {
    var finalX, finalY, lastWin, midX, midY, to;
    y = y + gameModel.scratchY;
    amount = currencyManager.localize(amount);
    lastWin = new PIXI.Text(amount, this.lastWinStyle);
    lastWin.alpha = 1;
    lastWin.centerAtPoint(x, y);
    this.addChild(lastWin);
    midX = x + 100;
    midY = y - 100;
    finalX = gameModel.rendererWidth - ((gameModel.rendererWidth - gameModel.gameWidth) / 2) - 50;
    finalY = gameModel.rendererHeight - 40;
    to = {
      bezier: {
        type: "soft",
        values: [
          {
            x: midX,
            y: midY
          }, {
            x: finalX,
            y: finalY
          }
        ]
      },
      ease: Power2.easeIn,
      onComplete: function() {
        return lastWin.removeSelf();
      }
    };
    return Tween.to(lastWin, 1, to);
  };

  GameView.prototype.showResult = function(isWinner, winAmount, ticketId, prizeId, isReplay, hasNoTickets, cb) {
    var key, time;
    if (isReplay) {
      this.playButton.updateText(__t.str("Okay"));
    } else {
      this.playButton.updateText(__t.str("Play again"));
    }
    if (isWinner) {
      key = gameModel.getSoundForPrizeId(prizeId);
      soundManager.win(key);
      time = 1500;
    } else {
      soundManager.loss();
      time = 1;
    }
    return this.timer = setTimeout((function(_this) {
      return function() {
        if (isWinner) {
          _this.updateWinText(winAmount);
          _this.playWinSign(function() {
            eventManager.trigger('won', winAmount);
            realityManager.canShowRealityCheck(true);
            return cb();
          });
          if (prizeId >= gameModel.bigWinStartingPrizeId) {
            soundManager.bigWin();
            _this.playConfetti();
          }
        } else {
          _this.lossTitleText.visible = true;
          _this.lossTitleText.bringToFront();
          _this.realityCheckTimer = setTimeout(function() {
            return realityManager.canShowRealityCheck(true);
          }, time + 1000);
          cb();
        }
        _this.addMenuButton();
        if (isReplay) {
          return _this.addEndOfReplay();
        }
      };
    })(this), time);
  };

  GameView.prototype.hideResult = function() {
    clearTimeout(this.timer);
    if (this.menuButton != null) {
      this.menuButton.visible = false;
    }
    if (this.lossTitleText != null) {
      this.lossTitleText.visible = false;
    }
    if (this.winSignContainer != null) {
      this.winSignContainer.visible = false;
    }
    this.stopConfetti();
    this.stopWinSign();
    this.removeEndOfReplay();
    return this.resultShown = false;
  };

  GameView.prototype.scratchAll = function(cb) {
    log.info(this.constructor.name, 'scratchAll');
    return this.scratchView.scratchAll((function(_this) {
      return function() {
        if (cb != null) {
          return cb();
        }
      };
    })(this));
  };

  GameView.prototype.spacebarHit = function() {
    if (!this.canClick) {
      return;
    }
    return this.buttonClick(false);
  };

  GameView.prototype.skipResultAnimation = function() {
    if (this.resultShown) {
      return;
    }
    if (!this.gameOver) {
      return;
    }
    this.canContinuePlaying();
    if (this.betModel.isWin()) {
      this.showWinResult();
    } else {
      this.showLossResult();
    }
    if (gameModel.isOutOfTickets()) {
      eventManager.trigger('no-tickets-left');
    }
    return delete this.betModel;
  };

  GameView.prototype.showWinResult = function() {
    var t, _i, _len, _ref;
    this.resultShown = true;
    this.stopConfetti();
    this.stopWinSign();
    _ref = this.tweens;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      t = _ref[_i];
      t.kill();
    }
    soundManager.stopBigWin();
    clearTimeout(this.timer);
    clearTimeout(this.realityCheckTimer);
    this.winSignContainer.visible = false;
    this.playButton.updateText(__t.str("Play again"));
    if (this.menuButton != null) {
      this.menuButton.visible = true;
    }
    return this.enableInteraction();
  };

  GameView.prototype.showLossResult = function() {
    this.resultShown = true;
    clearTimeout(this.timer);
    clearTimeout(this.realityCheckTimer);
    this.lossTitleText.visible = true;
    this.playButton.updateText(__t.str("Play again"));
    if (this.menuButton != null) {
      this.menuButton.visible = true;
    }
    return this.enableInteraction();
  };

  GameView.prototype.showStart = function() {
    clearTimeout(this.timer);
    clearTimeout(this.realityCheckTimer);
    this.disableInteraction();
    if (this.scratchView != null) {
      this.scratchView.reset();
    }
    if (this.menuButton != null) {
      this.menuButton.visible = false;
    }
    if (this.lossTitleText != null) {
      this.lossTitleText.visible = false;
    }
    if (this.winSignContainer != null) {
      this.winSignContainer.visible = false;
    }
    this.stopConfetti();
    this.stopWinSign();
    this.removeEndOfReplay();
    if (soundManager.isSetup()) {
      soundManager.stopWin();
      soundManager.stopBigWin();
    }
    return this.resultShown = false;
  };

  GameView.prototype.canContinuePlaying = function() {
    var res;
    res = true;
    if (gameModel.isOutOfTickets() && gameModel.shouldShowBuyMorePopup()) {
      this.disableInteraction();
      res = false;
    }
    return res;
  };

  GameView.prototype.enableInteraction = function() {
    if (gameModel.isOutOfTickets() && !gameModel.shouldShowBuyMoreButton()) {
      return;
    }
    this.canClick = true;
    if (this.playButton != null) {
      this.playButton.enable();
      return this.playButton.visible = true;
    }
  };

  GameView.prototype.disableInteraction = function() {
    this.canClick = false;
    if (this.playButton != null) {
      this.playButton.disable();
      return this.playButton.visible = false;
    }
  };

  GameView.prototype.addLogo = function(cb) {
    var url;
    log.info(this.constructor.name, 'addLogo');
    url = imageModel.logoGameImage;
    return imageManager.loadAsset(url, (function(_this) {
      return function(image) {
        _this.logo = new PIXI.Sprite.fromImage(url);
        _this.logo.x = Math.round((gameModel.gameWidth - _this.logo.width) / 2);
        _this.logo.y = gameModel.logoYInGame;
        _this.addChild(_this.logo);
        if (cb != null) {
          return cb();
        }
      };
    })(this));
  };

  GameView.prototype.addScratch = function(cb) {
    var y;
    log.info(this.constructor.name, 'addScratch');
    y = gameModel.scratchY;
    this.scratchView = new SingleScratchView(gameModel.gameWidth, gameModel.gameHeight, y);
    this.scratchView.initSetup((function(_this) {
      return function(x, y, w, h) {
        _this.scratchView.x = x;
        _this.scratchView.y = y;
        _this.addChild(_this.scratchView);
        return cb();
      };
    })(this));
    return this.scratchView.willClearAfterUserScratchedManually = (function(_this) {
      return function() {
        _this.disableInteraction();
        return eventManager.trigger('will-reveal-all');
      };
    })(this);
  };

  GameView.prototype.addButton = function(cb) {
    var options;
    log.info(this.constructor.name, 'addButton');
    options = {
      text: __t.str('Play again'),
      shadow: true,
      type: 'primary',
      buttonImage: gameModel.hasButtonImage ? imageModel.buttonImage : void 0,
      buttonHoverImage: gameModel.hasButtonImage ? imageModel.buttonHoverImage : void 0
    };
    this.playButton = new BaseButton(options);
    this.playButton.tapped = (function(_this) {
      return function(e) {
        return _this.buttonClick(false);
      };
    })(this);
    this.playButton.order = 0;
    layoutManager.placeButton(this.playButton);
    return this.addChild(this.playButton);
  };

  GameView.prototype.addConfetti = function() {
    var textureArray;
    if (this.confetti != null) {
      return;
    }
    textureArray = imageManager.makeTexturesFromName('confetti');
    this.confetti = new PIXI.extras.AnimatedSprite(textureArray);
    this.confetti.anchor.y = 1;
    this.confetti.y = gameModel.rendererHeight;
    this.confetti.loop = false;
    this.confetti.animationSpeed = 0.40;
    this.confetti.visible = false;
    __renderer.plugins.prepare.upload(this.confetti, (function(_this) {
      return function() {
        return _this.addChild(_this.confetti);
      };
    })(this));
    return this.confetti.onComplete = (function(_this) {
      return function() {
        return _this.stopConfetti();
      };
    })(this);
  };

  GameView.prototype.playConfetti = function() {
    this.confetti.alpha = 1;
    this.confetti.visible = true;
    this.confetti.bringToFront();
    this.confetti.x = 0;
    return setTimeout((function(_this) {
      return function() {
        return _this.confetti.gotoAndPlay(0);
      };
    })(this), 0);
  };

  GameView.prototype.stopConfetti = function() {
    this.confetti.gotoAndStop(0);
    return this.confetti.visible = false;
  };

  GameView.prototype.addWinSign = function() {
    var i, pattern, tmp, _i, _len;
    if (this.winSign != null) {
      return;
    }
    this.winSignContainer = new PIXI.Container();
    this.winSignContainer.width = gameModel.gameWidth;
    this.winSignContainer.visible = false;
    this.winSignContainer.y = this.signYOffset;
    this.addChild(this.winSignContainer);
    if (gameModel.winSign === 'movie') {
      this.textureArray = imageManager.makeTexturesFromName('result');
      tmp = [];
      pattern = [2, 3, 4, 2, 3, 4, 2, 3, 4, 0, 1, 0, 1, 0];
      for (_i = 0, _len = pattern.length; _i < _len; _i++) {
        i = pattern[_i];
        tmp.push(this.textureArray[i]);
      }
      this.winSign = new PIXI.extras.AnimatedSprite(tmp);
      this.winSign.loop = true;
      this.winSign.animationSpeed = 0.07;
      this.winSign.gotoAndPlay(0);
      this.winSignContainer.addChild(this.winSign);
      this.winSign.centerX(gameModel.gameWidth);
      __renderer.plugins.prepare.upload(this.winSign);
    }
    if (gameModel.winSign === 'image') {
      this.winSign = new PIXI.Sprite.fromImage(imageModel.winSignImage);
      this.winSignContainer.addChild(this.winSign);
      this.winSign.centerX(gameModel.gameWidth);
    }
    this.winTitleText = new PIXI.Text(__t.str('You Won!'), this.style);
    this.winTitleText.y = gameModel.winSignTextY;
    this.winTitleText.style = this.style;
    this.winTitleText.clarify();
    this.winTitleText.centerX(gameModel.gameWidth);
    this.winSignContainer.addChild(this.winTitleText);
    this.amountText = new PIXI.Text(this.amount, this.amountStyle);
    this.amountText.y = gameModel.winSignTextY + 15;
    return this.winSignContainer.addChild(this.amountText);
  };

  GameView.prototype.playWinSign = function(cb) {
    var to;
    this.winSignContainer.y = this.signYOffset;
    this.winSignContainer.bringToFront();
    to = {
      y: gameModel.winSignYOffset,
      ease: Back.easeOut.config(1.3),
      yoyo: true,
      repeat: 1,
      repeatDelay: 2.5,
      onComplete: function() {
        if (cb) {
          return cb();
        }
      }
    };
    this.tweens.push(Tween.to(this.winSignContainer, 0.4, to));
    this.winSignContainer.visible = true;
    if (gameModel.winSign === 'movie') {
      return setTimeout((function(_this) {
        return function() {
          return _this.winSign.play();
        };
      })(this), 0);
    }
  };

  GameView.prototype.stopWinSign = function() {
    if (gameModel.winSign === 'movie') {
      return this.winSign.gotoAndStop(0);
    }
  };

  GameView.prototype.updateWinText = function(amount) {
    amount = currencyManager.localize(amount);
    this.amountText.text = amount;
    this.amountText.style.fontSize = gameModel.winSignTextMaxFontSize;
    this.amountText.sizeToFit(gameModel.winSignTextMaxWidth, false);
    this.amountText.clarify();
    return this.amountText.centerAtPoint(gameModel.gameWidth / 2, gameModel.winSignTextY + 20 + (this.amountText.height / 2));
  };

  GameView.prototype.addLostText = function() {
    this.lossTitleText = new PIXI.Text(__t.str('Better luck next time...'), this.style);
    this.lossTitleText.y = this.titleLossY;
    this.lossTitleText.style = this.style;
    this.lossTitleText.clarify();
    this.lossTitleText.centerX(gameModel.gameWidth);
    this.lossTitleText.visible = false;
    return this.addChild(this.lossTitleText);
  };

  GameView.prototype.dropFlakes = function(data) {
    if (!this.canDropFlakes) {
      return;
    }
    this.canDropFlakes = false;
    this._dropFlakes(data);
    return setTimeout((function(_this) {
      return function() {
        return _this.canDropFlakes = true;
      };
    })(this), this.flakeThrottling * Math.random());
  };

  GameView.prototype._dropFlakes = function(data) {
    var dir, flake, to, url, x, y;
    url = imageModel.flakeImage;
    flake = new PIXI.Sprite.fromImage(url);
    x = data.x + (Math.random() * 60) - 30;
    y = data.y + (Math.random() * 60) - 30;
    dir = x + (data.dir * 2);
    flake.scale.set((Math.random() + 0.7) / 2, (Math.random() + 0.7) / 2);
    flake.anchor.set(0.5, 0.5);
    flake.position.set(x, y);
    this.addChild(flake);
    to = {
      y: 800,
      x: dir,
      alpha: 0,
      rotation: Math.random() * 10 - 5,
      onComplete: function() {
        return flake.removeSelf();
      }
    };
    return Tween.to(flake, 2000 / 1000, to);
  };

  GameView.prototype.addTicketText = function() {
    if (!gameModel.getShowTicketId()) {
      return;
    }
    if (this.ticketText != null) {
      this.updateTicktId('');
      this.ticketText.visible = true;
      return;
    }
    this.ticketText = new PIXI.Text('', this.ticketStyle);
    this.ticketText.y = 10;
    this.ticketText.alpha = 0.7;
    this.addChild(this.ticketText);
    return this.updateTicktId('');
  };

  GameView.prototype.updateTicktId = function(ticketId) {
    if (!gameModel.getShowTicketId()) {
      return;
    }
    if (ticketId == null) {
      return;
    }
    if (ticketId === 0) {
      ticketId = 'DEMO';
    } else if (ticketId === '') {
      ticketId = '';
    } else {
      ticketId = "#" + ticketId;
    }
    this.ticketText.text = ticketId;
    this.ticketText.clarify();
    this.ticketText.y = 320;
    this.ticketText.x = gameModel.gameWidth - 20 + gameModel.ticketIdX;
    return this.ticketText.rotation = (-90) * (Math.PI / 180);
  };

  GameView.prototype.addMenuButton = function(cb) {};

  GameView.prototype.addEndOfReplay = function() {
    this.replayText = new PIXI.Text(__t.str('Replay finished'), this.replayStyle);
    this.replayText.y = gameModel.gameHeight - 140;
    this.addChild(this.replayText);
    this.replayText.clarify();
    return this.replayText.centerX(gameModel.gameWidth);
  };

  GameView.prototype.removeEndOfReplay = function() {
    this.isReplay = false;
    if (this.replayText == null) {
      return;
    }
    this.replayText.removeSelf();
    return this.replayText = null;
  };

  GameView.prototype.showRealityFirst = function() {
    if (realityManager.needsToShowRealityCheck) {
      realityManager.canShowRealityCheck(true);
      return true;
    }
    return false;
  };

  GameView.prototype.resize = function() {
    layoutManager.repositionY(this.playButton);
    if (this.menuButton != null) {
      return this.menuButton.x = -(gameModel.rendererWidth - gameModel.gameWidth) / 2 + 10;
    }
  };

  return GameView;

})(PIXI.Container);

module.exports = GameView;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var HelpView, deviceManager, eventManager, gameModel, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

eventManager = __webpack_require__(3);

deviceManager = __webpack_require__(14);

gameModel = __webpack_require__(2);

HelpView = (function(_super) {
  __extends(HelpView, _super);

  HelpView.prototype.name = 'HelpView';

  HelpView.prototype.cornerRadius = 5;

  HelpView.prototype.visible = false;

  HelpView.prototype.isHTML = true;

  HelpView.prototype.balanceBarHeight = 45;

  HelpView.prototype.canClick = false;

  HelpView.prototype.isShowing = false;

  function HelpView() {
    HelpView.__super__.constructor.call(this);
    this.style = {
      fontFamily: gameModel.getFont(),
      fontSize: 22,
      fill: "#FFFFFF",
      align: "center",
      lineHeight: 32
    };
    this.addIframe();
  }

  HelpView.prototype.willShow = function() {
    return this.container.style.display = "block";
  };

  HelpView.prototype.didHide = function() {
    return this.container.style.display = "none";
  };

  HelpView.prototype.showingProgress = function(progress) {
    progress = Math.round(progress);
    return this.container.style.left = "" + progress + "px";
  };

  HelpView.prototype.addIframe = function() {
    var receiveMessage, vp, w;
    vp = deviceManager.getWrapperDimensions();
    w = vp.w;
    this.iframe = document.createElement('iframe');
    this.iframe.src = gameModel.getHelpUrl();
    this.iframe.style.width = w + 'px';
    this.container = document.getElementById('help-container');
    this.container.style["left"] = "" + vp.w + "px";
    this.container.style["bottom"] = Math.floor(this.balanceBarHeight * gameModel.scaledRatio) + 'px';
    this.container.style.display = "none";
    this.container.style.width = w + 'px';
    this.container.appendChild(this.iframe);
    this.resize();
    receiveMessage = (function(_this) {
      return function(event) {
        if (event.data === 'close-help') {
          return _this.buttonClick();
        }
      };
    })(this);
    return window.addEventListener("message", receiveMessage, false);
  };

  HelpView.prototype.addTitle = function() {
    var txt;
    txt = __t.str('PAYTABLE').replace(/(.)(?=.)/g, "$1 ");
    this.title = new PIXI.Text(txt, this.style);
    this.title.y = 20;
    this.addChild(this.title);
    return this.title.centerX(gameModel.gameWidth);
  };

  HelpView.prototype.buttonClick = function(e) {
    log.info(this.constructor.name, 'buttonClick');
    if (!this.canClick) {
      return;
    }
    eventManager.trigger('back');
    if (e != null) {
      return e.stopPropagation();
    }
  };

  HelpView.prototype.resize = function() {
    var vp, w;
    if (this.iframe == null) {
      return;
    }
    vp = deviceManager.getViewport();
    w = window.innerWidth;
    this.prevWidth = w;
    this.iframe.style.width = w + 'px';
    this.container.style.width = w + 'px';
    return this.container.style["bottom"] = Math.floor(this.balanceBarHeight * gameModel.scaledRatio) + 'px';
  };

  HelpView.prototype.didShow = function() {
    this.canClick = true;
    return this.isShowing = true;
  };

  HelpView.prototype.willHide = function() {
    this.canClick = false;
    return this.isShowing = false;
  };

  HelpView.prototype.spacebarHit = function() {};

  return HelpView;

})(PIXI.Container);

module.exports = HelpView;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var BaseButton, MenuView, SingleScratchView, Tween, currencyManager, eventManager, gameModel, imageManager, imageModel, layoutManager, log, realityManager,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

Tween = __webpack_require__(5);

BaseButton = __webpack_require__(11);

SingleScratchView = __webpack_require__(24);

currencyManager = __webpack_require__(7);

eventManager = __webpack_require__(3);

imageManager = __webpack_require__(4);

layoutManager = __webpack_require__(15);

realityManager = __webpack_require__(10);

gameModel = __webpack_require__(2);

imageModel = __webpack_require__(6);

MenuView = (function(_super) {
  __extends(MenuView, _super);

  function MenuView() {
    return MenuView.__super__.constructor.apply(this, arguments);
  }

  MenuView.prototype.name = 'MenuView';

  MenuView.prototype.winningPrizes = [];

  MenuView.prototype.updateCallback = null;

  MenuView.prototype.timer = null;

  MenuView.prototype.canClick = false;

  MenuView.prototype.completed = false;

  MenuView.prototype.isRootView = true;

  MenuView.prototype.characterMovement = -150;

  MenuView.prototype.textY = 140;

  MenuView.prototype.setup = function() {
    this.characterX = gameModel.characterX;
    this.characterY = gameModel.characterY;
    this.characterZ = gameModel.characterZ;
    this.style = gameModel.styles.introText;
    this.transitionSpeed = gameModel.transitionSpeed;
    this.addLogo();
    if (gameModel.showCharacter) {
      this.addCharacter();
    }
    this.addButtons();
    this.addTagline();
    this.zSort();
    return setTimeout((function(_this) {
      return function() {
        _this.playButton.reset();
        if ((!gameModel.isOutOfTickets() && !gameModel.isOutOfFunds()) || gameModel.showBuyMoreButton) {
          return _this.playButton.enable();
        } else {
          return _this.playButton.disable();
        }
      };
    })(this), 1);
  };

  MenuView.prototype.addLogo = function(cb) {
    var logoY, url;
    if (this.logo != null) {
      return this.logo.visible = true;
    } else {
      logoY = gameModel.logoYTitle;
      if (gameModel.logoFromBottomTitle) {
        logoY = gameModel.rendererHeight - gameModel.logoYTitle;
      }
      url = imageModel.logoTitleImage;
      return imageManager.loadAsset(url, (function(_this) {
        return function(image) {
          _this.logo = new PIXI.Sprite.fromImage(url);
          _this.logo.anchor.set(0.5);
          _this.logo.x = gameModel.gameWidth / 2;
          _this.logo.y = logoY;
          _this.logo.z = gameModel.logoZTitle;
          _this.addChild(_this.logo);
          if (cb != null) {
            return cb();
          }
        };
      })(this));
    }
  };

  MenuView.prototype.addTagline = function() {
    var maxPrize, tagline, x;
    maxPrize = gameModel.getMaxPrize();
    maxPrize = currencyManager.localize(maxPrize);
    tagline = __t.str("introtext", {
      maxPrize: maxPrize
    });
    this.tagline = new PIXI.Text(tagline, this.style);
    x = Math.round((gameModel.gameWidth - this.tagline.width) / 2);
    this.tagline.x = (gameModel.gameWidth - this.tagline.width) / 2;
    this.tagline.y = gameModel.rendererHeight - this.textY;
    this.tagline.z = gameModel.taglineZ;
    this.addChild(this.tagline);
    return this.tagline.clarify();
  };

  MenuView.prototype.addCharacter = function() {
    var url;
    if (this.character != null) {
      return this.character.visible = true;
    } else {
      url = imageModel.characterImage;
      return imageManager.loadAsset(url, (function(_this) {
        return function(image) {
          _this.character = new PIXI.Sprite.fromImage(url);
          _this.character.x = _this.characterX;
          _this.character.y = 0;
          _this.character.z = _this.characterZ;
          if (gameModel.characterScale != null) {
            _this.character.scale.set(gameModel.characterScale);
          }
          return _this.addChild(_this.character);
        };
      })(this));
    }
  };

  MenuView.prototype.addButtons = function(cb) {
    this.addPlayButton();
    return this.canClick = true;
  };

  MenuView.prototype.removeButtons = function(cb) {
    this.playButton.removeSelf();
    return this.playButton = null;
  };

  MenuView.prototype.addPlayButton = function(cb) {
    var btnText, options;
    if (this.playButton != null) {
      return;
    }
    btnText = __t.str("Play now");
    options = {
      text: btnText,
      type: 'primary',
      buttonImage: gameModel.hasButtonImage ? imageModel.buttonImage : void 0,
      buttonHoverImage: gameModel.hasButtonImage ? imageModel.buttonHoverImage : void 0
    };
    this.playButton = new BaseButton(options);
    this.playButton.tapped = (function(_this) {
      return function(e) {
        return _this.playButtonClick(e);
      };
    })(this);
    this.playButton.order = 0;
    layoutManager.placeButton(this.playButton);
    return this.addChild(this.playButton);
  };

  MenuView.prototype.playButtonClick = function(e) {
    this.playButton.disable();
    if (realityManager.needsToShowRealityCheck) {
      realityManager.canShowRealityCheck(true);
      return;
    }
    this.canClick = false;
    window.clearTimeout(this.timer);
    eventManager.trigger('place-bet');
    if (e != null) {
      return e.stopPropagation();
    }
  };

  MenuView.prototype.spacebarHit = function() {
    if (this.canClick) {
      this.playButtonClick();
    }
    return '1234';
  };

  MenuView.prototype.willHide = function() {
    return this.playButton.reset();
  };

  MenuView.prototype.didHide = function() {};

  MenuView.prototype.willShow = function() {
    this.playButton.reset();
    if (gameModel.isOutOfTickets() && !gameModel.shouldShowBuyMorePopup()) {
      this.playButton.disable();
      return this.canClick = false;
    } else {
      this.playButton.enable();
      return this.canClick = true;
    }
  };

  MenuView.prototype.didShow = function() {
    return setTimeout((function(_this) {
      return function() {
        return _this.playButton.reset();
      };
    })(this), 1);
  };

  MenuView.prototype.resize = function() {
    layoutManager.repositionY(this.playButton);
    if (gameModel.logoFromBottomTitle) {
      this.logo.y = gameModel.rendererHeight - gameModel.logoYTitle;
    }
    if (this.character != null) {
      this.character.y = gameModel.rendererHeight - this.characterY;
    }
    if (this.tagline != null) {
      return this.tagline.y = gameModel.rendererHeight - this.textY;
    }
  };

  return MenuView;

})(PIXI.Container);

module.exports = MenuView;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var BaseButton, NotificationView, Tween, deviceManager, gameModel, imageModel, layoutManager, log,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

Tween = __webpack_require__(5);

BaseButton = __webpack_require__(11);

deviceManager = __webpack_require__(14);

layoutManager = __webpack_require__(15);

gameModel = __webpack_require__(2);

imageModel = __webpack_require__(6);

NotificationView = (function(_super) {
  __extends(NotificationView, _super);

  NotificationView.prototype.name = 'NotificationView';

  NotificationView.prototype.completed = false;

  NotificationView.prototype.overlayAlpha = 0.9;

  NotificationView.prototype.buttons = [];

  NotificationView.prototype.offset = 100;

  NotificationView.prototype.padding = 56;

  NotificationView.prototype.style = {
    fontSize: 28,
    fontWeight: 100,
    fill: "#FFFFFF",
    align: "center",
    lineHeight: 32,
    wordWrap: true,
    wordWrapWidth: 280
  };

  NotificationView.prototype.msgStyle = {
    fontSize: 13,
    fontWeight: 100,
    align: "center",
    fill: "#FFFFFF",
    lineHeight: 17,
    wordWrap: true,
    wordWrapWidth: 280
  };

  function NotificationView() {
    var vp;
    NotificationView.__super__.constructor.call(this);
    vp = deviceManager.getViewport();
    this.style.fontFamily = gameModel.getFont();
    this.msgStyle.fontFamily = gameModel.getFont();
    this.addBg();
    this.inner = new PIXI.Container();
    this.inner.position.set(gameModel.stageX, gameModel.stageY);
    this.addChild(this.inner);
  }

  NotificationView.prototype.addBg = function() {
    this.overlay = new PIXI.Graphics();
    this.overlay.beginFill(0x000000);
    this.overlay.drawRect(0, 0, gameModel.rendererWidth, gameModel.rendererHeight);
    this.overlay.endFill();
    this.overlay.alpha = 0;
    return this.addChildAt(this.overlay, 0);
  };

  NotificationView.prototype.setup = function(title, message, actions) {
    this.completed = false;
    return this.showOverlay((function(_this) {
      return function() {
        _this.addText(title, message);
        _this.addButtons(actions);
        _this.resize();
        return _this.completed = true;
      };
    })(this));
  };

  NotificationView.prototype.hide = function(cb) {
    return setTimeout((function(_this) {
      return function() {
        if (_this.text != null) {
          _this.text.visible = false;
        }
        _this.removeButtons();
        return _this.hideOverlay(function() {
          if (cb != null) {
            return cb();
          }
        });
      };
    })(this), 1);
  };

  NotificationView.prototype.addText = function(title, msg) {
    if (this.text != null) {
      this.updateText(title, msg);
      this.text.visible = true;
      return;
    }
    this.text = new PIXI.Container();
    this.inner.addChild(this.text);
    title = __t.str(title);
    msg = __t.str(msg);
    this.titleText = new PIXI.Text(title, this.style);
    this.titleText.y = 45;
    this.text.addChild(this.titleText);
    this.titleText.clarify();
    this.titleText.centerX(gameModel.gameWidth);
    this.messageText = new PIXI.Text(msg, this.msgStyle);
    this.messageText.y = 110;
    this.text.addChild(this.messageText);
    this.messageText.clarify();
    return this.messageText.centerX(gameModel.gameWidth);
  };

  NotificationView.prototype.updateText = function(title, msg) {
    this.titleText.text = __t.str(title);
    this.titleText.clarify();
    this.titleText.centerX(gameModel.gameWidth);
    return this.updateMsg(msg);
  };

  NotificationView.prototype.updateMsg = function(msg) {
    if (this.messageText == null) {
      return;
    }
    this.messageText.text = __t.str(msg);
    this.messageText.clarify();
    return this.messageText.centerX(gameModel.gameWidth);
  };

  NotificationView.prototype.addButtons = function(actions) {
    var action, i, place, _i, _len, _results;
    this.removeButtons();
    actions = actions.reverse();
    place = 0;
    _results = [];
    for (i = _i = 0, _len = actions.length; _i < _len; i = ++_i) {
      action = actions[i];
      if (this.addButton(action, place, i, actions.length)) {
        _results.push(place++);
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  NotificationView.prototype.addButton = function(action, place, i, total) {
    var button, x, y;
    log.info(this.constructor.name, 'addButton', action, place);
    if (!this.canPerformAction(action.action)) {
      return false;
    }
    action.remainActive = true;
    if (i === total - 1) {
      action.type = 'primary';
      action.buttonImage = imageModel.buttonImage;
      action.buttonHoverImage = imageModel.buttonHoverImage;
    } else {
      action.type = 'secondary';
      action.buttonImage = imageModel.buttonSecondaryImage;
      action.buttonHoverImage = imageModel.buttonSecondaryHoverImage;
    }
    button = new BaseButton(action);
    x = (gameModel.gameWidth - button.width) / 2;
    y = (gameModel.rendererHeight - this.offset) - (this.padding * place);
    button.order = place;
    button.position.set(x, y);
    this.inner.addChild(button);
    this.buttons.push(button);
    return true;
  };

  NotificationView.prototype.removeButtons = function(cb) {
    var button, _i, _len, _ref;
    _ref = this.buttons;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      button = _ref[_i];
      button.removeSelf();
    }
    return this.buttons = [];
  };

  NotificationView.prototype.showOverlay = function(cb) {
    var to;
    to = {
      alpha: this.overlayAlpha,
      onComplete: cb
    };
    return Tween.to(this.overlay, 300 / 1000, to);
  };

  NotificationView.prototype.hideOverlay = function(cb) {
    var to;
    if (this.overlay == null) {
      if (cb != null) {
        cb();
      }
      return;
    }
    to = {
      alpha: 0,
      onComplete: (function(_this) {
        return function() {
          if (cb != null) {
            return cb();
          }
        };
      })(this)
    };
    return Tween.to(this.overlay, 300 / 1000, to);
  };

  NotificationView.prototype.resize = function() {
    var button, _i, _len, _ref, _results;
    this.removeChild(this.overlay);
    this.addBg();
    if (this.parent != null) {
      this.overlay.alpha = this.overlayAlpha;
    } else {
      this.overlay.alpha = 0;
    }
    if (this.inner != null) {
      this.inner.position.set(gameModel.stageX, gameModel.stageY);
    }
    if (this.buttons != null) {
      _ref = this.buttons;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        button = _ref[_i];
        _results.push(layoutManager.repositionY(button));
      }
      return _results;
    }
  };

  NotificationView.prototype.canPerformAction = function(action) {
    switch (action) {
      case 'cashier':
        if (gameModel.getCashierUrl() == null) {
          return false;
        }
        break;
      case 'history':
        if (gameModel.getHistoryUrl() == null) {
          return false;
        }
        break;
      case 'home':
        if (gameModel.getHomeUrl() == null) {
          return false;
        }
        break;
      case 'buy-more':
        if (gameModel.getBuyMoreUrl() == null) {
          return false;
        }
    }
    return true;
  };

  return NotificationView;

})(PIXI.Container);

module.exports = NotificationView;


/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/fonts.css";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sound/audio-sprite.json";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sound/audio-sprite.mp3";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sound/audio-sprite.ogg";

/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports) {

module.exports = {
	"gameWidth": 360,
	"gameHeight": 518,
	"defaultVolume": 0.6,
	"defaultCurrency": "EUR",
	"defaultLanguage": "en",
	"hideLoaderDelay": 200
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = {
	"LOAD_GAME_FAILED": {
		"title": "Game Error",
		"msg": "The Game you are trying to open is temporarily unavailable. Please try again in a few moments.",
		"fatal": true,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Reload game",
				"action": "reload"
			},
			{
				"textKey": "Home",
				"action": "home"
			}
		]
	},
	"LOAD_CONFIG_FAILED": {
		"title": "Game Error",
		"msg": "Game does not exist. Please try another title.",
		"fatal": true,
		"showServerMsg": true
	},
	"WAITING_ON_BALANCE": {
		"title": "Retrieving Balance",
		"msg": "Temporary problem. Please wait.",
		"fatal": false,
		"showServerMsg": true
	},
	"WAITING_ON_BALANCE_FAILED": {
		"title": "Temporary Problem",
		"msg": "Please load the game again.",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Reload game",
				"action": "reload"
			}
		]
	},
	"NO_TICKETS_LEFT": {
		"code": 112,
		"title": "No tickets left...",
		"msg": "The next big win could be just around the corner. Get more tickets now.",
		"fatal": true,
		"showServerMsg": false,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "hide-error"
			},
			{
				"textKey": "Get more tickets",
				"action": "buy-more"
			},
			{
				"textKey": "Home",
				"action": "home"
			}
		]
	},
	"INSUFFICIENT_FUNDS": {
		"code": 112,
		"title": "Oops",
		"msg": "You have insufficient funds",
		"fatal": true,
		"showServerMsg": false,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "hide-error"
			},
			{
				"textKey": "Deposit",
				"action": "cashier"
			},
			{
				"textKey": "Home",
				"action": "home"
			}
		]
	},
	"PLACE_BET_FAILED": {
		"title": "Game Error",
		"msg": "Bet was not placed. Please try again.",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "hide-error"
			},
			{
				"textKey": "Quit",
				"action": "home"
			}
		]
	},
	"WAITING_ON_NOTIFICATION": {
		"title": "Placing Bet",
		"msg": "This is taking longer than expected. Please wait.",
		"fatal": false,
		"showServerMsg": true
	},
	"GAME_QUIT": {
		"title": "Game Quit",
		"msg": "You have quit the game.",
		"fatal": true,
		"showServerMsg": true
	},
	"REPLAY_START": {
		"title": "Last round not finished",
		"msg": "The previous unseen round will now be replayed",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "start-replay"
			}
		]
	},
	"REPLAY_DONE": {
		"title": "Replay finished",
		"msg": "Your replay has finished, you will now return to game",
		"fatal": false,
		"showServerMsg": true,
		"buttons": [
			{
				"textKey": "Okay",
				"action": "back-to-menu"
			}
		]
	},
	"REALITY_CHECK": {
		"title": "Hello there!",
		"msg": "",
		"fatal": false,
		"showServerMsg": false,
		"buttons": [
			{
				"text": "Continue",
				"action": "hide-reality-check"
			},
			{
				"text": "History",
				"action": "history"
			},
			{
				"text": "Quit",
				"action": "home"
			}
		]
	}
};

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.eot": 134,
	"./proximasoft-bold-webfont.eot": 138,
	"./proximasoft-regular-webfont.eot": 143
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.svg": 135,
	"./proximasoft-bold-webfont.svg": 139,
	"./proximasoft-regular-webfont.svg": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.ttf": 136,
	"./proximasoft-bold-webfont.ttf": 140,
	"./proximasoft-regular-webfont.ttf": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SignPainter-HouseScript.woff": 137,
	"./proximasoft-bold-webfont.woff": 141,
	"./proximasoft-regular-webfont.woff": 146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./proximasoft-bold-webfont.woff2": 142,
	"./proximasoft-regular-webfont.woff2": 147
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var ScratchArea, Tween, eventManager, gameModel, imageManager, imageModel, log, soundManager,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

log = __webpack_require__(0);

Tween = __webpack_require__(5);

imageManager = __webpack_require__(4);

eventManager = __webpack_require__(3);

soundManager = __webpack_require__(8);

gameModel = __webpack_require__(2);

imageModel = __webpack_require__(6);

ScratchArea = (function(_super) {
  __extends(ScratchArea, _super);

  function ScratchArea() {
    return ScratchArea.__super__.constructor.apply(this, arguments);
  }

  ScratchArea.prototype.name = 'ScratchArea';

  ScratchArea.prototype.done = false;

  ScratchArea.prototype.lastPos = null;

  ScratchArea.prototype.mouseIsDown = false;

  ScratchArea.prototype.allowScratching = false;

  ScratchArea.prototype.isUnscratched = true;

  ScratchArea.prototype.isCalculating = false;

  ScratchArea.prototype.scaleFactor = 4;

  ScratchArea.prototype.scratchThrottling = 150;

  ScratchArea.prototype.dpi = __dpi;

  ScratchArea.prototype.debug = false;

  ScratchArea.prototype.render = function(img, width, height, offsetX, offsetY) {
    var existingMask, existingScratch, maskH, maskW, texture;
    this.img = img;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    this.completedColors = [];
    this.lastPos = null;
    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.canvas.width = width * this.dpi;
    this.canvas.height = height * this.dpi;
    this.canvas.id = 'scratch-canvas';
    this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
    this.ctx.globalCompositeOperation = "destination-out";
    this.texture = new PIXI.Texture.fromCanvas(this.canvas);
    this.height = height;
    this.width = width;
    this.position.x = 0;
    this.position.y = 0;
    this.interactive = true;
    this.buttonMode = true;
    maskH = height / this.scaleFactor;
    maskW = width / this.scaleFactor;
    this.maskCanvas = document.createElement("canvas");
    this.maskCtx = this.maskCanvas.getContext("2d");
    this.maskCanvas.width = maskW;
    this.maskCanvas.height = maskH;
    this.maskCanvas.id = 'mask-canvas';
    if (this.maskCtx.imageSmoothingEnabled != null) {
      this.maskCtx.imageSmoothingEnabled = false;
    } else {
      this.maskCtx.webkitImageSmoothingEnabled = false;
      this.maskCtx.mozImageSmoothingEnabled = false;
      this.maskCtx.oImageSmoothingEnabled = false;
    }
    if (this.debug) {
      existingScratch = document.getElementById('scratch-canvas');
      if (existingScratch != null) {
        existingScratch.remove();
      }
      document.body.appendChild(this.canvas);
      existingMask = document.getElementById('mask-canvas');
      if (existingMask != null) {
        existingMask.remove();
      }
      document.body.appendChild(this.maskCanvas);
    }
    this.originalCanvas = document.createElement("canvas");
    this.originalCtx = this.originalCanvas.getContext("2d");
    this.originalCanvas.width = width;
    this.originalCanvas.height = height;
    this.originalCtx.drawImage(this.img, 0, 0, this.img.width, this.img.height, 0, 0, width, height);
    texture = PIXI.Texture.fromImage(imageModel.brushImage);
    this.brushImg = texture.baseTexture.source;
    this.allowScratching = false;
    return this;
  };

  ScratchArea.prototype.reset = function() {
    this.done = false;
    this.interactive = true;
    this.mouseIsDown = false;
    this.allowScratching = false;
    this.isUnscratched = true;
    this.isCalculating = false;
    this.completedColors = [];
    this.lastPos = null;
    this.ctx.globalCompositeOperation = "source-over";
    this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
    this.texture = new PIXI.Texture.fromCanvas(this.canvas);
    this.texture.update();
    return this.ctx.globalCompositeOperation = "destination-out";
  };

  ScratchArea.prototype.setupMasks = function(prizes, multip) {
    var prize, _i, _len;
    if (multip == null) {
      multip = null;
    }
    this.maskCtx.rect(0, 0, this.maskCanvas.width, this.maskCanvas.height);
    this.maskCtx.fillStyle = "white";
    this.maskCtx.fill();
    for (_i = 0, _len = prizes.length; _i < _len; _i++) {
      prize = prizes[_i];
      this.addMask(prize, false);
    }
    if (multip != null) {
      this.addMask(multip, true);
    }
    this.originalColorCounts = this.getColoredPixelCount(this.maskCtx);
    this.prizeCount = UTIL.keys(this.originalColorCounts).length;
    return this.isUnscratched = true;
  };

  ScratchArea.prototype.addMask = function(prize, isMultip) {
    var c, channels, h, spriteRes, w, x, y;
    if (isMultip == null) {
      isMultip = false;
    }
    spriteRes = prize.getByTag('prize').texture.baseTexture.resolution;
    x = prize.x;
    y = prize.y;
    w = prize.width;
    h = prize.height;
    channels = prize.colorCode.split("-");
    c = "rgb(" + channels[0] + "," + channels[1] + "," + channels[2] + ")";
    w = w / this.scaleFactor;
    h = h / this.scaleFactor;
    w = Math.floor(w / 2 / spriteRes);
    h = Math.floor(h / 2 / spriteRes);
    x = Math.floor((x / this.scaleFactor) - (w / 2));
    y = Math.floor((y / this.scaleFactor) - (h / 2));
    this.maskCtx.fillStyle = c;
    return this.maskCtx.fillRect(x, y, w, h);
  };

  ScratchArea.prototype.calculateCoordinates = function(e, callback) {
    var h, maskX, maskY, offset, oldData, pixelData, pos, radius, w, x, y;
    if (this.done || !this.allowScratching) {
      callback(false);
      return;
    }
    pos = e.data.global;
    x = pos.x - this.offsetX - gameModel.stageX;
    y = pos.y - this.offsetY - gameModel.stageY;
    w = this.canvas.width;
    h = this.canvas.height;
    if (x < 0 || y < 0 || x > w || y > h) {
      callback(false);
      return;
    }
    pixelData = this.originalCtx.getImageData(x, y, 1, 1).data;
    if (pixelData[3] === 0) {
      callback(false);
      return;
    }
    e.data.originalEvent.preventDefault();
    radius = 80 * this.dpi;
    offset = radius / 2;
    maskX = x / this.scaleFactor;
    maskY = y / this.scaleFactor;
    x = x * this.dpi;
    y = y * this.dpi;
    oldData = this.ctx.getImageData(x - offset, y - offset, radius, radius).data;
    callback(true);
    return this.scratch(x, y, maskX, maskY, (function(_this) {
      return function() {
        var direction, eve, newData;
        newData = _this.ctx.getImageData(x - offset, y - offset, radius, radius).data;
        if (!_this.arraysIdentical(oldData, newData)) {
          direction = 0;
          if (_this.lastPos != null) {
            direction = e.data.global.x - _this.lastPos;
          }
          eve = {
            x: e.data.global.x - gameModel.stageX,
            y: e.data.global.y - gameModel.stageY,
            dir: direction
          };
          _this.lastPos = e.data.global.x;
          return eventManager.trigger('scratching', eve);
        }
      };
    })(this));
  };

  ScratchArea.prototype.arraysIdentical = function(a, b) {
    var i;
    i = a.length;
    if (i !== b.length) {
      return false;
    }
    while (i--) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  };

  ScratchArea.prototype.scratch = function(x, y, maskX, maskY, cb) {
    var brushSize, maskBrushSize;
    if (this.isUnscratched) {
      this.game.beganScratching();
      this.isUnscratched = false;
    }
    brushSize = gameModel.brushSize * this.dpi;
    maskBrushSize = gameModel.brushSize / this.scaleFactor;
    this.ctx.beginPath();
    this.maskCtx.fillStyle = "#FFFFFF";
    this.maskCtx.beginPath();
    this.drawBrush(this.ctx, this.maskCtx, x, y, maskX, maskY, this.brushImg, brushSize, maskBrushSize);
    this.ctx.fill();
    this.maskCtx.fill();
    if (this.isProcessingPercent) {
      return;
    }
    this.isProcessingPercent = true;
    if (this.isCalculating) {
      return;
    }
    return setTimeout(((function(_this) {
      return function() {
        _this.calculateCompletion();
        _this.isProcessingPercent = false;
        return cb();
      };
    })(this)), 150);
  };

  ScratchArea.prototype.calculateCompletion = function() {
    this.isCalculating = true;
    this.updatedColorCounts = this.getColoredPixelCount(this.maskCtx);
    if (this.calculateIsEnded(this.updatedColorCounts)) {
      this.game.willClearAfterUserScratchedManually();
      this.clear(true, (function(_this) {
        return function() {
          return _this.game.allScratched();
        };
      })(this));
    }
    return this.isCalculating = false;
  };

  ScratchArea.prototype.getColoredPixelCount = function(ctx) {
    var b, blue, colors, data, g, green, k, key, r, red, v, _ref;
    data = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height).data;
    r = 0;
    g = 1;
    b = 2;
    colors = {};
    while (r < data.length) {
      red = data[r];
      green = data[r + g];
      blue = data[r + b];
      key = "" + red + "-" + green + "-" + blue;
      if (key !== '255-255-255') {
        if (colors[key] != null) {
          colors[key]++;
        } else {
          colors[key] = 1;
        }
      }
      r += 4;
    }
    _ref = this.originalColorCounts;
    for (k in _ref) {
      v = _ref[k];
      if (colors[k] == null) {
        colors[k] = 0;
      }
    }
    return colors;
  };

  ScratchArea.prototype.calculateIsEnded = function(updatedCounts) {
    var completedColor, count, donePercent, isInCompleted, key, originalValue, percent, value;
    donePercent = gameModel.donePercent;
    count = 0;
    completedColor = '';
    for (key in updatedCounts) {
      value = updatedCounts[key];
      if (this.originalColorCounts[key] == null) {
        continue;
      }
      isInCompleted = UTIL.contains(this.completedColors, key);
      if (isInCompleted) {
        continue;
      }
      if (value === 0 && !isInCompleted) {
        completedColor = key;
        this.completedColors.push(key);
        continue;
      }
      originalValue = this.originalColorCounts[key];
      percent = ((originalValue - value) / originalValue) * 100;
      if (percent < donePercent) {
        count++;
      } else {
        completedColor = key;
        this.completedColors.push(key);
      }
    }
    if (count < this.prizeCount && completedColor !== '') {
      this.prizeCount = count;
      this.game.prizeScratched(completedColor);
    }
    return count === 0;
  };

  ScratchArea.prototype.clear = function(animate, callback) {
    var brushSize, direction, h, scratchAngle, unitSize, w, x, y;
    if (this.isUnscratched) {
      this.game.beganScratching();
      this.isUnscratched = false;
    }
    this.done = true;
    this.interactive = false;
    w = this.width * this.dpi;
    h = this.height * this.dpi;
    if (animate) {
      unitSize = 20 * this.dpi;
      brushSize = gameModel.brushSize * this.dpi;
      scratchAngle = (Math.random() * 30) - 15;
      y = brushSize / 2;
      if (scratchAngle > 0) {
        x = 0;
        direction = true;
      } else {
        x = w;
        direction = false;
      }
      soundManager.reveal();
      return this.timeBasedClearAll(x, y, w, h, direction, scratchAngle, this.brushImg, brushSize, (function(_this) {
        return function() {
          _this.revealAll(w, h, callback);
          return soundManager.stopReveal();
        };
      })(this));
    } else {
      return this.revealAll(w, h, callback);
    }
  };

  ScratchArea.prototype.revealAll = function(w, h, cb) {
    this.ctx.beginPath();
    this.ctx.fillStyle = "#FFFFFF";
    this.ctx.fillRect(0, 0, w, h);
    if (cb != null) {
      return cb(true);
    }
  };

  ScratchArea.prototype.timeBasedClearAll = function(x, y, w, h, dir, angle, brushImg, brushSize, cb) {
    var location, target, to, tween;
    location = {
      x: x,
      y: y
    };
    target = w;
    if (!dir) {
      target = 0;
    }
    to = {
      x: target,
      repeat: 5,
      yoyo: true,
      onRepeat: function() {
        location.y = location.y + (brushSize * 0.5);
        return dir = !dir;
      },
      onUpdate: (function(_this) {
        return function(d) {
          if (dir) {
            location.y = location.y - angle;
          } else {
            location.y = location.y + angle;
          }
          return _this.drawBrush(_this.ctx, null, location.x, location.y, null, null, brushImg, brushSize, null);
        };
      })(this),
      onComplete: (function(_this) {
        return function() {
          return cb();
        };
      })(this),
      ease: Linear.easeNone
    };
    return tween = Tween.to(location, 0.25, to);
  };

  ScratchArea.prototype.animateClearAll = function(x, y, w, h, units, brushSize, brushImg, delay, dir, angle, callback) {
    if (y > h) {
      if (callback != null) {
        callback();
      }
      return;
    }
    this.drawBrush(this.ctx, null, x, y, null, null, brushImg, brushSize, null);
    if (dir) {
      x = x + units;
      y = y + angle;
    } else {
      x = x - units;
      y = y - angle;
    }
    if (x >= w - 2 || x < 2) {
      dir = !dir;
      y = y + (brushSize / 2);
    }
    return setTimeout(((function(_this) {
      return function() {
        return _this.animateClearAll(x, y, w, h, units, brushSize, brushImg, delay, dir, angle, callback);
      };
    })(this)), delay);
  };

  ScratchArea.prototype.getCanvas = function() {
    return this.texture.baseTexture.source;
  };

  ScratchArea.prototype.getContext = function() {
    return this.getCanvas().getContext('2d');
  };

  ScratchArea.prototype.mousedown = function() {
    return this.mouseIsDown = true;
  };

  ScratchArea.prototype.mouseup = function() {
    return this.mouseIsDown = false;
  };

  ScratchArea.prototype.mouseupoutside = function() {
    return this.mouseIsDown = false;
  };

  ScratchArea.prototype.mousemove = function(data) {
    if (!this.mouseIsDown) {
      return;
    }
    return this.calculateCoordinates(data, (function(_this) {
      return function(didScratch) {
        return _this.scratchSound(didScratch);
      };
    })(this));
  };

  ScratchArea.prototype.touchmove = function(e) {
    e.data.originalEvent.preventDefault();
    return this.calculateCoordinates(e, (function(_this) {
      return function(didScratch) {
        return _this.scratchSound(didScratch);
      };
    })(this));
  };

  ScratchArea.prototype.touchstart = function(data) {
    return log.info('touchstart');
  };

  ScratchArea.prototype.touchend = function(data) {
    return log.info('touchend');
  };

  ScratchArea.prototype.drawBrush = function(ctx, maskCtx, x, y, maskX, maskY, img, brushSize, maskBrushSize) {
    var angle, h, w;
    angle = Math.random() * 360;
    img.width = brushSize;
    img.height = brushSize;
    w = img.width;
    h = img.height;
    this.drawRotatedImage(ctx, img, x, y, w, h, angle);
    if (maskCtx != null) {
      if (maskBrushSize) {
        img.width = maskBrushSize;
      }
      if (maskBrushSize) {
        img.height = maskBrushSize;
      }
      w = img.width;
      h = img.height;
      return this.drawRotatedImage(maskCtx, img, maskX, maskY, w, h, angle);
    }
  };

  ScratchArea.prototype.drawRotatedImage = function(context, image, x, y, width, height, angle) {
    context.save();
    context.translate(x, y);
    context.rotate(angle * (Math.PI / 180));
    context.drawImage(image, -width / 2, -height / 2, width, height);
    return context.restore();
  };

  ScratchArea.prototype.scratchSound = function(didScratch) {
    if (didScratch) {
      return soundManager.revealShort();
    }
  };

  return ScratchArea;

})(PIXI.Sprite);

module.exports = ScratchArea;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/brush/brush.png";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/brush/brush@2x.png";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary.png";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/btn/button-secondary@2x.png";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/finger/finger.png";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/finger/finger@2x.png";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/finger/finger@3x.png";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/background.jpg";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/background@2x.jpg";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/button.png";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/button@2x.png";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/character.png";

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/character@2x.png";

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/flake.png";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/flake@2x.png";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/logo-game.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/logo-game@2x.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/logo-title.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x1.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x10.png";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x10@2x.png";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x1@2x.png";

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x2.png";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x2@2x.png";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x3.png";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x3@2x.png";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x4.png";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x4@2x.png";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x5.png";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/multiplier-x5@2x.png";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-1.png";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-1@2x.png";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-2.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-2@2x.png";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-3.png";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-3@2x.png";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-4.png";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-4@2x.png";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-5.png";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-5@2x.png";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-6.png";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-6@2x.png";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-7.png";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-7@2x.png";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-8.png";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-8@2x.png";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-9.png";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/prize-9@2x.png";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/scratch-bg.png";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/scratch-bg@2x.png";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/scratch-cover.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/scratch-cover@2x.png";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/win-sign.png";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/img/win-sign@2x.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/cs.json";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/de.json";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/en.json";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/hu.json";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/pl.json";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/pt.json";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/sk.json";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lang/sv.json";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons.json";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons.png";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons@2x.json";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/buttons@2x.png";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/confetti-0.json";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/confetti-0.png";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/confetti-1.json";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/confetti-1.png";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/win-sign.json";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/win-sign.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/win-sign@2x.json";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sprite/win-sign@2x.png";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/SignPainter-HouseScript.eot";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/SignPainter-HouseScript.svg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/SignPainter-HouseScript.ttf";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/SignPainter-HouseScript.woff";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-bold-webfont.eot";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-bold-webfont.svg";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-bold-webfont.ttf";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-bold-webfont.woff";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-bold-webfont.woff2";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-regular-webfont.eot";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-regular-webfont.svg";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-regular-webfont.ttf";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-regular-webfont.woff";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/font/proximasoft-regular-webfont.woff2";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-1.json";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-1.png";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-10.json";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-10.png";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-10@2x.json";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-10@2x.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-1@2x.json";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-1@2x.png";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-2.json";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-2.png";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-2@2x.json";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-2@2x.png";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-3.json";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-3.png";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-3@2x.json";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-3@2x.png";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-4.json";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-4.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-4@2x.json";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-4@2x.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-5.json";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-5.png";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-5@2x.json";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/multi-5@2x.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-1.json";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-1.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-1@2x.json";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-1@2x.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-2.json";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-2.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-2@2x.json";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-2@2x.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-3.json";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-3.png";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-3@2x.json";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-3@2x.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-4.json";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-4.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-4@2x.json";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-4@2x.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-5.json";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-5.png";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-5@2x.json";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-5@2x.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-6.json";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-6.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-6@2x.json";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-6@2x.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-7.json";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-7.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-7@2x.json";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-7@2x.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-8.json";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-8.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-8@2x.json";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-8@2x.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-9.json";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-9.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-9@2x.json";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/hm/sprite/prize-9@2x.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/


/**
 * An even better animation frame.
 *
 * @copyright Oleg Slobodskoi 2015
 * @website https://github.com/kof/animationFrame
 * @license MIT
 */

module.exports = __webpack_require__(209)



/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var nativeImpl = __webpack_require__(210)
var now = __webpack_require__(16)
var performance = __webpack_require__(212)

// Weird native implementation doesn't work if context is defined.
var nativeRequest = nativeImpl.request
var nativeCancel = nativeImpl.cancel

/**
 * Animation frame constructor.
 *
 * Options:
 *   - `useNative` use the native animation frame if possible, defaults to true
 *   - `frameRate` pass a custom frame rate
 *
 * @param {Object|Number} options
 */
function AnimationFrame(options) {
    if (!(this instanceof AnimationFrame)) return new AnimationFrame(options)
    options || (options = {})

    // Its a frame rate.
    if (typeof options == 'number') options = {frameRate: options}
    options.useNative != null || (options.useNative = true)
    this.options = options
    this.frameRate = options.frameRate || AnimationFrame.FRAME_RATE
    this._frameLength = 1000 / this.frameRate
    this._isCustomFrameRate = this.frameRate !== AnimationFrame.FRAME_RATE
    this._timeoutId = null
    this._callbacks = {}
    this._lastTickTime = 0
    this._tickCounter = 0
}

module.exports = AnimationFrame

/**
 * Default frame rate used for shim implementation. Native implementation
 * will use the screen frame rate, but js have no way to detect it.
 *
 * If you know your target device, define it manually.
 *
 * @type {Number}
 * @api public
 */
AnimationFrame.FRAME_RATE = 60

/**
 * Replace the globally defined implementation or define it globally.
 *
 * @param {Object|Number} [options]
 * @api public
 */
AnimationFrame.shim = function(options) {
    var animationFrame = new AnimationFrame(options)

    window.requestAnimationFrame = function(callback) {
        return animationFrame.request(callback)
    }
    window.cancelAnimationFrame = function(id) {
        return animationFrame.cancel(id)
    }

    return animationFrame
}

/**
 * Request animation frame.
 * We will use the native RAF as soon as we know it does works.
 *
 * @param {Function} callback
 * @return {Number} timeout id or requested animation frame id
 * @api public
 */
AnimationFrame.prototype.request = function(callback) {
    var self = this

    // Alawys inc counter to ensure it never has a conflict with the native counter.
    // After the feature test phase we don't know exactly which implementation has been used.
    // Therefore on #cancel we do it for both.
    ++this._tickCounter

    if (nativeImpl.supported && this.options.useNative && !this._isCustomFrameRate) {
        return nativeRequest(callback)
    }

    if (!callback) throw new TypeError('Not enough arguments')

    if (this._timeoutId == null) {
        // Much faster than Math.max
        // http://jsperf.com/math-max-vs-comparison/3
        // http://jsperf.com/date-now-vs-date-gettime/11
        var delay = this._frameLength + this._lastTickTime - now()
        if (delay < 0) delay = 0

        this._timeoutId = setTimeout(function() {
            self._lastTickTime = now()
            self._timeoutId = null
            ++self._tickCounter
            var callbacks = self._callbacks
            self._callbacks = {}
            for (var id in callbacks) {
                if (callbacks[id]) {
                    if (nativeImpl.supported && self.options.useNative) {
                        nativeRequest(callbacks[id])
                    } else {
                        callbacks[id](performance.now())
                    }
                }
            }
        }, delay)
    }

    this._callbacks[this._tickCounter] = callback

    return this._tickCounter
}

/**
 * Cancel animation frame.
 *
 * @param {Number} timeout id or requested animation frame id
 *
 * @api public
 */
AnimationFrame.prototype.cancel = function(id) {
    if (nativeImpl.supported && this.options.useNative) nativeCancel(id)
    delete this._callbacks[id]
}



/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var global = window

// Test if we are within a foreign domain. Use raf from the top if possible.
try {
    // Accessing .name will throw SecurityError within a foreign domain.
    global.top.name
    global = global.top
} catch(e) {}

exports.request = global.requestAnimationFrame
exports.cancel = global.cancelAnimationFrame || global.cancelRequestAnimationFrame
exports.supported = false

var vendors = ['Webkit', 'Moz', 'ms', 'O']

// Grab the native implementation.
for (var i = 0; i < vendors.length && !exports.request; i++) {
    exports.request = global[vendors[i] + 'RequestAnimationFrame']
    exports.cancel = global[vendors[i] + 'CancelAnimationFrame'] ||
        global[vendors[i] + 'CancelRequestAnimationFrame']
}

// Test if native implementation works.
// There are some issues on ios6
// http://shitwebkitdoes.tumblr.com/post/47186945856/native-requestanimationframe-broken-on-ios-6
// https://gist.github.com/KrofDrakula/5318048

if (exports.request) {
    exports.request.call(null, function() {
        exports.supported = true
    });
}



/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var now = __webpack_require__(16)

/**
 * Replacement for PerformanceTiming.navigationStart for the case when
 * performance.now is not implemented.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming.navigationStart
 *
 * @type {Number}
 * @api private
 */
exports.navigationStart = now()



/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var now = __webpack_require__(16)
var PerformanceTiming = __webpack_require__(211)

/**
 * Crossplatform performance.now()
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Performance.now()
 *
 * @return {Number} relative time in ms
 * @api public
 */
exports.now = function () {
    if (window.performance && window.performance.now) return window.performance.now()
    return now() - PerformanceTiming.navigationStart
}




/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/


// async-each MIT license (by Paul Miller from http://paulmillr.com).
(function(globals) {
  'use strict';
  var each = function(items, next, callback) {
    if (!Array.isArray(items)) throw new TypeError('each() expects array as first argument');
    if (typeof next !== 'function') throw new TypeError('each() expects function as second argument');
    if (typeof callback !== 'function') callback = Function.prototype; // no-op

    if (items.length === 0) return callback(undefined, items);

    var transformed = new Array(items.length);
    var count = 0;
    var returned = false;

    items.forEach(function(item, index) {
      next(item, function(error, transformedItem) {
        if (returned) return;
        if (error) {
          returned = true;
          return callback(error);
        }
        transformed[index] = transformedItem;
        count += 1;
        if (count === items.length) return callback(undefined, transformed);
      });
    });
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return each;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // RequireJS
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = each; // CommonJS
  } else {
    globals.asyncEach = each; // <script>
  }
})(this);



/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var $isNaN = __webpack_require__(216);
var $isFinite = __webpack_require__(215);

var sign = __webpack_require__(218);
var mod = __webpack_require__(217);

var IsCallable = __webpack_require__(31);
var toPrimitive = __webpack_require__(219);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return Boolean(value);
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	}
};

module.exports = ES5;



/***/ }),
/* 215 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };



/***/ }),
/* 216 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



/***/ }),
/* 217 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};



/***/ }),
/* 218 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(220);

var isCallable = __webpack_require__(31);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};



/***/ }),
/* 220 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Promise, global) {var require;/*** IMPORTS FROM imports-loader ***/


/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(266);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));
//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(233), __webpack_require__(30), __webpack_require__(9)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/


var isFunction = __webpack_require__(229)

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}



/***/ }),
/* 223 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/



var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};




/***/ }),
/* 224 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};



/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/


/*!
 * VERSION: 1.19.1
 * DATE: 2017-01-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
(function(window, moduleName) {

		"use strict";
		var _exports = {},
			_doc = window.document,
			_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
		if (_globals.TweenLite) {
			return; //in case the core set of classes is already loaded, don't instantiate twice.
		}
		var _namespace = function(ns) {
				var a = ns.split("."),
					p = _globals, i;
				for (i = 0; i < a.length; i++) {
					p[a[i]] = p = p[a[i]] || {};
				}
				return p;
			},
			gs = _namespace("com.greensock"),
			_tinyNum = 0.0000000001,
			_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
				var b = [],
					l = a.length,
					i;
				for (i = 0; i !== l; b.push(a[i++])) {}
				return b;
			},
			_emptyFunc = function() {},
			_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
				var toString = Object.prototype.toString,
					array = toString.call([]);
				return function(obj) {
					return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
				};
			}()),
			a, i, p, _ticker, _tickerActive,
			_defLookup = {},

			/**
			 * @constructor
			 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
			 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
			 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
			 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
			 *
			 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
			 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
			 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
			 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
			 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
			 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
			 * sandbox the banner one like:
			 *
			 * <script>
			 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
			 * </script>
			 * <script src="js/greensock/v1.7/TweenMax.js"></script>
			 * <script>
			 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
			 * </script>
			 * <script src="js/greensock/v1.6/TweenMax.js"></script>
			 * <script>
			 *     gs.TweenLite.to(...); //would use v1.7
			 *     TweenLite.to(...); //would use v1.6
			 * </script>
			 *
			 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
			 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
			 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
			 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
			 */
			Definition = function(ns, dependencies, func, global) {
				this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
				_defLookup[ns] = this;
				this.gsClass = null;
				this.func = func;
				var _classes = [];
				this.check = function(init) {
					var i = dependencies.length,
						missing = i,
						cur, a, n, cl, hasModule;
					while (--i > -1) {
						if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
							_classes[i] = cur.gsClass;
							missing--;
						} else if (init) {
							cur.sc.push(this);
						}
					}
					if (missing === 0 && func) {
						a = ("com.greensock." + ns).split(".");
						n = a.pop();
						cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);

						//exports to multiple environments
						if (global) {
							_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
							hasModule = (typeof(module) !== "undefined" && module.exports);
							if (!hasModule && "function" === "function" && __webpack_require__(34)){ //AMD
								!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
							} else if (hasModule){ //node
								if (ns === moduleName) {
									module.exports = _exports[moduleName] = cl;
									for (i in _exports) {
										cl[i] = _exports[i];
									}
								} else if (_exports[moduleName]) {
									_exports[moduleName][n] = cl;
								}
							}
						}
						for (i = 0; i < this.sc.length; i++) {
							this.sc[i].check();
						}
					}
				};
				this.check(true);
			},

			//used to create Definition instances (which basically registers a class that has dependencies).
			_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
				return new Definition(ns, dependencies, func, global);
			},

			//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
			_class = gs._class = function(ns, func, global) {
				func = func || function() {};
				_gsDefine(ns, [], function(){ return func; }, global);
				return func;
			};

		_gsDefine.globals = _globals;



/*
 * ----------------------------------------------------------------
 * Ease
 * ----------------------------------------------------------------
 */
		var _baseParams = [0, 0, 1, 1],
			_blankArray = [],
			Ease = _class("easing.Ease", function(func, extraParams, type, power) {
				this._func = func;
				this._type = type || 0;
				this._power = power || 0;
				this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
			}, true),
			_easeMap = Ease.map = {},
			_easeReg = Ease.register = function(ease, names, types, create) {
				var na = names.split(","),
					i = na.length,
					ta = (types || "easeIn,easeOut,easeInOut").split(","),
					e, name, j, type;
				while (--i > -1) {
					name = na[i];
					e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
					j = ta.length;
					while (--j > -1) {
						type = ta[j];
						_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
					}
				}
			};

		p = Ease.prototype;
		p._calcEnd = false;
		p.getRatio = function(p) {
			if (this._func) {
				this._params[0] = p;
				return this._func.apply(null, this._params);
			}
			var t = this._type,
				pw = this._power,
				r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
			if (pw === 1) {
				r *= r;
			} else if (pw === 2) {
				r *= r * r;
			} else if (pw === 3) {
				r *= r * r * r;
			} else if (pw === 4) {
				r *= r * r * r * r;
			}
			return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
		};

		//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
		a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
		i = a.length;
		while (--i > -1) {
			p = a[i]+",Power"+i;
			_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
			_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
			_easeReg(new Ease(null,null,3,i), p, "easeInOut");
		}
		_easeMap.linear = gs.easing.Linear.easeIn;
		_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks


/*
 * ----------------------------------------------------------------
 * EventDispatcher
 * ----------------------------------------------------------------
 */
		var EventDispatcher = _class("events.EventDispatcher", function(target) {
			this._listeners = {};
			this._eventTarget = target || this;
		});
		p = EventDispatcher.prototype;

		p.addEventListener = function(type, callback, scope, useParam, priority) {
			priority = priority || 0;
			var list = this._listeners[type],
				index = 0,
				listener, i;
			if (this === _ticker && !_tickerActive) {
				_ticker.wake();
			}
			if (list == null) {
				this._listeners[type] = list = [];
			}
			i = list.length;
			while (--i > -1) {
				listener = list[i];
				if (listener.c === callback && listener.s === scope) {
					list.splice(i, 1);
				} else if (index === 0 && listener.pr < priority) {
					index = i + 1;
				}
			}
			list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
		};

		p.removeEventListener = function(type, callback) {
			var list = this._listeners[type], i;
			if (list) {
				i = list.length;
				while (--i > -1) {
					if (list[i].c === callback) {
						list.splice(i, 1);
						return;
					}
				}
			}
		};

		p.dispatchEvent = function(type) {
			var list = this._listeners[type],
				i, t, listener;
			if (list) {
				i = list.length;
				if (i > 1) { 
					list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
				}
				t = this._eventTarget;
				while (--i > -1) {
					listener = list[i];
					if (listener) {
						if (listener.up) {
							listener.c.call(listener.s || t, {type:type, target:t});
						} else {
							listener.c.call(listener.s || t);
						}
					}
				}
			}
		};


/*
 * ----------------------------------------------------------------
 * Ticker
 * ----------------------------------------------------------------
 */
 		var _reqAnimFrame = window.requestAnimationFrame,
			_cancelAnimFrame = window.cancelAnimationFrame,
			_getTime = Date.now || function() {return new Date().getTime();},
			_lastUpdate = _getTime();

		//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
		a = ["ms","moz","webkit","o"];
		i = a.length;
		while (--i > -1 && !_reqAnimFrame) {
			_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
			_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
		}

		_class("Ticker", function(fps, useRAF) {
			var _self = this,
				_startTime = _getTime(),
				_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
				_lagThreshold = 500,
				_adjustedLag = 33,
				_tickWord = "tick", //helps reduce gc burden
				_fps, _req, _id, _gap, _nextTime,
				_tick = function(manual) {
					var elapsed = _getTime() - _lastUpdate,
						overlap, dispatch;
					if (elapsed > _lagThreshold) {
						_startTime += elapsed - _adjustedLag;
					}
					_lastUpdate += elapsed;
					_self.time = (_lastUpdate - _startTime) / 1000;
					overlap = _self.time - _nextTime;
					if (!_fps || overlap > 0 || manual === true) {
						_self.frame++;
						_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
						dispatch = true;
					}
					if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
						_id = _req(_tick);
					}
					if (dispatch) {
						_self.dispatchEvent(_tickWord);
					}
				};

			EventDispatcher.call(_self);
			_self.time = _self.frame = 0;
			_self.tick = function() {
				_tick(true);
			};

			_self.lagSmoothing = function(threshold, adjustedLag) {
				_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
				_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
			};

			_self.sleep = function() {
				if (_id == null) {
					return;
				}
				if (!_useRAF || !_cancelAnimFrame) {
					clearTimeout(_id);
				} else {
					_cancelAnimFrame(_id);
				}
				_req = _emptyFunc;
				_id = null;
				if (_self === _ticker) {
					_tickerActive = false;
				}
			};

			_self.wake = function(seamless) {
				if (_id !== null) {
					_self.sleep();
				} else if (seamless) {
					_startTime += -_lastUpdate + (_lastUpdate = _getTime());
				} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
					_lastUpdate = _getTime() - _lagThreshold + 5;
				}
				_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
				if (_self === _ticker) {
					_tickerActive = true;
				}
				_tick(2);
			};

			_self.fps = function(value) {
				if (!arguments.length) {
					return _fps;
				}
				_fps = value;
				_gap = 1 / (_fps || 60);
				_nextTime = this.time + _gap;
				_self.wake();
			};

			_self.useRAF = function(value) {
				if (!arguments.length) {
					return _useRAF;
				}
				_self.sleep();
				_useRAF = value;
				_self.fps(_fps);
			};
			_self.fps(fps);

			//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
			setTimeout(function() {
				if (_useRAF === "auto" && _self.frame < 5 && _doc.visibilityState !== "hidden") {
					_self.useRAF(false);
				}
			}, 1500);
		});

		p = gs.Ticker.prototype = new gs.events.EventDispatcher();
		p.constructor = gs.Ticker;


/*
 * ----------------------------------------------------------------
 * Animation
 * ----------------------------------------------------------------
 */
		var Animation = _class("core.Animation", function(duration, vars) {
				this.vars = vars = vars || {};
				this._duration = this._totalDuration = duration || 0;
				this._delay = Number(vars.delay) || 0;
				this._timeScale = 1;
				this._active = (vars.immediateRender === true);
				this.data = vars.data;
				this._reversed = (vars.reversed === true);

				if (!_rootTimeline) {
					return;
				}
				if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
					_ticker.wake();
				}

				var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
				tl.add(this, tl._time);

				if (this.vars.paused) {
					this.paused(true);
				}
			});

		_ticker = Animation.ticker = new gs.Ticker();
		p = Animation.prototype;
		p._dirty = p._gc = p._initted = p._paused = false;
		p._totalTime = p._time = 0;
		p._rawPrevTime = -1;
		p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
		p._paused = false;


		//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
		var _checkTimeout = function() {
				if (_tickerActive && _getTime() - _lastUpdate > 2000) {
					_ticker.wake();
				}
				setTimeout(_checkTimeout, 2000);
			};
		_checkTimeout();


		p.play = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.reversed(false).paused(false);
		};

		p.pause = function(atTime, suppressEvents) {
			if (atTime != null) {
				this.seek(atTime, suppressEvents);
			}
			return this.paused(true);
		};

		p.resume = function(from, suppressEvents) {
			if (from != null) {
				this.seek(from, suppressEvents);
			}
			return this.paused(false);
		};

		p.seek = function(time, suppressEvents) {
			return this.totalTime(Number(time), suppressEvents !== false);
		};

		p.restart = function(includeDelay, suppressEvents) {
			return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
		};

		p.reverse = function(from, suppressEvents) {
			if (from != null) {
				this.seek((from || this.totalDuration()), suppressEvents);
			}
			return this.reversed(true).paused(false);
		};

		p.render = function(time, suppressEvents, force) {
			//stub - we override this method in subclasses.
		};

		p.invalidate = function() {
			this._time = this._totalTime = 0;
			this._initted = this._gc = false;
			this._rawPrevTime = -1;
			if (this._gc || !this.timeline) {
				this._enabled(true);
			}
			return this;
		};

		p.isActive = function() {
			var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
				startTime = this._startTime,
				rawTime;
			return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale));
		};

		p._enabled = function (enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			this._gc = !enabled;
			this._active = this.isActive();
			if (ignoreTimeline !== true) {
				if (enabled && !this.timeline) {
					this._timeline.add(this, this._startTime - this._delay);
				} else if (!enabled && this.timeline) {
					this._timeline._remove(this, true);
				}
			}
			return false;
		};


		p._kill = function(vars, target) {
			return this._enabled(false, false);
		};

		p.kill = function(vars, target) {
			this._kill(vars, target);
			return this;
		};

		p._uncache = function(includeSelf) {
			var tween = includeSelf ? this : this.timeline;
			while (tween) {
				tween._dirty = true;
				tween = tween.timeline;
			}
			return this;
		};

		p._swapSelfInParams = function(params) {
			var i = params.length,
				copy = params.concat();
			while (--i > -1) {
				if (params[i] === "{self}") {
					copy[i] = this;
				}
			}
			return copy;
		};

		p._callback = function(type) {
			var v = this.vars,
				callback = v[type],
				params = v[type + "Params"],
				scope = v[type + "Scope"] || v.callbackScope || this,
				l = params ? params.length : 0;
			switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
				case 0: callback.call(scope); break;
				case 1: callback.call(scope, params[0]); break;
				case 2: callback.call(scope, params[0], params[1]); break;
				default: callback.apply(scope, params);
			}
		};

//----Animation getters/setters --------------------------------------------------------

		p.eventCallback = function(type, callback, params, scope) {
			if ((type || "").substr(0,2) === "on") {
				var v = this.vars;
				if (arguments.length === 1) {
					return v[type];
				}
				if (callback == null) {
					delete v[type];
				} else {
					v[type] = callback;
					v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
					v[type + "Scope"] = scope;
				}
				if (type === "onUpdate") {
					this._onUpdate = callback;
				}
			}
			return this;
		};

		p.delay = function(value) {
			if (!arguments.length) {
				return this._delay;
			}
			if (this._timeline.smoothChildTiming) {
				this.startTime( this._startTime + value - this._delay );
			}
			this._delay = value;
			return this;
		};

		p.duration = function(value) {
			if (!arguments.length) {
				this._dirty = false;
				return this._duration;
			}
			this._duration = this._totalDuration = value;
			this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
			if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
				this.totalTime(this._totalTime * (value / this._duration), true);
			}
			return this;
		};

		p.totalDuration = function(value) {
			this._dirty = false;
			return (!arguments.length) ? this._totalDuration : this.duration(value);
		};

		p.time = function(value, suppressEvents) {
			if (!arguments.length) {
				return this._time;
			}
			if (this._dirty) {
				this.totalDuration();
			}
			return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
		};

		p.totalTime = function(time, suppressEvents, uncapped) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (!arguments.length) {
				return this._totalTime;
			}
			if (this._timeline) {
				if (time < 0 && !uncapped) {
					time += this.totalDuration();
				}
				if (this._timeline.smoothChildTiming) {
					if (this._dirty) {
						this.totalDuration();
					}
					var totalDuration = this._totalDuration,
						tl = this._timeline;
					if (time > totalDuration && !uncapped) {
						time = totalDuration;
					}
					this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
					if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
						this._uncache(false);
					}
					//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
					if (tl._timeline) {
						while (tl._timeline) {
							if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
								tl.totalTime(tl._totalTime, true);
							}
							tl = tl._timeline;
						}
					}
				}
				if (this._gc) {
					this._enabled(true, false);
				}
				if (this._totalTime !== time || this._duration === 0) {
					if (_lazyTweens.length) {
						_lazyRender();
					}
					this.render(time, suppressEvents, false);
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
						_lazyRender();
					}
				}
			}
			return this;
		};

		p.progress = p.totalProgress = function(value, suppressEvents) {
			var duration = this.duration();
			return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
		};

		p.startTime = function(value) {
			if (!arguments.length) {
				return this._startTime;
			}
			if (value !== this._startTime) {
				this._startTime = value;
				if (this.timeline) if (this.timeline._sortChildren) {
					this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
				}
			}
			return this;
		};

		p.endTime = function(includeRepeats) {
			return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
		};

		p.timeScale = function(value) {
			if (!arguments.length) {
				return this._timeScale;
			}
			value = value || _tinyNum; //can't allow zero because it'll throw the math off
			if (this._timeline && this._timeline.smoothChildTiming) {
				var pauseTime = this._pauseTime,
					t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
				this._startTime = t - ((t - this._startTime) * this._timeScale / value);
			}
			this._timeScale = value;
			return this._uncache(false);
		};

		p.reversed = function(value) {
			if (!arguments.length) {
				return this._reversed;
			}
			if (value != this._reversed) {
				this._reversed = value;
				this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
			}
			return this;
		};

		p.paused = function(value) {
			if (!arguments.length) {
				return this._paused;
			}
			var tl = this._timeline,
				raw, elapsed;
			if (value != this._paused) if (tl) {
				if (!_tickerActive && !value) {
					_ticker.wake();
				}
				raw = tl.rawTime();
				elapsed = raw - this._pauseTime;
				if (!value && tl.smoothChildTiming) {
					this._startTime += elapsed;
					this._uncache(false);
				}
				this._pauseTime = value ? raw : null;
				this._paused = value;
				this._active = this.isActive();
				if (!value && elapsed !== 0 && this._initted && this.duration()) {
					raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
					this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
				}
			}
			if (this._gc && !value) {
				this._enabled(true, false);
			}
			return this;
		};


/*
 * ----------------------------------------------------------------
 * SimpleTimeline
 * ----------------------------------------------------------------
 */
		var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
			Animation.call(this, 0, vars);
			this.autoRemoveChildren = this.smoothChildTiming = true;
		});

		p = SimpleTimeline.prototype = new Animation();
		p.constructor = SimpleTimeline;
		p.kill()._gc = false;
		p._first = p._last = p._recent = null;
		p._sortChildren = false;

		p.add = p.insert = function(child, position, align, stagger) {
			var prevTween, st;
			child._startTime = Number(position || 0) + child._delay;
			if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
				child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
			}
			if (child.timeline) {
				child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
			}
			child.timeline = child._timeline = this;
			if (child._gc) {
				child._enabled(true, true);
			}
			prevTween = this._last;
			if (this._sortChildren) {
				st = child._startTime;
				while (prevTween && prevTween._startTime > st) {
					prevTween = prevTween._prev;
				}
			}
			if (prevTween) {
				child._next = prevTween._next;
				prevTween._next = child;
			} else {
				child._next = this._first;
				this._first = child;
			}
			if (child._next) {
				child._next._prev = child;
			} else {
				this._last = child;
			}
			child._prev = prevTween;
			this._recent = child;
			if (this._timeline) {
				this._uncache(true);
			}
			return this;
		};

		p._remove = function(tween, skipDisable) {
			if (tween.timeline === this) {
				if (!skipDisable) {
					tween._enabled(false, true);
				}

				if (tween._prev) {
					tween._prev._next = tween._next;
				} else if (this._first === tween) {
					this._first = tween._next;
				}
				if (tween._next) {
					tween._next._prev = tween._prev;
				} else if (this._last === tween) {
					this._last = tween._prev;
				}
				tween._next = tween._prev = tween.timeline = null;
				if (tween === this._recent) {
					this._recent = this._last;
				}

				if (this._timeline) {
					this._uncache(true);
				}
			}
			return this;
		};

		p.render = function(time, suppressEvents, force) {
			var tween = this._first,
				next;
			this._totalTime = this._time = this._rawPrevTime = time;
			while (tween) {
				next = tween._next; //record it here because the value could change after rendering...
				if (tween._active || (time >= tween._startTime && !tween._paused)) {
					if (!tween._reversed) {
						tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
					} else {
						tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
					}
				}
				tween = next;
			}
		};

		p.rawTime = function() {
			if (!_tickerActive) {
				_ticker.wake();
			}
			return this._totalTime;
		};

/*
 * ----------------------------------------------------------------
 * TweenLite
 * ----------------------------------------------------------------
 */
		var TweenLite = _class("TweenLite", function(target, duration, vars) {
				Animation.call(this, duration, vars);
				this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)

				if (target == null) {
					throw "Cannot tween a null target.";
				}

				this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;

				var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
					overwrite = this.vars.overwrite,
					i, targ, targets;

				this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];

				if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
					this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					this._propLookup = [];
					this._siblings = [];
					for (i = 0; i < targets.length; i++) {
						targ = targets[i];
						if (!targ) {
							targets.splice(i--, 1);
							continue;
						} else if (typeof(targ) === "string") {
							targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
							if (typeof(targ) === "string") {
								targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
							}
							continue;
						} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
							targets.splice(i--, 1);
							this._targets = targets = targets.concat(_slice(targ));
							continue;
						}
						this._siblings[i] = _register(targ, this, false);
						if (overwrite === 1) if (this._siblings[i].length > 1) {
							_applyOverwrite(targ, this, null, 1, this._siblings[i]);
						}
					}

				} else {
					this._propLookup = {};
					this._siblings = _register(target, this, false);
					if (overwrite === 1) if (this._siblings.length > 1) {
						_applyOverwrite(target, this, null, 1, this._siblings);
					}
				}
				if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative
				}
			}, true),
			_isSelector = function(v) {
				return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
			},
			_autoCSS = function(vars, target) {
				var css = {},
					p;
				for (p in vars) {
					if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
						css[p] = vars[p];
						delete vars[p];
					}
				}
				vars.css = css;
			};

		p = TweenLite.prototype = new Animation();
		p.constructor = TweenLite;
		p.kill()._gc = false;

//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------

		p.ratio = 0;
		p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
		p._notifyPluginsOfEnabled = p._lazy = false;

		TweenLite.version = "1.19.1";
		TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
		TweenLite.defaultOverwrite = "auto";
		TweenLite.ticker = _ticker;
		TweenLite.autoSleep = 120;
		TweenLite.lagSmoothing = function(threshold, adjustedLag) {
			_ticker.lagSmoothing(threshold, adjustedLag);
		};

		TweenLite.selector = window.$ || window.jQuery || function(e) {
			var selector = window.$ || window.jQuery;
			if (selector) {
				TweenLite.selector = selector;
				return selector(e);
			}
			return (typeof(_doc) === "undefined") ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
		};

		var _lazyTweens = [],
			_lazyLookup = {},
			_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
			_setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val;
				while (pt) {
					val = !pt.blob ? pt.c * v + pt.s : (v === 1) ? this.end : v ? this.join("") : this.start;
					if (pt.m) {
						val = pt.m(val, this._target || pt.t);
					} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
						val = 0;
					}
					if (!pt.f) {
						pt.t[pt.p] = val;
					} else if (pt.fp) {
						pt.t[pt.p](pt.fp, val);
					} else {
						pt.t[pt.p](val);
					}
					pt = pt._next;
				}
			},
			//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
			_blobDif = function(start, end, filter, pt) {
				var a = [],
					charIndex = 0,
					s = "",
					color = 0,
					startNums, endNums, num, i, l, nonNumbers, currentNum;
				a.start = start;
				a.end = end;
				start = a[0] = start + ""; //ensure values are strings
				end = a[1] = end + "";
				if (filter) {
					filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
					start = a[0];
					end = a[1];
				}
				a.length = 0;
				startNums = start.match(_numbersExp) || [];
				endNums = end.match(_numbersExp) || [];
				if (pt) {
					pt._next = null;
					pt.blob = 1;
					a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
				}
				l = endNums.length;
				for (i = 0; i < l; i++) {
					currentNum = endNums[i];
					nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
					s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
					charIndex += nonNumbers.length;
					if (color) { //sense rgba() values and round them.
						color = (color + 1) % 5;
					} else if (nonNumbers.substr(-5) === "rgba(") {
						color = 1;
					}
					if (currentNum === startNums[i] || startNums.length <= i) {
						s += currentNum;
					} else {
						if (s) {
							a.push(s);
							s = "";
						}
						num = parseFloat(startNums[i]);
						a.push(num);
						a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
						//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
					}
					charIndex += currentNum.length;
				}
				s += end.substr(charIndex);
				if (s) {
					a.push(s);
				}
				a.setRatio = _setRatio;
				return a;
			},
			//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
			_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
				if (typeof(end) === "function") {
					end = end(index || 0, target);
				}
				var type = typeof(target[prop]),
					getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
					s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
					isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
					pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
					blob;

				if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
					if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
						//a blob (string that has multiple numbers in it)
						pt.fp = funcParam;
						blob = _blobDif(s, (isRelative ? pt.s + pt.c : end), stringFilter || TweenLite.defaultStringFilter, pt);
						pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
					} else {
						pt.s = parseFloat(s);
						if (!isRelative) {
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
				}
				if (pt.c) { //only add it to the linked list if there's a change.
					if ((pt._next = this._firstPT)) {
						pt._next._prev = pt;
					}
					this._firstPT = pt;
					return pt;
				}
			},
			_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
			_plugins = TweenLite._plugins = {},
			_tweenLookup = _internals.tweenLookup = {},
			_tweenLookupNum = 0,
			_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1},
			_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
			_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
			_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
			_nextGCFrame = 30,
			_lazyRender = _internals.lazyRender = function() {
				var i = _lazyTweens.length,
					tween;
				_lazyLookup = {};
				while (--i > -1) {
					tween = _lazyTweens[i];
					if (tween && tween._lazy !== false) {
						tween.render(tween._lazy[0], tween._lazy[1], true);
						tween._lazy = false;
					}
				}
				_lazyTweens.length = 0;
			};

		_rootTimeline._startTime = _ticker.time;
		_rootFramesTimeline._startTime = _ticker.frame;
		_rootTimeline._active = _rootFramesTimeline._active = true;
		setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".

		Animation._updateRoot = TweenLite.render = function() {
				var i, a, p;
				if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
					_lazyRender();
				}
				_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
				_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
				if (_lazyTweens.length) {
					_lazyRender();
				}
				if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
					_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
					for (p in _tweenLookup) {
						a = _tweenLookup[p].tweens;
						i = a.length;
						while (--i > -1) {
							if (a[i]._gc) {
								a.splice(i, 1);
							}
						}
						if (a.length === 0) {
							delete _tweenLookup[p];
						}
					}
					//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
					p = _rootTimeline._first;
					if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
						while (p && p._paused) {
							p = p._next;
						}
						if (!p) {
							_ticker.sleep();
						}
					}
				}
			};

		_ticker.addEventListener("tick", Animation._updateRoot);

		var _register = function(target, tween, scrub) {
				var id = target._gsTweenID, a, i;
				if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
					_tweenLookup[id] = {target:target, tweens:[]};
				}
				if (tween) {
					a = _tweenLookup[id].tweens;
					a[(i = a.length)] = tween;
					if (scrub) {
						while (--i > -1) {
							if (a[i] === tween) {
								a.splice(i, 1);
							}
						}
					}
				}
				return _tweenLookup[id].tweens;
			},
			_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
				var func = overwrittenTween.vars.onOverwrite, r1, r2;
				if (func) {
					r1 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				func = TweenLite.onOverwrite;
				if (func) {
					r2 = func(overwrittenTween, overwritingTween, target, killedProps);
				}
				return (r1 !== false && r2 !== false);
			},
			_applyOverwrite = function(target, tween, props, mode, siblings) {
				var i, changed, curTween, l;
				if (mode === 1 || mode >= 4) {
					l = siblings.length;
					for (i = 0; i < l; i++) {
						if ((curTween = siblings[i]) !== tween) {
							if (!curTween._gc) {
								if (curTween._kill(null, target, tween)) {
									changed = true;
								}
							}
						} else if (mode === 5) {
							break;
						}
					}
					return changed;
				}
				//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
				var startTime = tween._startTime + _tinyNum,
					overlaps = [],
					oCount = 0,
					zeroDur = (tween._duration === 0),
					globalStart;
				i = siblings.length;
				while (--i > -1) {
					if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
						//ignore
					} else if (curTween._timeline !== tween._timeline) {
						globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
						if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
							overlaps[oCount++] = curTween;
						}
					} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
						overlaps[oCount++] = curTween;
					}
				}

				i = oCount;
				while (--i > -1) {
					curTween = overlaps[i];
					if (mode === 2) if (curTween._kill(props, target, tween)) {
						changed = true;
					}
					if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
						if (mode !== 2 && !_onOverwrite(curTween, tween)) {
							continue;
						}
						if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
							changed = true;
						}
					}
				}
				return changed;
			},
			_checkOverlap = function(tween, reference, zeroDur) {
				var tl = tween._timeline,
					ts = tl._timeScale,
					t = tween._startTime;
				while (tl._timeline) {
					t += tl._startTime;
					ts *= tl._timeScale;
					if (tl._paused) {
						return -100;
					}
					tl = tl._timeline;
				}
				t /= ts;
				return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
			};


//---- TweenLite instance methods -----------------------------------------------------------------------------

		p._init = function() {
			var v = this.vars,
				op = this._overwrittenProps,
				dur = this._duration,
				immediate = !!v.immediateRender,
				ease = v.ease,
				i, initPlugins, pt, p, startVars, l;
			if (v.startAt) {
				if (this._startAt) {
					this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
					this._startAt.kill();
				}
				startVars = {};
				for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
					startVars[p] = v.startAt[p];
				}
				startVars.overwrite = false;
				startVars.immediateRender = true;
				startVars.lazy = (immediate && v.lazy !== false);
				startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
				this._startAt = TweenLite.to(this.target, 0, startVars);
				if (immediate) {
					if (this._time > 0) {
						this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
					} else if (dur !== 0) {
						return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
					}
				}
			} else if (v.runBackwards && dur !== 0) {
				//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
				if (this._startAt) {
					this._startAt.render(-1, true);
					this._startAt.kill();
					this._startAt = null;
				} else {
					if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
						immediate = false;
					}
					pt = {};
					for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
						if (!_reservedProps[p] || p === "autoCSS") {
							pt[p] = v[p];
						}
					}
					pt.overwrite = 0;
					pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
					pt.lazy = (immediate && v.lazy !== false);
					pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
					this._startAt = TweenLite.to(this.target, 0, pt);
					if (!immediate) {
						this._startAt._init(); //ensures that the initial values are recorded
						this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
						if (this.vars.immediateRender) {
							this._startAt = null;
						}
					} else if (this._time === 0) {
						return;
					}
				}
			}
			this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
			if (v.easeParams instanceof Array && ease.config) {
				this._ease = ease.config.apply(ease, v.easeParams);
			}
			this._easeType = this._ease._type;
			this._easePower = this._ease._power;
			this._firstPT = null;

			if (this._targets) {
				l = this._targets.length;
				for (i = 0; i < l; i++) {
					if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
						initPlugins = true;
					}
				}
			} else {
				initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
			}

			if (initPlugins) {
				TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
			}
			if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
				this._enabled(false, false);
			}
			if (v.runBackwards) {
				pt = this._firstPT;
				while (pt) {
					pt.s += pt.c;
					pt.c = -pt.c;
					pt = pt._next;
				}
			}
			this._onUpdate = v.onUpdate;
			this._initted = true;
		};

		p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
			var p, i, initPlugins, plugin, pt, v;
			if (target == null) {
				return false;
			}

			if (_lazyLookup[target._gsTweenID]) {
				_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
			}

			if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
				_autoCSS(this.vars, target);
			}
			for (p in this.vars) {
				v = this.vars[p];
				if (_reservedProps[p]) {
					if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
						this.vars[p] = v = this._swapSelfInParams(v, this);
					}

				} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {

					//t - target 		[object]
					//p - property 		[string]
					//s - start			[number]
					//c - change		[number]
					//f - isFunction	[boolean]
					//n - name			[string]
					//pg - isPlugin 	[boolean]
					//pr - priority		[number]
					//m - mod           [function | 0]
					this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
					i = plugin._overwriteProps.length;
					while (--i > -1) {
						propLookup[plugin._overwriteProps[i]] = this._firstPT;
					}
					if (plugin._priority || plugin._onInitAllProps) {
						initPlugins = true;
					}
					if (plugin._onDisable || plugin._onEnable) {
						this._notifyPluginsOfEnabled = true;
					}
					if (pt._next) {
						pt._next._prev = pt;
					}

				} else {
					propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
				}
			}

			if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
				this._kill(propLookup, target);
				return this._initProps(target, propLookup, siblings, overwrittenProps, index);
			}
			if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
				_lazyLookup[target._gsTweenID] = true;
			}
			return initPlugins;
		};

		p.render = function(time, suppressEvents, force) {
			var prevTime = this._time,
				duration = this._duration,
				prevRawPrevTime = this._rawPrevTime,
				isComplete, callback, pt, rawPrevTime;
			if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
				this._totalTime = this._time = duration;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
				if (!this._reversed ) {
					isComplete = true;
					callback = "onComplete";
					force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
				}
				if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
					if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
						time = 0;
					}
					if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
						force = true;
						if (prevRawPrevTime > _tinyNum) {
							callback = "onReverseComplete";
						}
					}
					this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
				}

			} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
				this._totalTime = this._time = 0;
				this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
				if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
					callback = "onReverseComplete";
					isComplete = this._reversed;
				}
				if (time < 0) {
					this._active = false;
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
							force = true;
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
				}
				if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
					force = true;
				}
			} else {
				this._totalTime = this._time = time;

				if (this._easeType) {
					var r = time / duration, type = this._easeType, pow = this._easePower;
					if (type === 1 || (type === 3 && r >= 0.5)) {
						r = 1 - r;
					}
					if (type === 3) {
						r *= 2;
					}
					if (pow === 1) {
						r *= r;
					} else if (pow === 2) {
						r *= r * r;
					} else if (pow === 3) {
						r *= r * r * r;
					} else if (pow === 4) {
						r *= r * r * r * r;
					}

					if (type === 1) {
						this.ratio = 1 - r;
					} else if (type === 2) {
						this.ratio = r;
					} else if (time / duration < 0.5) {
						this.ratio = r / 2;
					} else {
						this.ratio = 1 - (r / 2);
					}

				} else {
					this.ratio = this._ease.getRatio(time / duration);
				}
			}

			if (this._time === prevTime && !force) {
				return;
			} else if (!this._initted) {
				this._init();
				if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
					return;
				} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
					this._time = this._totalTime = prevTime;
					this._rawPrevTime = prevRawPrevTime;
					_lazyTweens.push(this);
					this._lazy = [time, suppressEvents];
					return;
				}
				//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
				if (this._time && !isComplete) {
					this.ratio = this._ease.getRatio(this._time / duration);
				} else if (isComplete && this._ease._calcEnd) {
					this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
				}
			}
			if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
				this._lazy = false;
			}
			if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
				this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
			}
			if (prevTime === 0) {
				if (this._startAt) {
					if (time >= 0) {
						this._startAt.render(time, suppressEvents, force);
					} else if (!callback) {
						callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
					}
				}
				if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
					this._callback("onStart");
				}
			}
			pt = this._firstPT;
			while (pt) {
				if (pt.f) {
					pt.t[pt.p](pt.c * this.ratio + pt.s);
				} else {
					pt.t[pt.p] = pt.c * this.ratio + pt.s;
				}
				pt = pt._next;
			}

			if (this._onUpdate) {
				if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
					this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
				}
				if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
					this._callback("onUpdate");
				}
			}
			if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
				if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
					this._startAt.render(time, suppressEvents, force);
				}
				if (isComplete) {
					if (this._timeline.autoRemoveChildren) {
						this._enabled(false, false);
					}
					this._active = false;
				}
				if (!suppressEvents && this.vars[callback]) {
					this._callback(callback);
				}
				if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
					this._rawPrevTime = 0;
				}
			}
		};

		p._kill = function(vars, target, overwritingTween) {
			if (vars === "all") {
				vars = null;
			}
			if (vars == null) if (target == null || target === this.target) {
				this._lazy = false;
				return this._enabled(false, false);
			}
			target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
			var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
				i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				while (--i > -1) {
					if (this._kill(vars, target[i], overwritingTween)) {
						changed = true;
					}
				}
			} else {
				if (this._targets) {
					i = this._targets.length;
					while (--i > -1) {
						if (target === this._targets[i]) {
							propLookup = this._propLookup[i] || {};
							this._overwrittenProps = this._overwrittenProps || [];
							overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
							break;
						}
					}
				} else if (target !== this.target) {
					return false;
				} else {
					propLookup = this._propLookup;
					overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
				}

				if (propLookup) {
					killProps = vars || propLookup;
					record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
					if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
						for (p in killProps) {
							if (propLookup[p]) {
								if (!killed) {
									killed = [];
								}
								killed.push(p);
							}
						}
						if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
							return false;
						}
					}

					for (p in killProps) {
						if ((pt = propLookup[p])) {
							if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
								if (pt.f) {
									pt.t[pt.p](pt.s);
								} else {
									pt.t[pt.p] = pt.s;
								}
								changed = true;
							}
							if (pt.pg && pt.t._kill(killProps)) {
								changed = true; //some plugins need to be notified so they can perform cleanup tasks first
							}
							if (!pt.pg || pt.t._overwriteProps.length === 0) {
								if (pt._prev) {
									pt._prev._next = pt._next;
								} else if (pt === this._firstPT) {
									this._firstPT = pt._next;
								}
								if (pt._next) {
									pt._next._prev = pt._prev;
								}
								pt._next = pt._prev = null;
							}
							delete propLookup[p];
						}
						if (record) {
							overwrittenProps[p] = 1;
						}
					}
					if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
						this._enabled(false, false);
					}
				}
			}
			return changed;
		};

		p.invalidate = function() {
			if (this._notifyPluginsOfEnabled) {
				TweenLite._onPluginEvent("_onDisable", this);
			}
			this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
			this._notifyPluginsOfEnabled = this._active = this._lazy = false;
			this._propLookup = (this._targets) ? {} : [];
			Animation.prototype.invalidate.call(this);
			if (this.vars.immediateRender) {
				this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
				this.render(Math.min(0, -this._delay)); //in case delay is negative.
			}
			return this;
		};

		p._enabled = function(enabled, ignoreTimeline) {
			if (!_tickerActive) {
				_ticker.wake();
			}
			if (enabled && this._gc) {
				var targets = this._targets,
					i;
				if (targets) {
					i = targets.length;
					while (--i > -1) {
						this._siblings[i] = _register(targets[i], this, true);
					}
				} else {
					this._siblings = _register(this.target, this, true);
				}
			}
			Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
			if (this._notifyPluginsOfEnabled) if (this._firstPT) {
				return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
			}
			return false;
		};


//----TweenLite static methods -----------------------------------------------------

		TweenLite.to = function(target, duration, vars) {
			return new TweenLite(target, duration, vars);
		};

		TweenLite.from = function(target, duration, vars) {
			vars.runBackwards = true;
			vars.immediateRender = (vars.immediateRender != false);
			return new TweenLite(target, duration, vars);
		};

		TweenLite.fromTo = function(target, duration, fromVars, toVars) {
			toVars.startAt = fromVars;
			toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
			return new TweenLite(target, duration, toVars);
		};

		TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
			return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
		};

		TweenLite.set = function(target, vars) {
			return new TweenLite(target, 0, vars);
		};

		TweenLite.getTweensOf = function(target, onlyActive) {
			if (target == null) { return []; }
			target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
			var i, a, j, t;
			if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
				i = target.length;
				a = [];
				while (--i > -1) {
					a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
				}
				i = a.length;
				//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
				while (--i > -1) {
					t = a[i];
					j = i;
					while (--j > -1) {
						if (t === a[j]) {
							a.splice(i, 1);
						}
					}
				}
			} else {
				a = _register(target).concat();
				i = a.length;
				while (--i > -1) {
					if (a[i]._gc || (onlyActive && !a[i].isActive())) {
						a.splice(i, 1);
					}
				}
			}
			return a;
		};

		TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
			if (typeof(onlyActive) === "object") {
				vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
				onlyActive = false;
			}
			var a = TweenLite.getTweensOf(target, onlyActive),
				i = a.length;
			while (--i > -1) {
				a[i]._kill(vars, target);
			}
		};



/*
 * ----------------------------------------------------------------
 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
 * ----------------------------------------------------------------
 */
		var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
					this._overwriteProps = (props || "").split(",");
					this._propName = this._overwriteProps[0];
					this._priority = priority || 0;
					this._super = TweenPlugin.prototype;
				}, true);

		p = TweenPlugin.prototype;
		TweenPlugin.version = "1.19.0";
		TweenPlugin.API = 2;
		p._firstPT = null;
		p._addTween = _addPropTween;
		p.setRatio = _setRatio;

		p._kill = function(lookup) {
			var a = this._overwriteProps,
				pt = this._firstPT,
				i;
			if (lookup[this._propName] != null) {
				this._overwriteProps = [];
			} else {
				i = a.length;
				while (--i > -1) {
					if (lookup[a[i]] != null) {
						a.splice(i, 1);
					}
				}
			}
			while (pt) {
				if (lookup[pt.n] != null) {
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
						pt._prev = null;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
					}
				}
				pt = pt._next;
			}
			return false;
		};

		p._mod = p._roundProps = function(lookup) {
			var pt = this._firstPT,
				val;
			while (pt) {
				val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
				if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
					if (pt.f === 2) {
						pt.t._applyPT.m = val;
					} else {
						pt.m = val;
					}
				}
				pt = pt._next;
			}
		};

		TweenLite._onPluginEvent = function(type, tween) {
			var pt = tween._firstPT,
				changed, pt2, first, last, next;
			if (type === "_onInitAllProps") {
				//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
				while (pt) {
					next = pt._next;
					pt2 = first;
					while (pt2 && pt2.pr > pt.pr) {
						pt2 = pt2._next;
					}
					if ((pt._prev = pt2 ? pt2._prev : last)) {
						pt._prev._next = pt;
					} else {
						first = pt;
					}
					if ((pt._next = pt2)) {
						pt2._prev = pt;
					} else {
						last = pt;
					}
					pt = next;
				}
				pt = tween._firstPT = first;
			}
			while (pt) {
				if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
					changed = true;
				}
				pt = pt._next;
			}
			return changed;
		};

		TweenPlugin.activate = function(plugins) {
			var i = plugins.length;
			while (--i > -1) {
				if (plugins[i].API === TweenPlugin.API) {
					_plugins[(new plugins[i]())._propName] = plugins[i];
				}
			}
			return true;
		};

		//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
		_gsDefine.plugin = function(config) {
			if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
			var propName = config.propName,
				priority = config.priority || 0,
				overwriteProps = config.overwriteProps,
				map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
				Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
					function() {
						TweenPlugin.call(this, propName, priority);
						this._overwriteProps = overwriteProps || [];
					}, (config.global === true)),
				p = Plugin.prototype = new TweenPlugin(propName),
				prop;
			p.constructor = Plugin;
			Plugin.API = config.API;
			for (prop in map) {
				if (typeof(config[prop]) === "function") {
					p[map[prop]] = config[prop];
				}
			}
			Plugin.version = config.version;
			TweenPlugin.activate([Plugin]);
			return Plugin;
		};


		//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
		a = window._gsQueue;
		if (a) {
			for (i = 0; i < a.length; i++) {
				a[i]();
			}
			for (p in _defLookup) {
				if (!_defLookup[p].func) {
					window.console.log("GSAP encountered missing dependency: " + p);
				}
			}
		}

		_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated

})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenLite");

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/


/*!
 * VERSION: 1.3.7
 * DATE: 2017-01-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";var a=180/Math.PI,b=[],c=[],d=[],e={},f=_gsScope._gsDefine.globals,g=function(a,b,c,d){c===d&&(c=d-(d-b)/1e6),a===b&&(b=a+(c-a)/1e6),this.a=a,this.b=b,this.c=c,this.d=d,this.da=d-a,this.ca=c-a,this.ba=b-a},h=",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",i=function(a,b,c,d){var e={a:a},f={},g={},h={c:d},i=(a+b)/2,j=(b+c)/2,k=(c+d)/2,l=(i+j)/2,m=(j+k)/2,n=(m-l)/8;return e.b=i+(a-i)/4,f.b=l+n,e.c=f.a=(e.b+f.b)/2,f.c=g.a=(l+m)/2,g.b=m-n,h.b=k+(d-k)/4,g.c=h.a=(g.b+h.b)/2,[e,f,g,h]},j=function(a,e,f,g,h){var j,k,l,m,n,o,p,q,r,s,t,u,v,w=a.length-1,x=0,y=a[0].a;for(j=0;w>j;j++)n=a[x],k=n.a,l=n.d,m=a[x+1].d,h?(t=b[j],u=c[j],v=(u+t)*e*.25/(g?.5:d[j]||.5),o=l-(l-k)*(g?.5*e:0!==t?v/t:0),p=l+(m-l)*(g?.5*e:0!==u?v/u:0),q=l-(o+((p-o)*(3*t/(t+u)+.5)/4||0))):(o=l-(l-k)*e*.5,p=l+(m-l)*e*.5,q=l-(o+p)/2),o+=q,p+=q,n.c=r=o,0!==j?n.b=y:n.b=y=n.a+.6*(n.c-n.a),n.da=l-k,n.ca=r-k,n.ba=y-k,f?(s=i(k,y,r,l),a.splice(x,1,s[0],s[1],s[2],s[3]),x+=4):x++,y=p;n=a[x],n.b=y,n.c=y+.4*(n.d-y),n.da=n.d-n.a,n.ca=n.c-n.a,n.ba=y-n.a,f&&(s=i(n.a,y,n.c,n.d),a.splice(x,1,s[0],s[1],s[2],s[3]))},k=function(a,d,e,f){var h,i,j,k,l,m,n=[];if(f)for(a=[f].concat(a),i=a.length;--i>-1;)"string"==typeof(m=a[i][d])&&"="===m.charAt(1)&&(a[i][d]=f[d]+Number(m.charAt(0)+m.substr(2)));if(h=a.length-2,0>h)return n[0]=new g(a[0][d],0,0,a[0][d]),n;for(i=0;h>i;i++)j=a[i][d],k=a[i+1][d],n[i]=new g(j,0,0,k),e&&(l=a[i+2][d],b[i]=(b[i]||0)+(k-j)*(k-j),c[i]=(c[i]||0)+(l-k)*(l-k));return n[i]=new g(a[i][d],0,0,a[i+1][d]),n},l=function(a,f,g,i,l,m){var n,o,p,q,r,s,t,u,v={},w=[],x=m||a[0];l="string"==typeof l?","+l+",":h,null==f&&(f=1);for(o in a[0])w.push(o);if(a.length>1){for(u=a[a.length-1],t=!0,n=w.length;--n>-1;)if(o=w[n],Math.abs(x[o]-u[o])>.05){t=!1;break}t&&(a=a.concat(),m&&a.unshift(m),a.push(a[1]),m=a[a.length-3])}for(b.length=c.length=d.length=0,n=w.length;--n>-1;)o=w[n],e[o]=-1!==l.indexOf(","+o+","),v[o]=k(a,o,e[o],m);for(n=b.length;--n>-1;)b[n]=Math.sqrt(b[n]),c[n]=Math.sqrt(c[n]);if(!i){for(n=w.length;--n>-1;)if(e[o])for(p=v[w[n]],s=p.length-1,q=0;s>q;q++)r=p[q+1].da/c[q]+p[q].da/b[q]||0,d[q]=(d[q]||0)+r*r;for(n=d.length;--n>-1;)d[n]=Math.sqrt(d[n])}for(n=w.length,q=g?4:1;--n>-1;)o=w[n],p=v[o],j(p,f,g,i,e[o]),t&&(p.splice(0,q),p.splice(p.length-q,q));return v},m=function(a,b,c){b=b||"soft";var d,e,f,h,i,j,k,l,m,n,o,p={},q="cubic"===b?3:2,r="soft"===b,s=[];if(r&&c&&(a=[c].concat(a)),null==a||a.length<q+1)throw"invalid Bezier data";for(m in a[0])s.push(m);for(j=s.length;--j>-1;){for(m=s[j],p[m]=i=[],n=0,l=a.length,k=0;l>k;k++)d=null==c?a[k][m]:"string"==typeof(o=a[k][m])&&"="===o.charAt(1)?c[m]+Number(o.charAt(0)+o.substr(2)):Number(o),r&&k>1&&l-1>k&&(i[n++]=(d+i[n-2])/2),i[n++]=d;for(l=n-q+1,n=0,k=0;l>k;k+=q)d=i[k],e=i[k+1],f=i[k+2],h=2===q?0:i[k+3],i[n++]=o=3===q?new g(d,e,f,h):new g(d,(2*e+d)/3,(2*e+f)/3,f);i.length=n}return p},n=function(a,b,c){for(var d,e,f,g,h,i,j,k,l,m,n,o=1/c,p=a.length;--p>-1;)for(m=a[p],f=m.a,g=m.d-f,h=m.c-f,i=m.b-f,d=e=0,k=1;c>=k;k++)j=o*k,l=1-j,d=e-(e=(j*j*g+3*l*(j*h+l*i))*j),n=p*c+k-1,b[n]=(b[n]||0)+d*d},o=function(a,b){b=b>>0||6;var c,d,e,f,g=[],h=[],i=0,j=0,k=b-1,l=[],m=[];for(c in a)n(a[c],g,b);for(e=g.length,d=0;e>d;d++)i+=Math.sqrt(g[d]),f=d%b,m[f]=i,f===k&&(j+=i,f=d/b>>0,l[f]=m,h[f]=j,i=0,m=[]);return{length:j,lengths:h,segments:l}},p=_gsScope._gsDefine.plugin({propName:"bezier",priority:-1,version:"1.3.7",API:2,global:!0,init:function(a,b,c){this._target=a,b instanceof Array&&(b={values:b}),this._func={},this._mod={},this._props=[],this._timeRes=null==b.timeResolution?6:parseInt(b.timeResolution,10);var d,e,f,g,h,i=b.values||[],j={},k=i[0],n=b.autoRotate||c.vars.orientToBezier;this._autoRotate=n?n instanceof Array?n:[["x","y","rotation",n===!0?0:Number(n)||0]]:null;for(d in k)this._props.push(d);for(f=this._props.length;--f>-1;)d=this._props[f],this._overwriteProps.push(d),e=this._func[d]="function"==typeof a[d],j[d]=e?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]():parseFloat(a[d]),h||j[d]!==i[0][d]&&(h=j);if(this._beziers="cubic"!==b.type&&"quadratic"!==b.type&&"soft"!==b.type?l(i,isNaN(b.curviness)?1:b.curviness,!1,"thruBasic"===b.type,b.correlate,h):m(i,b.type,j),this._segCount=this._beziers[d].length,this._timeRes){var p=o(this._beziers,this._timeRes);this._length=p.length,this._lengths=p.lengths,this._segments=p.segments,this._l1=this._li=this._s1=this._si=0,this._l2=this._lengths[0],this._curSeg=this._segments[0],this._s2=this._curSeg[0],this._prec=1/this._curSeg.length}if(n=this._autoRotate)for(this._initialRotations=[],n[0]instanceof Array||(this._autoRotate=n=[n]),f=n.length;--f>-1;){for(g=0;3>g;g++)d=n[f][g],this._func[d]="function"==typeof a[d]?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]:!1;d=n[f][2],this._initialRotations[f]=(this._func[d]?this._func[d].call(this._target):this._target[d])||0,this._overwriteProps.push(d)}return this._startRatio=c.vars.runBackwards?1:0,!0},set:function(b){var c,d,e,f,g,h,i,j,k,l,m=this._segCount,n=this._func,o=this._target,p=b!==this._startRatio;if(this._timeRes){if(k=this._lengths,l=this._curSeg,b*=this._length,e=this._li,b>this._l2&&m-1>e){for(j=m-1;j>e&&(this._l2=k[++e])<=b;);this._l1=k[e-1],this._li=e,this._curSeg=l=this._segments[e],this._s2=l[this._s1=this._si=0]}else if(b<this._l1&&e>0){for(;e>0&&(this._l1=k[--e])>=b;);0===e&&b<this._l1?this._l1=0:e++,this._l2=k[e],this._li=e,this._curSeg=l=this._segments[e],this._s1=l[(this._si=l.length-1)-1]||0,this._s2=l[this._si]}if(c=e,b-=this._l1,e=this._si,b>this._s2&&e<l.length-1){for(j=l.length-1;j>e&&(this._s2=l[++e])<=b;);this._s1=l[e-1],this._si=e}else if(b<this._s1&&e>0){for(;e>0&&(this._s1=l[--e])>=b;);0===e&&b<this._s1?this._s1=0:e++,this._s2=l[e],this._si=e}h=(e+(b-this._s1)/(this._s2-this._s1))*this._prec||0}else c=0>b?0:b>=1?m-1:m*b>>0,h=(b-c*(1/m))*m;for(d=1-h,e=this._props.length;--e>-1;)f=this._props[e],g=this._beziers[f][c],i=(h*h*g.da+3*d*(h*g.ca+d*g.ba))*h+g.a,this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i;if(this._autoRotate){var q,r,s,t,u,v,w,x=this._autoRotate;for(e=x.length;--e>-1;)f=x[e][2],v=x[e][3]||0,w=x[e][4]===!0?1:a,g=this._beziers[x[e][0]],q=this._beziers[x[e][1]],g&&q&&(g=g[c],q=q[c],r=g.a+(g.b-g.a)*h,t=g.b+(g.c-g.b)*h,r+=(t-r)*h,t+=(g.c+(g.d-g.c)*h-t)*h,s=q.a+(q.b-q.a)*h,u=q.b+(q.c-q.b)*h,s+=(u-s)*h,u+=(q.c+(q.d-q.c)*h-u)*h,i=p?Math.atan2(u-s,t-r)*w+v:this._initialRotations[e],this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i)}}}),q=p.prototype;p.bezierThrough=l,p.cubicToQuadratic=i,p._autoCSS=!0,p.quadraticToCubic=function(a,b,c){return new g(a,(2*b+a)/3,(2*b+c)/3,c)},p._cssRegister=function(){var a=f.CSSPlugin;if(a){var b=a._internals,c=b._parseToProxy,d=b._setPluginRatio,e=b.CSSPropTween;b._registerComplexSpecialProp("bezier",{parser:function(a,b,f,g,h,i){b instanceof Array&&(b={values:b}),i=new p;var j,k,l,m=b.values,n=m.length-1,o=[],q={};if(0>n)return h;for(j=0;n>=j;j++)l=c(a,m[j],g,h,i,n!==j),o[j]=l.end;for(k in b)q[k]=b[k];return q.values=o,h=new e(a,"bezier",0,0,l.pt,2),h.data=l,h.plugin=i,h.setRatio=d,0===q.autoRotate&&(q.autoRotate=!0),!q.autoRotate||q.autoRotate instanceof Array||(j=q.autoRotate===!0?0:Number(q.autoRotate),q.autoRotate=null!=l.end.left?[["left","top","rotation",j,!1]]:null!=l.end.x?[["x","y","rotation",j,!1]]:!1),q.autoRotate&&(g._transform||g._enableTransforms(!1),l.autoRotate=g._target._gsTransform,l.proxy.rotation=l.autoRotate.rotation||0,g._overwriteProps.push("rotation")),i._onInitTween(l.proxy,q,g._tween),h}})}},q._mod=function(a){for(var b,c=this._overwriteProps,d=c.length;--d>-1;)b=a[c[d]],b&&"function"==typeof b&&(this._mod[c[d]]=b)},q._kill=function(a){var b,c,d=this._props;for(b in this._beziers)if(b in a)for(delete this._beziers[b],delete this._func[b],c=d.length;--c>-1;)d[c]===b&&d.splice(c,1);if(d=this._autoRotate)for(c=d.length;--c>-1;)a[d[c][2]]&&d.splice(c,1);return this._super._kill.call(this,a)}}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a){"use strict";var b=function(){return(_gsScope.GreenSockGlobals||_gsScope)[a]}; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(225)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports&&(require("../TweenLite.min.js"),module.exports=b())}("BezierPlugin");

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/


var bind = __webpack_require__(17);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/


/*!
 *  howler.js v2.0.2
 *  howlerjs.com
 *
 *  (c) 2013-2016, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */
  var HowlerGlobal = function() {
    this.init();
  };
  HowlerGlobal.prototype = {
    /**
     * Initialize the global Howler object.
     * @return {Howler}
     */
    init: function() {
      var self = this || Howler;

      // Internal properties.
      self._codecs = {};
      self._howls = [];
      self._muted = false;
      self._volume = 1;
      self._canPlayEvent = 'canplaythrough';
      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;

      // Public properties.
      self.masterGain = null;
      self.noAudio = false;
      self.usingWebAudio = true;
      self.autoSuspend = true;
      self.ctx = null;

      // Set to false to disable the auto iOS enabler.
      self.mobileAutoEnable = true;

      // Setup the various state values for global tracking.
      self._setup();

      return self;
    },

    /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */
    volume: function(vol) {
      var self = this || Howler;
      vol = parseFloat(vol);

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        self._volume = vol;

        // Don't update any of the nodes if we are muted.
        if (self._muted) {
          return self;
        }

        // When using Web Audio, we just need to adjust the master gain.
        if (self.usingWebAudio) {
          self.masterGain.gain.value = vol;
        }

        // Loop through and change volume for all HTML5 audio nodes.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and change the volumes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node) {
                sound._node.volume = sound._volume * vol;
              }
            }
          }
        }

        return self;
      }

      return self._volume;
    },

    /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */
    mute: function(muted) {
      var self = this || Howler;

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      self._muted = muted;

      // With Web Audio, we just need to mute the master gain.
      if (self.usingWebAudio) {
        self.masterGain.gain.value = muted ? 0 : self._volume;
      }

      // Loop through and mute all HTML5 Audio nodes.
      for (var i=0; i<self._howls.length; i++) {
        if (!self._howls[i]._webAudio) {
          // Get all of the sounds in this Howl group.
          var ids = self._howls[i]._getSoundIds();

          // Loop through all sounds and mark the audio node as muted.
          for (var j=0; j<ids.length; j++) {
            var sound = self._howls[i]._soundById(ids[j]);

            if (sound && sound._node) {
              sound._node.muted = (muted) ? true : sound._muted;
            }
          }
        }
      }

      return self;
    },

    /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */
    unload: function() {
      var self = this || Howler;

      for (var i=self._howls.length-1; i>=0; i--) {
        self._howls[i].unload();
      }

      // Create a new AudioContext to make sure it is fully reset.
      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
        self.ctx.close();
        self.ctx = null;
        setupAudioContext();
      }

      return self;
    },

    /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */
    codecs: function(ext) {
      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
    },

    /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */
    _setup: function() {
      var self = this || Howler;

      // Keeps track of the suspend/resume state of the AudioContext.
      self.state = self.ctx ? self.ctx.state || 'running' : 'running';

      // Automatically begin the 30-second suspend process
      self._autoSuspend();

      // Check if audio is available.
      if (!self.usingWebAudio) {
        // No audio is available on this system if noAudio is set to true.
        if (typeof Audio !== 'undefined') {
          try {
            var test = new Audio();

            // Check if the canplaythrough event is available.
            if (typeof test.oncanplaythrough === 'undefined') {
              self._canPlayEvent = 'canplay';
            }
          } catch(e) {
            self.noAudio = true;
          }
        } else {
          self.noAudio = true;
        }
      }

      // Test to make sure audio isn't disabled in Internet Explorer.
      try {
        var test = new Audio();
        if (test.muted) {
          self.noAudio = true;
        }
      } catch (e) {}

      // Check for supported codecs.
      if (!self.noAudio) {
        self._setupCodecs();
      }

      return self;
    },

    /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */
    _setupCodecs: function() {
      var self = this || Howler;
      var audioTest = null;

      // Must wrap in a try/catch because IE11 in server mode throws an error.
      try {
        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
      } catch (err) {
        return self;
      }

      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
        return self;
      }

      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');

      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
      var checkOpera = self._navigator && self._navigator.userAgent.match(/OPR\/([0-6].)/g);
      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);

      self._codecs = {
        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
        mpeg: !!mpegTest,
        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        wav: !!audioTest.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''),
        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        weba: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        webm: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
      };

      return self;
    },

    /**
     * Mobile browsers will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */
    _enableMobileAudio: function() {
      var self = this || Howler;

      // Only run this on mobile devices if audio isn't already eanbled.
      var isMobile = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(self._navigator && self._navigator.userAgent);
      var isTouch = !!(('ontouchend' in window) || (self._navigator && self._navigator.maxTouchPoints > 0) || (self._navigator && self._navigator.msMaxTouchPoints > 0));
      if (self._mobileEnabled || !self.ctx || (!isMobile && !isTouch)) {
        return;
      }

      self._mobileEnabled = false;

      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
        self._mobileUnloaded = true;
        self.unload();
      }

      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
      // http://stackoverflow.com/questions/24119684
      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);

      // Call this method on touch start to create and play a buffer,
      // then check if the audio actually played to determine if
      // audio has now been unlocked on iOS, Android, etc.
      var unlock = function() {
        // Create an empty buffer.
        var source = self.ctx.createBufferSource();
        source.buffer = self._scratchBuffer;
        source.connect(self.ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function() {
          source.disconnect(0);

          // Update the unlocked state and prevent this check from happening again.
          self._mobileEnabled = true;
          self.mobileAutoEnable = false;

          // Remove the touch start listener.
          document.removeEventListener('touchend', unlock, true);
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchend', unlock, true);

      return self;
    },

    /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */
    _autoSuspend: function() {
      var self = this;

      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      // Check if any sounds are playing.
      for (var i=0; i<self._howls.length; i++) {
        if (self._howls[i]._webAudio) {
          for (var j=0; j<self._howls[i]._sounds.length; j++) {
            if (!self._howls[i]._sounds[j]._paused) {
              return self;
            }
          }
        }
      }

      if (self._suspendTimer) {
        clearTimeout(self._suspendTimer);
      }

      // If no sound has played after 30 seconds, suspend the context.
      self._suspendTimer = setTimeout(function() {
        if (!self.autoSuspend) {
          return;
        }

        self._suspendTimer = null;
        self.state = 'suspending';
        self.ctx.suspend().then(function() {
          self.state = 'suspended';

          if (self._resumeAfterSuspend) {
            delete self._resumeAfterSuspend;
            self._autoResume();
          }
        });
      }, 30000);

      return self;
    },

    /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */
    _autoResume: function() {
      var self = this;

      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      if (self.state === 'running' && self._suspendTimer) {
        clearTimeout(self._suspendTimer);
        self._suspendTimer = null;
      } else if (self.state === 'suspended') {
        self.state = 'resuming';
        self.ctx.resume().then(function() {
          self.state = 'running';

          // Emit to all Howls that the audio has resumed.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('resume');
          }
        });

        if (self._suspendTimer) {
          clearTimeout(self._suspendTimer);
          self._suspendTimer = null;
        }
      } else if (self.state === 'suspending') {
        self._resumeAfterSuspend = true;
      }

      return self;
    }
  };

  // Setup the global audio controller.
  var Howler = new HowlerGlobal();

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */
  var Howl = function(o) {
    var self = this;

    // Throw an error if no source is provided.
    if (!o.src || o.src.length === 0) {
      console.error('An array of source files must be passed with any new Howl.');
      return;
    }

    self.init(o);
  };
  Howl.prototype = {
    /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */
    init: function(o) {
      var self = this;

      // If we don't have an AudioContext created yet, run the setup.
      if (!Howler.ctx) {
        setupAudioContext();
      }

      // Setup user-defined default properties.
      self._autoplay = o.autoplay || false;
      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
      self._html5 = o.html5 || false;
      self._muted = o.mute || false;
      self._loop = o.loop || false;
      self._pool = o.pool || 5;
      self._preload = (typeof o.preload === 'boolean') ? o.preload : true;
      self._rate = o.rate || 1;
      self._sprite = o.sprite || {};
      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
      self._volume = o.volume !== undefined ? o.volume : 1;

      // Setup all other default properties.
      self._duration = 0;
      self._state = 'unloaded';
      self._sounds = [];
      self._endTimers = {};
      self._queue = [];

      // Setup event listeners.
      self._onend = o.onend ? [{fn: o.onend}] : [];
      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
      self._onload = o.onload ? [{fn: o.onload}] : [];
      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
      self._onresume = [];

      // Web Audio or HTML5 Audio?
      self._webAudio = Howler.usingWebAudio && !self._html5;

      // Automatically try to enable audio on iOS.
      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.mobileAutoEnable) {
        Howler._enableMobileAudio();
      }

      // Keep track of this Howl group in the global controller.
      Howler._howls.push(self);

      // If they selected autoplay, add a play event to the load queue.
      if (self._autoplay) {
        self._queue.push({
          event: 'play',
          action: function() {
            self.play();
          }
        });
      }

      // Load the source file unless otherwise specified.
      if (self._preload) {
        self.load();
      }

      return self;
    },

    /**
     * Load the audio file.
     * @return {Howler}
     */
    load: function() {
      var self = this;
      var url = null;

      // If no audio is available, quit immediately.
      if (Howler.noAudio) {
        self._emit('loaderror', null, 'No audio support.');
        return;
      }

      // Make sure our source is in an array.
      if (typeof self._src === 'string') {
        self._src = [self._src];
      }

      // Loop through the sources and pick the first one that is compatible.
      for (var i=0; i<self._src.length; i++) {
        var ext, str;

        if (self._format && self._format[i]) {
          // If an extension was specified, use that instead.
          ext = self._format[i];
        } else {
          // Make sure the source is a string.
          str = self._src[i];
          if (typeof str !== 'string') {
            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
            continue;
          }

          // Extract the file extension from the URL or base64 data URI.
          ext = /^data:audio\/([^;,]+);/i.exec(str);
          if (!ext) {
            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
          }

          if (ext) {
            ext = ext[1].toLowerCase();
          }
        }

        // Check if this extension is available.
        if (Howler.codecs(ext)) {
          url = self._src[i];
          break;
        }
      }

      if (!url) {
        self._emit('loaderror', null, 'No codec support for selected audio sources.');
        return;
      }

      self._src = url;
      self._state = 'loading';

      // If the hosting page is HTTPS and the source isn't,
      // drop down to HTML5 Audio to avoid Mixed Content errors.
      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
        self._html5 = true;
        self._webAudio = false;
      }

      // Create a new sound object and add it to the pool.
      new Sound(self);

      // Load and decode the audio data for playback.
      if (self._webAudio) {
        loadBuffer(self);
      }

      return self;
    },

    /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */
    play: function(sprite, internal) {
      var self = this;
      var id = null;

      // Determine if a sprite, sound id or nothing was passed
      if (typeof sprite === 'number') {
        id = sprite;
        sprite = null;
      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
        // If the passed sprite doesn't exist, do nothing.
        return null;
      } else if (typeof sprite === 'undefined') {
        // Use the default sound sprite (plays the full audio length).
        sprite = '__default';

        // Check if there is a single paused sound that isn't ended.
        // If there is, play that sound. If not, continue as usual.
        var num = 0;
        for (var i=0; i<self._sounds.length; i++) {
          if (self._sounds[i]._paused && !self._sounds[i]._ended) {
            num++;
            id = self._sounds[i]._id;
          }
        }

        if (num === 1) {
          sprite = null;
        } else {
          id = null;
        }
      }

      // Get the selected node, or get one from the pool.
      var sound = id ? self._soundById(id) : self._inactiveSound();

      // If the sound doesn't exist, do nothing.
      if (!sound) {
        return null;
      }

      // Select the sprite definition.
      if (id && !sprite) {
        sprite = sound._sprite || '__default';
      }

      // If we have no sprite and the sound hasn't loaded, we must wait
      // for the sound to load to get our audio's duration.
      if (self._state !== 'loaded' && !self._sprite[sprite]) {
        self._queue.push({
          event: 'play',
          action: function() {
            self.play(self._soundById(sound._id) ? sound._id : undefined);
          }
        });

        return sound._id;
      }

      // Don't play the sound if an id was passed and it is already playing.
      if (id && !sound._paused) {
        // Trigger the play event, in order to keep iterating through queue.
        if (!internal) {
          setTimeout(function() {
            self._emit('play', sound._id);
          }, 0);
        }

        return sound._id;
      }

      // Make sure the AudioContext isn't suspended, and resume it if it is.
      if (self._webAudio) {
        Howler._autoResume();
      }

      // Determine how long to play for and where to start playing.
      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
      var timeout = (duration * 1000) / Math.abs(sound._rate);

      // Update the parameters of the sound
      sound._paused = false;
      sound._ended = false;
      sound._sprite = sprite;
      sound._seek = seek;
      sound._start = self._sprite[sprite][0] / 1000;
      sound._stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
      sound._loop = !!(sound._loop || self._sprite[sprite][2]);

      // Begin the actual playback.
      var node = sound._node;
      if (self._webAudio) {
        // Fire this when the sound is ready to play to begin Web Audio playback.
        var playWebAudio = function() {
          self._refreshBuffer(sound);

          // Setup the playback params.
          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
          sound._playStart = Howler.ctx.currentTime;

          // Play the sound using the supported method.
          if (typeof node.bufferSource.start === 'undefined') {
            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
          } else {
            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
          }

          // Start a new timer if none is present.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }

          if (!internal) {
            setTimeout(function() {
              self._emit('play', sound._id);
            }, 0);
          }
        };

        var isRunning = (Howler.state === 'running');
        if (self._state === 'loaded' && isRunning) {
          playWebAudio();
        } else {
          // Wait for the audio to load and then begin playback.
          self.once(isRunning ? 'load' : 'resume', playWebAudio, isRunning ? sound._id : null);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      } else {
        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
        var playHtml5 = function() {
          node.currentTime = seek;
          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
          node.volume = sound._volume * Howler.volume();
          node.playbackRate = sound._rate;

          setTimeout(function() {
            node.play();

            // Setup the new end timer.
            if (timeout !== Infinity) {
              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            if (!internal) {
              self._emit('play', sound._id);
            }
          }, 0);
        };

        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
        var loadedNoReadyState = (self._state === 'loaded' && (window && window.ejecta || !node.readyState && Howler._navigator.isCocoonJS));
        if (node.readyState === 4 || loadedNoReadyState) {
          playHtml5();
        } else {
          var listener = function() {
            // Begin playback.
            playHtml5();

            // Clear this listener.
            node.removeEventListener(Howler._canPlayEvent, listener, false);
          };
          node.addEventListener(Howler._canPlayEvent, listener, false);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      }

      return sound._id;
    },

    /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */
    pause: function(id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to pause when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'pause',
          action: function() {
            self.pause(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be paused.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound && !sound._paused) {
          // Reset the seek position.
          sound._seek = self.seek(ids[i]);
          sound._rateSeek = 0;
          sound._paused = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // make sure the sound has been created
              if (!sound._node.bufferSource) {
                return self;
              }

              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.pause();
            }
          }
        }

        // Fire the pause event, unless `true` is passed as the 2nd argument.
        if (!arguments[1]) {
          self._emit('pause', sound ? sound._id : null);
        }
      }

      return self;
    },

    /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */
    stop: function(id, internal) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to stop when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'stop',
          action: function() {
            self.stop(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be stopped.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          // Reset the seek position.
          sound._seek = sound._start || 0;
          sound._rateSeek = 0;
          sound._paused = true;
          sound._ended = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // make sure the sound has been created
              if (!sound._node.bufferSource) {
                if (!internal) {
                  self._emit('stop', sound._id);
                }

                return self;
              }

              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.currentTime = sound._start || 0;
              sound._node.pause();
            }
          }
        }

        if (sound && !internal) {
          self._emit('stop', sound._id);
        }
      }

      return self;
    },

    /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */
    mute: function(muted, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to mute when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'mute',
          action: function() {
            self.mute(muted, id);
          }
        });

        return self;
      }

      // If applying mute/unmute to all sounds, update the group's value.
      if (typeof id === 'undefined') {
        if (typeof muted === 'boolean') {
          self._muted = muted;
        } else {
          return self._muted;
        }
      }

      // If no id is passed, get all ID's to be muted.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          sound._muted = muted;

          if (self._webAudio && sound._node) {
            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
          } else if (sound._node) {
            sound._node.muted = Howler._muted ? true : muted;
          }

          self._emit('mute', sound._id);
        }
      }

      return self;
    },

    /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */
    volume: function() {
      var self = this;
      var args = arguments;
      var vol, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // Return the value of the groups' volume.
        return self._volume;
      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
        // First check if this is an ID, and if not, assume it is a new volume.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          vol = parseFloat(args[0]);
        }
      } else if (args.length >= 2) {
        vol = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the volume or return the current volume.
      var sound;
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'volume',
            action: function() {
              self.volume.apply(self, args);
            }
          });

          return self;
        }

        // Set the group volume.
        if (typeof id === 'undefined') {
          self._volume = vol;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            sound._volume = vol;

            // Stop currently running fades.
            if (!args[2]) {
              self._stopFade(id[i]);
            }

            if (self._webAudio && sound._node && !sound._muted) {
              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
            } else if (sound._node && !sound._muted) {
              sound._node.volume = vol * Howler.volume();
            }

            self._emit('volume', sound._id);
          }
        }
      } else {
        sound = id ? self._soundById(id) : self._sounds[0];
        return sound ? sound._volume : 0;
      }

      return self;
    },

    /**
     * Fade a currently playing sound between two volumes (if no id is passsed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */
    fade: function(from, to, len, id) {
      var self = this;
      var diff = Math.abs(from - to);
      var dir = from > to ? 'out' : 'in';
      var steps = diff / 0.01;
      var stepLen = (steps > 0) ? len / steps : len;

      // Since browsers clamp timeouts to 4ms, we need to clamp our steps to that too.
      if (stepLen < 4) {
        steps = Math.ceil(steps / (4 / stepLen));
        stepLen = 4;
      }

      // If the sound hasn't loaded, add it to the load queue to fade when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'fade',
          action: function() {
            self.fade(from, to, len, id);
          }
        });

        return self;
      }

      // Set the volume to the start position.
      self.volume(from, id);

      // Fade the volume of one or all sounds.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        // Create a linear fade or fall back to timeouts with HTML5 Audio.
        if (sound) {
          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
          if (!id) {
            self._stopFade(ids[i]);
          }

          // If we are using Web Audio, let the native methods do the actual fade.
          if (self._webAudio && !sound._muted) {
            var currentTime = Howler.ctx.currentTime;
            var end = currentTime + (len / 1000);
            sound._volume = from;
            sound._node.gain.setValueAtTime(from, currentTime);
            sound._node.gain.linearRampToValueAtTime(to, end);
          }

          var vol = from;
          sound._interval = setInterval(function(soundId, sound) {
            // Update the volume amount, but only if the volume should change.
            if (steps > 0) {
              vol += (dir === 'in' ? 0.01 : -0.01);
            }

            // Make sure the volume is in the right bounds.
            vol = Math.max(0, vol);
            vol = Math.min(1, vol);

            // Round to within 2 decimal points.
            vol = Math.round(vol * 100) / 100;

            // Change the volume.
            if (self._webAudio) {
              if (typeof id === 'undefined') {
                self._volume = vol;
              }

              sound._volume = vol;
            } else {
              self.volume(vol, soundId, true);
            }

            // When the fade is complete, stop it and fire event.
            if (vol === to) {
              clearInterval(sound._interval);
              sound._interval = null;
              self.volume(vol, soundId);
              self._emit('fade', soundId);
            }
          }.bind(self, ids[i], sound), stepLen);
        }
      }

      return self;
    },

    /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */
    _stopFade: function(id) {
      var self = this;
      var sound = self._soundById(id);

      if (sound && sound._interval) {
        if (self._webAudio) {
          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
        }

        clearInterval(sound._interval);
        sound._interval = null;
        self._emit('fade', id);
      }

      return self;
    },

    /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */
    loop: function() {
      var self = this;
      var args = arguments;
      var loop, id, sound;

      // Determine the values for loop and id.
      if (args.length === 0) {
        // Return the grou's loop value.
        return self._loop;
      } else if (args.length === 1) {
        if (typeof args[0] === 'boolean') {
          loop = args[0];
          self._loop = loop;
        } else {
          // Return this sound's loop value.
          sound = self._soundById(parseInt(args[0], 10));
          return sound ? sound._loop : false;
        }
      } else if (args.length === 2) {
        loop = args[0];
        id = parseInt(args[1], 10);
      }

      // If no id is passed, get all ID's to be looped.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        sound = self._soundById(ids[i]);

        if (sound) {
          sound._loop = loop;
          if (self._webAudio && sound._node && sound._node.bufferSource) {
            sound._node.bufferSource.loop = loop;
            if (loop) {
              sound._node.bufferSource.loopStart = sound._start || 0;
              sound._node.bufferSource.loopEnd = sound._stop;
            }
          }
        }
      }

      return self;
    },

    /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */
    rate: function() {
      var self = this;
      var args = arguments;
      var rate, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current rate of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new rate value.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          rate = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        rate = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the playback rate or return the current value.
      var sound;
      if (typeof rate === 'number') {
        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'rate',
            action: function() {
              self.rate.apply(self, args);
            }
          });

          return self;
        }

        // Set the group rate.
        if (typeof id === 'undefined') {
          self._rate = rate;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            // Keep track of our position when the rate changed and update the playback
            // start position so we can properly adjust the seek position for time elapsed.
            sound._rateSeek = self.seek(id[i]);
            sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
            sound._rate = rate;

            // Change the playback rate.
            if (self._webAudio && sound._node && sound._node.bufferSource) {
              sound._node.bufferSource.playbackRate.value = rate;
            } else if (sound._node) {
              sound._node.playbackRate = rate;
            }

            // Reset the timers.
            var seek = self.seek(id[i]);
            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
            var timeout = (duration * 1000) / Math.abs(sound._rate);

            // Start a new end timer if sound is already playing.
            if (self._endTimers[id[i]] || !sound._paused) {
              self._clearTimer(id[i]);
              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            self._emit('rate', sound._id);
          }
        }
      } else {
        sound = self._soundById(id);
        return sound ? sound._rate : self._rate;
      }

      return self;
    },

    /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */
    seek: function() {
      var self = this;
      var args = arguments;
      var seek, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current position of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new seek position.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          id = self._sounds[0]._id;
          seek = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        seek = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // If there is no ID, bail out.
      if (typeof id === 'undefined') {
        return self;
      }

      // If the sound hasn't loaded, add it to the load queue to seek when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'seek',
          action: function() {
            self.seek.apply(self, args);
          }
        });

        return self;
      }

      // Get the sound.
      var sound = self._soundById(id);

      if (sound) {
        if (typeof seek === 'number' && seek >= 0) {
          // Pause the sound and update position for restarting playback.
          var playing = self.playing(id);
          if (playing) {
            self.pause(id, true);
          }

          // Move the position of the track and cancel timer.
          sound._seek = seek;
          sound._ended = false;
          self._clearTimer(id);

          // Restart the playback if the sound was playing.
          if (playing) {
            self.play(id, true);
          }

          // Update the seek position for HTML5 Audio.
          if (!self._webAudio && sound._node) {
            sound._node.currentTime = seek;
          }

          self._emit('seek', id);
        } else {
          if (self._webAudio) {
            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
          } else {
            return sound._node.currentTime;
          }
        }
      }

      return self;
    },

    /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */
    playing: function(id) {
      var self = this;

      // Check the passed sound ID (if any).
      if (typeof id === 'number') {
        var sound = self._soundById(id);
        return sound ? !sound._paused : false;
      }

      // Otherwise, loop through all sounds and check if any are playing.
      for (var i=0; i<self._sounds.length; i++) {
        if (!self._sounds[i]._paused) {
          return true;
        }
      }

      return false;
    },

    /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */
    duration: function(id) {
      var self = this;
      var duration = self._duration;

      // If we pass an ID, get the sound and return the sprite length.
      var sound = self._soundById(id);
      if (sound) {
        duration = self._sprite[sound._sprite][1] / 1000;
      }

      return duration;
    },

    /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */
    state: function() {
      return this._state;
    },

    /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */
    unload: function() {
      var self = this;

      // Stop playing any active sounds.
      var sounds = self._sounds;
      for (var i=0; i<sounds.length; i++) {
        // Stop the sound if it is currently playing.
        if (!sounds[i]._paused) {
          self.stop(sounds[i]._id);
          self._emit('end', sounds[i]._id);
        }

        // Remove the source or disconnect.
        if (!self._webAudio) {
          // Set the source to 0-second silence to stop any downloading.
          sounds[i]._node.src = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=';

          // Remove any event listeners.
          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
        }

        // Empty out all of the nodes.
        delete sounds[i]._node;

        // Make sure all timers are cleared out.
        self._clearTimer(sounds[i]._id);

        // Remove the references in the global Howler object.
        var index = Howler._howls.indexOf(self);
        if (index >= 0) {
          Howler._howls.splice(index, 1);
        }
      }

      // Delete this sound from the cache (if no other Howl is using it).
      var remCache = true;
      for (i=0; i<Howler._howls.length; i++) {
        if (Howler._howls[i]._src === self._src) {
          remCache = false;
          break;
        }
      }

      if (cache && remCache) {
        delete cache[self._src];
      }

      // Clear global errors.
      Howler.noAudio = false;

      // Clear out `self`.
      self._state = 'unloaded';
      self._sounds = [];
      self = null;

      return null;
    },

    /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */
    on: function(event, fn, id, once) {
      var self = this;
      var events = self['_on' + event];

      if (typeof fn === 'function') {
        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
      }

      return self;
    },

    /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */
    off: function(event, fn, id) {
      var self = this;
      var events = self['_on' + event];
      var i = 0;

      if (fn) {
        // Loop through event store and remove the passed function.
        for (i=0; i<events.length; i++) {
          if (fn === events[i].fn && id === events[i].id) {
            events.splice(i, 1);
            break;
          }
        }
      } else if (event) {
        // Clear out all events of this type.
        self['_on' + event] = [];
      } else {
        // Clear out all events of every type.
        var keys = Object.keys(self);
        for (i=0; i<keys.length; i++) {
          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
            self[keys[i]] = [];
          }
        }
      }

      return self;
    },

    /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */
    once: function(event, fn, id) {
      var self = this;

      // Setup the event listener.
      self.on(event, fn, id, 1);

      return self;
    },

    /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */
    _emit: function(event, id, msg) {
      var self = this;
      var events = self['_on' + event];

      // Loop through event store and fire all functions.
      for (var i=events.length-1; i>=0; i--) {
        if (!events[i].id || events[i].id === id || event === 'load') {
          setTimeout(function(fn) {
            fn.call(this, id, msg);
          }.bind(self, events[i].fn), 0);

          // If this event was setup with `once`, remove it.
          if (events[i].once) {
            self.off(event, events[i].fn, events[i].id);
          }
        }
      }

      return self;
    },

    /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */
    _loadQueue: function() {
      var self = this;

      if (self._queue.length > 0) {
        var task = self._queue[0];

        // don't move onto the next task until this one is done
        self.once(task.event, function() {
          self._queue.shift();
          self._loadQueue();
        });

        task.action();
      }

      return self;
    },

    /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _ended: function(sound) {
      var self = this;
      var sprite = sound._sprite;

      // Should this sound loop?
      var loop = !!(sound._loop || self._sprite[sprite][2]);

      // Fire the ended event.
      self._emit('end', sound._id);

      // Restart the playback for HTML5 Audio loop.
      if (!self._webAudio && loop) {
        self.stop(sound._id, true).play(sound._id);
      }

      // Restart this timer if on a Web Audio loop.
      if (self._webAudio && loop) {
        self._emit('play', sound._id);
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        sound._playStart = Howler.ctx.currentTime;

        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
      }

      // Mark the node as paused.
      if (self._webAudio && !loop) {
        sound._paused = true;
        sound._ended = true;
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        self._clearTimer(sound._id);

        // Clean up the buffer source.
        self._cleanBuffer(sound._node);

        // Attempt to auto-suspend AudioContext if no sounds are still playing.
        Howler._autoSuspend();
      }

      // When using a sprite, end the track.
      if (!self._webAudio && !loop) {
        self.stop(sound._id);
      }

      return self;
    },

    /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */
    _clearTimer: function(id) {
      var self = this;

      if (self._endTimers[id]) {
        clearTimeout(self._endTimers[id]);
        delete self._endTimers[id];
      }

      return self;
    },

    /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */
    _soundById: function(id) {
      var self = this;

      // Loop through all sounds and find the one with this ID.
      for (var i=0; i<self._sounds.length; i++) {
        if (id === self._sounds[i]._id) {
          return self._sounds[i];
        }
      }

      return null;
    },

    /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */
    _inactiveSound: function() {
      var self = this;

      self._drain();

      // Find the first inactive node to recycle.
      for (var i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          return self._sounds[i].reset();
        }
      }

      // If no inactive node was found, create a new one.
      return new Sound(self);
    },

    /**
     * Drain excess inactive sounds from the pool.
     */
    _drain: function() {
      var self = this;
      var limit = self._pool;
      var cnt = 0;
      var i = 0;

      // If there are less sounds than the max pool size, we are done.
      if (self._sounds.length < limit) {
        return;
      }

      // Count the number of inactive sounds.
      for (i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          cnt++;
        }
      }

      // Remove excess inactive sounds, going in reverse order.
      for (i=self._sounds.length - 1; i>=0; i--) {
        if (cnt <= limit) {
          return;
        }

        if (self._sounds[i]._ended) {
          // Disconnect the audio source when using Web Audio.
          if (self._webAudio && self._sounds[i]._node) {
            self._sounds[i]._node.disconnect(0);
          }

          // Remove sounds until we have the pool size.
          self._sounds.splice(i, 1);
          cnt--;
        }
      }
    },

    /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */
    _getSoundIds: function(id) {
      var self = this;

      if (typeof id === 'undefined') {
        var ids = [];
        for (var i=0; i<self._sounds.length; i++) {
          ids.push(self._sounds[i]._id);
        }

        return ids;
      } else {
        return [id];
      }
    },

    /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _refreshBuffer: function(sound) {
      var self = this;

      // Setup the buffer source for playback.
      sound._node.bufferSource = Howler.ctx.createBufferSource();
      sound._node.bufferSource.buffer = cache[self._src];

      // Connect to the correct node.
      if (sound._panner) {
        sound._node.bufferSource.connect(sound._panner);
      } else {
        sound._node.bufferSource.connect(sound._node);
      }

      // Setup looping and playback rate.
      sound._node.bufferSource.loop = sound._loop;
      if (sound._loop) {
        sound._node.bufferSource.loopStart = sound._start || 0;
        sound._node.bufferSource.loopEnd = sound._stop;
      }
      sound._node.bufferSource.playbackRate.value = sound._rate;

      return self;
    },

    /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */
    _cleanBuffer: function(node) {
      var self = this;

      if (self._scratchBuffer) {
        node.bufferSource.onended = null;
        node.bufferSource.disconnect(0);
        try { node.bufferSource.buffer = self._scratchBuffer; } catch(e) {}
      }
      node.bufferSource = null;

      return self;
    }
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */
  var Sound = function(howl) {
    this._parent = howl;
    this.init();
  };
  Sound.prototype = {
    /**
     * Initialize a new Sound object.
     * @return {Sound}
     */
    init: function() {
      var self = this;
      var parent = self._parent;

      // Setup the default parameters.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._muted = parent._muted;
      self._rate = parent._rate;
      self._seek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a unique ID for this sound.
      self._id = Math.round(Date.now() * Math.random());

      // Add itself to the parent's pool.
      parent._sounds.push(self);

      // Create the new node.
      self.create();

      return self;
    },

    /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */
    create: function() {
      var self = this;
      var parent = self._parent;
      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;

      if (parent._webAudio) {
        // Create the gain node for controlling volume (the source will connect to this).
        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
        self._node.paused = true;
        self._node.connect(Howler.masterGain);
      } else {
        self._node = new Audio();

        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
        self._errorFn = self._errorListener.bind(self);
        self._node.addEventListener('error', self._errorFn, false);

        // Listen for 'canplaythrough' event to let us know the sound is ready.
        self._loadFn = self._loadListener.bind(self);
        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);

        // Setup the new audio node.
        self._node.src = parent._src;
        self._node.preload = 'auto';
        self._node.volume = volume * Howler.volume();

        // Begin loading the source.
        self._node.load();
      }

      return self;
    },

    /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */
    reset: function() {
      var self = this;
      var parent = self._parent;

      // Reset all of the parameters of this sound.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._muted = parent._muted;
      self._rate = parent._rate;
      self._seek = 0;
      self._rateSeek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a new ID so that it isn't confused with the previous sound.
      self._id = Math.round(Date.now() * Math.random());

      return self;
    },

    /**
     * HTML5 Audio error listener callback.
     */
    _errorListener: function() {
      var self = this;

      // Fire an error event and pass back the code.
      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);

      // Clear the event listener.
      self._node.removeEventListener('error', self._errorListener, false);
    },

    /**
     * HTML5 Audio canplaythrough listener callback.
     */
    _loadListener: function() {
      var self = this;
      var parent = self._parent;

      // Round up the duration to account for the lower precision in HTML5 Audio.
      parent._duration = Math.ceil(self._node.duration * 10) / 10;

      // Setup a sprite if none is defined.
      if (Object.keys(parent._sprite).length === 0) {
        parent._sprite = {__default: [0, parent._duration * 1000]};
      }

      if (parent._state !== 'loaded') {
        parent._state = 'loaded';
        parent._emit('load');
        parent._loadQueue();
      }

      // Clear the event listener.
      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
    }
  };

  /** Helper Methods **/
  /***************************************************************************/

  var cache = {};

  /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */
  var loadBuffer = function(self) {
    var url = self._src;

    // Check if the buffer has already been cached and use it instead.
    if (cache[url]) {
      // Set the duration from the cache.
      self._duration = cache[url].duration;

      // Load the sound into this Howl.
      loadSound(self);

      return;
    }

    if (/^data:[^;]+;base64,/.test(url)) {
      // Decode the base64 data URI without XHR, since some browsers don't support it.
      var data = atob(url.split(',')[1]);
      var dataView = new Uint8Array(data.length);
      for (var i=0; i<data.length; ++i) {
        dataView[i] = data.charCodeAt(i);
      }

      decodeAudioData(dataView.buffer, self);
    } else {
      // Load the buffer from the URL.
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function() {
        // Make sure we get a successful response back.
        var code = (xhr.status + '')[0];
        if (code !== '0' && code !== '2' && code !== '3') {
          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
          return;
        }

        decodeAudioData(xhr.response, self);
      };
      xhr.onerror = function() {
        // If there is an error, switch to HTML5 Audio.
        if (self._webAudio) {
          self._html5 = true;
          self._webAudio = false;
          self._sounds = [];
          delete cache[url];
          self.load();
        }
      };
      safeXhrSend(xhr);
    }
  };

  /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */
  var safeXhrSend = function(xhr) {
    try {
      xhr.send();
    } catch (e) {
      xhr.onerror();
    }
  };

  /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */
  var decodeAudioData = function(arraybuffer, self) {
    // Decode the buffer into an audio source.
    Howler.ctx.decodeAudioData(arraybuffer, function(buffer) {
      if (buffer && self._sounds.length > 0) {
        cache[self._src] = buffer;
        loadSound(self, buffer);
      }
    }, function() {
      self._emit('loaderror', null, 'Decoding audio data failed.');
    });
  };

  /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */
  var loadSound = function(self, buffer) {
    // Set the duration.
    if (buffer && !self._duration) {
      self._duration = buffer.duration;
    }

    // Setup a sprite if none is defined.
    if (Object.keys(self._sprite).length === 0) {
      self._sprite = {__default: [0, self._duration * 1000]};
    }

    // Fire the loaded event.
    if (self._state !== 'loaded') {
      self._state = 'loaded';
      self._emit('load');
      self._loadQueue();
    }
  };

  /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */
  var setupAudioContext = function() {
    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        Howler.ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        Howler.ctx = new webkitAudioContext();
      } else {
        Howler.usingWebAudio = false;
      }
    } catch(e) {
      Howler.usingWebAudio = false;
    }

    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
    // If it is, disable Web Audio as it causes crashing.
    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    var version = appVersion ? parseInt(appVersion[1], 10) : null;
    if (iOS && version && version < 9) {
      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
      if (Howler._navigator && Howler._navigator.standalone && !safari || Howler._navigator && !Howler._navigator.standalone && !safari) {
        Howler.usingWebAudio = false;
      }
    }

    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
    if (Howler.usingWebAudio) {
      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
      Howler.masterGain.gain.value = 1;
      Howler.masterGain.connect(Howler.ctx.destination);
    }

    // Re-run the setup on Howler.
    Howler._setup();
  };

  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return {
        Howler: Howler,
        Howl: Howl
      };
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }

  // Add support for CommonJS libraries such as browserify.
  if (true) {
    exports.Howler = Howler;
    exports.Howl = Howl;
  }

  // Define globally in case AMD is not available or unused.
  if (typeof window !== 'undefined') {
    window.HowlerGlobal = HowlerGlobal;
    window.Howler = Howler;
    window.Howl = Howl;
    window.Sound = Sound;
  } else if (typeof global !== 'undefined') { // Add to global in Node.js (for testing, etc).
    global.HowlerGlobal = HowlerGlobal;
    global.Howler = Howler;
    global.Howl = Howl;
    global.Sound = Sound;
  }
})();


/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.0.2
 *  howlerjs.com
 *
 *  (c) 2013-2016, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  // Setup default properties.
  HowlerGlobal.prototype._pos = [0, 0, 0];
  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];
  
  /** Global Methods **/
  /***************************************************************************/

  /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */
  HowlerGlobal.prototype.stereo = function(pan) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Loop through all Howls and update their stereo panning.
    for (var i=self._howls.length-1; i>=0; i--) {
      self._howls[i].stereo(pan);
    }

    return self;
  };

  /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */
  HowlerGlobal.prototype.pos = function(x, y, z) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._pos[1] : y;
    z = (typeof z !== 'number') ? self._pos[2] : z;

    if (typeof x === 'number') {
      self._pos = [x, y, z];
      self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
    } else {
      return self._pos;
    }

    return self;
  };

  /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */
  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    var or = self._orientation;
    y = (typeof y !== 'number') ? or[1] : y;
    z = (typeof z !== 'number') ? or[2] : z;
    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
    zUp = (typeof zUp !== 'number') ? or[5] : zUp;

    if (typeof x === 'number') {
      self._orientation = [x, y, z, xUp, yUp, zUp];
      self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
    } else {
      return or;
    }

    return self;
  };

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */
  Howl.prototype.init = (function(_super) {
    return function(o) {
      var self = this;

      // Setup user-defined default properties.
      self._orientation = o.orientation || [1, 0, 0];
      self._stereo = o.stereo || null;
      self._pos = o.pos || null;
      self._pannerAttr = {
        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
      };

      // Setup event listeners.
      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];

      // Complete initilization with howler.js core's init function.
      return _super.call(this, o);
    };
  })(Howl.prototype.init);

  /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */
  Howl.prototype.stereo = function(pan, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'stereo',
        action: function() {
          self.stereo(pan, id);
        }
      });

      return self;
    }

    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';

    // Setup the group's stereo panning if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's stereo panning if no parameters are passed.
      if (typeof pan === 'number') {
        self._stereo = pan;
        self._pos = [pan, 0, 0];
      } else {
        return self._stereo;
      }
    }

    // Change the streo panning of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof pan === 'number') {
          sound._stereo = pan;
          sound._pos = [pan, 0, 0];

          if (sound._node) {
            // If we are falling back, make sure the panningModel is equalpower.
            sound._pannerAttr.panningModel = 'equalpower';

            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || !sound._panner.pan) {
              setupPanner(sound, pannerType);
            }

            if (pannerType === 'spatial') {
              sound._panner.setPosition(pan, 0, 0);
            } else {
              sound._panner.pan.value = pan;
            }
          }

          self._emit('stereo', sound._id);
        } else {
          return sound._stereo;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the 3D spatial position of the audio source for this sound or
   * all in the group. The most common usage is to set the 'x' position for
   * left/right panning. Setting any value higher than 1.0 will begin to
   * decrease the volume of the sound as it moves further away.
   * @param  {Number} x  The x-position of the audio from -1000.0 to 1000.0.
   * @param  {Number} y  The y-position of the audio from -1000.0 to 1000.0.
   * @param  {Number} z  The z-position of the audio from -1000.0 to 1000.0.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */
  Howl.prototype.pos = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change position when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'pos',
        action: function() {
          self.pos(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? 0 : y;
    z = (typeof z !== 'number') ? -0.5 : z;

    // Setup the group's spatial position if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial position if no parameters are passed.
      if (typeof x === 'number') {
        self._pos = [x, y, z];
      } else {
        return self._pos;
      }
    }

    // Change the spatial position of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._pos = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || sound._panner.pan) {
              setupPanner(sound, 'spatial');
            }

            sound._panner.setPosition(x, y, z);
          }

          self._emit('pos', sound._id);
        } else {
          return sound._pos;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */
  Howl.prototype.orientation = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'orientation',
        action: function() {
          self.orientation(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._orientation[1] : y;
    z = (typeof z !== 'number') ? self._orientation[2] : z;

    // Setup the group's spatial orientation if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial orientation if no parameters are passed.
      if (typeof x === 'number') {
        self._orientation = [x, y, z];
      } else {
        return self._orientation;
      }
    }

    // Change the spatial orientation of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._orientation = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner) {
              // Make sure we have a position to setup the node with.
              if (!sound._pos) {
                sound._pos = self._pos || [0, 0, -0.5];
              }

              setupPanner(sound, 'spatial');
            }

            sound._panner.setOrientation(x, y, z);
          }

          self._emit('orientation', sound._id);
        } else {
          return sound._orientation;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) There will be no volume reduction inside this angle.
   *     coneOuterAngle - (360 by default) The volume will be reduced to a constant value of
   *                      `coneOuterGain` outside this angle.
   *     coneOuterGain - (0 by default) The amount of volume reduction outside of `coneOuterAngle`.
   *     distanceModel - ('inverse' by default) Determines algorithm to use to reduce volume as audio moves
   *                      away from listener. Can be `linear`, `inverse` or `exponential`.
   *     maxDistance - (10000 by default) Volume won't reduce between source/listener beyond this distance.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *     refDistance - (1 by default) A reference distance for reducing volume as the source
   *                    moves away from the listener.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener.
   * 
   * @return {Howl/Object} Returns self or current panner attributes.
   */
  Howl.prototype.pannerAttr = function() {
    var self = this;
    var args = arguments;
    var o, id, sound;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // Determine the values based on arguments.
    if (args.length === 0) {
      // Return the group's panner attribute values.
      return self._pannerAttr;
    } else if (args.length === 1) {
      if (typeof args[0] === 'object') {
        o = args[0];

        // Set the grou's panner attribute values.
        if (typeof id === 'undefined') {
          self._pannerAttr = {
            coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : self._coneInnerAngle,
            coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : self._coneOuterAngle,
            coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : self._coneOuterGain,
            distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : self._distanceModel,
            maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : self._maxDistance,
            panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : self._panningModel,
            refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : self._refDistance,
            rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : self._rolloffFactor
          };
        }
      } else {
        // Return this sound's panner attribute values.
        sound = self._soundById(parseInt(args[0], 10));
        return sound ? sound._pannerAttr : self._pannerAttr;
      }
    } else if (args.length === 2) {
      o = args[0];
      id = parseInt(args[1], 10);
    }

    // Update the values of the specified sounds.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      sound = self._soundById(ids[i]);

      if (sound) {
        // Merge the new values into the sound.
        var pa = sound._pannerAttr;
        pa = {
          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel,
          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor
        };

        // Update the panner values or create a new panner if none exists.
        var panner = sound._panner;
        if (panner) {
          panner.coneInnerAngle = pa.coneInnerAngle;
          panner.coneOuterAngle = pa.coneOuterAngle;
          panner.coneOuterGain = pa.coneOuterGain;
          panner.distanceModel = pa.distanceModel;
          panner.maxDistance = pa.maxDistance;
          panner.panningModel = pa.panningModel;
          panner.refDistance = pa.refDistance;
          panner.rolloffFactor = pa.rolloffFactor;
        } else {
          // Make sure we have a position to setup the node with.
          if (!sound._pos) {
            sound._pos = self._pos || [0, 0, -0.5];
          }

          // Create a new panner node.
          setupPanner(sound, 'spatial');
        }
      }
    }

    return self;
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */
  Sound.prototype.init = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Setup user-defined default properties.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete initilization with howler.js core Sound's init function.
      _super.call(this);

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      }
    };
  })(Sound.prototype.init);

  /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */
  Sound.prototype.reset = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Reset all spatial plugin properties on this sound.
      self._orientation = parent._orientation;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete resetting of the sound.
      return _super.call(this);
    };
  })(Sound.prototype.reset);

  /** Helper Methods **/
  /***************************************************************************/

  /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */
  var setupPanner = function(sound, type) {
    type = type || 'spatial';

    // Create the new panner node.
    if (type === 'spatial') {
      sound._panner = Howler.ctx.createPanner();
      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
      sound._panner.panningModel = sound._pannerAttr.panningModel;
      sound._panner.refDistance = sound._pannerAttr.refDistance;
      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
      sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
      sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
    } else {
      sound._panner = Howler.ctx.createStereoPanner();
      sound._panner.pan.value = sound._stereo;
    }

    sound._panner.connect(sound._node);

    // Update the connections.
    if (!sound._paused) {
      sound._parent.pause(sound._id, true).play(sound._id);
    }
  };
})();


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 229 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};



/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/


//     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__(222);
var warning = __webpack_require__(237);
var has = __webpack_require__(227);
var trim = __webpack_require__(235);

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter = '||||';

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    if (n % 100 >= 3 && n % 100 <= 10) return 3;
    return n % 100 >= 11 ? 4 : 5;
  },
  chinese: function () { return 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  french: function (n) { return n > 1 ? 1 : 0; },
  russian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
};

// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages = {
  arabic: ['ar'],
  chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
  german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['hr', 'ru', 'lt'],
  czech: ['cs', 'sk'],
  polish: ['pl'],
  icelandic: ['is']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

var dollarRegex = /\$/g;
var dollarBillsYall = '$$';
var tokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimeter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, tokenRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
    return replace.call(options[argument], dollarRegex, dollarBillsYall);
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = transformPhrase;

module.exports = Polyglot;



/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(232);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;



/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};



/***/ }),
/* 233 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };



/***/ }),
/* 234 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


// stats.js - http://github.com/mrdoob/stats.js
var Stats=function(){function h(a){c.appendChild(a.dom);return a}function k(a){for(var d=0;d<c.children.length;d++)c.children[d].style.display=d===a?"block":"none";l=a}var l=0,c=document.createElement("div");c.style.cssText="position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";c.addEventListener("click",function(a){a.preventDefault();k(++l%c.children.length)},!1);var g=(performance||Date).now(),e=g,a=0,r=h(new Stats.Panel("FPS","#0ff","#002")),f=h(new Stats.Panel("MS","#0f0","#020"));
if(self.performance&&self.performance.memory)var t=h(new Stats.Panel("MB","#f08","#201"));k(0);return{REVISION:16,dom:c,addPanel:h,showPanel:k,begin:function(){g=(performance||Date).now()},end:function(){a++;var c=(performance||Date).now();f.update(c-g,200);if(c>e+1E3&&(r.update(1E3*a/(c-e),100),e=c,a=0,t)){var d=performance.memory;t.update(d.usedJSHeapSize/1048576,d.jsHeapSizeLimit/1048576)}return c},update:function(){g=this.end()},domElement:c,setMode:k}};
Stats.Panel=function(h,k,l){var c=Infinity,g=0,e=Math.round,a=e(window.devicePixelRatio||1),r=80*a,f=48*a,t=3*a,u=2*a,d=3*a,m=15*a,n=74*a,p=30*a,q=document.createElement("canvas");q.width=r;q.height=f;q.style.cssText="width:80px;height:48px";var b=q.getContext("2d");b.font="bold "+9*a+"px Helvetica,Arial,sans-serif";b.textBaseline="top";b.fillStyle=l;b.fillRect(0,0,r,f);b.fillStyle=k;b.fillText(h,t,u);b.fillRect(d,m,n,p);b.fillStyle=l;b.globalAlpha=.9;b.fillRect(d,m,n,p);return{dom:q,update:function(f,
v){c=Math.min(c,f);g=Math.max(g,f);b.fillStyle=l;b.globalAlpha=1;b.fillRect(0,0,r,m);b.fillStyle=k;b.fillText(e(f)+" "+h+" ("+e(c)+"-"+e(g)+")",t,u);b.drawImage(q,d+a,m,n-a,p,d,m,n-a,p);b.fillRect(d+n-a,m,a,p);b.fillStyle=l;b.globalAlpha=.9;b.fillRect(d+n-a,m,a,e((1-f/v)*p))}}};"object"===typeof module&&(module.exports=Stats);



/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var bind = __webpack_require__(17);
var define = __webpack_require__(29);

var implementation = __webpack_require__(32);
var getPolyfill = __webpack_require__(33);
var shim = __webpack_require__(236);

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;



/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/




var define = __webpack_require__(29);
var getPolyfill = __webpack_require__(33);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};



/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*** IMPORTS FROM imports-loader ***/


/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;



/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Promise) {var __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/


/* Web Font Loader v1.6.27 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.m=b||a;this.c=this.m.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function z(a){if("string"===typeof a.f)return a.f;var b=a.m.location.protocol;"about:"==b&&(b=a.a.location.protocol);return"https:"==b?"https:":"http:"}function ea(a){return a.m.location.hostname||a.a.location.hostname}
function A(a,b,c){function d(){k&&e&&f&&(k(g),k=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,k=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function B(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function C(){this.a=0;this.c=null}function D(a){a.a++;return function(){a.a--;E(a)}}function F(a,b){a.c=b;E(a)}function E(a){0==a.a&&a.c&&(a.c(),a.c=null)};function G(a){this.a=a||"-"}G.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function H(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return I(a)+" "+(a.f+"00")+" 300px "+J(a.c)}function J(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function K(a){return a.a+a.f}function I(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.m.document.documentElement;this.h=b;this.a=new G("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);L(a,"loading")}function M(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}L(a,"inactive")}function L(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,K(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function N(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function O(a){u(a.c,"body",a.a)}function P(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+J(a.c)+";"+("font-style:"+I(a)+";font-weight:"+(a.f+"00")+";")};function Q(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}Q.prototype.start=function(){var a=this.c.m.document,b=this,c=q(),d=new Promise(function(d,e){function k(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(k,25)},function(){e()})}k()}),e=new Promise(function(a,d){setTimeout(d,b.f)});Promise.race([e,d]).then(function(){b.g(b.a)},function(){b.j(b.a)})};function R(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.o=this.j=this.h=this.g=null;this.g=new N(this.c,this.s);this.h=new N(this.c,this.s);this.j=new N(this.c,this.s);this.o=new N(this.c,this.s);a=new H(this.a.c+",serif",K(this.a));a=P(a);this.g.a.style.cssText=a;a=new H(this.a.c+",sans-serif",K(this.a));a=P(a);this.h.a.style.cssText=a;a=new H("serif",K(this.a));a=P(a);this.j.a.style.cssText=a;a=new H("sans-serif",K(this.a));a=
P(a);this.o.a.style.cssText=a;O(this.g);O(this.h);O(this.j);O(this.o)}var S={D:"serif",C:"sans-serif"},T=null;function U(){if(null===T){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);T=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return T}R.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.o.a.offsetWidth;this.A=q();la(this)};
function ma(a,b,c){for(var d in S)if(S.hasOwnProperty(d)&&b===a.f[S[d]]&&c===a.f[S[d]])return!0;return!1}function la(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=U()&&ma(a,b,c));d?q()-a.A>=a.w?U()&&ma(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):na(a):V(a,a.v)}function na(a){setTimeout(p(function(){la(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.o.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.o=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,K(a).toString(),"active")],[b.a.c("wf",a.c,K(a).toString(),"loading"),b.a.c("wf",a.c,K(a).toString(),"inactive")]);L(b,"fontactive",a);this.o=!0;oa(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,K(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,K(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,K(a).toString(),"inactive"));w(b.f,d,e)}L(b,"fontinactive",a);oa(this)};function oa(a){0==--a.f&&a.j&&(a.o?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),L(a,"active")):M(a.a))};function pa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}pa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;qa(this,new ha(this.c,a),a)};
function ra(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,k=d||null||{};if(0===c.length&&f)M(b.a);else{b.f+=c.length;f&&(b.j=f);var h,m=[];for(h=0;h<c.length;h++){var l=c[h],n=k[l.c],r=b.a,x=l;r.g&&w(r.f,[r.a.c("wf",x.c,K(x).toString(),"loading")]);L(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),ya=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):ya?!1:!0}else X=!1;X?r=new Q(p(b.g,b),p(b.h,b),b.c,l,b.s,n):r=new R(p(b.g,b),p(b.h,b),b.c,l,b.s,a,n);m.push(r)}for(h=0;h<m.length;h++)m[h].start()}},0)}function qa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){ra(a,f,b,d,c)})};function sa(a,b){this.c=a;this.a=b}function ta(a,b,c){var d=z(a.c);a=(a.a.api||"fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/,"");return d+"//"+a+"/"+b+".js"+(c?"?v="+c:"")}
sa.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var m=0;m<c.length;m++){var l=c[m].fontfamily;void 0!=c[m].fontStyle&&void 0!=c[m].fontWeight?(h=c[m].fontStyle+c[m].fontWeight,e.push(new H(l,h))):e.push(new H(l))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.m;B(this.c,ta(c,d,e),function(e){e?a([]):(f["__MonotypeConfiguration__"+d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+
d}else a([])};function ua(a,b){this.c=a;this.a=b}ua.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new C;b=0;for(c=d.length;b<c;b++)A(this.c,d[b],D(g));var k=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),m=0;m<h.length;m+=1)k.push(new H(d[0],h[m]));else k.push(new H(d[0]));F(g,function(){a(k,f)})};function va(a,b,c){a?this.c=a:this.c=b+wa;this.a=[];this.f=[];this.g=c||""}var wa="//fonts.googleapis.com/css";function xa(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function za(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function Aa(a){this.f=a;this.a=[];this.c={}}
var Ba={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Ca={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Da={i:"i",italic:"i",n:"n",normal:"n"},
Ea=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Fa(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var k=d[1];g=[];if(k)for(var k=k.split(","),h=k.length,m=0;m<h;m++){var l;l=k[m];if(l.match(/^[\w-]+$/)){var n=Ea.exec(l.toLowerCase());if(null==n)l="";else{l=n[2];l=null==l||""==l?"n":Da[l];n=n[1];if(null==n||""==n)n="4";else var r=Ca[n],n=r?r:isNaN(n)?"4":n.substr(0,1);l=[l,n].join("")}}else l="";l&&g.push(l)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=Ba[d[0]])&&(a.c[e]=d))}a.c[e]||(d=Ba[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new H(e,f[d]))}};function Ga(a,b){this.c=a;this.a=b}var Ha={Arimo:!0,Cousine:!0,Tinos:!0};Ga.prototype.load=function(a){var b=new C,c=this.c,d=new va(this.a.api,z(c),this.a.text),e=this.a.families;xa(d,e);var f=new Aa(e);Fa(f);A(c,za(d),D(b));F(b,function(){a(f.a,f.c,Ha)})};function Ia(a,b){this.c=a;this.a=b}Ia.prototype.load=function(a){var b=this.a.id,c=this.c.m;b?B(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],k=b[f+1],h=0;h<k.length;h++)e.push(new H(g,k[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(m){}a(e)}},2E3):a([])};function Ja(a,b){this.c=a;this.f=b;this.a=[]}Ja.prototype.load=function(a){var b=this.f.id,c=this.c.m,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,k=c.fonts.length;g<k;++g){var h=c.fonts[g];d.a.push(new H(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},B(this.c,z(this.c)+(this.f.api||"//f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new pa(window);Y.a.c.custom=function(a,b){return new ua(b,a)};Y.a.c.fontdeck=function(a,b){return new Ja(b,a)};Y.a.c.monotype=function(a,b){return new sa(b,a)};Y.a.c.typekit=function(a,b){return new Ia(b,a)};Y.a.c.google=function(a,b){return new Ga(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = {
	"defaults": {
		"format": "%s%v",
		"noSymbolFormat": "%s %v",
		"decimal": ".",
		"thousand": ","
	},
	"locales": {
		"f": {
			"%s %v": [
				"ar",
				"ar-AE",
				"ar-BH",
				"ar-DJ",
				"ar-DZ",
				"ar-EG",
				"ar-EH",
				"ar-ER",
				"ar-IL",
				"ar-IQ",
				"ar-JO",
				"ar-KM",
				"ar-KW",
				"ar-LB",
				"ar-LY",
				"ar-MA",
				"ar-MR",
				"ar-OM",
				"ar-PS",
				"ar-QA",
				"ar-SA",
				"ar-SD",
				"ar-SO",
				"ar-SS",
				"ar-SY",
				"ar-TD",
				"ar-TN",
				"ar-YE",
				"az",
				"az-Latn",
				"de-AT",
				"de-CH",
				"de-LI",
				"en-AT",
				"en-CH",
				"en-IN",
				"en-NL",
				"en-US-POSIX",
				"es-AR",
				"es-CO",
				"es-PY",
				"es-UY",
				"fr-CH",
				"hy",
				"it-CH",
				"mk",
				"mn",
				"ms-BN",
				"my",
				"nb",
				"nb-SJ",
				"ne",
				"ne-IN",
				"nl",
				"nl-AW",
				"nl-BQ",
				"nl-CW",
				"nl-SR",
				"nl-SX",
				"pa",
				"pa-Guru",
				"root",
				"ta",
				"ta-LK",
				"ta-MY",
				"ta-SG",
				"to",
				"ur",
				"ur-IN",
				"vi"
			],
			"%v %s": [
				"be",
				"bg",
				"bs",
				"bs-Latn",
				"ca",
				"ca-AD",
				"ca-ES-VALENCIA",
				"ca-FR",
				"ca-IT",
				"cs",
				"da",
				"da-GL",
				"de",
				"de-BE",
				"de-LU",
				"el",
				"el-CY",
				"en-150",
				"en-BE",
				"en-DE",
				"en-DK",
				"en-FI",
				"en-SE",
				"en-SI",
				"es",
				"es-EA",
				"es-IC",
				"es-PH",
				"et",
				"eu",
				"fi",
				"fo",
				"fo-DK",
				"fr",
				"fr-BE",
				"fr-BF",
				"fr-BI",
				"fr-BJ",
				"fr-BL",
				"fr-CA",
				"fr-CD",
				"fr-CF",
				"fr-CG",
				"fr-CI",
				"fr-CM",
				"fr-DJ",
				"fr-DZ",
				"fr-GA",
				"fr-GF",
				"fr-GN",
				"fr-GP",
				"fr-GQ",
				"fr-HT",
				"fr-KM",
				"fr-LU",
				"fr-MA",
				"fr-MC",
				"fr-MF",
				"fr-MG",
				"fr-ML",
				"fr-MQ",
				"fr-MR",
				"fr-MU",
				"fr-NC",
				"fr-NE",
				"fr-PF",
				"fr-PM",
				"fr-RE",
				"fr-RW",
				"fr-SC",
				"fr-SN",
				"fr-SY",
				"fr-TD",
				"fr-TG",
				"fr-TN",
				"fr-VU",
				"fr-WF",
				"fr-YT",
				"he",
				"hr",
				"hr-BA",
				"hu",
				"is",
				"it",
				"it-SM",
				"ka",
				"kk",
				"ky",
				"lt",
				"lv",
				"nl-BE",
				"pl",
				"pt-AO",
				"pt-CV",
				"pt-GW",
				"pt-MO",
				"pt-MZ",
				"pt-PT",
				"pt-ST",
				"pt-TL",
				"ro",
				"ro-MD",
				"ru",
				"ru-BY",
				"ru-KG",
				"ru-KZ",
				"ru-MD",
				"ru-UA",
				"sk",
				"sl",
				"sq",
				"sq-MK",
				"sq-XK",
				"sr",
				"sr-Cyrl",
				"sr-Cyrl-BA",
				"sr-Cyrl-ME",
				"sr-Cyrl-XK",
				"sr-Latn",
				"sr-Latn-BA",
				"sr-Latn-ME",
				"sr-Latn-XK",
				"sv",
				"sv-SE",
				"sv-AX",
				"sv-FI",
				"tr",
				"tr-CY",
				"uk",
				"uz",
				"uz-Latn"
			],
			"%v%s": [
				"bn",
				"bn-IN"
			]
		},
		"d": {
			",": [
				"af",
				"af-NA",
				"ar-DZ",
				"ar-LB",
				"ar-LY",
				"ar-MA",
				"ar-MR",
				"ar-TN",
				"az",
				"az-Latn",
				"be",
				"bg",
				"bs",
				"bs-Latn",
				"ca",
				"ca-AD",
				"ca-ES-VALENCIA",
				"ca-FR",
				"ca-IT",
				"cs",
				"da",
				"da-GL",
				"de",
				"de-AT",
				"de-BE",
				"de-LU",
				"el",
				"el-CY",
				"en-150",
				"en-AT",
				"en-BE",
				"en-CH",
				"en-DE",
				"en-DK",
				"en-FI",
				"en-NL",
				"en-SE",
				"en-SI",
				"en-ZA",
				"es",
				"es-AR",
				"es-BO",
				"es-CL",
				"es-CO",
				"es-CR",
				"es-EA",
				"es-EC",
				"es-GQ",
				"es-IC",
				"es-PH",
				"es-PY",
				"es-UY",
				"es-VE",
				"et",
				"eu",
				"fi",
				"fo",
				"fo-DK",
				"fr",
				"fr-BE",
				"fr-BF",
				"fr-BI",
				"fr-BJ",
				"fr-BL",
				"fr-CA",
				"fr-CD",
				"fr-CF",
				"fr-CG",
				"fr-CI",
				"fr-CM",
				"fr-DJ",
				"fr-DZ",
				"fr-GA",
				"fr-GF",
				"fr-GN",
				"fr-GP",
				"fr-GQ",
				"fr-HT",
				"fr-KM",
				"fr-LU",
				"fr-MA",
				"fr-MC",
				"fr-MF",
				"fr-MG",
				"fr-ML",
				"fr-MQ",
				"fr-MR",
				"fr-MU",
				"fr-NC",
				"fr-NE",
				"fr-PF",
				"fr-PM",
				"fr-RE",
				"fr-RW",
				"fr-SC",
				"fr-SN",
				"fr-SY",
				"fr-TD",
				"fr-TG",
				"fr-TN",
				"fr-VU",
				"fr-WF",
				"fr-YT",
				"gl",
				"hr",
				"hr-BA",
				"hu",
				"hy",
				"id",
				"is",
				"it",
				"it-SM",
				"ka",
				"kk",
				"km",
				"ky",
				"lo",
				"lt",
				"lv",
				"mk",
				"ms-BN",
				"nb",
				"nb-SJ",
				"nl",
				"nl-AW",
				"nl-BE",
				"nl-BQ",
				"nl-CW",
				"nl-SR",
				"nl-SX",
				"pl",
				"pt",
				"pt-AO",
				"pt-CV",
				"pt-GW",
				"pt-MO",
				"pt-MZ",
				"pt-PT",
				"pt-ST",
				"pt-TL",
				"ro",
				"ro-MD",
				"ru",
				"ru-BY",
				"ru-KG",
				"ru-KZ",
				"ru-MD",
				"ru-UA",
				"sk",
				"sl",
				"sq",
				"sq-MK",
				"sq-XK",
				"sr",
				"sr-Cyrl",
				"sr-Cyrl-BA",
				"sr-Cyrl-ME",
				"sr-Cyrl-XK",
				"sr-Latn",
				"sr-Latn-BA",
				"sr-Latn-ME",
				"sr-Latn-XK",
				"sv",
				"sv-SE",
				"sv-AX",
				"sv-FI",
				"sw-CD",
				"tr",
				"tr-CY",
				"uk",
				"uz",
				"uz-Latn",
				"vi"
			]
		},
		"t": {
			" ": [
				"af",
				"af-NA",
				"be",
				"bg",
				"cs",
				"de-AT",
				"en-FI",
				"en-SE",
				"en-ZA",
				"es-CR",
				"et",
				"fi",
				"fr",
				"fr-BF",
				"fr-BI",
				"fr-BJ",
				"fr-BL",
				"fr-CA",
				"fr-CD",
				"fr-CF",
				"fr-CG",
				"fr-CH",
				"fr-CI",
				"fr-CM",
				"fr-DJ",
				"fr-DZ",
				"fr-GA",
				"fr-GF",
				"fr-GN",
				"fr-GP",
				"fr-GQ",
				"fr-HT",
				"fr-KM",
				"fr-MC",
				"fr-MF",
				"fr-MG",
				"fr-ML",
				"fr-MQ",
				"fr-MR",
				"fr-MU",
				"fr-NC",
				"fr-NE",
				"fr-PF",
				"fr-PM",
				"fr-RE",
				"fr-RW",
				"fr-SC",
				"fr-SN",
				"fr-SY",
				"fr-TD",
				"fr-TG",
				"fr-TN",
				"fr-VU",
				"fr-WF",
				"fr-YT",
				"hu",
				"ka",
				"kk",
				"ky",
				"lt",
				"lv",
				"nb",
				"nb-SJ",
				"pl",
				"pt-AO",
				"pt-CV",
				"pt-GW",
				"pt-MO",
				"pt-MZ",
				"pt-PT",
				"pt-ST",
				"pt-TL",
				"ru",
				"ru-BY",
				"ru-KG",
				"ru-KZ",
				"ru-MD",
				"ru-UA",
				"sk",
				"sq",
				"sq-MK",
				"sq-XK",
				"sv",
				"sv-SE",
				"sv-AX",
				"sv-FI",
				"uk",
				"uz",
				"uz-Latn"
			],
			".": [
				"ar-DZ",
				"ar-LB",
				"ar-LY",
				"ar-MA",
				"ar-MR",
				"ar-TN",
				"az",
				"az-Latn",
				"bs",
				"bs-Latn",
				"ca",
				"ca-AD",
				"ca-ES-VALENCIA",
				"ca-FR",
				"ca-IT",
				"da",
				"da-GL",
				"de",
				"de-BE",
				"de-LU",
				"el",
				"el-CY",
				"en-150",
				"en-AT",
				"en-BE",
				"en-CH",
				"en-DE",
				"en-DK",
				"en-NL",
				"en-SI",
				"es",
				"es-AR",
				"es-BO",
				"es-CL",
				"es-CO",
				"es-EA",
				"es-EC",
				"es-GQ",
				"es-IC",
				"es-PH",
				"es-PY",
				"es-UY",
				"es-VE",
				"eu",
				"fo",
				"fo-DK",
				"fr-BE",
				"fr-LU",
				"fr-MA",
				"gl",
				"hr",
				"hr-BA",
				"hy",
				"id",
				"is",
				"it",
				"it-SM",
				"km",
				"lo",
				"mk",
				"ms-BN",
				"nl",
				"nl-AW",
				"nl-BE",
				"nl-BQ",
				"nl-CW",
				"nl-SR",
				"nl-SX",
				"pt",
				"ro",
				"ro-MD",
				"sl",
				"sr",
				"sr-Cyrl",
				"sr-Cyrl-BA",
				"sr-Cyrl-ME",
				"sr-Cyrl-XK",
				"sr-Latn",
				"sr-Latn-BA",
				"sr-Latn-ME",
				"sr-Latn-XK",
				"sw-CD",
				"tr",
				"tr-CY",
				"vi"
			],
			"'": [
				"de-CH",
				"de-LI",
				"it-CH"
			]
		}
	},
	"currencies": {
		"s": {
			"€": [
				"EUR"
			],
			"£": [
				"GBP"
			],
			"kr": [
				"DKK",
				"SEK",
				"NOK"
			],
			"$": [
				"AUD",
				"CAD",
				"NZD",
				"USD",
				"HKD",
				"SGD"
			],
			"Դ": [
				"AMD"
			],
			"R$": [
				"BRL"
			],
			"Kč": [
				"CZK"
			],
			"¥": [
				"JPY",
				"CNY"
			],
			"zł": [
				"PLN"
			],
			"Ft": [
				"HUF"
			],
			"₦": [
				"NGN"
			],
			"৳": [
				"BDT"
			],
			"CHF": [
				"CHF"
			],
			"Rp": [
				"IDR"
			],
			"₩": [
				"KRW"
			],
			"₨": [
				"LKR"
			],
			"RM": [
				"MYR"
			],
			"C$": [
				"NIO"
			],
			"₱": [
				"PHP"
			],
			"฿": [
				"THB"
			],
			"R": [
				"ZAR"
			],
			"₺": [
				"TRY"
			]
		}
	}
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./brush.png": 60,
	"./brush@2x.png": 61
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-secondary-hover.png": 25,
	"./button-secondary-hover@2x.png": 26,
	"./button-secondary.png": 62,
	"./button-secondary@2x.png": 63
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-secondary-hover.png": 25,
	"./button-secondary-hover@2x.png": 26
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./finger.png": 64,
	"./finger@2x.png": 65,
	"./finger@3x.png": 66
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cs.json": 114,
	"./de.json": 115,
	"./en.json": 116,
	"./hu.json": 117,
	"./pl.json": 118,
	"./pt.json": 119,
	"./sk.json": 120,
	"./sv.json": 121
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 244;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./buttons.json": 122,
	"./buttons@2x.json": 124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 245;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./buttons.png": 123,
	"./buttons@2x.png": 125
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 246;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./win-sign.json": 130,
	"./win-sign@2x.json": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 247;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./win-sign.png": 131,
	"./win-sign@2x.png": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 248;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./background.jpg": 67,
	"./background@2x.jpg": 68
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-hover.png": 27,
	"./button-hover@2x.png": 28,
	"./button.png": 69,
	"./button@2x.png": 70
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 250;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./button-hover.png": 27,
	"./button-hover@2x.png": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 251;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./character.png": 71,
	"./character@2x.png": 72
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./flake.png": 73,
	"./flake@2x.png": 74
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 253;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./logo-game.png": 75,
	"./logo-game@2x.png": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./logo-title.png": 77,
	"./logo-title@2x.png": 13
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./multiplier-x1.png": 78,
	"./multiplier-x10.png": 79,
	"./multiplier-x10@2x.png": 80,
	"./multiplier-x1@2x.png": 81,
	"./multiplier-x2.png": 82,
	"./multiplier-x2@2x.png": 83,
	"./multiplier-x3.png": 84,
	"./multiplier-x3@2x.png": 85,
	"./multiplier-x4.png": 86,
	"./multiplier-x4@2x.png": 87,
	"./multiplier-x5.png": 88,
	"./multiplier-x5@2x.png": 89
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 256;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./prize-1.png": 90,
	"./prize-1@2x.png": 91,
	"./prize-2.png": 92,
	"./prize-2@2x.png": 93,
	"./prize-3.png": 94,
	"./prize-3@2x.png": 95,
	"./prize-4.png": 96,
	"./prize-4@2x.png": 97,
	"./prize-5.png": 98,
	"./prize-5@2x.png": 99,
	"./prize-6.png": 100,
	"./prize-6@2x.png": 101,
	"./prize-7.png": 102,
	"./prize-7@2x.png": 103,
	"./prize-8.png": 104,
	"./prize-8@2x.png": 105,
	"./prize-9.png": 106,
	"./prize-9@2x.png": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./scratch-bg.png": 108,
	"./scratch-bg@2x.png": 109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 258;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./scratch-cover.png": 110,
	"./scratch-cover@2x.png": 111
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 260;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./win-sign.png": 112,
	"./win-sign@2x.png": 113
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./multi-1.json": 148,
	"./multi-10.json": 150,
	"./multi-10@2x.json": 152,
	"./multi-1@2x.json": 154,
	"./multi-2.json": 156,
	"./multi-2@2x.json": 158,
	"./multi-3.json": 160,
	"./multi-3@2x.json": 162,
	"./multi-4.json": 164,
	"./multi-4@2x.json": 166,
	"./multi-5.json": 168,
	"./multi-5@2x.json": 170
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 262;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./multi-1.png": 149,
	"./multi-10.png": 151,
	"./multi-10@2x.png": 153,
	"./multi-1@2x.png": 155,
	"./multi-2.png": 157,
	"./multi-2@2x.png": 159,
	"./multi-3.png": 161,
	"./multi-3@2x.png": 163,
	"./multi-4.png": 165,
	"./multi-4@2x.png": 167,
	"./multi-5.png": 169,
	"./multi-5@2x.png": 171
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./prize-1.json": 172,
	"./prize-1@2x.json": 174,
	"./prize-2.json": 176,
	"./prize-2@2x.json": 178,
	"./prize-3.json": 180,
	"./prize-3@2x.json": 182,
	"./prize-4.json": 184,
	"./prize-4@2x.json": 186,
	"./prize-5.json": 188,
	"./prize-5@2x.json": 190,
	"./prize-6.json": 192,
	"./prize-6@2x.json": 194,
	"./prize-7.json": 196,
	"./prize-7@2x.json": 198,
	"./prize-8.json": 200,
	"./prize-8@2x.json": 202,
	"./prize-9.json": 204,
	"./prize-9@2x.json": 206
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./prize-1.png": 173,
	"./prize-1@2x.png": 175,
	"./prize-2.png": 177,
	"./prize-2@2x.png": 179,
	"./prize-3.png": 181,
	"./prize-3@2x.png": 183,
	"./prize-4.png": 185,
	"./prize-4@2x.png": 187,
	"./prize-5.png": 189,
	"./prize-5@2x.png": 191,
	"./prize-6.png": 193,
	"./prize-6@2x.png": 195,
	"./prize-7.png": 197,
	"./prize-7@2x.png": 199,
	"./prize-8.png": 201,
	"./prize-8@2x.png": 203,
	"./prize-9.png": 205,
	"./prize-9@2x.png": 207
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var BottomBarView, Game, GameView, HelpView, MenuView, NotificationView, arrayExtender, canvasManager, configDefaults, currencyManager, errorConfig, eventManager, fontManager, gameModel, imageManager, imageModel, loadingManager, localeManager, log, networkManager, pixiExtender, realityManager, soundManager, trackingManager;

log = __webpack_require__(0);

window.__log = log;

log.disableAll();

configDefaults = __webpack_require__(51);

errorConfig = __webpack_require__(52);

arrayExtender = __webpack_require__(35);

pixiExtender = __webpack_require__(36);

canvasManager = __webpack_require__(37);

currencyManager = __webpack_require__(7);

eventManager = __webpack_require__(3);

fontManager = __webpack_require__(38);

imageManager = __webpack_require__(4);

loadingManager = __webpack_require__(19);

localeManager = __webpack_require__(39);

networkManager = __webpack_require__(20);

soundManager = __webpack_require__(8);

realityManager = __webpack_require__(10);

trackingManager = __webpack_require__(12);

GameView = __webpack_require__(41);

MenuView = __webpack_require__(43);

HelpView = __webpack_require__(42);

NotificationView = __webpack_require__(44);

BottomBarView = __webpack_require__(40);

gameModel = __webpack_require__(2);

imageModel = __webpack_require__(6);

Game = (function() {
  Game.prototype.name = "Game";

  Game.prototype.parallaxOffset = 150;

  function Game() {
    var that;
    gameModel.inject(configDefaults);
    log.info(this.name, 'constructor');
    loadingManager.start('#progress-bar');
    if (true) {
      that = this;
      __webpack_require__.e/* require.ensure */(2).then((function(require) {
        var RGS;
        RGS = __webpack_require__(22).Pariplay;
        return that.loadGame(RGS);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    } else {
      that = this;
      require.ensure(['gluckgames'], function(require) {
        var RGS;
        RGS = require('gluckgames').GluckGames;
        return that.loadGame(RGS);
      }, 'gg');
    }
  }

  Game.prototype.loadGame = function(RGS) {
    var queryData;
    queryData = UTIL.getQueryAsObj();
    if (__theme.apiGameCode) {
      queryData.gameCode = __theme.apiGameCode;
    }
    this.rgs = new RGS(queryData, __isMobile);
    this.setupLogging();
    return this.rgs.loadGame((function(_this) {
      return function(err, rgsModel, code) {
        return _this.loadGameHandler(err, rgsModel);
      };
    })(this));
  };

  Game.prototype.loadGameHandler = function(err, rgsModel) {
    log.info(this.name, 'loadGameHandler', rgsModel, err);
    gameModel.inject(rgsModel.getData());
    gameModel.inject(__theme);
    window.__config = gameModel;
    this.setupCurrencyManager();
    this.setupEventListeners();
    this.setupDebugging();
    this.setupTrackingManager();
    this.setupFontManager((function(_this) {
      return function(result) {
        return _this.setupImageManager(function(resources) {
          return _this.setupLocaleManager(function(defaultLang, localeErr) {
            return _this.setupCanvasManager(function() {
              return _this.setupInitialViews(function() {
                _this.showGameAfterDelay();
                if (err != null) {
                  _this.showError(err);
                  return;
                }
                _this.setupSoundManager();
                return _this.rgs.getInitialBalance(rgsModel, function(err, balance, code) {
                  if (err != null) {
                    _this.showError(err);
                    return;
                  }
                  if (balance == null) {
                    balance = -1;
                  }
                  eventManager.trigger('balance', {
                    balance: balance,
                    animate: false
                  });
                  if (balance != null) {
                    gameModel.setBalance(balance);
                  }
                  trackingManager.trackEvent('Request', 'LoadGame', err == null);
                  _this.setupRealityCheckManager();
                  if (gameModel.getReplayOutcome() != null) {
                    return _this.showReplayMessage();
                  }
                  return _this.startGame();
                });
              });
            });
          });
        });
      };
    })(this));
  };

  Game.prototype.setupEventListeners = function() {
    eventManager.listenTo('page-resize', (function(_this) {
      return function(data) {
        return _this.sizeToFit(data);
      };
    })(this));
    eventManager.listenTo('page-hide', (function(_this) {
      return function(data) {
        return _this.pauseGame(data);
      };
    })(this));
    eventManager.listenTo('page-show', (function(_this) {
      return function(data) {
        return _this.resumeGame(data);
      };
    })(this));
    eventManager.listenTo('place-bet', (function(_this) {
      return function(data) {
        return _this.placeBet(data);
      };
    })(this));
    eventManager.listenTo('end-round', (function(_this) {
      return function(data) {
        return _this.endRound(data);
      };
    })(this));
    eventManager.listenTo('show-menu', (function(_this) {
      return function(data) {
        return _this.showMenuView(data);
      };
    })(this));
    eventManager.listenTo('show-help', (function(_this) {
      return function(data) {
        return _this.showHelpView(data);
      };
    })(this));
    eventManager.listenTo('show-settings', (function(_this) {
      return function(data) {
        return _this.showSettingsView(data);
      };
    })(this));
    eventManager.listenTo('start-replay', (function(_this) {
      return function(data) {
        return _this.startReplay(data);
      };
    })(this));
    eventManager.listenTo('end-replay', (function(_this) {
      return function(data) {
        return _this.endReplay(data);
      };
    })(this));
    eventManager.listenTo('reload', (function(_this) {
      return function(e) {
        return _this.reload(e);
      };
    })(this));
    eventManager.listenTo('root-view', (function(_this) {
      return function(data) {
        return _this.rootViewShown(data);
      };
    })(this));
    eventManager.listenTo('pop-overlay', (function(_this) {
      return function(data) {
        return _this.popOverlay(data);
      };
    })(this));
    eventManager.listenTo('hide-reality-check', (function(_this) {
      return function(data) {
        return _this.hideRealityCheck(data);
      };
    })(this));
    eventManager.listenTo('change-reality-check', (function(_this) {
      return function(value) {
        return _this.realityCheckChanged(value);
      };
    })(this));
    eventManager.listenTo('show-error', (function(_this) {
      return function(err) {
        return _this.showError(err);
      };
    })(this));
    eventManager.listenTo('hide-error', (function(_this) {
      return function(err) {
        return _this.hideError(err);
      };
    })(this));
    eventManager.listenTo('showing-error', (function(_this) {
      return function(data) {
        return _this.disableUserActions(data);
      };
    })(this));
    eventManager.listenTo('hiding-error', (function(_this) {
      return function(data) {
        return _this.enableUserActions(data);
      };
    })(this));
    eventManager.listenTo('home', (function(_this) {
      return function(e) {
        return _this.rgs.goHome();
      };
    })(this));
    eventManager.listenTo('cashier', (function(_this) {
      return function(e) {
        return _this.rgs.goCashier();
      };
    })(this));
    eventManager.listenTo('buy-more', (function(_this) {
      return function(e) {
        return _this.rgs.goBuyMore();
      };
    })(this));
    eventManager.listenTo('history', (function(_this) {
      return function(e) {
        return _this.rgs.goHistory();
      };
    })(this));
    eventManager.listenTo('mute', (function(_this) {
      return function(state) {
        return _this.toggleMute(state);
      };
    })(this));
    eventManager.listenTo('balance', (function(_this) {
      return function(amount) {
        return _this.balanceChanged(amount);
      };
    })(this));
    eventManager.listenTo('no-tickets-left', (function(_this) {
      return function(data) {
        return _this.noTicketsLeft(data);
      };
    })(this));
    eventManager.listenTo('will-reveal-all', (function(_this) {
      return function(data) {
        return _this.willRevealAll(data);
      };
    })(this));
    eventManager.listenTo('track-event', (function(_this) {
      return function(data) {
        return _this.trackEvent(data);
      };
    })(this));
    return eventManager.listenTo('won', (function(_this) {
      return function(amount) {
        return _this.won(amount);
      };
    })(this));
  };

  Game.prototype.setupLogging = function() {
    if (gameModel.debug) {
      return log.enableAll();
    }
  };

  Game.prototype.setupInitialViews = function(cb) {
    log.info(this.name, 'setupInitialViews');
    this.menuView = new MenuView();
    this.menuView.setup();
    this.showMenuView();
    this.sizeToFit();
    this.gameView = new GameView();
    this.gameView.initSetup(cb);
    if (gameModel.getHelpUrl() != null) {
      if (this.helpView == null) {
        return this.helpView = new HelpView();
      }
    }
  };

  Game.prototype.setupCanvasManager = function(cb) {
    var parallax, ss;
    this.gameBg = new PIXI.Sprite.fromImage(imageModel.backgroundImage);
    this.bottomBarView = new BottomBarView(gameModel.rendererWidth, gameModel.rendererHeight);
    canvasManager.setup(this.gameBg, this.bottomBarView, this.parallaxOffset);
    canvasManager.renderCanvas();
    canvasManager.sizeToFit();
    canvasManager.pushInitHistory('MenuView');
    canvasManager.enableScrolling();
    ss = imageManager.getSpriteSheetImageNames();
    canvasManager.uploadImagesToGPU(ss);
    if (gameModel.hasBackgroundView) {
      parallax = this.parallaxOffset;
      return __webpack_require__.e/* require.ensure */(0).then((function(require) {
        var BackgroundView, backgroundView;
        BackgroundView = __webpack_require__(21);
        backgroundView = new BackgroundView();
        return canvasManager.addBackgroundView(backgroundView, cb);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    } else {
      return cb();
    }
  };

  Game.prototype.setupImageManager = function(cb) {
    var urls;
    urls = imageModel.setup();
    return imageManager.loadAssets(urls, cb);
  };

  Game.prototype.setupLocaleManager = function(cb) {
    var lang;
    lang = gameModel.getLanguageCode();
    localeManager.defaultLanguage = gameModel.defaultLanguage;
    return localeManager.setLanguage(lang, cb);
  };

  Game.prototype.setupCurrencyManager = function() {
    var options;
    options = {
      cc: gameModel.getCurrencyCode(),
      lc: gameModel.getLanguageCode()
    };
    currencyManager.setup(options);
    if (this.rgs.currencyLoaded) {
      return this.rgs.currencyLoaded({
        cs: currencyManager.getCurrencySymbol(),
        cc: gameModel.getCurrencyCode()
      });
    }
  };

  Game.prototype.setupFontManager = function(cb) {
    var fake, fontCssUrl, fontsToLoad;
    fake = function() {
      __webpack_require__(54)("./" + val + ".eot");
      __webpack_require__(55)("./" + val + ".svg");
      __webpack_require__(56)("./" + val + ".ttf");
      __webpack_require__(57)("./" + val + ".woff");
      return __webpack_require__(58)("./" + val + ".woff2");
    };
    fontCssUrl = __webpack_require__(46);
    fontsToLoad = [gameModel.getFontWithVariations(), gameModel.getSecondaryFont()];
    return fontManager.loadFonts(fontsToLoad, fontCssUrl, cb);
  };

  Game.prototype.setupSoundManager = function() {
    var audioSpriteUrl, startAudio;
    startAudio = function() {
      document.getElementById("canvas").removeEventListener('touchend', startAudio, false);
      return soundManager.startAudio();
    };
    audioSpriteUrl = __webpack_require__(47);
    return networkManager.getJSON(audioSpriteUrl, (function(_this) {
      return function(audioSpriteObj, err, code) {
        var mp3, ogg, options;
        if ((err != null) || (audioSpriteObj == null)) {
          return;
        }
        audioSpriteObj.sprite['music'].push(true);
        mp3 = __webpack_require__(48);
        ogg = __webpack_require__(49);
        options = {
          mp3: mp3 + "?v=" + __version,
          ogg: ogg + "?v=" + __version,
          masterVolume: gameModel.getSound(),
          volumes: gameModel.sounds.volumes,
          mute: gameModel.getInitialMute(),
          audioSpriteObj: audioSpriteObj
        };
        soundManager.setup(options);
        if (!__isTouch) {
          return startAudio();
        }
        _this.mute();
        return document.getElementById("canvas").addEventListener('touchend', startAudio, false);
      };
    })(this));
  };

  Game.prototype.setupTrackingManager = function() {
    return trackingManager.setup(gameModel.gameCode);
  };

  Game.prototype.setupDebugging = function() {
    if (gameModel.getDebug()) {
      return __webpack_require__.e/* require.ensure */(1).then((function(require) {
        var debugManager, prizeCount;
        debugManager = __webpack_require__(18);
        prizeCount = Object.keys(gameModel.images.prizes).length;
        return debugManager.render(prizeCount);
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  };

  Game.prototype.setupRealityCheckManager = function() {
    gameModel.setDefaultRealityInterval();
    if (gameModel.shouldShowRealityCheck()) {
      trackingManager.trackEvent('RealityCheck', 'event', 'show');
      return eventManager.listenTo("reality", (function(_this) {
        return function(msg, e) {
          return _this.showRealityCheck(msg);
        };
      })(this));
    }
  };

  Game.prototype.showGameAfterDelay = function() {
    return setTimeout((function(_this) {
      return function() {
        loadingManager.hideInitialLoader();
        return canvasManager.showCanvasEle();
      };
    })(this), gameModel.hideLoaderDelay);
  };

  Game.prototype.startGame = function() {
    this.enableUserActions();
    canvasManager.popOverlay();
    this.rgs.balanceHandler = function(balance) {
      return eventManager.trigger('balance', balance);
    };
    eventManager.trigger('balance', gameModel.getBalance());
    if (gameModel.isOutOfTickets() && gameModel.shouldShowBuyMorePopup()) {
      this.showError({
        code: 'NO_TICKETS_LEFT'
      });
    }
  };

  Game.prototype.placeBet = function() {
    if (gameModel.shouldShowRealityCheck()) {
      realityManager.canShowRealityCheck(false);
    }
    return this.startRound(gameModel.getStake());
  };

  Game.prototype.startRound = function(stake) {
    if (gameModel.isOutOfTickets()) {
      this.noTicketsLeft();
    }
    if (gameModel.isOutOfTickets() && gameModel.shouldShowBuyMorePopup()) {
      this.showError({
        code: 'NO_TICKETS_LEFT'
      });
      return;
    }
    this.showGameView();
    return this.rgs.placeBet(stake, (function(_this) {
      return function(err, betModel, code) {
        if (err != null) {
          _this.showError(err);
          return;
        }
        canvasManager.popAllOverlays();
        if (gameModel.shouldShowRealityCheck()) {
          realityManager.start(gameModel.getRealityIntervalInMs());
        }
        _this.gameView.executeBet(betModel, err, code);
        return canvasManager.disableScrolling();
      };
    })(this));
  };

  Game.prototype.endRound = function(data) {
    return this.rgs.endBet(data);
  };

  Game.prototype.showReplayMessage = function() {
    return this.showError({
      code: 'REPLAY_START'
    });
  };

  Game.prototype.startReplay = function() {
    var ticketModel;
    ticketModel = gameModel.getReplayOutcome();
    return this.rgs.replayBet(ticketModel, (function(_this) {
      return function(err, betModel, code) {
        if (err != null) {
          _this.showError(err);
          return;
        }
        trackingManager.trackEvent('Replay', 'event', 'start');
        eventManager.trigger('balance', betModel.getBalanceBefore());
        return _this.gameView.setupWithTicket(betModel, function() {
          _this.showGameView(true);
          return _this.enableUserActions();
        }, true);
      };
    })(this));
  };

  Game.prototype.endReplay = function() {
    eventManager.trigger('enable-navigation');
    eventManager.trigger('balance', {
      balance: gameModel.getBalance(),
      animate: false
    });
    this.showMenuView();
    return this.startGame();
  };

  Game.prototype.showGameView = function(isReplay) {
    var supressEvents;
    trackingManager.trackEvent('GameView', 'views', 'show');
    supressEvents = isReplay;
    canvasManager.popAllOverlays(supressEvents);
    canvasManager.popAllViews();
    if (!isReplay) {
      this.gameView.showStart();
    }
    return this.pushView(this.gameView);
  };

  Game.prototype.showMenuView = function() {
    trackingManager.trackEvent('MenuView', 'views', 'show');
    if (this.menuView == null) {
      this.menuView = new MenuView();
    }
    canvasManager.popOverlay();
    canvasManager.popAllViews();
    return this.pushView(this.menuView);
  };

  Game.prototype.showSettingsView = function() {
    trackingManager.trackEvent('SettingsView', 'views', 'show');
    if (this.settingsView == null) {
      this.settingsView = new SettingsView();
    }
    return this.pushView(this.settingsView);
  };

  Game.prototype.showHelpView = function() {
    if (gameModel.getHelpUrl() == null) {
      return;
    }
    if (canvasManager.isTransitioning) {
      return;
    }
    if (this.helpView.isShowing) {
      canvasManager.back();
      return;
    }
    this.gameView.skipResultAnimation();
    trackingManager.trackEvent('HelpView', 'views', 'show');
    return this.pushView(this.helpView);
  };

  Game.prototype.showError = function(rawErr) {
    var button, code, err, serverMsg, _i, _len, _ref;
    if (rawErr.code != null) {
      code = rawErr.code;
    }
    if (rawErr.msg != null) {
      serverMsg = rawErr.msg;
    }
    log.info(this.constructor.name, 'show', code);
    err = UTIL.clone(errorConfig[code]);
    if (err == null) {
      return;
    }
    if ((err.showServerMsg != null) && err.showServerMsg) {
      if (serverMsg != null) {
        err.msg = serverMsg;
      }
    }
    if (err.buttons != null) {
      _ref = err.buttons;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        button = _ref[_i];
        button.text = __t.str(button.textKey);
      }
    } else {
      err.buttons = [];
    }
    if (err.fatal) {
      console.error('fatal');
      this.disableUserActions();
    }
    trackingManager.trackException(code + ':' + serverMsg, err.fatal);
    if (this.notificationView == null) {
      this.notificationView = new NotificationView();
    }
    this.notificationView.setup(err.title, err.msg, err.buttons);
    return this.pushOverlay(this.notificationView);
  };

  Game.prototype.hideError = function() {
    this.gameView.resetAfterNotification();
    return canvasManager.popOverlay();
  };

  Game.prototype.showRealityCheck = function(msg) {
    var err;
    this.disableUserActions();
    if (this.isShowingRealityCheck) {
      this.notificationView.updateMsg(msg);
      return;
    }
    err = UTIL.clone(errorConfig['REALITY_CHECK']);
    if (this.notificationView == null) {
      this.notificationView = new NotificationView();
    }
    this.notificationView.setup(err.title, msg, err.buttons);
    this.pushOverlay(this.notificationView);
    this.isShowingRealityCheck = true;
    return trackingManager.trackEvent('RealityView', 'views', 'show');
  };

  Game.prototype.hideRealityCheck = function() {
    this.isShowingRealityCheck = false;
    canvasManager.popOverlay();
    this.enableUserActions();
    return this.gameView.resetAfterNotification();
  };

  Game.prototype.realityCheckChanged = function(value) {
    if (gameModel.shouldShowRealityCheck()) {
      gameModel.setRealityInterval(value);
      return realityManager.setCheckIntveral(gameModel.getRealityIntervalInMs());
    }
  };

  Game.prototype.sizeToFit = function() {
    var h, w;
    canvasManager.sizeToFit();
    if (this.menuView != null) {
      this.menuView.resize();
    }
    if (this.gameView != null) {
      this.gameView.resize();
    }
    if (this.helpView != null) {
      this.helpView.resize();
    }
    if (this.settingsView != null) {
      this.settingsView.resize();
    }
    if (this.notificationView != null) {
      this.notificationView.resize();
    }
    w = document.getElementById("canvas").style.width;
    h = document.getElementById("canvas").style.height;
    if (w === this.lastW && h === this.lastH) {
      return;
    }
    this.lastW = w;
    this.lastH = h;
    return this.rgs.resize(w, h);
  };

  Game.prototype.reload = function() {
    return location.reload();
  };

  Game.prototype.pushView = function(view) {
    return canvasManager.pushView(view);
  };

  Game.prototype.pushOverlay = function(view) {
    return canvasManager.pushOverlay(view);
  };

  Game.prototype.popOverlay = function() {
    return canvasManager.popOverlay();
  };

  Game.prototype.rootViewShown = function() {
    return this.showingHelpView = false;
  };

  Game.prototype.won = function(amount) {};

  Game.prototype.resumeGame = function() {
    canvasManager.freezeGame = false;
    return soundManager.resumeAll();
  };

  Game.prototype.pauseGame = function() {
    canvasManager.freezeGame = true;
    return soundManager.pauseAll();
  };

  Game.prototype.toggleMute = function() {
    log.info('toggle mute');
    if (!gameModel.getMute()) {
      return this.mute();
    } else {
      return this.unMute();
    }
  };

  Game.prototype.mute = function() {
    gameModel.setMute(true);
    soundManager.setMute(true);
    this.bottomBarView.displaySoundOffButton();
    return trackingManager.trackEvent('Mute', 'button', true);
  };

  Game.prototype.unMute = function() {
    gameModel.setMute(false);
    soundManager.setMute(false);
    this.bottomBarView.displaySoundOnButton();
    return trackingManager.trackEvent('Mute', 'button', false);
  };

  Game.prototype.balanceChanged = function(amount) {
    if (amount === gameModel.getBalance()) {
      return;
    }
    return this.rgs.balanceChanged(amount);
  };

  Game.prototype.noTicketsLeft = function() {
    return this.rgs.noTicketsLeft();
  };

  Game.prototype.willRevealAll = function() {
    return this.rgs.willRevealAll();
  };

  Game.prototype.enableUserActions = function() {
    return canvasManager.enableUserActions();
  };

  Game.prototype.disableUserActions = function() {
    return canvasManager.disableUserActions();
  };

  Game.prototype.trackEvent = function(data) {
    return trackingManager.trackEvent(data[0], data[1], data[2]);
  };

  return Game;

})();

module.exports = new Game();


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// d-game.js